import * as React from 'react';
import { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';
import { AnnotationLabel, AnnotationCalloutCircle, AnnotationCalloutRect, AnnotationCalloutCustom, AnnotationXYThreshold, AnnotationCallout, AnnotationBracket } from 'react-annotation';
import labella from 'labella';
import { line, curveLinear, arc, curveLinearClosed, curveCardinal, area, curveStep, curveStepBefore, curveStepAfter, curveBasis, curveCatmullRom, curveMonotoneY, curveMonotoneX, curveNatural, linkHorizontal, linkVertical } from 'd3-shape';
import { sum, extent as extent$1, quantile, histogram, max, min } from 'd3-array';
import { Mark } from 'semiotic-mark';
export { Mark } from 'semiotic-mark';
import { scaleLinear, scaleOrdinal, scaleBand } from 'd3-scale';
import { brushX, brushY, brush } from 'd3-brush';
import { select } from 'd3-selection';
import { voronoi } from 'd3-voronoi';
import { interpolateNumber } from 'd3-interpolate';
import { contourDensity } from 'd3-contour';
import { hexbin } from 'd3-hexbin';
import regression from 'regression';
import { packEnclose, hierarchy, tree, pack, cluster, treemap, partition } from 'd3-hierarchy';
import { polygonHull } from 'd3-polygon';
import Offset from 'polygon-offset';
import { nest } from 'd3-collection';
import { forceSimulation, forceY, forceX, forceCollide, forceLink, forceManyBody } from 'd3-force';
import pathBounds from 'svg-path-bounding-box';
import { d } from 'd3-glyphedge';
import { sankeyCircular, sankeyLeft, sankeyRight, sankeyCenter, sankeyJustify } from 'd3-sankey-circular';
import { ribbon, chord } from 'd3-chord';
import memoize from 'memoize-one';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

// from Evan Wang's https://github.com/tinker10/D3-Labeler
function labeler () {
    var lab = [], anc = [], w = 1, // box width
    h = 1, // box width
    labeler = {
        start: function (x) { },
        width: function (x) { },
        height: function (x) { },
        label: function (x) { },
        anchor: function (x) { },
        alt_energy: function (x) { },
        alt_schedule: function (x) { }
    };
    var max_move = 5.0, max_angle = 0.5;
    // weights
    var w_len = 0.2, // leader line length
    w_inter = 1.0, // leader line intersection
    w_lab2 = 30.0, // label-label overlap
    w_lab_anc = 30.0, // label-anchor overlap
    w_orient = 3.0; // orientation bias
    // booleans for user defined functions
    var user_energy = false;
    var user_defined_energy;
    var energy = function (index) {
        // energy function, tailored for label placement
        var m = lab.length, ener = 0, dx = lab[index].x - anc[index].x, dy = anc[index].y - lab[index].y, dist = Math.sqrt(dx * dx + dy * dy);
        // penalty for length of leader line
        if (dist > 0)
            ener += dist * w_len;
        // label orientation bias
        dx /= dist;
        dy /= dist;
        if (dx > 0 && dy > 0) {
            ener += 0 * w_orient;
        }
        else if (dx < 0 && dy > 0) {
            ener += 1 * w_orient;
        }
        else if (dx < 0 && dy < 0) {
            ener += 2 * w_orient;
        }
        else {
            ener += 3 * w_orient;
        }
        var x21 = lab[index].x, y21 = lab[index].y - lab[index].height + 2.0, x22 = lab[index].x + lab[index].width, y22 = lab[index].y + 2.0;
        var x11, x12, y11, y12, x_overlap, y_overlap, overlap_area;
        for (var i = 0; i < m; i++) {
            if (i !== index) {
                // penalty for intersection of leader lines
                var overlap_1 = intersect(anc[index].x, lab[index].x, anc[i].x, lab[i].x, anc[index].y, lab[index].y, anc[i].y, lab[i].y);
                if (overlap_1)
                    ener += w_inter;
                // penalty for label-label overlap
                x11 = lab[i].x;
                y11 = lab[i].y - lab[i].height + 2.0;
                x12 = lab[i].x + lab[i].width;
                y12 = lab[i].y + 2.0;
                x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
                y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
                overlap_area = x_overlap * y_overlap;
                ener += overlap_area * w_lab2;
            }
            // penalty for label-anchor overlap
            x11 = anc[i].x - anc[i].r;
            y11 = anc[i].y - anc[i].r;
            x12 = anc[i].x + anc[i].r;
            y12 = anc[i].y + anc[i].r;
            x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
            y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
            overlap_area = x_overlap * y_overlap;
            ener += overlap_area * w_lab_anc;
        }
        return ener;
    };
    var mcmove = function (currT) {
        // Monte Carlo translation move
        // select a random label
        var i = Math.floor(Math.random() * lab.length);
        // save old coordinates
        var x_old = lab[i].x;
        var y_old = lab[i].y;
        // old energy
        var old_energy;
        if (user_energy) {
            old_energy = user_defined_energy(i, lab, anc);
        }
        else {
            old_energy = energy(i);
        }
        // random translation
        lab[i].x += (Math.random() - 0.5) * max_move;
        lab[i].y += (Math.random() - 0.5) * max_move;
        // hard wall boundaries
        if (lab[i].x > w)
            lab[i].x = x_old;
        if (lab[i].x < 0)
            lab[i].x = x_old;
        if (lab[i].y > h)
            lab[i].y = y_old;
        if (lab[i].y < 0)
            lab[i].y = y_old;
        // new energy
        var new_energy;
        if (user_energy) {
            new_energy = user_defined_energy(i, lab, anc);
        }
        else {
            new_energy = energy(i);
        }
        // delta E
        var delta_energy = new_energy - old_energy;
        if (!(Math.random() < Math.exp(-delta_energy / currT))) {
            // move back to old coordinates
            lab[i].x = x_old;
            lab[i].y = y_old;
        }
    };
    var mcrotate = function (currT) {
        // Monte Carlo rotation move
        // select a random label
        var i = Math.floor(Math.random() * lab.length);
        // save old coordinates
        var x_old = lab[i].x;
        var y_old = lab[i].y;
        // old energy
        var old_energy;
        if (user_energy) {
            old_energy = user_defined_energy(i, lab, anc);
        }
        else {
            old_energy = energy(i);
        }
        // random angle
        var angle = (Math.random() - 0.5) * max_angle;
        var s = Math.sin(angle);
        var c = Math.cos(angle);
        // translate label (relative to anchor at origin):
        lab[i].x -= anc[i].x;
        lab[i].y -= anc[i].y;
        // rotate label
        var x_new = lab[i].x * c - lab[i].y * s, y_new = lab[i].x * s + lab[i].y * c;
        // translate label back
        lab[i].x = x_new + anc[i].x;
        lab[i].y = y_new + anc[i].y;
        // hard wall boundaries
        if (lab[i].x > w)
            lab[i].x = x_old;
        if (lab[i].x < 0)
            lab[i].x = x_old;
        if (lab[i].y > h)
            lab[i].y = y_old;
        if (lab[i].y < 0)
            lab[i].y = y_old;
        // new energy
        var new_energy;
        if (user_energy) {
            new_energy = user_defined_energy(i, lab, anc);
        }
        else {
            new_energy = energy(i);
        }
        // delta E
        var delta_energy = new_energy - old_energy;
        if (!(Math.random() < Math.exp(-delta_energy / currT))) {
            // move back to old coordinates
            lab[i].x = x_old;
            lab[i].y = y_old;
        }
    };
    var intersect = function (x1, x2, x3, x4, y1, y2, y3, y4) {
        // returns true if two lines intersect, else false
        // from http://paulbourke.net/geometry/lineline2d/
        var mua, mub;
        var denom, numera, numerb;
        denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
        numera = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
        numerb = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
        /* Is the intersection along the the segments */
        mua = numera / denom;
        mub = numerb / denom;
        if (!(mua < 0 || mua > 1 || mub < 0 || mub > 1)) {
            return true;
        }
        return false;
    };
    var cooling_schedule = function (currT, initialT, nsweeps) {
        // linear cooling
        return currT - initialT / nsweeps;
    };
    labeler.start = function (nsweeps) {
        // main simulated annealing function
        var m = lab.length, currT = 1.0, initialT = 1.0;
        for (var i = 0; i < nsweeps; i++) {
            for (var j = 0; j < m; j++) {
                if (Math.random() < 0.5) {
                    mcmove(currT);
                }
                else {
                    mcrotate(currT);
                }
            }
            currT = cooling_schedule(currT, initialT, nsweeps);
        }
    };
    labeler.width = function (x) {
        // users insert graph width
        if (!arguments.length)
            return w;
        w = x;
        return labeler;
    };
    labeler.height = function (x) {
        // users insert graph height
        if (!arguments.length)
            return h;
        h = x;
        return labeler;
    };
    labeler.label = function (x) {
        // users insert label positions
        if (!arguments.length)
            return lab;
        lab = x;
        return labeler;
    };
    labeler.anchor = function (x) {
        // users insert anchor positions
        if (!arguments.length)
            return anc;
        anc = x;
        return labeler;
    };
    labeler.alt_energy = function (x) {
        // user defined energy
        if (!arguments.length)
            return energy;
        user_defined_energy = x;
        user_energy = true;
        return labeler;
    };
    labeler.alt_schedule = function (x) {
        // user defined cooling_schedule
        if (!arguments.length)
            return cooling_schedule;
        return labeler;
    };
    return labeler;
}
/*eslint-enable */

var basicLabelSizeFunction = function (noteData, characterWidth, lineHeight, padding) {
    var text = noteData.note.label || noteData.note.title;
    var textLength = text.length;
    var wrap = noteData.note.wrap || 120;
    var width = Math.min(wrap, textLength * characterWidth) + padding * 2;
    var height = Math.ceil((textLength * characterWidth) / 120) * lineHeight + padding * 2;
    return [width, height];
};
function bumpAnnotations(adjustableNotes, processor, size, propsPointSizeFunction, propsLabelSizeFunction) {
    var _a = processor.padding, padding = _a === void 0 ? 1 : _a, _b = processor.characterWidth, characterWidth = _b === void 0 ? 8 : _b, _c = processor.lineHeight, lineHeight = _c === void 0 ? 20 : _c, _d = processor.iterations, iterations = _d === void 0 ? 500 : _d, _e = processor.pointSizeFunction, pointSizeFunction = _e === void 0 ? propsPointSizeFunction : _e, _f = processor.labelSizeFunction, labelSizeFunction = _f === void 0 ? propsLabelSizeFunction || basicLabelSizeFunction : _f;
    var labels = adjustableNotes.map(function (d, i) {
        var anchorX = (d.props.noteData.x[0] || d.props.noteData.x) +
            (d.props.noteData.dx !== undefined
                ? d.props.noteData.dx
                : ((i % 3) - 1) * -10);
        var anchorY = (d.props.noteData.y[0] || d.props.noteData.y) +
            (d.props.noteData.dy !== undefined
                ? d.props.noteData.dy
                : ((i % 3) - 1) * 10);
        var _a = __read(labelSizeFunction(d.props.noteData, characterWidth, lineHeight, padding), 2), labelWidth = _a[0], labelHeight = _a[1];
        return {
            x: anchorX,
            y: anchorY,
            above: anchorY < d.props.noteData.y,
            left: anchorX < d.props.noteData.x,
            width: labelWidth,
            height: labelHeight,
            type: "label",
            name: "",
            originalNote: d
        };
    });
    var points = adjustableNotes.map(function (d) { return ({
        x: d.props.noteData.x,
        y: d.props.noteData.y,
        fx: d.props.noteData.x,
        fy: d.props.noteData.y,
        r: (pointSizeFunction && pointSizeFunction(d.props.noteData)) || 5,
        type: "point",
        originalNote: d
    }); });
    var instantiatedLabeler = labeler();
    instantiatedLabeler.label(labels);
    instantiatedLabeler.anchor(points);
    instantiatedLabeler.width(size[0]);
    instantiatedLabeler.height(size[1]);
    instantiatedLabeler.start(iterations);
    labels.forEach(function (d) {
        if (d.type === "label") {
            var adjusted = adjustedXY(d.originalNote.props.noteData, d, padding);
            d.originalNote.props.noteData.nx = adjusted[0];
            d.originalNote.props.noteData.ny = adjusted[1];
        }
    });
    return adjustableNotes;
}
function adjustedXY(note, calculated, padding) {
    if (note.y > calculated.y) {
        //below
        return [
            calculated.x + calculated.width / 2 + padding / 2,
            calculated.y - calculated.height + padding / 2
        ];
    }
    return [calculated.x + calculated.width / 2, calculated.y];
}

var typeHash = {
    fill: function (style) { return React.createElement("rect", { style: style, width: 20, height: 20 }); },
    line: function (style) { return React.createElement("line", { style: style, x1: 0, y1: 0, x2: 20, y2: 20 }); }
};
function renderType(item, i, type, styleFn) {
    var renderedType;
    if (typeof type === "function") {
        renderedType = type(item);
    }
    else {
        var Type = typeHash[type];
        var style = styleFn(item, i);
        renderedType = Type(style);
    }
    return renderedType;
}
var renderLegendGroupVertical = function (legendGroup, customClickBehavior) {
    var _a = legendGroup.type, type = _a === void 0 ? "fill" : _a, styleFn = legendGroup.styleFn, items = legendGroup.items;
    var renderedItems = [];
    var itemOffset = 0;
    items.forEach(function (item, i) {
        var renderedType = renderType(item, i, type, styleFn);
        renderedItems.push(React.createElement("g", { key: "legend-item-" + i, transform: "translate(0," + itemOffset + ")", onClick: customClickBehavior ? function () { return customClickBehavior(item); } : undefined, style: {
                cursor: customClickBehavior ? "pointer" : "default"
            } },
            renderedType,
            React.createElement("text", { y: 15, x: 30 }, item.label)));
        itemOffset += 25;
    });
    return renderedItems;
};
var renderLegendGroupHorizontal = function (legendGroup, customClickBehavior) {
    var _a = legendGroup.type, type = _a === void 0 ? "fill" : _a, styleFn = legendGroup.styleFn, items = legendGroup.items;
    var renderedItems = [];
    var itemOffset = 0;
    items.forEach(function (item, i) {
        var renderedType = renderType(item, i, type, styleFn);
        renderedItems.push(React.createElement("g", { key: "legend-item-" + i, transform: "translate(" + itemOffset + ",0)", onClick: customClickBehavior ? function () { return customClickBehavior(item); } : undefined, style: {
                cursor: customClickBehavior ? "pointer" : "default"
            } },
            renderedType,
            React.createElement("text", { y: 15, x: 25 }, item.label)));
        itemOffset += 35;
        itemOffset += item.label.length * 8;
    });
    return { items: renderedItems, offset: itemOffset };
};
var renderVerticalGroup = function (_a) {
    var legendGroups = _a.legendGroups, width = _a.width, customClickBehavior = _a.customClickBehavior;
    var offset = 30;
    var renderedGroups = [];
    legendGroups.forEach(function (l, i) {
        offset += 5;
        renderedGroups.push(React.createElement("line", { key: "legend-top-line legend-symbol-" + i, stroke: "gray", x1: 0, y1: offset, x2: width, y2: offset }));
        offset += 10;
        if (l.label) {
            offset += 20;
            renderedGroups.push(React.createElement("text", { key: "legend-text-" + i, y: offset, className: "legend-group-label" }, l.label));
            offset += 10;
        }
        renderedGroups.push(React.createElement("g", { key: "legend-group-" + i, className: "legend-item", transform: "translate(0," + offset + ")" }, renderLegendGroupVertical(l, customClickBehavior)));
        offset += l.items.length * 25 + 10;
    });
    return renderedGroups;
};
var renderHorizontalGroup = function (_a) {
    var legendGroups = _a.legendGroups, title = _a.title, height = _a.height, customClickBehavior = _a.customClickBehavior;
    var offset = 0;
    var renderedGroups = [];
    var verticalOffset = title === false ? 10 : 40;
    legendGroups.forEach(function (l, i) {
        if (l.label) {
            renderedGroups.push(React.createElement("text", { key: "legend-text-" + i, transform: "translate(" + offset + "," + verticalOffset + ") rotate(90)", textAnchor: "start", className: "legend-group-label" }, l.label));
            offset += 20;
        }
        var renderedItems = renderLegendGroupHorizontal(l, customClickBehavior);
        renderedGroups.push(React.createElement("g", { key: "legend-group-" + i, className: "legend-item", transform: "translate(" + offset + "," + verticalOffset + ")" }, renderedItems.items));
        offset += renderedItems.offset + 5;
        if (legendGroups[i + 1]) {
            renderedGroups.push(React.createElement("line", { key: "legend-top-line legend-symbol-" + i, stroke: "gray", x1: offset, y1: verticalOffset - 10, x2: offset, y2: height + verticalOffset + 10 }));
        }
        offset += 15;
    });
    return (React.createElement("g", null,
        title !== false && (React.createElement("line", { x1: 0, x2: offset + 10, y1: verticalOffset - 10, y2: verticalOffset - 10, stroke: "gray", className: "title-neatline" })),
        renderedGroups));
};
function Legend(props) {
    var legendGroups = props.legendGroups, customClickBehavior = props.customClickBehavior, _a = props.title, title = _a === void 0 ? "Legend" : _a, _b = props.width, width = _b === void 0 ? 100 : _b, _c = props.height, height = _c === void 0 ? 20 : _c, _d = props.orientation, orientation = _d === void 0 ? "vertical" : _d;
    var renderedGroups = orientation === "vertical"
        ? renderVerticalGroup({
            legendGroups: legendGroups,
            width: width,
            customClickBehavior: customClickBehavior
        })
        : renderHorizontalGroup({
            legendGroups: legendGroups,
            title: title,
            height: height,
            customClickBehavior: customClickBehavior
        });
    return (React.createElement("g", null,
        title !== undefined && (React.createElement("text", { className: "legend-title", y: 20, x: orientation === "horizontal" ? 0 : width / 2, textAnchor: orientation === "horizontal" ? "start" : "middle" }, title)),
        renderedGroups));
}

var interactivityFns = ["onDragEnd", "onDragStart", "onDrag"];
function SemioticAnnotation(props) {
    var baseNoteData = props.noteData;
    var screenCoordinates = baseNoteData.screenCoordinates;
    var noteData = __assign({}, baseNoteData);
    interactivityFns.forEach(function (d) {
        if (baseNoteData[d]) {
            delete noteData[d];
            var originalFn_1 = baseNoteData[d];
            noteData[d] = function (updatedSettingsFromRA) {
                originalFn_1({
                    originalSettings: baseNoteData,
                    updatedSettings: updatedSettingsFromRA,
                    noteIndex: baseNoteData.i
                });
            };
        }
    });
    var AnnotationType = typeof noteData.type === "function" ? noteData.type : AnnotationLabel;
    var eventListeners = noteData.eventListeners || noteData.events || {};
    var finalStyle = {};
    if (noteData.events || noteData.eventListeners || noteData.editMode) {
        finalStyle.pointerEvents = "all";
    }
    if (noteData.coordinates && screenCoordinates) {
        //Multisubject annotation
        var setNX_1 = noteData.nx || screenCoordinates[0][0] + noteData.dx;
        var setNY_1 = noteData.ny || screenCoordinates[0][1] + noteData.dy;
        var notes = screenCoordinates.map(function (d, i) {
            var subjectNote = Object.assign({}, noteData, {
                note: i === 0 ? noteData.note : { label: "" },
                x: d[0],
                y: d[1],
                nx: setNX_1,
                ny: setNY_1
            });
            return React.createElement(AnnotationType, __assign({ key: "multi-annotation-" + i }, subjectNote));
        });
        return (React.createElement("g", __assign({}, eventListeners, { style: finalStyle }), notes));
    }
    var keyData = noteData.note || { title: "none", label: noteData.label };
    var annotationKey = keyData.label + "-" + keyData.title + "-" + noteData.i;
    var finalAnnotation = (React.createElement(AnnotationType, __assign({ key: annotationKey, events: eventListeners }, noteData)));
    if (finalStyle.pointerEvents) {
        return React.createElement("g", { style: finalStyle }, finalAnnotation);
    }
    return finalAnnotation;
}

function SpanOrDiv(props) {
    var style = props.style, className = props.className, span = props.span, children = props.children;
    if (span)
        return (React.createElement("span", { className: className, style: __assign({ display: "block" }, style) }, children));
    return (React.createElement("div", { className: className, style: style }, children));
}
var HOCSpanOrDiv = function (span) {
    if (span) {
        return function (props) {
            var className = props.className, style = props.style, children = props.children;
            return (React.createElement("span", { className: className, style: __assign({ display: "block" }, style) }, children));
        };
    }
    return function (props) {
        var className = props.className, style = props.style, children = props.children;
        return (React.createElement("div", { className: className, style: style }, children));
    };
};

function safeStringify(value) {
    var seen = new Set();
    return JSON.stringify(value, function (k, v) {
        if (seen.has(v)) {
            return "...";
        }
        if (typeof v === "object") {
            if (Array.isArray(v)) {
                return "...";
            }
            seen.add(v);
        }
        return v;
    });
}
var keyFromSVGAnnotations = function (adjustableAnnotations, annotationProcessor, size) {
    return "" + adjustableAnnotations
        .map(adjustedAnnotationKeyMapper)
        .join(",") + JSON.stringify(annotationProcessor) + size.join(",");
};
function marginOffsetFn(orient, axisSettings, marginOffset) {
    if (typeof marginOffset === "number") {
        return marginOffset;
    }
    if (axisSettings && axisSettings.find(function (d) { return d.props.orient === orient; })) {
        return 50;
    }
    return 10;
}
function adjustedAnnotationKeyMapper(d) {
    var _a;
    if (!((_a = d.props) === null || _a === void 0 ? void 0 : _a.noteData)) {
        return "";
    }
    var _b = d.props.noteData.note, note = _b === void 0 ? {} : _b;
    var label = note.label, title = note.title;
    var id = d.props.noteData.id || d.props.noteData.x + "-" + d.props.noteData.y;
    return id + "-" + label + "=" + title;
}
function noteDataWidth(noteData, charWidth, layoutNoteWidth) {
    if (charWidth === void 0) { charWidth = 8; }
    var _a = noteData.noteWidth, noteWidth = _a === void 0 ? layoutNoteWidth : _a;
    var noteWidthFn = noteWidth;
    if (typeof noteWidth === "number") {
        noteWidthFn = function () { return noteWidth; };
    }
    var wrap = (noteData.note && noteData.note.wrap) || 120;
    var noteText = noteData.note.label || noteData.note.label || "";
    var width = (noteWidth && noteWidthFn(noteData)) ||
        (React.isValidElement(noteData.note)
            ? 100
            : Math.min(wrap, noteText.length * charWidth));
    return width;
}
function noteDataHeight(noteData, charWidth, lineHeight, layoutNoteHeight) {
    if (charWidth === void 0) { charWidth = 8; }
    if (lineHeight === void 0) { lineHeight = 20; }
    var _a = noteData.noteHeight, noteHeight = _a === void 0 ? layoutNoteHeight : _a;
    var noteHeightFn = noteHeight;
    if (typeof noteHeight === "number") {
        noteHeightFn = function () { return noteHeight; };
    }
    var wrap = (noteData.note && noteData.note.wrap) || 120;
    var text = noteData.note.label || noteData.note.title || "";
    var height = (noteHeight && noteHeightFn(noteData)) ||
        (React.isValidElement(noteData.note)
            ? 30
            : Math.ceil((text.length * charWidth) / wrap) * lineHeight +
                (noteData.note.label && noteData.note.title ? lineHeight : 0));
    return height;
}
var processAnnotations = function (adjustableAnnotations, annotationProcessor, props) {
    var _a = annotationProcessor.layout, layout = _a === void 0 ? { type: false, noteHeight: undefined, noteWidth: undefined } : _a;
    if (layout.type === false) {
        return adjustableAnnotations;
    }
    var layoutNoteHeight = layout.noteWidth, layoutNoteWidth = layout.noteHeight;
    var _b = props.margin, margin = _b === void 0 ? { top: 0, bottom: 0, left: 0, right: 0 } : _b;
    var size = props.size, _c = props.axes, axes = _c === void 0 ? [] : _c;
    margin =
        typeof margin === "number"
            ? { top: margin, left: margin, right: margin, bottom: margin }
            : margin;
    if (layout.type === "bump") {
        var adjustedAnnotations = bumpAnnotations(adjustableAnnotations, layout, size, props.pointSizeFunction, props.labelSizeFunction);
        return adjustedAnnotations;
    }
    else if (layout.type === "marginalia") {
        var marginOffset_1 = layout.marginOffset, _d = layout.orient, orient = _d === void 0 ? "nearest" : _d, _e = layout.characterWidth, characterWidth_1 = _e === void 0 ? 8 : _e, _f = layout.lineHeight, lineHeight_1 = _f === void 0 ? 20 : _f, _g = layout.padding, padding_1 = _g === void 0 ? 2 : _g, _h = layout.axisMarginOverride, axisMarginOverride = _h === void 0 ? {} : _h;
        var finalOrientation = orient === "nearest"
            ? ["left", "right", "top", "bottom"]
            : Array.isArray(orient)
                ? orient
                : [orient];
        var leftOn_1 = finalOrientation.find(function (d) { return d === "left"; });
        var rightOn_1 = finalOrientation.find(function (d) { return d === "right"; });
        var topOn_1 = finalOrientation.find(function (d) { return d === "top"; });
        var bottomOn_1 = finalOrientation.find(function (d) { return d === "bottom"; });
        var leftNodes_1 = [];
        var rightNodes_1 = [];
        var topNodes_1 = [];
        var bottomNodes_1 = [];
        adjustableAnnotations.forEach(function (aNote) {
            var noteData = aNote.props.noteData;
            var noteX = noteData.x[0] || noteData.x;
            var noteY = noteData.y[0] || noteData.y;
            var leftDist = leftOn_1 ? noteX : Infinity;
            var rightDist = rightOn_1 ? size[0] - noteX : Infinity;
            var topDist = topOn_1 ? noteY : Infinity;
            var bottomDist = bottomOn_1 ? size[1] - noteY : Infinity;
            var minDist = Math.min(leftDist, rightDist, topDist, bottomDist);
            if (leftDist === minDist) {
                leftNodes_1.push(aNote);
            }
            else if (rightDist === minDist) {
                rightNodes_1.push(aNote);
            }
            else if (topDist === minDist) {
                topNodes_1.push(aNote);
            }
            else {
                bottomNodes_1.push(aNote);
            }
        });
        //Adjust the margins based on which regions are active
        var leftForce = new labella.Force({
            minPos: axisMarginOverride.top !== undefined
                ? 0 + axisMarginOverride.top
                : 0 - margin.top,
            maxPos: axisMarginOverride.bottom !== undefined
                ? size[1] - axisMarginOverride.bottom
                : bottomOn_1
                    ? size[1]
                    : size[1] + margin.bottom
        })
            .nodes(leftNodes_1.map(function (d) {
            var noteY = d.props.noteData.y[0] || d.props.noteData.y;
            return new labella.Node(noteY, noteDataHeight(d.props.noteData, characterWidth_1, lineHeight_1, layoutNoteHeight) + padding_1);
        }))
            .compute();
        var rightForce = new labella.Force({
            minPos: axisMarginOverride.top !== undefined
                ? 0 + axisMarginOverride.top
                : topOn_1
                    ? 0
                    : 0 - margin.top,
            maxPos: axisMarginOverride.bottom !== undefined
                ? size[1] - axisMarginOverride.bottom
                : size[1] + margin.bottom
        })
            .nodes(rightNodes_1.map(function (d) {
            var noteY = d.props.noteData.y[0] || d.props.noteData.y;
            return new labella.Node(noteY, noteDataHeight(d.props.noteData, characterWidth_1, lineHeight_1, layoutNoteHeight) + padding_1);
        }))
            .compute();
        var topForce = new labella.Force({
            minPos: axisMarginOverride.left !== undefined
                ? 0 + axisMarginOverride.left
                : leftOn_1
                    ? 0
                    : 0 - margin.left,
            maxPos: axisMarginOverride.right !== undefined
                ? size[0] - axisMarginOverride.right
                : size[0] + margin.right
        })
            .nodes(topNodes_1.map(function (d) {
            var noteX = d.props.noteData.x[0] || d.props.noteData.x;
            return new labella.Node(noteX, noteDataWidth(d.props.noteData, characterWidth_1, layoutNoteWidth) +
                padding_1);
        }))
            .compute();
        var bottomForce = new labella.Force({
            minPos: axisMarginOverride.left !== undefined
                ? 0 + axisMarginOverride.left
                : 0 - margin.left,
            maxPos: axisMarginOverride.right !== undefined
                ? size[0] - axisMarginOverride.right
                : rightOn_1
                    ? size[0]
                    : size[0] + margin.right
        })
            .nodes(bottomNodes_1.map(function (d) {
            var noteX = d.props.noteData.x[0] || d.props.noteData.x;
            return new labella.Node(noteX, noteDataWidth(d.props.noteData, characterWidth_1, layoutNoteWidth) +
                padding_1);
        }))
            .compute();
        var bottomOffset_1 = Math.max.apply(Math, __spread(bottomNodes_1.map(function (d) {
            return noteDataHeight(d.props.noteData, characterWidth_1, lineHeight_1, layoutNoteHeight) + padding_1;
        })));
        var topOffset_1 = Math.max.apply(Math, __spread(topNodes_1.map(function (d) {
            return noteDataHeight(d.props.noteData, characterWidth_1, lineHeight_1, layoutNoteHeight) + padding_1;
        })));
        var leftOffset_1 = Math.max.apply(Math, __spread(leftNodes_1.map(function (d) {
            return noteDataWidth(d.props.noteData, characterWidth_1, layoutNoteWidth) +
                padding_1;
        })));
        var rightOffset_1 = Math.max.apply(Math, __spread(rightNodes_1.map(function (d) {
            return noteDataWidth(d.props.noteData, characterWidth_1, layoutNoteWidth) +
                padding_1;
        })));
        //      const nodeOffsetHeight = Math.max()
        var leftSortedNodes_1 = leftForce.nodes();
        var rightSortedNodes_1 = rightForce.nodes();
        var topSortedNodes_1 = topForce.nodes();
        var bottomSortedNodes_1 = bottomForce.nodes();
        leftNodes_1.forEach(function (note, i) {
            var x = 0 -
                leftSortedNodes_1[i].layerIndex * leftOffset_1 -
                marginOffsetFn("left", axes, marginOffset_1);
            var y = leftSortedNodes_1[i].currentPos;
            note.props.noteData.nx = x;
            note.props.noteData.ny = y;
            if (note.props.noteData.note && !React.isValidElement(note)) {
                note.props.noteData.note.orientation =
                    note.props.noteData.note.orientation || "leftRight";
                note.props.noteData.note.align =
                    note.props.noteData.note.align || "right";
            }
        });
        rightNodes_1.forEach(function (note, i) {
            var x = size[0] +
                rightSortedNodes_1[i].layerIndex * rightOffset_1 +
                marginOffsetFn("right", axes, marginOffset_1);
            var y = rightSortedNodes_1[i].currentPos;
            note.props.noteData.nx = x;
            note.props.noteData.ny = y;
            if (note.props.noteData.note && !React.isValidElement(note)) {
                note.props.noteData.note.orientation =
                    note.props.noteData.note.orientation || "leftRight";
                note.props.noteData.note.align =
                    note.props.noteData.note.align || "left";
            }
        });
        topNodes_1.forEach(function (note, i) {
            var x = topSortedNodes_1[i].currentPos;
            var y = 0 -
                topSortedNodes_1[i].layerIndex * topOffset_1 -
                marginOffsetFn("top", axes, marginOffset_1);
            note.props.noteData.nx = x;
            note.props.noteData.ny = y;
        });
        bottomNodes_1.forEach(function (note, i) {
            var x = bottomSortedNodes_1[i].currentPos;
            var y = size[1] +
                bottomSortedNodes_1[i].layerIndex * bottomOffset_1 +
                marginOffsetFn("bottom", axes, marginOffset_1);
            note.props.noteData.nx = x;
            note.props.noteData.ny = y;
        });
        return adjustableAnnotations;
    }
    return adjustableAnnotations;
};
var generateSVGAnnotations = function (props, annotations) {
    var renderedAnnotations = annotations
        .map(function (d, i) { return props.svgAnnotationRule(d, i, props); })
        .filter(function (d) { return d !== null && d !== undefined; });
    return renderedAnnotations;
};
var generateHTMLAnnotations = function (props, annotations) {
    var renderedAnnotations = annotations
        .map(function (d, i) { return props.htmlAnnotationRule(d, i, props); })
        .filter(function (d) { return d !== null && d !== undefined; });
    return renderedAnnotations;
};
var createAnnotations = function (props, state) {
    var adjustedAnnotations = state.adjustedAnnotations, adjustableAnnotationsKey = state.adjustedAnnotationsKey, adjustableAnnotations = state.adjustableAnnotations, fixedAnnotations = state.fixedAnnotations;
    var renderedSVGAnnotations = [];
    var renderedHTMLAnnotations = [];
    var adjustedAnnotationsKey = state.adjustedAnnotationsKey, adjustedAnnotationsDataVersion = state.adjustedAnnotationsDataVersion;
    var annotations = props.annotations, _a = props.annotationHandling, annotationHandling = _a === void 0 ? false : _a, size = props.size, svgAnnotationRule = props.svgAnnotationRule, htmlAnnotationRule = props.htmlAnnotationRule;
    var annotationProcessor = typeof annotationHandling === "object"
        ? annotationHandling
        : { layout: { type: annotationHandling }, dataVersion: "" };
    var _b = annotationProcessor.dataVersion, dataVersion = _b === void 0 ? "" : _b;
    if (svgAnnotationRule) {
        var initialSVGAnnotations = generateSVGAnnotations(props, annotations);
        adjustableAnnotationsKey = keyFromSVGAnnotations(initialSVGAnnotations, annotationProcessor, size);
        if (annotationHandling === false) {
            adjustedAnnotations = adjustableAnnotations;
        }
        if (adjustedAnnotations.length !== adjustableAnnotations.length ||
            adjustedAnnotationsKey !== adjustableAnnotationsKey ||
            adjustedAnnotationsDataVersion !== dataVersion) {
            adjustedAnnotations = processAnnotations(adjustableAnnotations, annotationProcessor, props);
        }
        else {
            //Handle when style or other attributes change
            adjustedAnnotations = adjustableAnnotations.map(function (d, i) {
                var oldAnnotation = adjustedAnnotations[i];
                var newNoteData = __assign(__assign({}, oldAnnotation.props.noteData), d.props.noteData);
                return React.createElement(SemioticAnnotation, { key: d.key, noteData: newNoteData });
            });
        }
        renderedSVGAnnotations = __spread(adjustedAnnotations, fixedAnnotations);
    }
    if (htmlAnnotationRule) {
        renderedHTMLAnnotations = generateHTMLAnnotations(props, annotations);
    }
    return {
        svgAnnotations: renderedSVGAnnotations,
        htmlAnnotations: renderedHTMLAnnotations,
        adjustedAnnotations: adjustedAnnotations,
        adjustedAnnotationsKey: adjustableAnnotationsKey,
        adjustedAnnotationsDataVersion: dataVersion
    };
};
function AnnotationLayer(props) {
    var legendSettings = props.legendSettings, margin = props.margin, size = props.size, annotations = props.annotations, annotationHandling = props.annotationHandling;
    var _a = __read(useState(function () { return HOCSpanOrDiv(props.useSpans); }), 1), SpanOrDiv = _a[0];
    var annotationProcessor = typeof annotationHandling === "object"
        ? annotationHandling
        : { layout: { type: annotationHandling }, dataVersion: "" };
    var _b = annotationProcessor.dataVersion, dataVersion = _b === void 0 ? "" : _b;
    var _c = __read(useState([]), 2), adjustedAnnotations = _c[0], changeAdjustedAnnotations = _c[1];
    var _d = __read(useState([]), 2), svgAnnotations = _d[0], changeSVGAnnotations = _d[1];
    var _e = __read(useState([]), 2), htmlAnnotations = _e[0], changeHTMLAnnotations = _e[1];
    var _f = __read(useState(""), 2), adjustedAnnotationsKey = _f[0], changeAdjustedAnnotationsKey = _f[1];
    var _g = __read(useState(dataVersion), 2), adjustedAnnotationsDataVersion = _g[0], changeAdjustedAnnotationsDataVersion = _g[1];
    var initialSVGAnnotations = generateSVGAnnotations(props, annotations);
    var adjustableAnnotations = initialSVGAnnotations.filter(function (d) { return d.props && d.props.noteData && !d.props.noteData.fixedPosition; });
    var updatedAnnotationsKey = keyFromSVGAnnotations(adjustableAnnotations, annotationProcessor, size);
    useEffect(function () {
        var fixedAnnotations = initialSVGAnnotations.filter(function (d) { return !d.props || !d.props.noteData || d.props.noteData.fixedPosition; });
        var updatedState = createAnnotations(props, {
            adjustedAnnotations: adjustedAnnotations,
            adjustedAnnotationsKey: adjustedAnnotationsKey,
            adjustedAnnotationsDataVersion: adjustedAnnotationsDataVersion,
            adjustableAnnotations: adjustableAnnotations,
            fixedAnnotations: fixedAnnotations
        });
        changeAdjustedAnnotations(updatedState.adjustedAnnotations);
        changeAdjustedAnnotationsKey(updatedState.adjustedAnnotationsKey);
        changeAdjustedAnnotationsDataVersion(updatedState.adjustedAnnotationsDataVersion);
        changeSVGAnnotations(updatedState.svgAnnotations);
        changeHTMLAnnotations(updatedState.htmlAnnotations);
    }, [
        updatedAnnotationsKey,
        dataVersion,
        annotations.length,
        annotations.map(function (a) { return safeStringify(a); }).join("-")
    ]);
    var renderedLegend;
    if (legendSettings) {
        var positionHash = {
            left: [15, 15],
            right: [size[0] + 15, 15]
        };
        var _h = legendSettings.position, position = _h === void 0 ? "right" : _h, _j = legendSettings.title, title = _j === void 0 ? "Legend" : _j;
        var legendPosition = positionHash[position];
        renderedLegend = (React.createElement("g", { transform: "translate(" + legendPosition.join(",") + ")" },
            React.createElement(Legend, __assign({}, legendSettings, { title: title, position: position }))));
    }
    return (React.createElement(SpanOrDiv, { className: "annotation-layer", style: {
            position: "absolute",
            pointerEvents: "none",
            background: "none"
        } },
        React.createElement("svg", { className: "annotation-layer-svg", height: size[1], width: size[0], style: {
                background: "none",
                pointerEvents: "none",
                position: "absolute",
                left: margin.left + "px",
                top: margin.top + "px",
                overflow: "visible"
            } },
            React.createElement("g", null,
                renderedLegend,
                svgAnnotations)),
        React.createElement(SpanOrDiv, { className: "annotation-layer-html", style: {
                background: "none",
                pointerEvents: "none",
                position: "absolute",
                height: size[1] + "px",
                width: size[0] + "px",
                left: margin.left + "px",
                top: margin.top + "px"
            } }, htmlAnnotations)));
}

var findFirstAccessorValue = function (accessorArray, data) {
    for (var i = 0; i < accessorArray.length; i++) {
        var valueCheck = accessorArray[i](data);
        if (valueCheck !== undefined &&
            !Number.isNaN(valueCheck) &&
            valueCheck !== null)
            return valueCheck;
    }
    return undefined;
};

var datesForUnique = function (d) { return (d instanceof Date ? d.getTime() : d); };
var projectSummaryData = function (_a) {
    var data = _a.data, summaryDataAccessor = _a.summaryDataAccessor, xAccessor = _a.xAccessor, yAccessor = _a.yAccessor;
    var projectedData = [];
    summaryDataAccessor.forEach(function (actualSummaryAccessor) {
        xAccessor.forEach(function (actualXAccessor) {
            yAccessor.forEach(function (actualYAccessor) {
                var projection = function (d) {
                    return actualSummaryAccessor(d).map(function (p, q) { return [
                        actualXAccessor(p, q),
                        actualYAccessor(p, q)
                    ]; });
                };
                data.forEach(function (d) {
                    projectedData.push(__assign(__assign({}, d), { _baseData: actualSummaryAccessor(d), _xyfCoordinates: projection(d) }));
                });
            });
        });
    });
    return projectedData;
};
var projectLineData = function (_a) {
    var data = _a.data, lineDataAccessor = _a.lineDataAccessor, xProp = _a.xProp, xPropTop = _a.xPropTop, xPropBottom = _a.xPropBottom, yProp = _a.yProp, yPropTop = _a.yPropTop, yPropBottom = _a.yPropBottom, xAccessor = _a.xAccessor, yAccessor = _a.yAccessor;
    if (!Array.isArray(data)) {
        data = [data];
    }
    var projectedLine = [];
    lineDataAccessor.forEach(function (actualLineAccessor, lineIndex) {
        xAccessor.forEach(function (actualXAccessor, xIndex) {
            yAccessor.forEach(function (actualYAccessor, yIndex) {
                data.forEach(function (d) {
                    var originalLineData = __assign(__assign({}, d), { xIndex: xIndex, yIndex: yIndex, lineIndex: lineIndex });
                    originalLineData.data = actualLineAccessor(d).map(function (p, q) {
                        var originalCoords = { data: p };
                        originalCoords[xProp] = actualXAccessor(p, q);
                        originalCoords[xPropTop] = originalCoords[xProp];
                        originalCoords[xPropBottom] = originalCoords[xProp];
                        originalCoords[yProp] = actualYAccessor(p, q);
                        originalCoords[yPropTop] = originalCoords[yProp];
                        originalCoords[yPropBottom] = originalCoords[yProp];
                        return originalCoords;
                    });
                    originalLineData.key = originalLineData.key || projectedLine.length;
                    projectedLine.push(originalLineData);
                });
            });
        });
    });
    return projectedLine;
};
var differenceLine = function (_a) {
    var data = _a.data, yProp = _a.yProp, yPropTop = _a.yPropTop, yPropBottom = _a.yPropBottom;
    data.forEach(function (l, i) {
        l.data.forEach(function (point, q) {
            var otherLine = i === 0 ? 1 : 0;
            if (point[yProp] > data[otherLine].data[q][yProp]) {
                point[yPropBottom] = data[otherLine].data[q][yProp];
                point[yPropTop] = point[yProp];
            }
            else {
                point[yPropTop] = point[yProp];
                point[yPropBottom] = point[yProp];
            }
        });
    });
    return data;
};
var stackedArea = function (_a) {
    var _b = _a.type, type = _b === void 0 ? "stackedarea" : _b, data = _a.data, xProp = _a.xProp, yProp = _a.yProp, yPropMiddle = _a.yPropMiddle, sort = _a.sort, yPropTop = _a.yPropTop, yPropBottom = _a.yPropBottom;
    var uniqXValues = data
        .map(function (d) { return d.data.map(function (p) { return datesForUnique(p[xProp]); }); })
        .reduce(function (a, b) { return a.concat(b); }, [])
        .reduce(function (p, c) {
        if (p.indexOf(c) === -1) {
            p.push(c);
        }
        return p;
    }, []);
    var stackSort = function (a, b) {
        return sum(b.data.map(function (p) { return p[yProp]; })) - sum(a.data.map(function (p) { return p[yProp]; }));
    };
    if (type === "stackedpercent-invert" || type === "stackedarea-invert") {
        stackSort = function (a, b) {
            return sum(a.data.map(function (p) { return p[yProp]; })) - sum(b.data.map(function (p) { return p[yProp]; }));
        };
    }
    sort = sort === undefined ? stackSort : sort;
    if (sort !== null) {
        data = data.sort(sort);
    }
    uniqXValues.forEach(function (xValue) {
        var negativeOffset = 0;
        var positiveOffset = 0;
        var stepValues = data
            .map(function (d) { return d.data.filter(function (p) { return datesForUnique(p[xProp]) === xValue; }); })
            .reduce(function (a, b) { return a.concat(b); }, []);
        var positiveStepTotal = sum(stepValues.map(function (d) { return (d[yProp] > 0 ? d[yProp] : 0); }));
        var negativeStepTotal = sum(stepValues.map(function (d) { return (d[yProp] < 0 ? d[yProp] : 0); }));
        stepValues.forEach(function (l) {
            if (l[yProp] < 0) {
                if (type === "linepercent" ||
                    type === "stackedpercent" ||
                    type === "stackedpercent-invert") {
                    var percent = l[yProp] / negativeStepTotal;
                    l.percent = percent;
                    if (type === "linepercent") {
                        l[yPropBottom] = l[yPropBottom] = l[yPropTop] = l[yPropMiddle] = percent;
                    }
                    else {
                        var adjustment = negativeStepTotal >= 0 ? 0 : percent;
                        l[yPropBottom] =
                            negativeStepTotal === 0
                                ? 0
                                : -(negativeOffset / negativeStepTotal);
                        l[yPropTop] = l[yPropBottom] - adjustment;
                        l[yPropMiddle] = l[yPropBottom] - adjustment / 2;
                    }
                }
                else {
                    l[yPropBottom] = negativeOffset;
                    l[yPropTop] = negativeOffset + l[yProp];
                    l[yPropMiddle] = negativeOffset + l[yProp] / 2;
                }
                negativeOffset += l[yProp];
            }
            else {
                if (type === "linepercent" ||
                    type === "stackedpercent" ||
                    type === "stackedpercent-invert") {
                    var percent = l[yProp] / positiveStepTotal;
                    l.percent = percent;
                    if (type === "linepercent") {
                        l[yPropBottom] = l[yPropTop] = l[yPropMiddle] = percent;
                    }
                    else {
                        var adjustment = positiveStepTotal <= 0 ? 0 : percent;
                        l[yPropBottom] =
                            positiveStepTotal === 0 ? 0 : positiveOffset / positiveStepTotal;
                        l[yPropTop] = l[yPropBottom] + adjustment;
                        l[yPropMiddle] = l[yPropBottom] + adjustment / 2;
                    }
                }
                else {
                    l[yPropBottom] = positiveOffset;
                    l[yPropTop] = positiveOffset + l[yProp];
                    l[yPropMiddle] = positiveOffset + l[yProp] / 2;
                }
                positiveOffset += l[yProp];
            }
        });
    });
    return data;
};
var lineChart = function (_a) {
    var data = _a.data, y1 = _a.y1, x1 = _a.x1, yPropTop = _a.yPropTop, yPropMiddle = _a.yPropMiddle, yPropBottom = _a.yPropBottom, xPropTop = _a.xPropTop, xPropMiddle = _a.xPropMiddle, xPropBottom = _a.xPropBottom;
    if (y1) {
        data.forEach(function (d) {
            d.data.forEach(function (p) {
                p[yPropBottom] = y1(p);
                p[yPropMiddle] = (p[yPropBottom] + p[yPropTop]) / 2;
            });
        });
    }
    if (x1) {
        data.forEach(function (d) {
            d.data.forEach(function (p) {
                p[xPropBottom] = x1(p);
                p[xPropMiddle] = (p[xPropBottom] + p[xPropTop]) / 2;
            });
        });
    }
    return data;
};
var cumulativeLine = function (_a) {
    var data = _a.data, y1 = _a.y1, yPropTop = _a.yPropTop, yPropMiddle = _a.yPropMiddle, yPropBottom = _a.yPropBottom, _b = _a.type, type = _b === void 0 ? "cumulative" : _b;
    data.forEach(function (d) {
        var cumulativeValue = 0;
        var dataArray = type === "cumulative-reverse" ? d.data.reverse() : d.data;
        dataArray.forEach(function (p) {
            cumulativeValue += p[yPropTop];
            p[yPropBottom] = p[yPropTop] = p[yPropMiddle] = cumulativeValue;
            if (y1) {
                p[yPropBottom] = y1(p);
                p[yPropMiddle] = p[yPropBottom] + p[yPropTop] / 2;
            }
        });
    });
    return data;
};
var bumpChart = function (_a) {
    var _b = _a.type, type = _b === void 0 ? "bumpline" : _b, data = _a.data, xProp = _a.xProp, yProp = _a.yProp, yPropMiddle = _a.yPropMiddle, yPropTop = _a.yPropTop, yPropBottom = _a.yPropBottom;
    var uniqXValues = data
        .map(function (d) { return d.data.map(function (p) { return datesForUnique(p[xProp]); }); })
        .reduce(function (a, b) { return a.concat(b); }, [])
        .reduce(function (p, c) {
        if (p.indexOf(c) === -1) {
            p.push(c);
        }
        return p;
    }, []);
    var bumpSort = function (a, b) {
        if (a[yProp] > b[yProp]) {
            return 1;
        }
        if (a[yProp] < b[yProp]) {
            return -1;
        }
        return -1;
    };
    if (type === "bumparea-invert" || type === "bumpline-invert") {
        bumpSort = function (a, b) {
            if (a[yProp] < b[yProp]) {
                return 1;
            }
            if (a[yProp] > b[yProp]) {
                return -1;
            }
            return -1;
        };
    }
    uniqXValues.forEach(function (xValue) {
        var negativeOffset = 0;
        var positiveOffset = 0;
        data
            .map(function (d) { return d.data.filter(function (p) { return datesForUnique(p[xProp]) === xValue; }); })
            .reduce(function (a, b) { return a.concat(b); }, [])
            .sort(bumpSort)
            .forEach(function (l, rank) {
            //determine ranking and offset by the number of less than this one at each step
            l._XYFrameRank = rank + 1;
            if (type === "bumparea" || type === "bumparea-invert") {
                if (l[yProp] < 0) {
                    l[yPropTop] = negativeOffset + l[yProp];
                    l[yPropMiddle] = negativeOffset + l[yProp] / 2;
                    l[yPropBottom] = negativeOffset;
                    negativeOffset += l[yProp];
                }
                else {
                    l[yPropTop] = positiveOffset + l[yProp];
                    l[yPropMiddle] = positiveOffset + l[yProp] / 2;
                    l[yPropBottom] = positiveOffset;
                    positiveOffset += l[yProp];
                }
            }
            else {
                l[yProp] = rank + 1;
                l[yPropTop] = rank + 1;
                l[yPropBottom] = rank + 1;
            }
        });
    });
    return data;
};
var dividedLine = function (parameters, points, searchIterations) {
    if (searchIterations === void 0) { searchIterations = 10; }
    var currentParameters = parameters(points[0], 0);
    var currentPointsArray = [];
    var dividedLinesData = [
        { key: currentParameters, points: currentPointsArray }
    ];
    points.forEach(function (point, pointI) {
        var newParameters = parameters(point, pointI);
        var matchingParams = newParameters === currentParameters;
        var stringNewParams = JSON.stringify(newParameters);
        var stringCurrentParams = JSON.stringify(currentParameters);
        if (typeof currentParameters === "object") {
            matchingParams = stringNewParams === stringCurrentParams;
        }
        if (matchingParams) {
            currentPointsArray.push(point);
        }
        else {
            var lastPoint = currentPointsArray[currentPointsArray.length - 1];
            var pointA = lastPoint;
            var pointB = point;
            var stringBParams = stringNewParams;
            var x = 0;
            while (x < searchIterations && stringNewParams === stringBParams) {
                var keys = Object.keys(pointA);
                var findPoints = simpleSearchFunction({
                    pointA: pointA,
                    pointB: pointB,
                    currentParameters: currentParameters,
                    parameters: parameters,
                    keys: keys
                });
                pointA = findPoints[0];
                pointB = findPoints[1];
                stringBParams = JSON.stringify(parameters(pointB));
                x++;
            }
            currentPointsArray.push(pointB);
            currentPointsArray = [pointB, point];
            dividedLinesData.push({ key: newParameters, points: currentPointsArray });
            currentParameters = newParameters;
        }
    });
    return dividedLinesData;
};
function simpleSearchFunction(_a) {
    var pointA = _a.pointA, pointB = _a.pointB, currentParameters = _a.currentParameters, parameters = _a.parameters, keys = _a.keys;
    var betweenPoint = {};
    keys.forEach(function (key) {
        betweenPoint[key] =
            typeof pointA[key] === "number"
                ? (pointA[key] + pointB[key]) / 2
                : undefined;
    });
    var stringBetween = JSON.stringify(parameters(betweenPoint));
    var stringCurrent = JSON.stringify(currentParameters);
    if (stringBetween === stringCurrent) {
        return [betweenPoint, pointB];
    }
    return [pointA, betweenPoint];
}
function funnelize(_a) {
    var data = _a.data, steps = _a.steps, key = _a.key;
    var funnelData = [];
    if (!Array.isArray(data)) {
        data = [data];
    }
    if (!steps) {
        steps = data.map(function (d) { return Object.keys(d); }).reduce(function (a, b) { return a.concat(b); }, []);
    }
    data.forEach(function (datum, i) {
        var datumKey = key ? datum[key] : i;
        steps.forEach(function (step) {
            var funnelDatum = { funnelKey: datumKey, stepName: "", stepValue: 0 };
            funnelDatum.stepName = step;
            funnelDatum.stepValue = datum[step] ? datum[step] : 0;
            funnelData.push(funnelDatum);
        });
    });
    return funnelData;
}
var whichPoint = {
    bottom: "yBottom",
    top: "yTop"
};
function relativeY(_a) {
    var point = _a.point, projectedY = _a.projectedY, yAccessor = _a.yAccessor, yScale = _a.yScale, showLinePoints = _a.showLinePoints;
    var baseData = point &&
        (showLinePoints &&
            showLinePoints !== true &&
            point[whichPoint[showLinePoints]] !== undefined
            ? point[whichPoint[showLinePoints]]
            : point.yMiddle !== undefined
                ? point.yMiddle
                : point[projectedY] !== undefined
                    ? point[projectedY]
                    : findFirstAccessorValue(yAccessor, point));
    if (Array.isArray(baseData)) {
        return baseData.map(function (d) { return yScale(d); });
    }
    return baseData !== undefined ? yScale(baseData) : 0;
}
function relativeX(_a) {
    var point = _a.point, projectedXMiddle = _a.projectedXMiddle, projectedX = _a.projectedX, xAccessor = _a.xAccessor, xScale = _a.xScale;
    var baseData = point &&
        (point[projectedXMiddle] !== undefined
            ? point[projectedXMiddle]
            : point[projectedX] !== undefined
                ? point[projectedX]
                : findFirstAccessorValue(xAccessor, point));
    if (Array.isArray(baseData)) {
        return baseData.map(function (d) { return xScale(d); });
    }
    return baseData !== undefined ? xScale(baseData) : 0;
}
function findPointByID(_a) {
    var point = _a.point, idAccessor = _a.idAccessor, lines = _a.lines, xScale = _a.xScale, projectedX = _a.projectedX, xAccessor = _a.xAccessor;
    var pointID = idAccessor(point.parentLine || point);
    if (pointID) {
        var thisLine = lines.data.find(function (l) { return idAccessor(l) === pointID; });
        if (!thisLine) {
            return null;
        }
        var pointX_1 = xScale(findFirstAccessorValue(xAccessor, point));
        var thisPoint = thisLine.data.find(function (p) { return xScale(p[projectedX]) === pointX_1; });
        if (!thisPoint) {
            return null;
        }
        var newPoint_1 = __assign(__assign(__assign(__assign({}, point), thisPoint), thisPoint.data), { parentLine: thisLine });
        var reactAnnotationProps = [
            "type",
            "label",
            "note",
            "connector",
            "disabled",
            "color",
            "subject"
        ];
        reactAnnotationProps.forEach(function (prop) {
            if (point[prop])
                newPoint_1[prop] = point[prop];
        });
        return newPoint_1;
    }
    return point;
}

var createLineSegments = function (props) {
    var parameters = props.parameters, className = props.className, _a = props.interpolate, interpolate = _a === void 0 ? curveLinear : _a, customAccessors = props.customAccessors, lineDataAccessor = props.lineDataAccessor, data = props.data, searchIterations = props.searchIterations, rest = __rest(props, ["parameters", "className", "interpolate", "customAccessors", "lineDataAccessor", "data", "searchIterations"]);
    var x = customAccessors.x, y = customAccessors.y;
    var lineData = projectLineData({
        data: data,
        lineDataAccessor: [lineDataAccessor],
        xProp: "x",
        yProp: "y",
        xAccessor: [x],
        yAccessor: [y]
    });
    //Compatibility before Semiotic 2
    lineData.forEach(function (projectedD) {
        projectedD.data = projectedD.data.map(function (d) { return (__assign(__assign({}, d.data), d)); });
    });
    var lines = dividedLine(parameters, lineData[0].data, searchIterations);
    var lineRender = line()
        .curve(interpolate)
        .x(function (d) { return d.x; })
        .y(function (d) { return d.y; });
    return lines.map(function (d, i) { return (React.createElement(Mark, __assign({}, rest, { className: className, markType: "path", key: "DividedLine-" + i, style: d.key, d: lineRender(d.points) }))); });
};
function DividedLine(props) {
    var lines = createLineSegments(props);
    return React.createElement("g", null, lines);
}

var flatten = function (list) {
    return list.reduce(function (a, b) { return a.concat(Array.isArray(b) ? flatten(b.sort(function (a, b) { return a - b; })) : b); }, []);
};
function flatShortArray(baseArray) {
    if (baseArray === void 0) { baseArray = []; }
    var array = __spread(baseArray);
    if (!Array.isArray(array))
        return "not-array";
    if (!Array.isArray(array[0])) {
        array = array.sort(function (a, b) { return a - b; });
    }
    var flat = flatten(array);
    var stringifiedFlattened = flat
        .map(function (d) {
        return (d instanceof Date && d.toString()) ||
            (d !== undefined && d.toFixed && d.toFixed(2)) ||
            "empty";
    })
        .toString();
    return stringifiedFlattened;
}
var createBrush$1 = function (node, props) {
    var brush = props.svgBrush, baseSelectedExtent = props.selectedExtent;
    select(node).call(brush);
    if (baseSelectedExtent) {
        var selectedExtent = baseSelectedExtent;
        if (Array.isArray(baseSelectedExtent[0])) {
            var sortedY = [selectedExtent[0][1], selectedExtent[1][1]].sort(function (a, b) { return a - b; });
            selectedExtent = [
                [selectedExtent[0][0], sortedY[0]],
                [selectedExtent[1][0], sortedY[1]]
            ];
        }
        select(node).call(brush.move, selectedExtent);
    }
};
function Brush(props) {
    var extent = props.extent, selectedExtent = props.selectedExtent;
    var node = useRef(null);
    var flatExtent = flatShortArray(extent);
    var flatSelectedExtent = flatShortArray(selectedExtent);
    useEffect(function () {
        if (node === null || node === void 0 ? void 0 : node.current) {
            createBrush$1(node.current, props);
        }
    }, [flatExtent, flatSelectedExtent, node]);
    var _a = props.position, position = _a === void 0 ? [0, 0] : _a;
    return (React.createElement("g", { transform: "translate(" + position + ")", ref: node, className: "xybrush" }));
}

var projectedX = "x";
var projectedY = "y";
var projectedYMiddle = "yMiddle";
var projectedYTop = "yTop";
var projectedYBottom = "yBottom";
var projectedXMiddle = "xMiddle";
var projectedXTop = "xTop";
var projectedXBottom = "xBottom";

var _this = window;
var constructDataObject = function (d, points) {
    if (d === undefined)
        return d;
    return d && d.data ? __assign(__assign({ points: points }, d.data), d) : __assign({ points: points }, d);
};
var changeVoronoi = function (voronoiHover, d, customHoverTypes, customHoverBehavior, points, e) {
    //Until semiotic 2
    var dataObject = constructDataObject(d, points);
    if (customHoverBehavior)
        customHoverBehavior(dataObject);
    if (!d)
        voronoiHover(null);
    else if (customHoverTypes === true) {
        var vorD = Object.assign({}, dataObject);
        vorD.type = vorD.type === "column-hover" ? "column-hover" : "frame-hover";
        voronoiHover(vorD, e);
    }
    else if (customHoverTypes) {
        var arrayWrappedHoverTypes = Array.isArray(customHoverTypes)
            ? customHoverTypes
            : [customHoverTypes];
        var mappedHoverTypes = arrayWrappedHoverTypes
            .map(function (c) {
            var finalC = typeof c === "function" ? c(dataObject) : c;
            if (!finalC)
                return undefined;
            return Object.assign({}, dataObject, finalC);
        })
            .filter(function (d) { return d; });
        voronoiHover(mappedHoverTypes, e);
    }
};
var clickVoronoi = function (d, customClickBehavior, points, e) {
    //Until semiotic 2
    var dataObject = constructDataObject(d, points);
    if (customClickBehavior)
        customClickBehavior(dataObject, e);
};
var doubleclickVoronoi = function (d, customDoubleClickBehavior, points, e) {
    //Until semiotic 2
    var dataObject = constructDataObject(d, points);
    if (customDoubleClickBehavior)
        customDoubleClickBehavior(dataObject, e);
};
var brushStart = function (e, columnName, data, columnData, interaction) {
    if (interaction && interaction.start)
        interaction.start(e, columnName, data, columnData);
};
var brushing = function (e, columnName, data, columnData, interaction) {
    if (interaction && interaction.during)
        interaction.during(e, columnName, data, columnData);
};
var brushEnd = function (e, columnName, data, columnData, interaction) {
    if (interaction && interaction.end)
        interaction.end(e, columnName, data, columnData);
};
var calculateOverlay = function (props) {
    var voronoiPaths = [];
    var xScale = props.xScale, yScale = props.yScale, points = props.points, projectedX = props.projectedX, showLinePoints = props.showLinePoints, size = props.size, overlay = props.overlay, _a = props.interactionOverflow, interactionOverflow = _a === void 0 ? { top: 0, bottom: 0, left: 0, right: 0 } : _a, customClickBehavior = props.customClickBehavior, customDoubleClickBehavior = props.customDoubleClickBehavior, customHoverBehavior = props.customHoverBehavior, hoverAnnotation = props.hoverAnnotation, voronoiHover = props.voronoiHover, margin = props.margin, _b = props.advancedSettings, advancedSettings = _b === void 0 ? {} : _b;
    var whichPoints = {
        top: projectedYTop,
        bottom: projectedYBottom
    };
    var pointerStyle = customClickBehavior || customDoubleClickBehavior
        ? { cursor: "pointer" }
        : {};
    if (points && hoverAnnotation && !overlay) {
        var _c = advancedSettings.voronoiFilter, voronoiFilter_1 = _c === void 0 ? function () { return true; } : _c;
        var voronoiDataset_1 = [];
        var voronoiUniqueHash_1 = {};
        points
            .filter(function (d) { return voronoiFilter_1(__assign(__assign({}, d), d.data)); })
            .forEach(function (d) {
            var xValue = Math.floor(xScale(d[projectedX]));
            var yValue = Math.floor(yScale(showLinePoints && d[whichPoints[showLinePoints]] !== undefined
                ? d[whichPoints[showLinePoints]]
                : d[projectedYMiddle] !== undefined
                    ? d[projectedYMiddle]
                    : d[projectedY]));
            if (xValue >= 0 - margin.left &&
                xValue <= size[0] + margin.right &&
                yValue >= 0 - margin.top &&
                yValue <= size[1] + margin.bottom &&
                xValue !== undefined &&
                yValue !== undefined &&
                isNaN(xValue) === false &&
                isNaN(yValue) === false) {
                var pointKey = xValue + "," + yValue;
                if (!voronoiUniqueHash_1[pointKey]) {
                    var voronoiPoint = __assign(__assign({}, d), { coincidentPoints: [d], voronoiX: xValue, voronoiY: yValue });
                    voronoiDataset_1.push(voronoiPoint);
                    voronoiUniqueHash_1[pointKey] = voronoiPoint;
                }
                else
                    voronoiUniqueHash_1[pointKey].coincidentPoints.push(d);
            }
        });
        var voronoiXExtent = extent$1(voronoiDataset_1.map(function (d) { return d.voronoiX; }));
        var voronoiYExtent = extent$1(voronoiDataset_1.map(function (d) { return d.voronoiY; }));
        var voronoiExtent = [
            [
                Math.min(voronoiXExtent[0] - 5, -interactionOverflow.left),
                Math.min(voronoiYExtent[0] - 5, -interactionOverflow.top)
            ],
            [
                Math.max(voronoiXExtent[1] + 5, size[0] + interactionOverflow.right),
                Math.max(voronoiYExtent[1] + 5, size[1] + interactionOverflow.bottom)
            ]
        ];
        var voronoiDiagram = voronoi()
            .extent(voronoiExtent)
            .x(function (d) { return d.voronoiX; })
            .y(function (d) { return d.voronoiY; });
        var voronoiData = voronoiDiagram.polygons(voronoiDataset_1);
        voronoiPaths = voronoiData.map(function (d, i) {
            var clipPath = null;
            if (advancedSettings.voronoiClipping) {
                var circleSize = advancedSettings.voronoiClipping === true
                    ? 50
                    : advancedSettings.voronoiClipping;
                var correspondingD = voronoiDataset_1[i];
                clipPath = (React.createElement("clipPath", { id: "voronoi-" + i },
                    React.createElement("circle", { r: circleSize, cx: correspondingD.voronoiX, cy: correspondingD.voronoiY })));
            }
            return (React.createElement("g", { key: "voronoi-" + i },
                React.createElement("path", { onClick: function (e) {
                        clickVoronoi(voronoiDataset_1[i], customClickBehavior, points, e);
                    }, onDoubleClick: function (e) {
                        doubleclickVoronoi(voronoiDataset_1[i], customDoubleClickBehavior, points, e);
                    }, onMouseEnter: function (e) {
                        changeVoronoi(voronoiHover, voronoiDataset_1[i], hoverAnnotation, customHoverBehavior, points, e);
                    }, onMouseLeave: function (e) {
                        changeVoronoi(voronoiHover, undefined, undefined, customHoverBehavior, undefined, e);
                    }, key: "interactionVoronoi" + i, d: "M" + d.join("L") + "Z", style: __assign({ fillOpacity: 0 }, pointerStyle), clipPath: "url(#voronoi-" + i + ")" }),
                clipPath));
        }, _this);
        return voronoiPaths;
    }
    else if (overlay) {
        var renderedOverlay = overlay.map(function (overlayRegion, i) {
            var overlayData = overlayRegion.overlayData, rest = __rest(overlayRegion, ["overlayData"]);
            var overlayProps = {
                key: "overlay-" + i,
                onMouseEnter: function (e) {
                    changeVoronoi(voronoiHover, overlayData, props.hoverAnnotation, customHoverBehavior, points, e);
                },
                onMouseLeave: function (e) {
                    changeVoronoi(voronoiHover, undefined, undefined, customHoverBehavior, undefined, e);
                },
                onClick: function (e) {
                    clickVoronoi(overlayData, customClickBehavior, points, e);
                },
                onDoubleClick: function (e) {
                    doubleclickVoronoi(overlayData, customDoubleClickBehavior, points, e);
                },
                style: __assign({ opacity: 0 }, pointerStyle)
            };
            if (React.isValidElement(overlayRegion.renderElement)) {
                return React.cloneElement(overlayRegion.renderElement, overlayProps);
            }
            else {
                return (React.createElement(Mark, __assign({ forceUpdate: true }, rest, { key: "overlay-" + i }, overlayProps)));
            }
        });
        return renderedOverlay;
    }
};

var emptyObjectReturnFn$1 = function () { return ({}); };
var twoPI$2 = Math.PI * 2;
var dedupeRibbonPoints = function (weight) {
    if (weight === void 0) { weight = 1; }
    return function (p, c) {
        var l = p[p.length - 1];
        if (!l ||
            Math.round(l.x / weight) !== Math.round(c.x / weight) ||
            Math.round(l.y / weight) !== Math.round(c.y / weight)) {
            p.push(c);
        }
        return p;
    };
};
var arcTweener = function (oldProps, newProps) {
    var innerRadiusInterpolator = interpolateNumber(oldProps.innerRadius, newProps.innerRadius);
    var outerRadiusInterpolator = interpolateNumber(oldProps.outerRadius, newProps.outerRadius);
    var startAngleInterpolator = interpolateNumber(oldProps.startAngle, newProps.startAngle);
    var endAngleInterpolator = interpolateNumber(oldProps.endAngle, newProps.endAngle);
    return function (t) {
        var sliceGenerator = arc()
            .innerRadius(innerRadiusInterpolator(t))
            .outerRadius(outerRadiusInterpolator(t));
        return sliceGenerator({
            startAngle: startAngleInterpolator(t),
            endAngle: endAngleInterpolator(t)
        });
    };
};
var drawAreaConnector = function (_a) {
    var x1 = _a.x1, x2 = _a.x2, y1 = _a.y1, y2 = _a.y2, sizeX1 = _a.sizeX1, sizeY1 = _a.sizeY1, sizeX2 = _a.sizeX2, sizeY2 = _a.sizeY2;
    return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + "L" + (x2 + sizeX2) + "," + (y2 + sizeY2) + "L" + (x1 +
        sizeX1) + "," + (y1 + sizeY1) + "Z";
};
var groupBarMark = function (_a) {
    var bins = _a.bins, binMax = _a.binMax, relativeBuckets = _a.relativeBuckets, columnWidth = _a.columnWidth, projection = _a.projection, adjustedSize = _a.adjustedSize, summaryI = _a.summaryI, summary = _a.summary, renderValue = _a.renderValue, summaryStyle = _a.summaryStyle, type = _a.type, baseMarkProps = _a.baseMarkProps;
    var mappedBins = [];
    var mappedPoints = [];
    var actualMax = (relativeBuckets && relativeBuckets[summary.name]) || binMax;
    var summaryElementStylingFn = type.elementStyleFn || emptyObjectReturnFn$1;
    var barPadding = type.padding || 0;
    bins.forEach(function (d, i) {
        var opacity = d.value / actualMax;
        var additionalStyle = summaryElementStylingFn(d.value, opacity, d.pieces);
        var finalStyle = type.type === "heatmap"
            ? __assign({ opacity: opacity, fill: summaryStyle.fill }, additionalStyle) : __assign(__assign({}, summaryStyle), additionalStyle);
        var thickness = Math.max(1, d.y1 - barPadding * 2);
        var finalColumnWidth = type.type === "heatmap" ? columnWidth : columnWidth * opacity;
        var yProp = d.y + barPadding;
        var xProp = type.type === "heatmap" || type.flip
            ? -columnWidth / 2
            : columnWidth / 2 - finalColumnWidth;
        var height = thickness;
        var width = finalColumnWidth;
        var xOffset = type.type === "heatmap" ? finalColumnWidth / 2 : finalColumnWidth;
        var yOffset = d.y1 / 2;
        if (projection === "horizontal") {
            yProp =
                type.type === "heatmap"
                    ? -columnWidth / 2
                    : type.flip
                        ? -columnWidth / 2
                        : columnWidth / 2 - finalColumnWidth;
            xProp = d.y - d.y1 + barPadding;
            height = finalColumnWidth;
            width = thickness;
            yOffset =
                type.type === "heatmap" ? finalColumnWidth / 2 : finalColumnWidth;
            xOffset = d.y1 / 2;
        }
        else if (projection === "radial") {
            var arcGenerator = arc()
                .innerRadius(d.y / 2)
                .outerRadius((d.y + d.y1) / 2);
            var angle = summary.pct - summary.pct_padding;
            var startAngle = summary.pct_middle - summary.pct_padding;
            var endAngle = type.type === "heatmap"
                ? startAngle + angle
                : startAngle + angle * opacity;
            startAngle *= twoPI$2;
            endAngle *= twoPI$2;
            var arcAdjustX = adjustedSize[0] / 2;
            var arcAdjustY = adjustedSize[1] / 2;
            var arcTranslate = "translate(" + arcAdjustX + "," + arcAdjustY + ")";
            var arcCenter = arcGenerator.centroid({ startAngle: startAngle, endAngle: endAngle });
            mappedPoints.push({
                key: summary.name,
                value: d.value,
                pieces: d.pieces.map(function (p) { return p.piece; }),
                label: "Heatmap",
                x: arcCenter[0] + arcAdjustX,
                y: arcCenter[1] + arcAdjustY
            });
            mappedBins.push(React.createElement(Mark, __assign({}, baseMarkProps, { markType: "path", transform: arcTranslate, renderMode: renderValue, key: "groupIcon-" + summaryI + "-" + i, d: arcGenerator({ startAngle: startAngle, endAngle: endAngle }), style: finalStyle })));
        }
        if (projection !== "radial") {
            mappedPoints.push({
                key: summary.name,
                value: d.value,
                pieces: d.pieces.map(function (p) { return p.piece; }),
                label: "Heatmap",
                x: xProp + xOffset,
                y: yProp + yOffset
            });
            mappedBins.push(React.createElement(Mark, __assign({}, baseMarkProps, { markType: "rect", renderMode: renderValue, key: "groupIcon-" + summaryI + "-" + i, x: xProp, y: yProp, height: height, width: width, style: finalStyle })));
        }
    });
    return { marks: mappedBins, points: mappedPoints };
};
// FROM d3-svg-ribbon
function linearRibbon() {
    var _lineConstructor = line();
    var _xAccessor = function (d) {
        return d.x;
    };
    var _yAccessor = function (d) {
        return d.y;
    };
    var _rAccessor = function (d) {
        return d.r;
    };
    var _interpolator = curveLinearClosed;
    function _ribbon(pathData) {
        if (pathData.multiple) {
            var original_r = _rAccessor;
            var parallelTotal_1 = pathData.multiple.reduce(function (p, c) { return p + c.weight; }, 0);
            _rAccessor = function () { return parallelTotal_1; };
            var totalPoints = buildRibbon(pathData.points);
            var currentPoints_1 = totalPoints
                .filter(function (d) { return d.direction === "forward"; })
                .reduce(dedupeRibbonPoints(), []);
            var allRibbons_1 = [];
            pathData.multiple.forEach(function (siblingPath, siblingI) {
                _rAccessor = function () { return siblingPath.weight; };
                var currentRibbon = buildRibbon(currentPoints_1);
                allRibbons_1.push(currentRibbon);
                var nextSibling = pathData.multiple[siblingI + 1];
                if (nextSibling) {
                    var currentLeftSide = currentRibbon
                        .reverse()
                        .filter(function (d) { return d.direction === "back"; })
                        .reduce(dedupeRibbonPoints(), []);
                    _rAccessor = function () { return nextSibling.weight; };
                    var leftHandInflatedRibbon = buildRibbon(currentLeftSide);
                    currentPoints_1 = leftHandInflatedRibbon
                        .reverse()
                        .filter(function (d) { return d.direction === "back"; })
                        .reduce(dedupeRibbonPoints(), []);
                }
            });
            _rAccessor = original_r;
            return allRibbons_1.map(function (d) {
                return _lineConstructor
                    .x(_xAccessor)
                    .y(_yAccessor)
                    .curve(_interpolator)(d);
            });
        }
        var bothPoints = buildRibbon(pathData).reduce(dedupeRibbonPoints(), []);
        return _lineConstructor
            .x(_xAccessor)
            .y(_yAccessor)
            .curve(_interpolator)(bothPoints);
    }
    _ribbon.x = function (_value) {
        if (!arguments.length)
            return _xAccessor;
        _xAccessor = _value;
        return _ribbon;
    };
    _ribbon.y = function (_value) {
        if (!arguments.length)
            return _yAccessor;
        _yAccessor = _value;
        return _ribbon;
    };
    _ribbon.r = function (_value) {
        if (!arguments.length)
            return _rAccessor;
        _rAccessor = _value;
        return _ribbon;
    };
    _ribbon.interpolate = function (_value) {
        if (!arguments.length)
            return _interpolator;
        _interpolator = _value;
        return _ribbon;
    };
    return _ribbon;
    function offsetEdge(d) {
        var diffX = _yAccessor(d.target) - _yAccessor(d.source);
        var diffY = _xAccessor(d.target) - _xAccessor(d.source);
        var angle0 = Math.atan2(diffY, diffX) + Math.PI / 2;
        var angle1 = angle0 + Math.PI * 0.5;
        var angle2 = angle0 + Math.PI * 0.5;
        var x1 = _xAccessor(d.source) + _rAccessor(d.source) * Math.cos(angle1);
        var y1 = _yAccessor(d.source) - _rAccessor(d.source) * Math.sin(angle1);
        var x2 = _xAccessor(d.target) + _rAccessor(d.target) * Math.cos(angle2);
        var y2 = _yAccessor(d.target) - _rAccessor(d.target) * Math.sin(angle2);
        return { x1: x1, y1: y1, x2: x2, y2: y2 };
    }
    function buildRibbon(points) {
        var bothCode = [];
        var x = 0;
        var transformedPoints = { x1: 0, y1: 0, x2: 0, y2: 0 };
        while (x < points.length) {
            if (x !== points.length - 1) {
                transformedPoints = offsetEdge({
                    source: points[x],
                    target: points[x + 1]
                });
                var p1 = {
                    x: transformedPoints.x1,
                    y: transformedPoints.y1,
                    direction: "forward"
                };
                var p2 = {
                    x: transformedPoints.x2,
                    y: transformedPoints.y2,
                    direction: "forward"
                };
                bothCode.push(p1, p2);
                if (bothCode.length > 3) {
                    var l = bothCode.length - 1;
                    var lineA = { a: bothCode[l - 3], b: bothCode[l - 2] };
                    var lineB = { a: bothCode[l - 1], b: bothCode[l] };
                    var intersect = findIntersect(lineA.a.x, lineA.a.y, lineA.b.x, lineA.b.y, lineB.a.x, lineB.a.y, lineB.b.x, lineB.b.y);
                    if (intersect.found === true) {
                        lineA.b.x = intersect.x;
                        lineA.b.y = intersect.y;
                        lineB.a.x = intersect.x;
                        lineB.a.y = intersect.y;
                    }
                }
            }
            x++;
        }
        x--;
        //Back
        while (x >= 0) {
            if (x !== 0) {
                transformedPoints = offsetEdge({
                    source: points[x],
                    target: points[x - 1]
                });
                var p1 = {
                    x: transformedPoints.x1,
                    y: transformedPoints.y1,
                    direction: "back"
                };
                var p2 = {
                    x: transformedPoints.x2,
                    y: transformedPoints.y2,
                    direction: "back"
                };
                bothCode.push(p1, p2);
                if (bothCode.length > 3) {
                    var l = bothCode.length - 1;
                    var lineA = { a: bothCode[l - 3], b: bothCode[l - 2] };
                    var lineB = { a: bothCode[l - 1], b: bothCode[l] };
                    var intersect = findIntersect(lineA.a.x, lineA.a.y, lineA.b.x, lineA.b.y, lineB.a.x, lineB.a.y, lineB.b.x, lineB.b.y);
                    if (intersect.found === true) {
                        lineA.b.x = intersect.x;
                        lineA.b.y = intersect.y;
                        lineB.a.x = intersect.x;
                        lineB.a.y = intersect.y;
                    }
                }
            }
            x--;
        }
        return bothCode;
    }
    function findIntersect(l1x1, l1y1, l1x2, l1y2, l2x1, l2y1, l2x2, l2y2) {
        var a, b;
        var result = {
            x: null,
            y: null,
            found: false
        };
        var d = (l2y2 - l2y1) * (l1x2 - l1x1) - (l2x2 - l2x1) * (l1y2 - l1y1);
        if (d === 0) {
            return result;
        }
        a = l1y1 - l2y1;
        b = l1x1 - l2x1;
        var n1 = (l2x2 - l2x1) * a - (l2y2 - l2y1) * b;
        var n2 = (l1x2 - l1x1) * a - (l1y2 - l1y1) * b;
        a = n1 / d;
        b = n2 / d;
        result.x = l1x1 + a * (l1x2 - l1x1);
        result.y = l1y1 + a * (l1y2 - l1y1);
        if (a > 0 && a < 1 && (b > 0 && b < 1)) {
            result.found = true;
        }
        return result;
    }
}

var horizontalTornTickGenerator = function (width, ticks, y, orient) {
    var step = width / ticks;
    var currentStep = 0;
    var tickPath = "M0," + y;
    var mod = orient === "right" ? -1 : 1;
    while (currentStep <= width) {
        tickPath += "L" + currentStep + "," + y;
        if (currentStep < width) {
            tickPath += "L" + (currentStep + step / 2) + "," + (y + 10 * mod);
        }
        currentStep += step;
    }
    return tickPath;
};
var verticalTornTickGenerator = function (height, ticks, x, orient) {
    var step = height / ticks;
    var currentStep = 0;
    var tickPath = "M" + x + ",0";
    var mod = orient === "bottom" ? -1 : 1;
    while (currentStep <= height) {
        tickPath += "L" + x + "," + currentStep;
        if (currentStep < height) {
            tickPath += "L" + (x + 10 * mod) + "," + (currentStep + step / 2);
        }
        currentStep += step;
    }
    return tickPath;
};
var generateTornBaseline = function (orient, baselineSettings) {
    var tornD = "";
    var x1 = baselineSettings.x1, x2 = baselineSettings.x2, y1 = baselineSettings.y1, y2 = baselineSettings.y2;
    if (orient === "left" || orient === "right") {
        var calcWidth = Math.abs(x2 - x1);
        var ticks = Math.ceil(calcWidth / 40);
        tornD = horizontalTornTickGenerator(calcWidth, ticks, orient === "right" ? 0 : y1, orient);
    }
    else {
        var calcHeight = Math.abs(y2 - y1);
        var ticks = Math.ceil(calcHeight / 40);
        tornD = verticalTornTickGenerator(calcHeight, ticks, x1, orient);
    }
    return tornD;
};
var defaultTickLineGenerator = function (_a) {
    var xy = _a.xy, orient = _a.orient, i = _a.i, baseMarkProps = _a.baseMarkProps, _b = _a.className, className = _b === void 0 ? "" : _b, jaggedBase = _a.jaggedBase;
    var genD = "M" + xy.x1 + "," + xy.y1 + "L" + xy.x2 + "," + xy.y2;
    if (jaggedBase && i === 0) {
        genD = generateTornBaseline(orient, xy);
    }
    return (React.createElement(Mark, __assign({ key: i, markType: "path", renderMode: xy.renderMode, fill: "none", stroke: "black", strokeWidth: "1px", simpleInterpolate: true, d: genD, className: "tick-line tick " + orient + " " + className }, baseMarkProps)));
};
var outboundTickLineGenerator = function (_a) {
    var xy = _a.xy, orient = _a.orient, i = _a.i, _b = _a.className, className = _b === void 0 ? "" : _b;
    var tickLength = 8;
    var genD = "M-4," + xy.y1 + "L" + xy.x1 + "," + xy.y2;
    if (orient === "left") {
        genD = "M" + (xy.x1 - tickLength) + "," + xy.y1 + "L" + xy.x1 + "," + xy.y2;
    }
    else if (orient === "right") {
        genD = "M" + xy.x2 + "," + xy.y1 + "L" + (xy.x2 + tickLength) + "," + xy.y2;
    }
    else if (orient === "top") {
        genD = "M" + xy.x1 + "," + (xy.y1 - tickLength) + "L" + xy.x1 + "," + xy.y1;
    }
    else if (orient === "bottom") {
        genD = "M" + xy.x1 + "," + xy.y2 + "L" + xy.x1 + "," + (xy.y2 + tickLength);
    }
    return (React.createElement(Mark, { key: i, markType: "path", renderMode: xy.renderMode, fill: "none", stroke: "black", strokeWidth: "1px", simpleInterpolate: true, d: genD, className: "outbound-tick-line tick " + orient + " " + className }));
};
function generateTickValues(tickValues, ticks, scale) {
    var axisSize = Math.abs(scale.range()[1] - scale.range()[0]);
    if (!tickValues) {
        if (!ticks) {
            ticks = Math.max(1, Math.floor(axisSize / 40));
        }
        tickValues = (scale.ticks && scale.ticks(ticks)) || scale.domain();
    }
    return tickValues;
}
function axisPieces(_a) {
    var _b = _a.renderMode, renderMode = _b === void 0 ? function () { return undefined; } : _b, _c = _a.padding, padding = _c === void 0 ? 5 : _c, scale = _a.scale, ticks = _a.ticks, _d = _a.tickValues, tickValues = _d === void 0 ? generateTickValues(undefined, ticks, scale) : _d, _e = _a.orient, orient = _e === void 0 ? "left" : _e, size = _a.size, _f = _a.footer, footer = _f === void 0 ? false : _f, _g = _a.tickSize, tickSize = _g === void 0 ? footer
        ? -10
        : ["top", "bottom"].find(function (d) { return d === orient; })
            ? size[1]
            : size[0] : _g, jaggedBase = _a.jaggedBase;
    //returns x1 (start of line), x2 (end of line) associated with the value of the tick
    var axisDomain = [], position1, position2, domain1, domain2, tposition1, tposition2, textPositionMod = 0, textPositionMod2 = 0, defaultAnchor = "middle";
    switch (orient) {
        case "top":
            position1 = "x1";
            position2 = "x2";
            domain1 = "y1";
            domain2 = "y2";
            axisDomain = [0, tickSize];
            tposition1 = "tx";
            tposition2 = "ty";
            textPositionMod -= 20 - padding;
            break;
        case "bottom":
            position1 = "x1";
            position2 = "x2";
            domain1 = "y2";
            domain2 = "y1";
            axisDomain = [size[1], size[1] - tickSize];
            tposition1 = "tx";
            tposition2 = "ty";
            textPositionMod += 20 + padding;
            break;
        case "right":
            position1 = "y2";
            position2 = "y1";
            domain1 = "x2";
            domain2 = "x1";
            axisDomain = [size[0], size[0] - tickSize];
            tposition1 = "ty";
            tposition2 = "tx";
            textPositionMod += 5 + padding;
            textPositionMod2 += 5;
            defaultAnchor = "start";
            break;
        //left
        default:
            position1 = "y1";
            position2 = "y2";
            domain1 = "x1";
            domain2 = "x2";
            axisDomain = [0, tickSize];
            tposition1 = "ty";
            tposition2 = "tx";
            textPositionMod -= 5 + padding;
            textPositionMod2 += 5;
            defaultAnchor = "end";
            break;
    }
    var generatedTicks = tickValues instanceof Function ? tickValues({ orient: orient }) : tickValues;
    if (jaggedBase &&
        generatedTicks.find(function (t) { return t === scale.domain()[0]; }) === undefined) {
        generatedTicks = __spread([scale.domain()[0]], generatedTicks);
    }
    return generatedTicks.map(function (tick, i) {
        var _a;
        var tickPosition = scale(tick);
        return _a = {},
            _a[position1] = tickPosition,
            _a[position2] = tickPosition,
            _a[domain1] = axisDomain[0],
            _a[domain2] = axisDomain[1],
            _a[tposition1] = tickPosition + textPositionMod2,
            _a[tposition2] = axisDomain[0] + textPositionMod,
            _a.defaultAnchor = defaultAnchor,
            _a.renderMode = renderMode(tick, i),
            _a.value = tick,
            _a;
    });
}
var axisLabels = function (_a) {
    var axisParts = _a.axisParts, tickFormat = _a.tickFormat, _b = _a.rotate, rotate = _b === void 0 ? 0 : _b, _c = _a.center, center = _c === void 0 ? false : _c, orient = _a.orient;
    return axisParts.map(function (axisPart, i) {
        var renderedValue = tickFormat(axisPart.value, i);
        if (typeof renderedValue !== "object" || renderedValue instanceof Date) {
            renderedValue = (React.createElement("text", { textAnchor: axisPart.defaultAnchor, className: "axis-label" }, renderedValue.toString ? renderedValue.toString() : renderedValue));
        }
        var textX = axisPart.tx;
        var textY = axisPart.ty;
        if (center) {
            switch (orient) {
                case "right":
                    textX -= (axisPart.x2 - axisPart.x1) / 2;
                    break;
                case "left":
                    textX += (axisPart.x2 - axisPart.x1) / 2;
                    break;
                case "top":
                    textY += (axisPart.y2 - axisPart.y1) / 2;
                    break;
                case "bottom":
                    textY -= (axisPart.y2 - axisPart.y1) / 2;
                    break;
            }
        }
        return (React.createElement("g", { key: i, pointerEvents: "none", transform: "translate(" + textX + "," + textY + ") rotate(" + rotate + ")", className: "axis-label" }, renderedValue));
    });
};
var baselineGenerator = function (orient, size, className) {
    var offsets = {
        left: { x: 0, y: 0, width: 0, height: size[1] },
        right: { x: size[0], y: 0, width: 0, height: size[1] },
        top: { x: 0, y: 0, width: size[0], height: 0 },
        bottom: { x: 0, y: size[1], width: size[0], height: 0 }
    };
    var orientOffset = offsets[orient];
    return (React.createElement("line", { key: "baseline", className: "axis-baseline " + className, stroke: "black", strokeLinecap: "square", x1: orientOffset.x, x2: orientOffset.x + orientOffset.width, y1: orientOffset.y, y2: orientOffset.y + orientOffset.height }));
};
var axisLines = function (_a) {
    var axisParts = _a.axisParts, orient = _a.orient, _b = _a.tickLineGenerator, tickLineGenerator = _b === void 0 ? defaultTickLineGenerator : _b, baseMarkProps = _a.baseMarkProps, className = _a.className, jaggedBase = _a.jaggedBase, scale = _a.scale, _c = _a.showOutboundTickLines, showOutboundTickLines = _c === void 0 ? false : _c;
    var axisLines = axisParts.map(function (axisPart, i) {
        return tickLineGenerator({
            xy: axisPart,
            orient: orient,
            i: i,
            baseMarkProps: baseMarkProps,
            className: className,
            jaggedBase: jaggedBase,
            scale: scale
        });
    });
    var outboundAxisLines = showOutboundTickLines ?
        axisParts.map(function (axisPart, i) {
            return outboundTickLineGenerator({
                xy: axisPart,
                orient: orient,
                i: i,
                className: className
            });
        })
        : [];
    return __spread(axisLines, [outboundAxisLines]);
};

var generateLineBounds = function (xydata, basedata, topBoundingAccessor, bottomBoundingAccessor) {
    var tops = xydata.map(function (d, i) { return [
        d[0],
        d[1] + topBoundingAccessor(basedata[i])
    ]; });
    var bottoms = xydata.map(function (d, i) { return [
        d[0],
        d[1] - bottomBoundingAccessor(basedata[i])
    ]; });
    return __spread(tops, bottoms.reverse());
};
function lineBounding(_a) {
    var summaryType = _a.summaryType, data = _a.data, defined = _a.defined;
    var projectedSummaries = [];
    if (!summaryType.type) {
        summaryType = { type: summaryType };
    }
    var boundingAccessor = summaryType.boundingAccessor, _b = summaryType.topBoundingAccessor, topBoundingAccessor = _b === void 0 ? boundingAccessor : _b, _c = summaryType.bottomBoundingAccessor, bottomBoundingAccessor = _c === void 0 ? boundingAccessor : _c;
    data.forEach(function (lineData) {
        var definedData = lineData._baseData.map(defined);
        var currentBaseData = [];
        var currentXYFC = [];
        var boundingPieces = [
            {
                xyf: currentXYFC,
                base: currentBaseData
            }
        ];
        definedData.forEach(function (d, i) {
            if (d === true) {
                currentBaseData.push(lineData._baseData[i]);
                currentXYFC.push(lineData._xyfCoordinates[i]);
            }
            else if (definedData[i + 1]) {
                currentBaseData = [];
                currentXYFC = [];
                boundingPieces.push({
                    xyf: currentXYFC,
                    base: currentBaseData
                });
            }
        });
        boundingPieces.forEach(function (_a) {
            var xyf = _a.xyf, base = _a.base;
            var boundingProjectedSummary = {
                data: lineData,
                parentSummary: lineData,
                _xyfCoordinates: generateLineBounds(xyf, base, topBoundingAccessor, bottomBoundingAccessor)
            };
            projectedSummaries = __spread(projectedSummaries, [boundingProjectedSummary]);
        });
    });
    return projectedSummaries;
}
function contouring(_a) {
    var summaryType = _a.summaryType, data = _a.data, finalXExtent = _a.finalXExtent, finalYExtent = _a.finalYExtent;
    var projectedSummaries = [];
    if (!summaryType.type) {
        summaryType = { type: summaryType };
    }
    var _b = summaryType.resolution, resolution = _b === void 0 ? 500 : _b, _c = summaryType.thresholds, thresholds = _c === void 0 ? 10 : _c, _d = summaryType.bandwidth, bandwidth = _d === void 0 ? 20 : _d, neighborhood = summaryType.neighborhood;
    var xScale = scaleLinear()
        .domain(finalXExtent)
        .rangeRound([0, resolution])
        .nice();
    var yScale = scaleLinear()
        .domain(finalYExtent)
        .rangeRound([resolution, 0])
        .nice();
    data.forEach(function (contourData) {
        var contourProjectedSummaries = contourDensity()
            .size([resolution, resolution])
            .x(function (d) { return xScale(d[0]); })
            .y(function (d) { return yScale(d[1]); })
            .thresholds(thresholds)
            .bandwidth(bandwidth)(contourData._xyfCoordinates);
        if (neighborhood) {
            contourProjectedSummaries = [contourProjectedSummaries[0]];
        }
        var max = Math.max.apply(Math, __spread(contourProjectedSummaries.map(function (d) { return d.value; })));
        contourProjectedSummaries.forEach(function (summary) {
            summary.parentSummary = contourData;
            summary.bounds = [];
            summary.percent = summary.value / max;
            summary.coordinates.forEach(function (poly) {
                poly.forEach(function (subpoly, i) {
                    poly[i] = subpoly.map(function (coordpair) {
                        coordpair = [
                            xScale.invert(coordpair[0]),
                            yScale.invert(coordpair[1])
                        ];
                        return coordpair;
                    });
                    //Only push bounds for the main poly, not its interior rings, otherwise you end up labeling interior cutouts
                    if (i === 0) {
                        summary.bounds.push(shapeBounds(poly[i]));
                    }
                });
            });
        });
        projectedSummaries = __spread(projectedSummaries, contourProjectedSummaries);
    });
    return projectedSummaries;
}
function hexbinning(_a) {
    var _b = _a.preprocess, preprocess = _b === void 0 ? true : _b, _c = _a.processedData, processedData = _c === void 0 ? false : _c, baseSummaryType = _a.summaryType, baseData = _a.data, baseXExtent = _a.finalXExtent, baseYExtent = _a.finalYExtent, size = _a.size, _d = _a.xScaleType, xScaleType = _d === void 0 ? scaleLinear() : _d, _e = _a.yScaleType, yScaleType = _e === void 0 ? scaleLinear() : _e, margin = _a.margin, baseMarkProps = _a.baseMarkProps, styleFn = _a.styleFn, classFn = _a.classFn, renderFn = _a.renderFn, chartSize = _a.chartSize;
    var finalXExtent = baseXExtent;
    var finalYExtent = baseYExtent;
    if (!finalXExtent) {
        var xData = baseData.coordinates.map(function (p) { return p.x; });
        finalXExtent = [Math.min.apply(Math, __spread(xData)), Math.max.apply(Math, __spread(xData))];
    }
    if (!finalYExtent) {
        var yData = baseData.coordinates.map(function (p) { return p.y; });
        finalYExtent = [Math.min.apply(Math, __spread(yData)), Math.max.apply(Math, __spread(yData))];
    }
    if (processedData && baseData) {
        return baseData.coordinates;
    }
    var projectedSummaries = [];
    var summaryType;
    if (!baseSummaryType.type) {
        summaryType = { type: summaryType };
    }
    else {
        summaryType = baseSummaryType;
    }
    var 
    //    binGraphic = "hex",
    _f = summaryType.bins, 
    //    binGraphic = "hex",
    bins = _f === void 0 ? 0.05 : _f, cellPx = summaryType.cellPx, _g = summaryType.binValue, binValue = _g === void 0 ? function (d) { return d.length; } : _g, binMax = summaryType.binMax, customMark = summaryType.customMark;
    if (baseData.coordinates && !baseData._xyfCoordinates) {
        baseData._xyfCoordinates = baseData.coordinates.map(function (d) { return [d.x, d.y]; });
    }
    var data = Array.isArray(baseData) ? baseData : [baseData];
    var hexBinXScale = xScaleType.domain(finalXExtent).range([0, size[0]]);
    var hexBinYScale = yScaleType.domain(finalYExtent).range([0, size[1]]);
    var actualResolution = (cellPx && cellPx / 2) || ((bins > 1 ? 1 / bins : bins) * size[0]) / 2;
    var hexbinner = hexbin()
        .x(function (d) { return hexBinXScale(d._xyfPoint[0]); })
        .y(function (d) { return hexBinYScale(d._xyfPoint[1]); })
        .radius(actualResolution)
        .size(size);
    var hexMax;
    var allHexes = hexbinner.centers();
    data.forEach(function (hexbinData) {
        hexMax = 0;
        var hexes = hexbinner(hexbinData._xyfCoordinates.map(function (d, i) { return (__assign({ _xyfPoint: d }, hexbinData.coordinates[i])); }));
        var centerHash = {};
        hexes.forEach(function (d) {
            centerHash[parseInt(d.x) + "-" + parseInt(d.y)] = true;
        });
        allHexes.forEach(function (hexCenter) {
            if (!centerHash[parseInt(hexCenter[0]) + "-" + parseInt(hexCenter[1])]) {
                var newHex = [];
                newHex.x = hexCenter[0];
                newHex.y = hexCenter[1];
                hexes.push(newHex);
            }
        });
        hexMax = Math.max.apply(Math, __spread(hexes.map(function (d) { return binValue(d); })));
        if (binMax) {
            binMax(hexMax);
        }
        //Option for blank hexe
        var hexBase = [
            [0, -1],
            [0.866, -0.5],
            [0.866, 0.5],
            [0, 1],
            [-0.866, 0.5],
            [-0.866, -0.5]
        ];
        var hexWidth = hexBinXScale.invert(actualResolution) - finalXExtent[0];
        var hexHeight = hexBinYScale.invert(actualResolution) - finalYExtent[0];
        var hexacoordinates = hexBase.map(function (d) { return [
            d[0] * hexWidth,
            d[1] * hexHeight
        ]; });
        var hexbinProjectedSummaries = hexes.map(function (d) {
            var hexValue = binValue(d);
            var gx = d.x;
            var gy = d.y;
            d.x = hexBinXScale.invert(d.x);
            d.y = hexBinYScale.invert(d.y);
            var percent = hexValue / hexMax;
            return {
                customMark: customMark && (React.createElement("g", { transform: "translate(" + gx + "," + (size[1] - gy) + ")" }, customMark({
                    d: __assign(__assign({}, d), { binItems: d, percent: percent, value: hexValue, radius: actualResolution, hexCoordinates: hexBase.map(function (d) { return [
                            d[0] * actualResolution,
                            d[1] * actualResolution
                        ]; }) }),
                    baseMarkProps: baseMarkProps,
                    margin: margin,
                    styleFn: styleFn,
                    classFn: classFn,
                    renderFn: renderFn,
                    chartSize: chartSize,
                    adjustedSize: size
                }))),
                _xyfCoordinates: hexacoordinates.map(function (p) { return [p[0] + d.x, p[1] + d.y]; }),
                value: hexValue,
                percent: percent,
                data: d,
                parentSummary: hexbinData,
                centroid: true
            };
        });
        projectedSummaries = __spread(projectedSummaries, hexbinProjectedSummaries);
    });
    if (preprocess) {
        projectedSummaries.forEach(function (d) {
            d.x = d.data.x;
            d.y = d.data.y;
        });
        return {
            type: "hexbin",
            processedData: true,
            coordinates: projectedSummaries,
            binMax: hexMax
        };
    }
    return projectedSummaries;
}
// ADD PRECALC AND EXPOSE PRECALC FUNCTION
function heatmapping(_a) {
    var _b = _a.preprocess, preprocess = _b === void 0 ? true : _b, _c = _a.processedData, processedData = _c === void 0 ? false : _c, baseSummaryType = _a.summaryType, baseData = _a.data, _d = _a.finalXExtent, finalXExtent = _d === void 0 ? [
        Math.min.apply(Math, __spread(baseData.coordinates.map(function (d) { return d.x; }))),
        Math.max.apply(Math, __spread(baseData.coordinates.map(function (d) { return d.x; })))
    ] : _d, _e = _a.finalYExtent, finalYExtent = _e === void 0 ? [
        Math.min.apply(Math, __spread(baseData.coordinates.map(function (d) { return d.y; }))),
        Math.max.apply(Math, __spread(baseData.coordinates.map(function (d) { return d.y; })))
    ] : _e, size = _a.size, _f = _a.xScaleType, xScaleType = _f === void 0 ? scaleLinear() : _f, _g = _a.yScaleType, yScaleType = _g === void 0 ? scaleLinear() : _g, margin = _a.margin, baseMarkProps = _a.baseMarkProps, styleFn = _a.styleFn, classFn = _a.classFn, renderFn = _a.renderFn, chartSize = _a.chartSize;
    if (processedData && baseData) {
        return baseData.coordinates;
    }
    if (baseData.coordinates && !baseData._xyfCoordinates) {
        baseData._xyfCoordinates = baseData.coordinates.map(function (d) { return [d.x, d.y]; });
    }
    var data = Array.isArray(baseData) ? baseData : [baseData];
    var projectedSummaries = [];
    var summaryType;
    if (!baseSummaryType.type) {
        summaryType = { type: summaryType };
    }
    else {
        summaryType = baseSummaryType;
    }
    var 
    //    binGraphic = "square",
    _h = summaryType.binValue, 
    //    binGraphic = "square",
    binValue = _h === void 0 ? function (d) { return d.length; } : _h, _j = summaryType.xBins, xBins = _j === void 0 ? summaryType.yBins || 0.05 : _j, _k = summaryType.yBins, yBins = _k === void 0 ? xBins : _k, _l = summaryType.xCellPx, xCellPx = _l === void 0 ? !summaryType.xBins && summaryType.xCellPx : _l, _m = summaryType.yCellPx, yCellPx = _m === void 0 ? !summaryType.yBins && summaryType.yCellPx : _m, customMark = summaryType.customMark, binMax = summaryType.binMax;
    var xBinPercent = xBins < 1 ? xBins : 1 / xBins;
    var yBinPercent = yBins < 1 ? yBins : 1 / yBins;
    var heatmapBinXScale = xScaleType.domain(finalXExtent).range([0, size[0]]);
    var heatmapBinYScale = yScaleType.domain(finalYExtent).range([size[1], 0]);
    var actualResolution = [
        Math.ceil(((xCellPx && xCellPx / size[0]) || xBinPercent) * size[0] * 10) /
            10,
        Math.ceil(((yCellPx && yCellPx / size[1]) || yBinPercent) * size[1] * 10) /
            10
    ];
    var maxValue = -Infinity;
    console.log("summaryType", summaryType);
    data.forEach(function (heatmapData) {
        var grid = [];
        var flatGrid = [];
        var cell;
        var gridColumn;
        for (var i = 0; Math.ceil(i) < size[0]; i += actualResolution[0]) {
            var x = heatmapBinXScale.invert(i);
            var x1 = heatmapBinXScale.invert(i + actualResolution[0]);
            gridColumn = [];
            grid.push(gridColumn);
            for (var j = 0; Math.ceil(j) < size[1]; j += actualResolution[1]) {
                var y = heatmapBinYScale.invert(j);
                var y1 = heatmapBinYScale.invert(j + actualResolution[1]);
                cell = {
                    gx: i,
                    gy: j,
                    gw: actualResolution[0],
                    gh: actualResolution[1],
                    x: (x + x1) / 2,
                    y: (y + y1) / 2,
                    binItems: [],
                    value: 0,
                    _xyfCoordinates: [
                        [x, y],
                        [x1, y],
                        [x1, y1],
                        [x, y1]
                    ],
                    parentSummary: heatmapData
                };
                gridColumn.push(cell);
                flatGrid.push(cell);
            }
            gridColumn.push(cell);
        }
        grid.push(gridColumn);
        heatmapData._xyfCoordinates.forEach(function (d, di) {
            var baseX = heatmapBinXScale(d[0]);
            var baseY = heatmapBinYScale(d[1]);
            var xCoordinate = Math.floor(baseX / actualResolution[0]);
            var yCoordinate = Math.floor(baseY / actualResolution[1]);
            if (grid[xCoordinate][yCoordinate]) {
                grid[xCoordinate][yCoordinate].binItems.push(heatmapData.coordinates[di]);
            }
        });
        flatGrid.forEach(function (d) {
            d.value = binValue(d.binItems);
            maxValue = Math.max(maxValue, d.value);
        });
        flatGrid.forEach(function (d) {
            d.percent = d.value / maxValue;
            d.customMark = customMark && (React.createElement("g", { transform: "translate(" + d.gx + "," + d.gy + ")" }, customMark({
                d: d,
                baseMarkProps: baseMarkProps,
                margin: margin,
                styleFn: styleFn,
                classFn: classFn,
                renderFn: renderFn,
                chartSize: chartSize,
                adjustedSize: size
            })));
        });
        projectedSummaries = __spread(projectedSummaries, flatGrid);
    });
    if (binMax) {
        binMax(maxValue);
    }
    if (preprocess) {
        var preprocessedSummary = {
            type: "heatmap",
            processedData: true,
            _baseData: [],
            _xyfCoordinates: [],
            data: [],
            bounds: [],
            x: 0,
            y: 0,
            coordinates: projectedSummaries,
            binMax: maxValue
        };
        return preprocessedSummary;
    }
    return projectedSummaries;
}
function trendlining(_a) {
    var _b = _a.preprocess, preprocess = _b === void 0 ? false : _b, baseSummaryType = _a.summaryType, baseData = _a.data, _c = _a.finalXExtent, finalXExtent = _c === void 0 ? [
        Math.min.apply(Math, __spread(baseData.coordinates.map(function (d) { return d.x; }))),
        Math.max.apply(Math, __spread(baseData.coordinates.map(function (d) { return d.x; })))
    ] : _c, _d = _a.xScaleType, xScaleType = _d === void 0 ? scaleLinear() : _d;
    if (preprocess) {
        return baseData[0].coordinates;
    }
    var projectedSummaries = [];
    var summaryType;
    if (!baseSummaryType.type) {
        summaryType = { type: summaryType };
    }
    else {
        summaryType = baseSummaryType;
    }
    var _e = summaryType.regressionType, baseRegressionType = _e === void 0 ? "linear" : _e, _f = summaryType.order, order = _f === void 0 ? 2 : _f, _g = summaryType.precision, precision = _g === void 0 ? 4 : _g, _h = summaryType.controlPoints, controlPoints = _h === void 0 ? 20 : _h, _j = summaryType.curve, curve = _j === void 0 ? curveCardinal : _j;
    var regressionType = baseRegressionType;
    if (finalXExtent[0] < 0 &&
        (baseRegressionType === "logarithmic" ||
            baseRegressionType === "power" ||
            baseRegressionType === "exponential")) {
        console.error("Cannot use this " + baseRegressionType + " regressionType type with value range that goes below 0, defaulting to linear");
        regressionType = "linear";
    }
    if (baseData.coordinates && !baseData._xyfCoordinates) {
        baseData._xyfCoordinates = baseData.coordinates.map(function (d) { return [d.x, d.y]; });
    }
    var data = Array.isArray(baseData) ? baseData : [baseData];
    var xScale = xScaleType.domain([0, 1]).range(finalXExtent);
    projectedSummaries = [];
    data.forEach(function (bdata) {
        var regressionLine = regression[regressionType](bdata._xyfCoordinates.map(function (d) {
            var x = d[0];
            var y = d[1];
            if (typeof x !== "number") {
                x = x.getTime();
            }
            if (typeof y !== "number") {
                y = y.getTime();
            }
            return [x, y];
        }), {
            order: order,
            precision: precision
        });
        var controlStep = 1 / controlPoints;
        var steps = [0, 1];
        if (regressionType !== "linear") {
            steps = [];
            for (var step = 0; step < 1 + controlStep; step += controlStep) {
                steps.push(step);
            }
        }
        var controlPointArray = [];
        steps.forEach(function (controlPoint) {
            controlPointArray.push(regressionLine.predict(xScale(controlPoint)));
        });
        projectedSummaries.push({
            centroid: false,
            customMark: undefined,
            data: bdata,
            parentSummary: bdata,
            value: regressionLine.string,
            r2: regressionLine.r2,
            curve: curve,
            _xyfCoordinates: controlPointArray
        });
    });
    return projectedSummaries;
}
function shapeBounds(coordinates) {
    var left = [Infinity, 0];
    var right = [-Infinity, 0];
    var top = [0, Infinity];
    var bottom = [0, -Infinity];
    coordinates.forEach(function (d) {
        left = d[0] < left[0] ? d : left;
        right = d[0] > right[0] ? d : right;
        bottom = d[1] > bottom[1] ? d : bottom;
        top = d[1] < top[1] ? d : top;
    });
    return {
        center: [(left[0] + right[0]) / 2, (top[1] + bottom[1]) / 2],
        top: top,
        left: left,
        right: right,
        bottom: bottom
    };
}

function pointOnArcAtAngle$1(center, angle, distance) {
    var radians = Math.PI * (angle + 0.75) * 2;
    var xPosition = center[0] + distance * Math.cos(radians);
    var yPosition = center[1] + distance * Math.sin(radians);
    return [xPosition, yPosition];
}
var renderLaidOutPieces = function (_a) {
    var data = _a.data, shouldRender = _a.shouldRender, canvasRender = _a.canvasRender, canvasDrawing = _a.canvasDrawing, styleFn = _a.styleFn, classFn = _a.classFn, baseMarkProps = _a.baseMarkProps, renderKeyFn = _a.renderKeyFn, ariaLabel = _a.ariaLabel, axis = _a.axis;
    var valueFormat = axis && axis[0] && axis[0].tickFormat;
    if (!shouldRender)
        return null;
    var renderedPieces = [];
    data.forEach(function (d, i) {
        if (canvasRender && canvasRender(d) === true) {
            var canvasPiece = {
                baseClass: "orframe-piece",
                tx: d.renderElement.tx || 0,
                ty: d.renderElement.ty || 0,
                d: d.piece,
                i: i,
                markProps: d.renderElement || d,
                styleFn: styleFn,
                classFn: classFn
            };
            canvasDrawing.push(canvasPiece);
        }
        else {
            if (React.isValidElement(d.renderElement || d)) {
                renderedPieces.push(d.renderElement || d);
            }
            else {
                /*ariaLabel.items*/
                var pieceAriaLabel = d.o + " " + ariaLabel.items + " value " + ((valueFormat && valueFormat(d.piece.value)) || d.piece.value);
                renderedPieces.push(React.createElement(Mark, __assign({}, baseMarkProps, { key: renderKeyFn
                        ? renderKeyFn(d.piece)
                        : d.renderKey || "piece-render-" + i }, d.renderElement || d, { "aria-label": pieceAriaLabel })));
            }
        }
    });
    return renderedPieces;
};

var curveHash = {
    step: curveStep,
    stepbefore: curveStepBefore,
    stepafter: curveStepAfter,
    cardinal: curveCardinal,
    basis: curveBasis,
    linear: curveLinear,
    catmullrom: curveCatmullRom,
    monotone: curveMonotoneY,
    monotonex: curveMonotoneX,
    monotoney: curveMonotoneY,
    natural: curveNatural
};
function lineGeneratorDecorator(_a) {
    var generator = _a.generator, projectedCoordinateNames = _a.projectedCoordinateNames, defined = _a.defined, xScale = _a.xScale, yScale = _a.yScale, interpolator = _a.interpolator, simpleLine = _a.simpleLine;
    var x = projectedCoordinateNames.x, y = projectedCoordinateNames.y, yTop = projectedCoordinateNames.yTop, yBottom = projectedCoordinateNames.yBottom, xBottom = projectedCoordinateNames.xBottom, xTop = projectedCoordinateNames.xTop;
    generator.x(function (d) { return xScale(d[x]); }).curve(interpolator);
    if (simpleLine) {
        generator.y(function (d) { return yScale(d[y]); });
    }
    else {
        generator.y0(function (d) { return yScale(d[yBottom]); }).y1(function (d) { return yScale(d[yTop]); });
        generator.x0(function (d) { return xScale(d[xBottom]); }).x1(function (d) { return xScale(d[xTop]); });
    }
    if (defined) {
        generator.defined(function (p, q) { return defined(p, q); });
    }
    else {
        generator.defined(function (p) { return !p._xyFrameUndefined; });
    }
}
function createPoints(_a) {
    var xScale = _a.xScale, yScale = _a.yScale, canvasDrawing = _a.canvasDrawing, data = _a.data, projectedCoordinateNames = _a.projectedCoordinateNames, customMark = _a.customMark, canvasRender = _a.canvasRender, styleFn = _a.styleFn, classFn = _a.classFn, renderKeyFn = _a.renderKeyFn, renderMode = _a.renderMode, baseMarkProps = _a.baseMarkProps, baseShowLinePoints = _a.showLinePoints;
    var y = projectedCoordinateNames.y, x = projectedCoordinateNames.x, xMiddle = projectedCoordinateNames.xMiddle, yMiddle = projectedCoordinateNames.yMiddle, yTop = projectedCoordinateNames.yTop, yBottom = projectedCoordinateNames.yBottom;
    var showLinePoints = baseShowLinePoints === true ? undefined : baseShowLinePoints;
    var whichPoints = {
        top: yTop,
        bottom: yBottom
    };
    var whichWay = whichPoints[showLinePoints];
    var mappedPoints = [];
    data.forEach(function (d, i) {
        var dX = xScale(d[xMiddle] !== undefined ? d[xMiddle] : d[x]);
        var dY = yScale(d[whichWay] !== undefined
            ? d[whichWay]
            : d[yMiddle] !== undefined
                ? d[yMiddle]
                : d[y]);
        var pointAriaLabel = "Point at x " + d.x + " and y " + d.y;
        // CUSTOM MARK IMPLEMENTATION
        var renderedCustomMark = !customMark
            ? undefined
            : React.isValidElement(customMark)
                ? customMark
                : customMark({ d: d.data, xy: d, i: i, xScale: xScale, yScale: yScale });
        var markProps = customMark
            ? Object.assign(baseMarkProps, renderedCustomMark.props, {
                "aria-label": pointAriaLabel
            })
            : __assign(__assign({}, baseMarkProps), { key: "piece-" + i, markType: "circle", r: 2, "aria-label": pointAriaLabel });
        if (renderedCustomMark &&
            renderedCustomMark.props &&
            !renderedCustomMark.props.markType &&
            (!canvasRender || canvasRender(d.data, i) !== true)) {
            mappedPoints.push(React.createElement("g", { transform: "translate(" + dX + "," + dY + ")", key: renderKeyFn ? renderKeyFn(d.data, i) : "custom-point-mark-" + i, style: styleFn ? styleFn(d.data, i) : {}, className: classFn ? classFn(d.data, i) : "" }, renderedCustomMark));
        }
        else {
            if (canvasRender && canvasRender(d.data, i) === true) {
                var canvasPoint = {
                    type: "point",
                    baseClass: "frame-piece",
                    tx: dX,
                    ty: dY,
                    d: d,
                    i: i,
                    markProps: markProps,
                    styleFn: styleFn,
                    renderFn: renderMode,
                    classFn: classFn
                };
                canvasDrawing.push(canvasPoint);
            }
            else {
                var yCoordinates = Array.isArray(d[y])
                    ? d[y].map(function (p) { return yScale(p); })
                    : [dY];
                yCoordinates.forEach(function (yc, yi) {
                    var xCoordinates = Array.isArray(d[x])
                        ? d[x].map(function (p) { return xScale(p); })
                        : [dX];
                    xCoordinates.forEach(function (xc, xi) {
                        mappedPoints.push(clonedAppliedElement({
                            baseClass: "frame-piece",
                            tx: xc,
                            ty: yc,
                            d: (d.data && __assign(__assign({}, d), d.data)) || d,
                            i: yi === 0 && xi === 0 ? i : i + "-" + yi + "-" + xi,
                            markProps: markProps,
                            styleFn: styleFn,
                            renderFn: renderMode,
                            renderKeyFn: renderKeyFn,
                            classFn: classFn,
                            yi: yi
                        }));
                    });
                });
            }
        }
    });
    return mappedPoints;
}
function createLines(_a) {
    var xScale = _a.xScale, yScale = _a.yScale, canvasDrawing = _a.canvasDrawing, data = _a.data, projectedCoordinateNames = _a.projectedCoordinateNames, customMark = _a.customMark, canvasRender = _a.canvasRender, styleFn = _a.styleFn, classFn = _a.classFn, renderMode = _a.renderMode, renderKeyFn = _a.renderKeyFn, type = _a.type, defined = _a.defined, baseMarkProps = _a.baseMarkProps, ariaLabel = _a.ariaLabel, _b = _a.axesData, axesData = _b === void 0 ? [] : _b;
    var xAxis = axesData.find(function (d) { return d.orient === "bottom" || d.orient === "top"; });
    var yAxis = axesData.find(function (d) { return d.orient === "left" || d.orient === "right"; });
    var xAxisFormatter = (xAxis && xAxis.tickFormat) || (function (d) { return d; });
    var yAxisFormatter = (yAxis && yAxis.tickFormat) || (function (d) { return d; });
    var customLine = typeof type === "object" ? type : { type: type };
    var interpolator = typeof customLine.interpolator === "string"
        ? curveHash[customLine.interpolator]
        : customLine.interpolator || curveLinear;
    var lineGenerator = customLine.simpleLine ? line() : area();
    lineGeneratorDecorator({
        projectedCoordinateNames: projectedCoordinateNames,
        defined: defined,
        interpolator: interpolator,
        generator: lineGenerator,
        xScale: xScale,
        yScale: yScale,
        simpleLine: customLine.simpleLine
    });
    var dynamicLineGenerator = (interpolator.dynamicInterpolator &&
        (function (d, i) {
            var dynLineGenerator = area();
            lineGeneratorDecorator({
                projectedCoordinateNames: projectedCoordinateNames,
                defined: defined,
                interpolator: interpolator.dynamicInterpolator(d, i),
                generator: dynLineGenerator,
                xScale: xScale,
                yScale: yScale,
                simpleLine: customLine.simpleLine
            });
            return dynLineGenerator;
        })) ||
        (function () { return lineGenerator; });
    var mappedLines = [];
    data.forEach(function (d, i) {
        var mappedDataForLines = d.data.map(function (p) { return (__assign(__assign({}, p.data), p)); });
        if (customMark && typeof customMark === "function") {
            //shim to make customLineMark work until Semiotic 2
            var compatibleData = __assign(__assign({}, d), { data: mappedDataForLines });
            mappedLines.push(customMark({ d: compatibleData, i: i, xScale: xScale, yScale: yScale, canvasDrawing: canvasDrawing }));
        }
        else {
            var builtInDisplayProps = {};
            if (customLine.simpleLine) {
                builtInDisplayProps.fill = "none";
                builtInDisplayProps.stroke = "black";
            }
            var pathString = dynamicLineGenerator(d, i)(mappedDataForLines);
            var markProps = __assign(__assign(__assign({}, builtInDisplayProps), baseMarkProps), { markType: "path", d: pathString, "aria-label": d.data &&
                    d.data.length > 0 &&
                    d.data.length + " point " + ariaLabel.items + " starting value " + yAxisFormatter(d.data[0].y) + " at " + xAxisFormatter(d.data[0].x) + " ending value " + yAxisFormatter(d.data[d.data.length - 1].y) + " at " + xAxisFormatter(d.data[d.data.length - 1].x) });
            if (canvasRender && canvasRender(d, i) === true) {
                var canvasLine = {
                    type: "line",
                    baseClass: "xyframe-line",
                    tx: 0,
                    ty: 0,
                    d: d,
                    i: i,
                    markProps: markProps,
                    styleFn: styleFn,
                    renderFn: renderMode,
                    classFn: classFn
                };
                canvasDrawing.push(canvasLine);
            }
            else {
                var moddedStyleFn = styleFn;
                if (customLine.type === "area" && customLine.enclosed !== true) {
                    moddedStyleFn = function (d, i) { return (__assign(__assign({}, styleFn(d, i)), { stroke: "none" })); };
                }
                mappedLines.push(clonedAppliedElement({
                    baseClass: "xyframe-line",
                    d: d,
                    i: i,
                    markProps: markProps,
                    styleFn: moddedStyleFn,
                    renderFn: renderMode,
                    renderKeyFn: renderKeyFn,
                    classFn: classFn
                }));
                if (customLine.type === "area" && customLine.enclosed !== true) {
                    var topperStyleFn = function (d, i) { return (__assign(__assign({}, styleFn(d, i)), { fill: "none" })); };
                    var topperLineGenerator = line();
                    lineGeneratorDecorator({
                        projectedCoordinateNames: projectedCoordinateNames,
                        defined: defined,
                        interpolator: interpolator,
                        generator: topperLineGenerator,
                        xScale: xScale,
                        yScale: yScale,
                        simpleLine: true
                    });
                    var topperMarkProps = __assign(__assign({}, markProps), { d: topperLineGenerator(mappedDataForLines) });
                    mappedLines.push(clonedAppliedElement({
                        baseClass: "xyframe-line",
                        d: d,
                        i: i,
                        markProps: topperMarkProps,
                        styleFn: topperStyleFn,
                        renderFn: renderMode,
                        renderKeyFn: renderKeyFn,
                        classFn: classFn
                    }));
                }
            }
        }
    });
    if (customLine.type === "difference" && data.length === 2) {
        //Create the overlay line for the difference chart
        var diffdataA = data[0].data.map(function (basedata, baseI) {
            var linePoint = basedata.yTop > data[1].data[baseI].yTop
                ? basedata.yTop
                : basedata.yBottom;
            return {
                x: basedata.x,
                y: linePoint,
                yBottom: linePoint,
                yTop: linePoint
            };
        });
        var diffdataB = data[0].data.map(function (basedata, baseI) {
            var linePoint = data[1].data[baseI].yTop > basedata.yTop
                ? data[1].data[baseI].yTop
                : data[1].data[baseI].yBottom;
            return {
                x: basedata.x,
                y: linePoint,
                yBottom: linePoint,
                yTop: linePoint
            };
        });
        var doClassname = classFn
            ? "xyframe-line " + classFn(diffdataA)
            : "xyframe-line";
        var overLine = line();
        lineGeneratorDecorator({
            projectedCoordinateNames: projectedCoordinateNames,
            defined: defined,
            interpolator: interpolator,
            generator: overLine,
            xScale: xScale,
            yScale: yScale,
            simpleLine: true
        });
        //      let baseStyle = props.lineStyle ? props.lineStyle(diffdata, 0) : {}
        var diffOverlayA = (React.createElement(Mark, { key: "xyline-diff-a", className: doClassname + " difference-overlay-a", markType: "path", d: overLine(diffdataA), style: { fill: "none", pointerEvents: "none" } }));
        mappedLines.push(diffOverlayA);
        var diffOverlayB = (React.createElement(Mark, { key: "xyline-diff-b", className: doClassname + " difference-overlay-b", markType: "path", d: overLine(diffdataB), style: { fill: "none", pointerEvents: "none" } }));
        mappedLines.push(diffOverlayB);
    }
    return mappedLines;
}
function createSummaries(_a) {
    var xScale = _a.xScale, yScale = _a.yScale, canvasDrawing = _a.canvasDrawing, data = _a.data, canvasRender = _a.canvasRender, styleFn = _a.styleFn, classFn = _a.classFn, renderKeyFn = _a.renderKeyFn, renderMode = _a.renderMode, baseMarkProps = _a.baseMarkProps, customMark = _a.customMark;
    var summaryClass = classFn || (function () { return ""; });
    var summaryStyle = styleFn || (function () { return ({}); });
    var renderFn = renderMode;
    if (!Array.isArray(data)) {
        data = [data];
    }
    var renderedSummaries = [];
    data.forEach(function (d, i) {
        var className = "xyframe-summary";
        if (summaryClass) {
            className = "xyframe-summary " + summaryClass(d);
        }
        var drawD = "";
        var shouldBeValid = false;
        if (typeof d.customMark === "string" ||
            React.isValidElement(d.customMark)) {
            drawD = d.customMark;
            shouldBeValid = true;
        }
        else if (d.type === "MultiPolygon") {
            var polycoords = d.coordinates;
            polycoords.forEach(function (coord) {
                coord.forEach(function (c) {
                    drawD += "M" + c
                        .map(function (p) { return xScale(p[0]) + "," + yScale(p[1]); })
                        .join("L") + "Z ";
                });
            });
        }
        else if (customMark) {
            var xyfCoords = d._xyfCoordinates;
            var projectedCoordinates = xyfCoords.map(function (p) { return [
                xScale(p[0]),
                yScale(p[1])
            ]; });
            // CUSTOM MARK IMPLEMENTATION
            drawD = customMark({
                d: d,
                i: i,
                classFn: summaryClass,
                styleFn: summaryStyle,
                renderFn: renderFn,
                projectedCoordinates: projectedCoordinates,
                xScale: xScale,
                yScale: yScale,
                bounds: shapeBounds(projectedCoordinates)
            });
            shouldBeValid = true;
        }
        else {
            var xyfCoords = d._xyfCoordinates;
            if (d.curve) {
                var lineDrawing = line()
                    .x(function (d) { return xScale(d[0]); })
                    .y(function (d) { return yScale(d[1]); })
                    .curve(d.curve);
                drawD = lineDrawing(xyfCoords);
            }
            else {
                drawD = "M" + xyfCoords
                    .map(function (p) { return xScale(p[0]) + "," + yScale(p[1]); })
                    .join("L") + "Z";
            }
        }
        var renderKey = renderKeyFn ? renderKeyFn(d, i) : "summary-" + i;
        if (shouldBeValid && React.isValidElement(drawD)) {
            renderedSummaries.push(drawD);
        }
        else if (canvasRender && canvasRender(d, i) === true) {
            var canvasSummary = {
                type: "summary",
                baseClass: "xyframe-summary",
                tx: 0,
                ty: 0,
                d: d,
                i: i,
                markProps: { markType: "path", d: drawD },
                styleFn: summaryStyle,
                renderFn: renderFn,
                classFn: function () { return className; }
            };
            canvasDrawing.push(canvasSummary);
        }
        else {
            renderedSummaries.push(React.createElement(Mark, __assign({}, baseMarkProps, { key: renderKey, forceUpdate: true, renderMode: renderFn ? renderFn(d, i) : undefined, className: className, markType: "path", d: drawD, style: summaryStyle(d, i) })));
        }
    });
    return renderedSummaries;
}
function clonedAppliedElement(_a) {
    var tx = _a.tx, ty = _a.ty, d = _a.d, i = _a.i, markProps = _a.markProps, styleFn = _a.styleFn, renderFn = _a.renderFn, classFn = _a.classFn, renderKeyFn = _a.renderKeyFn, baseClass = _a.baseClass, yi = _a.yi;
    markProps.style = styleFn ? styleFn(d, i, yi) : {};
    markProps.className = baseClass;
    markProps.key = renderKeyFn
        ? renderKeyFn(d, i, yi)
        : baseClass + "-" + (d.key === undefined ? i : d.key);
    if (tx || ty) {
        markProps.transform = "translate(" + (tx || 0) + "," + (ty || 0) + ")";
    }
    if (classFn) {
        markProps.className = baseClass + " " + classFn(d, i, yi);
    }
    if (markProps.style.r) {
        markProps.r = markProps.style.r;
    }
    if (!markProps.markType) {
        var RenderableMark = markProps;
        return React.createElement(RenderableMark);
    }
    markProps.renderMode = renderFn ? renderFn(d, i, yi) : undefined;
    return React.createElement(Mark, __assign({}, markProps));
}

var contourMap = function (d) { return [d.xy.x, d.xy.y]; };
var verticalXYSorting = function (a, b) { return a.xy.y - b.xy.y; };
var horizontalXYSorting = function (a, b) { return b.xy.x - a.xy.x; };
var emptyObjectReturnFn = function () { return ({}); };
function createSummaryAxis(_a) {
    var summary = _a.summary, summaryI = _a.summaryI, axisSettings = _a.axisSettings, axisCreator = _a.axisCreator, projection = _a.projection, actualMax = _a.actualMax, adjustedSize = _a.adjustedSize, columnWidth = _a.columnWidth;
    var axisTranslate = "translate(" + summary.x + ",0)";
    var axisDomain = [0, actualMax];
    if (projection === "horizontal") {
        axisTranslate = "translate(" + 0 + "," + summary.x + ")";
        axisDomain = [actualMax, 0];
    }
    else if (projection === "radial") {
        axisTranslate = "translate(0, 0)";
    }
    var axisWidth = projection === "horizontal" ? adjustedSize[0] : columnWidth;
    var axisHeight = projection === "vertical" ? adjustedSize[1] : columnWidth;
    axisSettings.size = [axisWidth, axisHeight];
    var axisScale = scaleLinear().domain(axisDomain).range([0, columnWidth]);
    var renderedSummaryAxis = axisCreator(axisSettings, summaryI, axisScale);
    return (React.createElement("g", { className: "summary-axis", key: "summaryPiece-axis-" + summaryI, transform: axisTranslate }, renderedSummaryAxis));
}
function boxplotRenderFn(_a) {
    var data = _a.data, type = _a.type, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, classFn = _a.classFn, projection = _a.projection, adjustedSize = _a.adjustedSize, baseMarkProps = _a.baseMarkProps;
    var summaryElementStylingFn = type.elementStyleFn || emptyObjectReturnFn;
    var outliers = type.outliers;
    var keys = Object.keys(data);
    var renderedSummaryMarks = [];
    var summaryXYCoords = [];
    keys.forEach(function (key, summaryI) {
        var summary = data[key];
        var eventListeners = eventListenersGenerator(summary, summaryI);
        var columnWidth = summary.width;
        var thisSummaryData = summary.pieceData;
        var calculatedSummaryStyle = styleFn(thisSummaryData[0].data, summaryI);
        var calculatedSummaryClass = classFn(thisSummaryData[0].data, summaryI);
        var summaryPositionNest, summaryValueNest, translate, extentlineX1, extentlineX2, extentlineY1, extentlineY2, topLineX1, topLineX2, midLineX1, midLineX2, bottomLineX1, bottomLineX2, rectTopWidth, rectTopHeight, rectTopY, rectTopX, rectBottomWidth, rectBottomHeight, rectBottomY, rectBottomX, rectWholeWidth, rectWholeHeight, rectWholeY, rectWholeX, topLineY1, topLineY2, bottomLineY1, bottomLineY2, midLineY1, midLineY2;
        var renderValue = renderMode ? renderMode(summary, summaryI) : undefined;
        summaryValueNest = thisSummaryData.map(function (p) { return p.value; }).sort(function (a, b) { return a - b; });
        summaryValueNest = [
            quantile(summaryValueNest, 0.0),
            quantile(summaryValueNest, 0.25),
            quantile(summaryValueNest, 0.5),
            quantile(summaryValueNest, 0.75),
            quantile(summaryValueNest, 1.0)
        ];
        var iqr = summaryValueNest[3] - summaryValueNest[1];
        var minOutlier, maxOutlier;
        if (outliers) {
            minOutlier = summaryValueNest[1] - iqr * 1.5;
            maxOutlier = summaryValueNest[3] + iqr * 1.5;
            summaryValueNest[0] = Math.max(summaryValueNest[0], minOutlier);
            summaryValueNest[4] = Math.min(summaryValueNest[4], maxOutlier);
        }
        //translate
        if (projection === "vertical") {
            summaryPositionNest = thisSummaryData
                .map(function (p) { return p.scaledVerticalValue; })
                .sort(function (a, b) { return b - a; });
            translate = "translate(" + (summary.x + summary.padding) + ",0)";
            summaryPositionNest = [
                quantile(summaryPositionNest, 0.0),
                quantile(summaryPositionNest, 0.25),
                quantile(summaryPositionNest, 0.5),
                quantile(summaryPositionNest, 0.75),
                quantile(summaryPositionNest, 1.0)
            ];
            if (outliers) {
                var positionIQR = summaryPositionNest[3] - summaryPositionNest[1];
                summaryPositionNest[0] = Math.min(summaryPositionNest[0], summaryPositionNest[1] - positionIQR * 1.5);
                summaryPositionNest[4] = Math.max(summaryPositionNest[4], summaryPositionNest[3] + positionIQR * 1.5);
            }
            extentlineX1 = 0;
            extentlineX2 = 0;
            extentlineY1 = summaryPositionNest[0];
            extentlineY2 = summaryPositionNest[4];
            topLineX1 = -columnWidth / 2;
            topLineX2 = columnWidth / 2;
            midLineX1 = -columnWidth / 2;
            midLineX2 = columnWidth / 2;
            bottomLineX1 = -columnWidth / 2;
            bottomLineX2 = columnWidth / 2;
            rectBottomWidth = columnWidth;
            rectBottomHeight = summaryPositionNest[1] - summaryPositionNest[2];
            rectBottomY = summaryPositionNest[2];
            rectBottomX = -columnWidth / 2;
            rectTopWidth = columnWidth;
            rectTopHeight = summaryPositionNest[2] - summaryPositionNest[3];
            rectWholeWidth = columnWidth;
            rectWholeHeight = summaryPositionNest[1] - summaryPositionNest[3];
            rectWholeY = summaryPositionNest[3];
            rectWholeX = -columnWidth / 2;
            rectTopY = summaryPositionNest[3];
            rectTopX = -columnWidth / 2;
            topLineY1 = summaryPositionNest[0];
            topLineY2 = summaryPositionNest[0];
            bottomLineY1 = summaryPositionNest[4];
            bottomLineY2 = summaryPositionNest[4];
            midLineY1 = summaryPositionNest[2];
            midLineY2 = summaryPositionNest[2];
            summaryXYCoords.push({
                label: "Maximum",
                key: key,
                summaryPieceName: "max",
                x: 0,
                y: summaryPositionNest[4],
                value: summaryValueNest[4]
            }, {
                label: "3rd Quartile",
                key: key,
                summaryPieceName: "q3area",
                x: 0,
                y: summaryPositionNest[3],
                value: summaryValueNest[3]
            }, {
                label: "Median",
                key: key,
                summaryPieceName: "median",
                x: 0,
                y: summaryPositionNest[2],
                value: summaryValueNest[2]
            }, {
                label: "1st Quartile",
                key: key,
                summaryPieceName: "q1area",
                x: 0,
                y: summaryPositionNest[1],
                value: summaryValueNest[1]
            }, {
                label: "Minimum",
                key: key,
                summaryPieceName: "min",
                x: 0,
                y: summaryPositionNest[0],
                value: summaryValueNest[0]
            });
        }
        else if (projection === "horizontal") {
            summaryPositionNest = thisSummaryData
                .map(function (p) { return p.scaledValue; })
                .sort(function (a, b) { return a - b; });
            var boxplotY = summary.x + summary.padding;
            translate = "translate(0," + (summary.x + summary.padding + summary.width / 2) + ")";
            summaryPositionNest = [
                quantile(summaryPositionNest, 0.0),
                quantile(summaryPositionNest, 0.25),
                quantile(summaryPositionNest, 0.5),
                quantile(summaryPositionNest, 0.75),
                quantile(summaryPositionNest, 1.0)
            ];
            if (outliers) {
                var positionIQR = summaryPositionNest[3] - summaryPositionNest[1];
                summaryPositionNest[0] = Math.max(summaryPositionNest[0], summaryPositionNest[1] - positionIQR * 1.5);
                summaryPositionNest[4] = Math.min(summaryPositionNest[4], summaryPositionNest[3] + positionIQR * 1.5);
            }
            extentlineY1 = 0;
            extentlineY2 = 0;
            extentlineX1 = summaryPositionNest[0];
            extentlineX2 = summaryPositionNest[4];
            topLineY1 = -columnWidth / 2;
            topLineY2 = columnWidth / 2;
            midLineY1 = -columnWidth / 2;
            midLineY2 = columnWidth / 2;
            bottomLineY1 = -columnWidth / 2;
            bottomLineY2 = columnWidth / 2;
            rectTopHeight = columnWidth;
            rectTopWidth = summaryPositionNest[3] - summaryPositionNest[2];
            rectTopX = summaryPositionNest[2];
            rectTopY = -columnWidth / 2;
            rectBottomHeight = columnWidth;
            rectBottomWidth = summaryPositionNest[2] - summaryPositionNest[1];
            rectBottomX = summaryPositionNest[1];
            rectBottomY = -columnWidth / 2;
            rectWholeHeight = columnWidth;
            rectWholeWidth = summaryPositionNest[3] - summaryPositionNest[1];
            rectWholeX = summaryPositionNest[1];
            rectWholeY = -columnWidth / 2;
            topLineX1 = summaryPositionNest[0];
            topLineX2 = summaryPositionNest[0];
            bottomLineX1 = summaryPositionNest[4];
            bottomLineX2 = summaryPositionNest[4];
            midLineX1 = summaryPositionNest[2];
            midLineX2 = summaryPositionNest[2];
            summaryXYCoords.push({
                label: "Maximum",
                key: key,
                summaryPieceName: "max",
                x: summaryPositionNest[4],
                y: boxplotY,
                value: summaryValueNest[4]
            }, {
                label: "3rd Quartile",
                key: key,
                summaryPieceName: "q3area",
                x: summaryPositionNest[3],
                y: boxplotY,
                value: summaryValueNest[3]
            }, {
                label: "Median",
                key: key,
                summaryPieceName: "median",
                x: summaryPositionNest[2],
                y: boxplotY,
                value: summaryValueNest[2]
            }, {
                label: "1st Quartile",
                key: key,
                summaryPieceName: "q1area",
                x: summaryPositionNest[1],
                y: boxplotY,
                value: summaryValueNest[1]
            }, {
                label: "Minimum",
                key: key,
                summaryPieceName: "min",
                x: summaryPositionNest[0],
                y: boxplotY,
                value: summaryValueNest[0]
            });
        }
        if (projection === "radial") {
            summaryPositionNest = thisSummaryData
                .map(function (p) { return p.scaledValue; })
                .sort(function (a, b) { return a - b; });
            summaryPositionNest = [
                quantile(summaryPositionNest, 0.0),
                quantile(summaryPositionNest, 0.25),
                quantile(summaryPositionNest, 0.5),
                quantile(summaryPositionNest, 0.75),
                quantile(summaryPositionNest, 1.0)
            ];
            extentlineX1 = 0;
            extentlineX2 = 0;
            extentlineY1 = summaryPositionNest[0];
            extentlineY2 = summaryPositionNest[4];
            topLineX1 = -columnWidth / 2;
            topLineX2 = columnWidth / 2;
            midLineX1 = -columnWidth / 2;
            midLineX2 = columnWidth / 2;
            bottomLineX1 = -columnWidth / 2;
            bottomLineX2 = columnWidth / 2;
            rectTopWidth = columnWidth;
            rectTopHeight = summaryPositionNest[1] - summaryPositionNest[3];
            rectTopY = summaryPositionNest[3];
            rectTopX = -columnWidth / 2;
            rectBottomWidth = columnWidth;
            rectBottomHeight = summaryPositionNest[1] - summaryPositionNest[3];
            rectBottomY = summaryPositionNest[3];
            rectBottomX = -columnWidth / 2;
            topLineY1 = summaryPositionNest[0];
            topLineY2 = summaryPositionNest[0];
            bottomLineY1 = summaryPositionNest[4];
            bottomLineY2 = summaryPositionNest[4];
            midLineY1 = summaryPositionNest[2];
            midLineY2 = summaryPositionNest[2];
            var twoPI = Math.PI * 2;
            var bottomLineArcGenerator = arc()
                .innerRadius(bottomLineY1 / 2)
                .outerRadius(bottomLineY1 / 2);
            //        .padAngle(summary.pct_padding * twoPI);
            var topLineArcGenerator = arc()
                .innerRadius(topLineY1 / 2)
                .outerRadius(topLineY1 / 2);
            //        .padAngle(summary.pct_padding * twoPI);
            var midLineArcGenerator = arc()
                .innerRadius(midLineY1 / 2)
                .outerRadius(midLineY1 / 2);
            //        .padAngle(summary.pct_padding * twoPI);
            var bodyArcTopGenerator = arc()
                .innerRadius(summaryPositionNest[1] / 2)
                .outerRadius(midLineY1 / 2);
            //        .padAngle(summary.pct_padding * twoPI);
            var bodyArcBottomGenerator = arc()
                .innerRadius(midLineY1 / 2)
                .outerRadius(summaryPositionNest[3] / 2);
            //        .padAngle(summary.pct_padding * twoPI);
            var bodyArcWholeGenerator = arc()
                .innerRadius(summaryPositionNest[1] / 2)
                .outerRadius(summaryPositionNest[3] / 2);
            //        .padAngle(summary.pct_padding * twoPI);
            var startAngle = summary.pct_start + summary.pct_padding / 2;
            var endAngle = summary.pct + summary.pct_start - summary.pct_padding / 2;
            var midAngle = summary.pct / 2 + summary.pct_start;
            startAngle *= twoPI;
            endAngle *= twoPI;
            var radialAdjustX = adjustedSize[0] / 2;
            var radialAdjustY = adjustedSize[1] / 2;
            //        const bottomPoint = bottomLineArcGenerator.centroid({ startAngle, endAngle })
            //        const topPoint = topLineArcGenerator.centroid({ startAngle, endAngle })
            var bottomPoint = pointOnArcAtAngle$1([0, 0], midAngle, summaryPositionNest[4] / 2);
            var topPoint = pointOnArcAtAngle$1([0, 0], midAngle, summaryPositionNest[0] / 2);
            var thirdPoint = pointOnArcAtAngle$1([0, 0], midAngle, summaryPositionNest[3] / 2);
            var midPoint = pointOnArcAtAngle$1([0, 0], midAngle, summaryPositionNest[2] / 2);
            var firstPoint = pointOnArcAtAngle$1([0, 0], midAngle, summaryPositionNest[1] / 2);
            summaryXYCoords.push({
                label: "Minimum",
                key: key,
                summaryPieceName: "min",
                x: topPoint[0] + radialAdjustX,
                y: topPoint[1] + radialAdjustY,
                value: summaryValueNest[0]
            }, {
                label: "1st Quartile",
                key: key,
                summaryPieceName: "q3area",
                x: firstPoint[0] + radialAdjustX,
                y: firstPoint[1] + radialAdjustY,
                value: summaryValueNest[1]
            }, {
                label: "Median",
                key: key,
                summaryPieceName: "median",
                x: midPoint[0] + radialAdjustX,
                y: midPoint[1] + radialAdjustY,
                value: summaryValueNest[2]
            }, {
                label: "3rd Quartile",
                key: key,
                summaryPieceName: "q1area",
                x: thirdPoint[0] + radialAdjustX,
                y: thirdPoint[1] + radialAdjustY,
                value: summaryValueNest[3]
            }, {
                label: "Maximum",
                key: key,
                summaryPieceName: "max",
                x: bottomPoint[0] + radialAdjustX,
                y: bottomPoint[1] + radialAdjustY,
                value: summaryValueNest[4]
            });
            translate = "translate(" + radialAdjustX + "," + radialAdjustY + ")";
            renderedSummaryMarks.push(React.createElement("g", __assign({}, eventListeners, { className: calculatedSummaryClass, transform: translate, key: "summaryPiece-" + summaryI, role: "img", tabIndex: -1, "data-o": key, "aria-label": key + " boxplot showing " + summaryXYCoords
                    .filter(function (d) { return d.key === key; })
                    .map(function (d) { return d.label + " " + d.value; }) }),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "line", x1: bottomPoint[0], x2: topPoint[0], y1: bottomPoint[1], y2: topPoint[1], style: Object.assign({ strokeWidth: 2 }, calculatedSummaryStyle, summaryElementStylingFn("whisker")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "path", d: topLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }), style: Object.assign({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("max")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "path", d: midLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }), style: Object.assign({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("median")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "path", d: bottomLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }), style: Object.assign({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("min")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "path", d: bodyArcWholeGenerator({ startAngle: startAngle, endAngle: endAngle }), style: Object.assign({ strokeWidth: 4 }, calculatedSummaryStyle, summaryElementStylingFn("iqrarea")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "path", d: bodyArcTopGenerator({ startAngle: startAngle, endAngle: endAngle }), style: Object.assign({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q3area")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "path", d: bodyArcBottomGenerator({ startAngle: startAngle, endAngle: endAngle }), style: Object.assign({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q1area")) }))));
        }
        else {
            var boxplotMarks = [
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "line", x1: extentlineX1, x2: extentlineX2, y1: extentlineY1, y2: extentlineY2, style: Object.assign({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("whisker")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "line", x1: topLineX1, x2: topLineX2, y1: topLineY1, y2: topLineY2, style: Object.assign({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("min")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "line", x1: bottomLineX1, x2: bottomLineX2, y1: bottomLineY1, y2: bottomLineY2, style: Object.assign({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("max")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "rect", x: rectWholeX, width: rectWholeWidth, y: rectWholeY, height: rectWholeHeight, style: Object.assign({ strokeWidth: "1px" }, calculatedSummaryStyle, summaryElementStylingFn("iqrarea")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "rect", x: rectTopX, width: rectTopWidth, y: rectTopY, height: rectTopHeight, style: Object.assign({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q3area")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "rect", x: rectBottomX, width: rectBottomWidth, y: rectBottomY, height: rectBottomHeight, style: Object.assign({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q1area")) })),
                React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderValue, markType: "line", x1: midLineX1, x2: midLineX2, y1: midLineY1, y2: midLineY2, style: Object.assign({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("median")) }))
            ];
            var outlierMarks_1 = [];
            if (outliers) {
                var outlierPoints = thisSummaryData.filter(function (d) { return d.value > maxOutlier || d.value < minOutlier; });
                outlierPoints.forEach(function (point) {
                    outlierMarks_1.push(React.createElement(Mark, __assign({}, baseMarkProps, { 
                        //              renderMode={renderValue}
                        markType: "circle", cx: projection === "horizontal" ? point.scaledValue : 0, cy: projection === "vertical" ? point.scaledVerticalValue : 0, style: Object.assign({ strokeWidth: "1px", stroke: "black", fill: "none", r: 2 }, calculatedSummaryStyle, summaryElementStylingFn("outlier")) })));
                });
            }
            renderedSummaryMarks.push(React.createElement("g", __assign({}, eventListeners, { className: calculatedSummaryClass, transform: translate, key: "summaryPiece-" + summaryI, role: "img", tabIndex: -1, "data-o": key, "aria-label": key + " boxplot showing " + summaryXYCoords
                    .filter(function (d) { return d.key === key; })
                    .map(function (d) { return d.label + " " + d.value; })
                    .join(", ") }),
                boxplotMarks,
                outlierMarks_1));
        }
    });
    return { marks: renderedSummaryMarks, xyPoints: summaryXYCoords };
}
function contourRenderFn(_a) {
    var data = _a.data, type = _a.type, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, classFn = _a.classFn, adjustedSize = _a.adjustedSize, baseMarkProps = _a.baseMarkProps;
    var keys = Object.keys(data);
    var renderedSummaryMarks = [];
    var summaryXYCoords = [];
    keys.forEach(function (key, ordsetI) {
        var ordset = data[key];
        var renderValue = renderMode && renderMode(ordset, ordsetI);
        type.thresholds = type.thresholds || 8;
        type.bandwidth = type.bandwidth || 12;
        type.resolution = type.resolution || 1000;
        var projectedOrd = [
            { id: ordset, _xyfCoordinates: ordset.xyData.map(contourMap) }
        ];
        var oContours = contouring({
            summaryType: type,
            data: projectedOrd,
            finalXExtent: [0, adjustedSize[0]],
            finalYExtent: [0, adjustedSize[1]]
        });
        var contourMarks = [];
        oContours.forEach(function (d, i) {
            d.coordinates.forEach(function (coords, ii) {
                var eventListeners = eventListenersGenerator(d, i);
                contourMarks.push(React.createElement(Mark, __assign({}, baseMarkProps, eventListeners, { renderMode: renderValue, simpleInterpolate: true, key: i + "-" + ii, style: styleFn(ordset.pieceData[0].data, ordsetI), className: classFn(ordset.pieceData[0].data, ordsetI), markType: "path", d: "M" + d.coordinates[0].map(function (p) { return p.join(","); }).join("L") + "Z" })));
            });
        });
        renderedSummaryMarks.push(React.createElement("g", { key: "contour-container-" + ordsetI, role: "img", tabIndex: -1, "data-o": key, "aria-label": key + " Contour plot" }, contourMarks));
    });
    return { marks: renderedSummaryMarks, xyPoints: summaryXYCoords };
}
function axisGenerator(axisProps, i, axisScale) {
    return (React.createElement(Axis, { label: axisProps.label, key: axisProps.key || "orframe-summary-axis-" + i, orient: axisProps.orient, size: axisProps.size, ticks: axisProps.ticks, tickSize: axisProps.tickSize, tickFormat: axisProps.tickFormat, tickValues: axisProps.tickValues, rotate: axisProps.rotate, scale: axisScale, className: axisProps.className }));
}
function bucketizedRenderingFn(_a) {
    var data = _a.data, type = _a.type, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, classFn = _a.classFn, projection = _a.projection, adjustedSize = _a.adjustedSize, chartSize = _a.chartSize, baseMarkProps = _a.baseMarkProps;
    var renderedSummaryMarks = [];
    var summaryXYCoords = [];
    var buckets = type.bins || 25;
    var relativeBuckets = type.relative ? {} : false;
    var summaryValueAccessor = type.binValue || (function (d) { return d.length; });
    var summaryElementStylingFn = type.elementStyleFn || emptyObjectReturnFn;
    var axisCreator;
    if (type.axis) {
        type.axis.orient =
            projection === "horizontal" &&
                ["left", "right"].indexOf(type.axis.orient) === -1
                ? "left"
                : type.axis.orient;
        type.axis.orient =
            projection === "vertical" &&
                ["bottom", "top"].indexOf(type.axis.orient) === -1
                ? "bottom"
                : type.axis.orient;
        axisCreator = axisGenerator;
        if (projection === "radial") {
            console.error("Summary axes cannot be drawn for radial histograms");
            axisCreator = function () { return null; };
        }
    }
    var bucketSize = chartSize / buckets;
    var keys = Object.keys(data);
    var binMax = 0;
    var baseHistogram = histogram();
    var binDomain = [0, chartSize];
    var binBuckets = [];
    for (var x = 0; x < buckets; x++) {
        binBuckets.push(binDomain[0] + (x / buckets) * chartSize);
    }
    var xyValue = projection === "vertical"
        ? function (p) { return p.piece.scaledVerticalValue; }
        : function (p) { return p.piece.scaledValue; };
    var instantiatedHistogram = baseHistogram
        .domain(binDomain)
        .thresholds(binBuckets)
        .value(xyValue);
    var calculatedBins = keys.map(function (key, summaryI) {
        var summary = data[key];
        var thisSummaryData = summary.xyData;
        var xySorting = projection === "vertical" ? verticalXYSorting : horizontalXYSorting;
        var summaryPositionNest = thisSummaryData.sort(xySorting);
        var keyBins;
        if (type.useBins === false) {
            var calculatedValues_1 = summaryPositionNest.map(function (value) {
                return xyValue(value);
            });
            keyBins = summaryPositionNest
                .map(function (value, i) {
                var bucketArray = [];
                bucketArray.x0 = calculatedValues_1[i] - 1;
                bucketArray.x1 = calculatedValues_1[i] + 1;
                bucketArray.push(value);
                return bucketArray;
            })
                .sort(function (a, b) { return a.x0 - b.x0; });
            bucketSize = chartSize / keyBins.length;
        }
        else {
            keyBins = instantiatedHistogram(summaryPositionNest);
        }
        keyBins = keyBins.map(function (d) { return ({
            y: d.x0,
            y1: d.x1 - d.x0,
            pieces: d,
            value: summaryValueAccessor(d.map(function (p) { return p.piece.data; }))
        }); });
        if (type.type === "histogram" || type.type === "heatmap") {
            keyBins = keyBins.filter(function (d) { return d.value !== 0; });
        }
        var relativeMax = keyBins.length === 0 ? 0 : max(keyBins.map(function (d) { return d.value; }));
        if (relativeBuckets) {
            relativeBuckets[key] = relativeMax;
        }
        binMax = Math.max(binMax, relativeMax);
        return { bins: keyBins, summary: summary, summaryI: summaryI, thisSummaryData: thisSummaryData };
    });
    var numHorizons = type.horizon
        ? binMax / type.horizon
        : type.numHorizons || 4;
    var horizon = type.horizon || binMax / numHorizons;
    calculatedBins.forEach(function (_a) {
        var bins = _a.bins, summary = _a.summary, summaryI = _a.summaryI, thisSummaryData = _a.thisSummaryData;
        var eventListeners = eventListenersGenerator(summary, summaryI);
        var columnWidth = summary.width;
        var renderValue = renderMode && renderMode(summary, summaryI);
        var calculatedSummaryStyle = thisSummaryData[0]
            ? styleFn(thisSummaryData[0].piece.data, summaryI)
            : {};
        var calculatedSummaryClass = thisSummaryData[0]
            ? classFn(thisSummaryData[0].piece.data, summaryI)
            : "";
        var translate = [summary.middle, 0];
        if (projection === "horizontal") {
            translate = [bucketSize, summary.middle];
        }
        else if (projection === "radial") {
            translate = [adjustedSize[0] / 2, adjustedSize[1] / 2];
        }
        var actualMax = (relativeBuckets && relativeBuckets[summary.name]) || binMax;
        if (type.type === "heatmap" || type.type === "histogram") {
            var mappedBars = groupBarMark({
                bins: bins,
                binMax: binMax,
                relativeBuckets: relativeBuckets,
                columnWidth: columnWidth,
                projection: projection,
                adjustedSize: adjustedSize,
                summaryI: summaryI,
                summary: summary,
                renderValue: renderValue,
                summaryStyle: calculatedSummaryStyle,
                type: type,
                baseMarkProps: baseMarkProps
            });
            var tiles = mappedBars.marks;
            if (projection === "radial") {
                translate = [0, 0];
            }
            if (type.axis && type.type === "histogram") {
                renderedSummaryMarks.push(createSummaryAxis({
                    summary: summary,
                    summaryI: summaryI,
                    axisSettings: type.axis,
                    axisCreator: axisCreator,
                    projection: projection,
                    actualMax: actualMax,
                    adjustedSize: adjustedSize,
                    columnWidth: columnWidth
                }));
            }
            mappedBars.points.forEach(function (d) {
                d.x += translate[0];
                d.y += translate[1];
            });
            summaryXYCoords.push.apply(summaryXYCoords, __spread(mappedBars.points));
            renderedSummaryMarks.push(React.createElement("g", __assign({}, eventListeners, { transform: "translate(" + translate + ")", key: "summaryPiece-" + summaryI, role: "img", tabIndex: -1, "data-o": summary.name, "aria-label": summary.name + " " + type.type }), tiles));
        }
        else if (type.type === "violin") {
            var iqr_1 = type.iqr;
            var subsets = type.subsets || [false];
            bins[0].y = bins[0].y - bucketSize / 2;
            bins[bins.length - 1].y = bins[bins.length - 1].y + bucketSize / 2;
            subsets.forEach(function (subsettingFn, subsettingIndex) {
                var actualBins = bins;
                if (subsettingFn) {
                    calculatedSummaryStyle = thisSummaryData[0]
                        ? styleFn(thisSummaryData[0].piece.data, summaryI, subsettingIndex)
                        : {};
                    calculatedSummaryClass = thisSummaryData[0]
                        ? classFn(thisSummaryData[0].piece.data, summaryI, subsettingIndex)
                        : "";
                    actualBins = bins.map(function (d) {
                        var actualPieces = d.pieces
                            .filter(function (p, pi) { return subsettingFn(p.piece, pi); })
                            .map(function (d) { return d; });
                        var actualValue = summaryValueAccessor(actualPieces);
                        return __assign(__assign({}, d), { pieces: actualPieces, value: actualValue });
                    });
                }
                var violinArea = area().curve(type.curve || curveCatmullRom);
                var violinPoints = [];
                if (projection === "horizontal") {
                    actualBins.forEach(function (summaryPoint) {
                        var xValue = summaryPoint.y - bucketSize / 2;
                        var yValue = ((summaryPoint.value / actualMax) * columnWidth) / 2;
                        violinPoints.push({
                            x: xValue,
                            y0: -yValue,
                            y1: yValue
                        });
                        summaryXYCoords.push({
                            key: summary.name,
                            x: xValue + translate[0],
                            y: yValue + translate[1],
                            pieces: summaryPoint.pieces.map(function (d) { return d.piece; }),
                            value: summaryPoint.value
                        });
                    });
                    violinArea
                        .x(function (d) { return d.x; })
                        .y0(function (d) { return d.y0; })
                        .y1(function (d) { return d.y1; })
                        .defined(function (d, i) {
                        return d.y0 !== 0 ||
                            (violinPoints[i - 1] && violinPoints[i - 1].y0 !== 0) ||
                            (violinPoints[i + 1] && violinPoints[i + 1].y0 !== 0);
                    });
                }
                else if (projection === "vertical") {
                    actualBins.forEach(function (summaryPoint) {
                        var yValue = summaryPoint.y + bucketSize / 2;
                        var xValue = ((summaryPoint.value / actualMax) * columnWidth) / 2;
                        violinPoints.push({
                            y: yValue,
                            x0: -xValue,
                            x1: xValue
                        });
                        summaryXYCoords.push({
                            key: summary.name,
                            x: xValue + translate[0],
                            y: yValue + translate[1],
                            pieces: summaryPoint.pieces.map(function (d) { return d.piece; }),
                            value: summaryPoint.value
                        });
                    });
                    violinArea
                        .y(function (d) { return d.y; })
                        .x0(function (d) { return d.x0; })
                        .x1(function (d) { return d.x1; })
                        .defined(function (d, i) {
                        return d.x0 !== 0 ||
                            (violinPoints[i - 1] && violinPoints[i - 1].x0 !== 0) ||
                            (violinPoints[i + 1] && violinPoints[i + 1].x0 !== 0);
                    });
                }
                else if (projection === "radial") {
                    var angle_1 = summary.pct - summary.pct_padding / 2;
                    var midAngle_1 = summary.pct_middle;
                    violinPoints = actualBins;
                    violinArea = function (inbins) {
                        var forward = [];
                        var backward = [];
                        inbins.forEach(function (bin) {
                            var outsidePoint = pointOnArcAtAngle$1([0, 0], midAngle_1 + (angle_1 * bin.value) / actualMax / 2, (bin.y + bin.y1 - bucketSize / 2) / 2);
                            var insidePoint = pointOnArcAtAngle$1([0, 0], midAngle_1 - (angle_1 * bin.value) / actualMax / 2, (bin.y + bin.y1 - bucketSize / 2) / 2);
                            //Ugh a terrible side effect has appeared
                            summaryXYCoords.push({
                                key: summary.name,
                                x: insidePoint[0] + translate[0],
                                y: insidePoint[1] + translate[1],
                                pieces: bin.pieces.map(function (d) { return d.piece; }),
                                value: bin.value
                            });
                            summaryXYCoords.push({
                                key: summary.name,
                                x: outsidePoint[0] + translate[0],
                                y: outsidePoint[1] + translate[1],
                                pieces: bin.pieces.map(function (d) { return d.piece; }),
                                value: bin.value
                            });
                            forward.push(outsidePoint);
                            backward.push(insidePoint);
                        });
                        return "M" + forward.map(function (d) { return d.join(","); }).join("L") + "L" + backward
                            .reverse()
                            .map(function (d) { return d.join(","); })
                            .join("L") + "Z";
                    };
                }
                renderedSummaryMarks.push(React.createElement(Mark, __assign({}, baseMarkProps, { transform: "translate(" + translate + ")", key: "summaryPiece-" + summaryI + "-" + subsettingIndex }, eventListeners, { renderMode: renderValue, markType: "path", className: calculatedSummaryClass, style: calculatedSummaryStyle, d: violinArea(violinPoints), role: "img", tabIndex: -1, "data-o": summary.name, "aria-label": summary.name + " distribution" })));
                if (iqr_1) {
                    var iqrPieces_1 = [];
                    actualBins.forEach(function (aBin) {
                        iqrPieces_1.push.apply(iqrPieces_1, __spread(aBin.pieces));
                    });
                    iqrPieces_1 = iqrPieces_1
                        .map(function (d) {
                        return projection === "vertical"
                            ? d.piece.scaledVerticalValue
                            : d.piece.scaledValue;
                    })
                        .sort(function (a, b) { return a - b; });
                    var iqrValues = [
                        quantile(iqrPieces_1, 0.25),
                        quantile(iqrPieces_1, 0.5),
                        quantile(iqrPieces_1, 0.75)
                    ];
                    var iqrLine = projection === "vertical"
                        ? function (first, last, translate) {
                            return "M" + translate[0] + "," + first + "L" + translate[0] + "," + last;
                        }
                        : function (first, last, translate) {
                            return "M" + first + "," + translate[1] + "L" + last + "," + translate[1];
                        };
                    renderedSummaryMarks.push(React.createElement(Mark, __assign({}, baseMarkProps, { key: "summaryPiece-" + summaryI + "-" + subsettingIndex + "-iqr-line" }, eventListeners, { renderMode: renderValue, markType: "path", className: calculatedSummaryClass, style: __assign(__assign({ stroke: "black", strokeWidth: "2px" }, calculatedSummaryStyle), summaryElementStylingFn("iqr")), d: iqrLine(iqrValues[0], iqrValues[2], translate), role: "img", tabIndex: -1, "data-o": summary.name, "aria-label": summary.name + " distribution" })));
                    renderedSummaryMarks.push(React.createElement(Mark, __assign({}, baseMarkProps, { key: "summaryPiece-" + summaryI + "-" + subsettingIndex + "-iqr-median" }, eventListeners, { markType: "circle", className: calculatedSummaryClass, style: __assign(__assign({ stroke: "black", fill: "black", strokeWidth: "1px", r: "3px" }, calculatedSummaryStyle), summaryElementStylingFn("median")), cx: projection === "vertical" ? translate[0] : iqrValues[1], cy: projection === "vertical" ? iqrValues[1] : translate[1], role: "img", tabIndex: -1, "data-o": summary.name, "aria-label": summary.name + " distribution" })));
                }
            });
        }
        else if (type.type === "ridgeline") {
            var zeroedStart = Object.assign({}, bins[0], { value: 0 });
            var zeroedEnd = Object.assign({}, bins[bins.length - 1], { value: 0 });
            //Ridgeline plots need to visually signify the zero baseline with their start and end position
            zeroedStart.y = zeroedStart.y - bucketSize / 2;
            zeroedEnd.y = zeroedEnd.y + bucketSize / 2;
            var joyBins_1 = __spread([zeroedStart], bins, [zeroedEnd]);
            var joyPoints_1 = [];
            var interpolatorSetting = type.curve || type.interpolator;
            var actualInterpolator = typeof interpolatorSetting === "string"
                ? curveHash[interpolatorSetting]
                : interpolatorSetting;
            var joyArea = line()
                .curve(actualInterpolator || curveCatmullRom)
                .x(function (d) { return d.x; })
                .y(function (d) { return d.y; });
            var joyHeight_1 = type.amplitude || 0;
            if (type.axis && type.type === "histogram") {
                renderedSummaryMarks.push(createSummaryAxis({
                    summary: summary,
                    summaryI: summaryI,
                    axisSettings: __assign({ baseline: false }, type.axis),
                    axisCreator: axisCreator,
                    projection: projection,
                    actualMax: actualMax,
                    adjustedSize: adjustedSize,
                    columnWidth: columnWidth
                }));
            }
            if (projection === "horizontal") {
                joyBins_1.forEach(function (summaryPoint, i) {
                    var xValue = summaryPoint.y - bucketSize / 2;
                    var yValue = type.flip
                        ? (summaryPoint.value / actualMax) * (columnWidth + joyHeight_1) -
                            columnWidth / 2
                        : (-summaryPoint.value / actualMax) * (columnWidth + joyHeight_1) +
                            columnWidth / 2;
                    joyPoints_1.push({
                        y: yValue,
                        x: xValue
                    });
                    //Don't make an interaction point for the first or last
                    if (i !== 0 && i !== joyBins_1.length - 1) {
                        summaryXYCoords.push({
                            key: summary.name,
                            x: xValue + translate[0],
                            y: yValue + translate[1],
                            pieces: summaryPoint.pieces.map(function (d) { return d.piece; }),
                            value: summaryPoint.value
                        });
                    }
                });
            }
            else if (projection === "vertical") {
                joyBins_1.forEach(function (summaryPoint) {
                    var yValue = summaryPoint.y + bucketSize / 2;
                    var xValue = type.flip === true
                        ? (summaryPoint.value / actualMax) * (columnWidth + joyHeight_1) -
                            columnWidth / 2
                        : (-summaryPoint.value / actualMax) * (columnWidth + joyHeight_1) +
                            columnWidth / 2;
                    joyPoints_1.push({
                        y: yValue,
                        x: xValue
                    });
                    summaryXYCoords.push({
                        key: summary.name,
                        x: xValue + translate[0],
                        y: yValue + translate[1],
                        pieces: summaryPoint.pieces.map(function (d) { return d.piece; }),
                        value: summaryPoint.value
                    });
                });
            }
            else if (projection === "radial") {
                var angle_2 = summary.pct - summary.pct_padding / 2;
                var midAngle_2 = summary.pct_start + summary.pct_padding / 2;
                translate = [0, 0];
                joyPoints_1 = joyBins_1;
                joyArea = function (inbins) {
                    var forward = [];
                    inbins.forEach(function (bin) {
                        var outsidePoint = pointOnArcAtAngle$1([adjustedSize[0] / 2, adjustedSize[1] / 2], midAngle_2 + (angle_2 * bin.value) / actualMax, (bin.y + bin.y1 - bucketSize / 2) / 2);
                        //Ugh a terrible side effect has appeared
                        summaryXYCoords.push({
                            key: summary.name,
                            x: outsidePoint[0] + translate[0],
                            y: outsidePoint[1] + translate[1],
                            pieces: bin.pieces.map(function (d) { return d.piece; }),
                            value: bin.value
                        });
                        forward.push(outsidePoint);
                    });
                    return "M" + forward.map(function (d) { return d.join(","); }).join("L") + "Z";
                };
            }
            if (type.axis) {
                renderedSummaryMarks.push(createSummaryAxis({
                    summary: summary,
                    summaryI: summaryI,
                    axisSettings: type.axis,
                    axisCreator: axisCreator,
                    projection: projection,
                    actualMax: actualMax,
                    adjustedSize: adjustedSize,
                    columnWidth: columnWidth
                }));
            }
            renderedSummaryMarks.push(React.createElement(Mark, __assign({}, baseMarkProps, { transform: "translate(" + translate + ")", key: "summaryPiece-" + summaryI }, eventListeners, { renderMode: renderValue, markType: "path", className: calculatedSummaryClass, style: calculatedSummaryStyle, d: joyArea(joyPoints_1), role: "img", tabIndex: -1, "data-o": summary.name, "aria-label": summary.name + " distribution" })));
        }
        else if (type.type === "horizon") {
            var zeroedStart = Object.assign({}, bins[0], { value: 0 });
            var zeroedEnd = Object.assign({}, bins[bins.length - 1], { value: 0 });
            zeroedStart.y = zeroedStart.y - bucketSize / 2;
            zeroedEnd.y = zeroedEnd.y + bucketSize / 2;
            var horizonBins_1 = __spread([zeroedStart], bins, [zeroedEnd]);
            var multiBins = [];
            var remainingPieces = true;
            var currentHorizon_1 = 0;
            while (remainingPieces === true) {
                var currentStrip = horizonBins_1.map(function (d) { return (__assign(__assign({}, d), { value: Math.max(0, Math.min(d.value - currentHorizon_1, horizon)) })); });
                multiBins.push(currentStrip.map(function (d) { return (__assign(__assign({}, d), { value: d.value * numHorizons })); }));
                currentHorizon_1 += horizon;
                if (max(currentStrip.map(function (d) { return d.value; })) < horizon) {
                    remainingPieces = false;
                }
            }
            multiBins = multiBins.filter(function (d) { return sum(d.map(function (p) { return p.value; })) > 0; });
            horizonBins_1.forEach(function (summaryPoint, i) {
                if (i !== 0 && i !== horizonBins_1.length - 1) {
                    if (projection === "horizontal") {
                        var xValue = summaryPoint.y - bucketSize / 2;
                        var yValue = (-summaryPoint.value / actualMax) * columnWidth + columnWidth / 2;
                        summaryXYCoords.push({
                            key: summary.name,
                            x: xValue + translate[0],
                            y: yValue + translate[1],
                            pieces: summaryPoint.pieces.map(function (d) { return d.piece; }),
                            value: summaryPoint.value
                        });
                    }
                    else if (projection === "vertical") {
                        var yValue = summaryPoint.y + bucketSize / 2;
                        var xValue = type.flip === true
                            ? (summaryPoint.value / actualMax) * columnWidth -
                                columnWidth / 2
                            : (-summaryPoint.value / actualMax) * columnWidth +
                                columnWidth / 2;
                        summaryXYCoords.push({
                            key: summary.name,
                            x: xValue + translate[0],
                            y: yValue + translate[1],
                            pieces: summaryPoint.pieces.map(function (d) { return d.piece; }),
                            value: summaryPoint.value
                        });
                    }
                }
            });
            var multiBinMarks = multiBins.map(function (multiBin, multiBinI) {
                var horizonPoints = [];
                var interpolatorSetting = type.curve || type.interpolator;
                var actualInterpolator = typeof interpolatorSetting === "string"
                    ? curveHash[interpolatorSetting]
                    : interpolatorSetting;
                var horizonArea = line()
                    .curve(actualInterpolator || curveLinear)
                    .x(function (d) { return d.x; })
                    .y(function (d) { return d.y; });
                if (projection === "horizontal") {
                    multiBin.forEach(function (summaryPoint) {
                        var xValue = summaryPoint.y - bucketSize / 2;
                        var yValue = (-summaryPoint.value / actualMax) * columnWidth + columnWidth / 2;
                        horizonPoints.push({
                            y: yValue,
                            x: xValue
                        });
                        //Don't make an interaction point for the first or last
                    });
                }
                else if (projection === "vertical") {
                    multiBin.forEach(function (summaryPoint) {
                        var yValue = summaryPoint.y + bucketSize / 2;
                        var xValue = type.flip === true
                            ? (summaryPoint.value / actualMax) * columnWidth -
                                columnWidth / 2
                            : (-summaryPoint.value / actualMax) * columnWidth +
                                columnWidth / 2;
                        horizonPoints.push({
                            y: yValue,
                            x: xValue
                        });
                    });
                }
                else if (projection === "radial") {
                    var angle_3 = summary.pct - summary.pct_padding / 2;
                    var midAngle_3 = summary.pct_start + summary.pct_padding / 2;
                    translate = [0, 0];
                    horizonPoints = multiBin;
                    horizonArea = function (inbins) {
                        var forward = [];
                        inbins.forEach(function (bin) {
                            var outsidePoint = pointOnArcAtAngle$1([adjustedSize[0] / 2, adjustedSize[1] / 2], midAngle_3 + (angle_3 * bin.value) / actualMax, (bin.y + bin.y1 - bucketSize / 2) / 2);
                            forward.push(outsidePoint);
                        });
                        return "M" + forward.map(function (d) { return d.join(","); }).join("L") + "Z";
                    };
                }
                return (React.createElement(Mark, __assign({}, baseMarkProps, { transform: "translate(" + translate + ")", key: "summaryPiece-" + summaryI + "-" + multiBinI }, eventListeners, { renderMode: renderValue, markType: "path", className: calculatedSummaryClass, style: __assign(__assign({}, calculatedSummaryStyle), summaryElementStylingFn(multiBin, multiBinI)), d: horizonArea(horizonPoints), role: "img", tabIndex: -1, "data-o": summary.name, "aria-label": summary.name + " distribution" })));
            });
            if (type.axis) {
                renderedSummaryMarks.push(createSummaryAxis({
                    summary: summary,
                    summaryI: summaryI,
                    axisSettings: type.axis,
                    axisCreator: axisCreator,
                    projection: projection,
                    actualMax: actualMax,
                    adjustedSize: adjustedSize,
                    columnWidth: columnWidth
                }));
            }
            renderedSummaryMarks.push(React.createElement("g", null, multiBinMarks));
        }
    });
    return {
        marks: renderedSummaryMarks,
        xyPoints: summaryXYCoords,
        thresholds: binBuckets
    };
}
var drawSummaries = function (_a) {
    var data = _a.data, type = _a.type, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, classFn = _a.classFn, projection = _a.projection, adjustedSize = _a.adjustedSize, margin = _a.margin, baseMarkProps = _a.baseMarkProps;
    if (!type || !type.type)
        return;
    type = typeof type === "string" ? { type: type } : type;
    var chartSize = projection === "vertical" ? adjustedSize[1] : adjustedSize[0];
    return orFrameSummaryRenderer({
        data: data,
        type: type,
        renderMode: renderMode,
        eventListenersGenerator: eventListenersGenerator,
        styleFn: styleFn,
        classFn: classFn,
        projection: projection,
        adjustedSize: adjustedSize,
        chartSize: chartSize,
        margin: margin,
        baseMarkProps: baseMarkProps
    });
};
var renderLaidOutSummaries = function (_a) {
    var data = _a.data;
    return data;
};

// components
var marginalPointMapper = function (orient, width, data) {
    var xMod = orient === "left" || orient === "right" ? width / 2 : 0;
    var yMod = orient === "bottom" || orient === "top" ? width / 2 : 0;
    return data.map(function (p) { return [p.xy.x + xMod, p.xy.y + yMod]; });
};
function formatValue(value, props) {
    if (props.tickFormat) {
        return props.tickFormat(value);
    }
    if (value.toString) {
        return value.toString();
    }
    return value;
}
var boundingBoxMax = function (axisNode, orient) {
    var axisRef = axisNode.current;
    if (!axisRef)
        return 30;
    var positionType = orient === "left" || orient === "right" ? "width" : "height";
    var axisLabelMax = Math.max.apply(Math, __spread(__spread(axisRef.querySelectorAll(".axis-label")).map(function (l) {
        return (l.getBBox && l.getBBox()) || { height: 30, width: 30 };
    })
        .map(function (d) { return d[positionType]; }))) + 25;
    return axisLabelMax;
};
function Axis(props) {
    var rotate = props.rotate, label = props.label, dynamicLabelPosition = props.dynamicLabelPosition, _a = props.orient, orient = _a === void 0 ? "left" : _a, marginalSummaryType = props.marginalSummaryType, _b = props.tickFormat, tickFormat = _b === void 0 ? marginalSummaryType ? function () { return ""; } : function (d) { return d; } : _b, size = props.size, _c = props.width, width = _c === void 0 ? (size && size[0]) || 0 : _c, _d = props.height, height = _d === void 0 ? (size && size[1]) || 0 : _d, className = props.className, padding = props.padding, tickValues = props.tickValues, scale = props.scale, ticks = props.ticks, footer = props.footer, tickSize = props.tickSize, tickLineGenerator = props.tickLineGenerator, _e = props.baseline, baseline = _e === void 0 ? true : _e, _f = props.margin, margin = _f === void 0 ? { top: 0, bottom: 0, left: 0, right: 0 } : _f, _g = props.center, center = _g === void 0 ? false : _g, annotationFunction = props.annotationFunction, glyphFunction = props.glyphFunction, xyPoints = props.xyPoints;
    var _h = __read(useState(0), 2), hoverPosition = _h[0], changeHoverPosition = _h[1];
    var _j = __read(useState(undefined), 2), calculatedLabelPosition = _j[0], changeCalculatedLabelPosition = _j[1];
    var axisNode = useRef(null);
    useEffect(function () {
        if (!(label === null || label === void 0 ? void 0 : label.position) && dynamicLabelPosition) {
            var newBBMax = boundingBoxMax(axisNode, orient);
            if (newBBMax !== calculatedLabelPosition) {
                changeCalculatedLabelPosition(newBBMax);
            }
        }
    }, [label, dynamicLabelPosition]);
    var axisParts = props.axisParts, _k = props.position, position = _k === void 0 ? [0, 0] : _k;
    var axisTickLines;
    if (!axisParts) {
        axisParts = axisPieces({
            padding: padding,
            tickValues: tickValues,
            scale: scale,
            ticks: ticks,
            orient: orient,
            size: [width, height],
            footer: footer,
            tickSize: tickSize
        });
        axisTickLines = (React.createElement("g", { className: "axis " + className }, axisLines({
            axisParts: axisParts,
            orient: orient,
            tickLineGenerator: tickLineGenerator,
            className: className,
            scale: scale
        })));
    }
    if (axisParts.length === 0) {
        return null;
    }
    var hoverWidth = 50;
    var hoverHeight = height;
    var hoverX = -50;
    var hoverY = 0;
    var baselineX = 0;
    var baselineY = 0;
    var baselineX2 = 0;
    var baselineY2 = height;
    var hoverFunction = function (e) {
        changeHoverPosition(e.nativeEvent.offsetY);
    };
    var circleX = 25;
    var textX = -25;
    var textY = 18;
    var lineWidth = width + 25;
    var lineHeight = 0;
    var circleY = hoverPosition;
    var annotationOffset = 0;
    var annotationType = "y";
    switch (orient) {
        case "right":
            position = [position[0], position[1]];
            hoverX = width;
            baselineX2 = baselineX = width;
            annotationOffset = margin.top;
            lineWidth = -width - 25;
            textX = 5;
            hoverFunction = function (e) {
                changeHoverPosition(e.nativeEvent.offsetY - annotationOffset);
            };
            if (center === true) {
                baselineX2 = baselineX = width / 2;
            }
            break;
        case "top":
            position = [position[0], 0];
            hoverWidth = width;
            hoverHeight = 50;
            hoverY = -50;
            hoverX = 0;
            annotationOffset = margin.left;
            annotationType = "x";
            baselineX2 = width;
            baselineY2 = 0;
            if (center === true) {
                baselineY2 = baselineY = height / 2;
            }
            hoverFunction = function (e) {
                changeHoverPosition(e.nativeEvent.offsetX - annotationOffset);
            };
            circleX = hoverPosition;
            circleY = 25;
            textX = 0;
            textY = -10;
            lineWidth = 0;
            lineHeight = height + 25;
            break;
        case "bottom":
            position = [position[0], 0];
            hoverWidth = width;
            hoverHeight = 50;
            baselineY = baselineY2 = hoverY = height;
            baselineX = hoverX = 0;
            baselineX2 = width;
            annotationOffset = margin.left;
            hoverFunction = function (e) {
                changeHoverPosition(e.nativeEvent.offsetX - annotationOffset);
            };
            circleX = hoverPosition;
            circleY = 25;
            textX = 0;
            textY = 15;
            lineWidth = 0;
            lineHeight = -height - 25;
            annotationType = "x";
            if (center === true) {
                baselineY2 = baselineY = height / 2;
            }
            break;
        default:
            position = [position[0], position[1]];
            annotationOffset = margin.top;
            if (center === true) {
                baselineX2 = baselineX = width / 2;
            }
            hoverFunction = function (e) {
                changeHoverPosition(e.nativeEvent.offsetY - annotationOffset);
            };
    }
    var annotationBrush;
    if (annotationFunction) {
        var formattedValue = formatValue(scale.invert(hoverPosition), props);
        var hoverGlyph = glyphFunction ? (glyphFunction({
            lineHeight: lineHeight,
            lineWidth: lineWidth,
            value: scale.invert(hoverPosition)
        })) : (React.createElement("g", null,
            React.isValidElement(formattedValue) ? (React.createElement("g", { transform: "translate(" + textX + "," + textY + ")" }, formattedValue)) : (React.createElement("text", { x: textX, y: textY }, formattedValue)),
            React.createElement("circle", { r: 5 }),
            React.createElement("line", { x1: lineWidth, y1: lineHeight, style: { stroke: "black" } })));
        var annotationSymbol = hoverPosition ? (React.createElement("g", { style: { pointerEvents: "none" }, transform: "translate(" + circleX + "," + circleY + ")" }, hoverGlyph)) : null;
        annotationBrush = (React.createElement("g", { className: "annotation-brush", transform: "translate(" + hoverX + "," + hoverY + ")" },
            React.createElement("rect", { style: { fillOpacity: 0 }, height: hoverHeight, width: hoverWidth, onMouseMove: hoverFunction, onClick: function (e) {
                    return annotationFunction({
                        className: "dynamic-axis-annotation",
                        type: annotationType,
                        value: scale.invert(hoverPosition),
                        e: e
                    });
                }, onMouseOut: function () {
                    changeHoverPosition(undefined);
                } }),
            annotationSymbol));
    }
    var summaryGraphic;
    if (marginalSummaryType && xyPoints) {
        var summaryWidth = Math.max(margin[orient] - 6, 5);
        var decoratedSummaryType_1 = typeof marginalSummaryType === "string"
            ? { type: marginalSummaryType }
            : marginalSummaryType;
        if (decoratedSummaryType_1.flip === undefined &&
            (orient === "bottom" || orient === "right")) {
            decoratedSummaryType_1.flip = true;
        }
        var summaryStyle = decoratedSummaryType_1.summaryStyle
            ? function () { return decoratedSummaryType_1.summaryStyle; }
            : function () { return ({
                fill: "black",
                fillOpacity: 0.5,
                stroke: "black",
                strokeDasharray: "0"
            }); };
        var summaryRenderMode = decoratedSummaryType_1.renderMode
            ? function () { return decoratedSummaryType_1.renderMode; }
            : function () { return undefined; };
        var summaryClass = decoratedSummaryType_1.summaryClass
            ? function () { return decoratedSummaryType_1.summaryClass; }
            : function () { return ""; };
        var dataFilter_1 = decoratedSummaryType_1.filter || (function () { return true; });
        var forSummaryData = xyPoints
            .filter(function (p) {
            return p.x !== undefined && p.y !== undefined && dataFilter_1(p.data);
        })
            .map(function (d) { return (__assign(__assign({}, d), { xy: {
                x: orient === "top" || orient === "bottom" ? scale(d.x) : 0,
                y: orient === "left" || orient === "right" ? scale(d.y) : 0
            }, piece: {
                scaledVerticalValue: scale(d.y),
                scaledValue: scale(d.x)
            }, value: orient === "top" || orient === "bottom" ? scale(d.y) : scale(d.x), scaledValue: scale(d.x), scaledVerticalValue: scale(d.y) })); });
        var renderedSummary = drawSummaries({
            data: {
                column: {
                    middle: summaryWidth / 2,
                    pieceData: forSummaryData,
                    width: summaryWidth,
                    xyData: forSummaryData
                }
            },
            type: decoratedSummaryType_1,
            renderMode: summaryRenderMode,
            eventListenersGenerator: decoratedSummaryType_1.eventListenersGenerator || (function () { return ({}); }),
            styleFn: summaryStyle,
            classFn: summaryClass,
            projection: orient === "top" || orient === "bottom" ? "horizontal" : "vertical",
            adjustedSize: size,
            margin: { top: 0, bottom: 0, left: 0, right: 0 },
            baseMarkProps: {}
        });
        var points = void 0;
        if (decoratedSummaryType_1.showPoints === true) {
            var mappedPoints = marginalPointMapper(orient, summaryWidth, forSummaryData);
            points = mappedPoints.map(function (d, i) { return (React.createElement("circle", { key: "axis-summary-point-" + i, cx: d[0], cy: d[1], r: decoratedSummaryType_1.r || 3, style: decoratedSummaryType_1.pointStyle || {
                    fill: "black",
                    fillOpacity: 0.1
                } })); });
        }
        var translation = {
            left: [-margin.left + 2, 0],
            right: [size[0] + 2, 0],
            top: [0, -margin.top + 2],
            bottom: [0, size[1] + 2]
        };
        summaryGraphic = (React.createElement("g", { transform: "translate(" + translation[orient] + ")" },
            React.createElement("g", { transform: "translate(" + ((decoratedSummaryType_1.type === "contour" ||
                    decoratedSummaryType_1.type === "boxplot") &&
                    (orient === "left" || orient === "right")
                    ? summaryWidth / 2
                    : 0) + "," + ((decoratedSummaryType_1.type === "contour" ||
                    decoratedSummaryType_1.type === "boxplot") &&
                    (orient === "top" || orient === "bottom")
                    ? summaryWidth / 2
                    : 0) + ")" }, renderedSummary.marks),
            points));
    }
    var axisTitle;
    var axisTickLabels = axisLabels({
        tickFormat: tickFormat,
        axisParts: axisParts,
        orient: orient,
        rotate: rotate,
        center: center
    });
    if (label) {
        var labelName = label.name || label;
        var labelPosition = label.position || {};
        var locationMod = labelPosition.location || "outside";
        var anchorMod = labelPosition.anchor || "middle";
        var distance = label.locationDistance || calculatedLabelPosition;
        var rotateHash = {
            left: -90,
            right: 90,
            top: 0,
            bottom: 0
        };
        var rotation = labelPosition.rotation || rotateHash[orient];
        var positionHash = {
            left: {
                start: [0, size[1]],
                middle: [0, size[1] / 2],
                end: [0, 0],
                inside: [distance || 15, 0],
                outside: [-(distance || 45), 0]
            },
            right: {
                start: [size[0] + 0, size[1]],
                middle: [size[0] + 0, size[1] / 2],
                end: [size[0] + 0, 0],
                inside: [-(distance || 15), 0],
                outside: [distance || 45, 0]
            },
            top: {
                start: [0, 0],
                middle: [0 + size[0] / 2, 0],
                end: [0 + size[0], 0],
                inside: [0, distance || 15],
                outside: [0, -(distance || 40)]
            },
            bottom: {
                start: [0, size[1]],
                middle: [0 + size[0] / 2, size[1]],
                end: [0 + size[0], size[1]],
                inside: [0, -(distance || 5)],
                outside: [0, distance || 50]
            }
        };
        var translation = positionHash[orient][anchorMod];
        var location_1 = positionHash[orient][locationMod];
        translation[0] = translation[0] + location_1[0];
        translation[1] = translation[1] + location_1[1];
        if (anchorMod === "start" && orient === "right") {
            anchorMod = "end";
        }
        else if (anchorMod === "end" && orient === "right") {
            anchorMod = "start";
        }
        axisTitle = (React.createElement("g", { className: "axis-title " + className, transform: "translate(" + [
                translation[0] + position[0],
                translation[1] + position[1]
            ] + ") rotate(" + rotation + ")" }, React.isValidElement(labelName) ? (labelName) : (React.createElement("text", { textAnchor: anchorMod }, labelName))));
    }
    var axisAriaLabel = orient + " axis " + ((axisParts &&
        axisParts.length > 0 &&
        "from " + tickFormat(axisParts[0].value, 0) + " to " + tickFormat(axisParts[axisParts.length - 1].value, axisParts.length - 1)) ||
        "without ticks");
    return (React.createElement("g", { className: className, "aria-label": axisAriaLabel, ref: axisNode },
        annotationBrush,
        axisTickLabels,
        axisTickLines,
        baseline === true ? (React.createElement("line", { key: "baseline", className: "axis-baseline " + className, stroke: "black", strokeLinecap: "square", x1: baselineX, x2: baselineX2, y1: baselineY, y2: baselineY2 })) : null,
        axisTitle,
        summaryGraphic));
}

var extent = function (inputArray) {
    return inputArray.reduce(function (p, c) {
        return [Math.min(c, p[0]), Math.max(c, p[1])];
    }, [Infinity, -Infinity]);
};
var findActualTitle = function (rawTitle) {
    var title = null;
    var orient = "top";
    if (typeof rawTitle === "string") {
        title = rawTitle;
    }
    else if ("title" in rawTitle) {
        title = rawTitle.title;
        orient = rawTitle.orient || "top";
    }
    else {
        title = rawTitle;
    }
    return { orient: orient, title: title };
};
function roundToTenth(number) {
    return Math.round(number * 10) / 10;
}
var circlePath = function (cx, cy, r) {
    return [
        "M",
        roundToTenth(cx - r),
        roundToTenth(cy),
        "a",
        r,
        r,
        0,
        1,
        0,
        r * 2,
        0,
        "a",
        r,
        r,
        0,
        1,
        0,
        -(r * 2),
        0
    ].join(" ") + "Z";
};
var drawMarginPath = function (_a) {
    var margin = _a.margin, size = _a.size, _b = _a.inset, inset = _b === void 0 ? 0 : _b;
    var iSize = [size[0] - inset, size[1] - inset];
    return "M0,0 h" + size[0] + " v" + size[1] + " h-" + size[0] + "Z M" + (margin.left -
        inset) + "," + (margin.top - inset) + " v" + (size[1] +
        inset * 2 -
        margin.top -
        margin.bottom) + " h" + (iSize[0] +
        inset * 3 -
        margin.left -
        margin.right) + " v-" + (iSize[1] + inset * 3 - margin.top - margin.bottom) + "Z";
};
var calculateMargin = function (_a) {
    var margin = _a.margin, axes = _a.axes, rawTitle = _a.title, oLabel = _a.oLabel, projection = _a.projection, size = _a.size;
    if (margin !== undefined) {
        if (typeof margin === "function") {
            margin = margin({ size: size });
        }
        if (typeof margin !== "object") {
            return { top: margin, bottom: margin, left: margin, right: margin };
        }
        else if (typeof margin === "object") {
            return Object.assign({ top: 0, bottom: 0, left: 0, right: 0 }, margin);
        }
    }
    var finalMargin = { top: 0, bottom: 0, left: 0, right: 0 };
    var orient = "left";
    if (axes && projection !== "radial") {
        axes.forEach(function (axisObj) {
            var axisObjAdditionMargin = axisObj.label ? 60 : 50;
            orient = axisObj.orient;
            finalMargin[orient] = axisObjAdditionMargin;
        });
    }
    var _b = findActualTitle(rawTitle), title = _b.title, titleOrient = _b.orient;
    if (title && !(typeof title === "string" && title.length === 0)) {
        finalMargin[titleOrient] += 40;
    }
    if (oLabel && projection !== "radial") {
        if (orient === "bottom" || orient === "top") {
            finalMargin.left += 50;
        }
        else {
            finalMargin.bottom += 50;
        }
    }
    return finalMargin;
};
function objectifyType(type) {
    if (type instanceof Function || typeof type === "string") {
        return { type: type };
    }
    else if (type === undefined) {
        return {};
    }
    return type;
}
function keyAndObjectifyBarData(_a) {
    var data = _a.data, _b = _a.renderKey, renderKey = _b === void 0 ? function (d, i) { return i; } : _b, oAccessor = _a.oAccessor, baseRAccessor = _a.rAccessor, originalRAccessor = _a.originalRAccessor, originalOAccessor = _a.originalOAccessor, _c = _a.multiAxis, multiAxis = _c === void 0 ? false : _c;
    var rAccessor;
    var multiExtents;
    if (multiAxis && baseRAccessor.length > 1) {
        var minNegative_1 = Infinity;
        multiExtents = baseRAccessor.map(function (accessor) {
            var basicExtent = extent(data.map(accessor));
            minNegative_1 = Math.min(basicExtent[0] / basicExtent[1], minNegative_1);
            return basicExtent;
        });
        var rScales = multiExtents.map(function (ext) {
            var range = [0, 1];
            var adjustedExtent = ext;
            if (ext[0] < 0 && ext[1] > 0) {
                range[0] = minNegative_1;
                adjustedExtent[0] = adjustedExtent[1] * minNegative_1;
            }
            else if (ext[0] < 0 && ext[1] < 0) {
                adjustedExtent[1] = 0;
                range = [-1, 0];
            }
            else {
                adjustedExtent[0] = 0;
            }
            return scaleLinear()
                .domain(ext)
                .range(range);
        });
        rAccessor = rScales.map(function (scale, i) { return function (d) {
            return scale(baseRAccessor[i](d));
        }; });
    }
    else {
        rAccessor = baseRAccessor;
    }
    var decoratedData = [];
    oAccessor.forEach(function (actualOAccessor, oIndex) {
        rAccessor.forEach(function (actualRAccessor, rIndex) {
            (data || []).forEach(function (d) {
                var baseAppliedKey = renderKey(d, decoratedData.length);
                var appliedKey = (baseAppliedKey !== undefined &&
                    baseAppliedKey.toString &&
                    baseAppliedKey.toString()) ||
                    baseAppliedKey;
                var originalR = originalRAccessor[rIndex];
                var originalO = originalOAccessor[oIndex];
                var rName = typeof originalR === "string" ? originalR : "function-" + rIndex;
                var oName = typeof originalO === "string" ? originalO : "function-" + oIndex;
                if (typeof d !== "object") {
                    var expandedData = { value: d, renderKey: appliedKey };
                    var value = actualRAccessor(expandedData);
                    decoratedData.push({
                        data: expandedData,
                        value: value,
                        rIndex: rIndex,
                        rName: rName,
                        oIndex: oIndex,
                        oName: oName,
                        column: appliedKey,
                        renderKey: appliedKey
                    });
                }
                else {
                    var value = actualRAccessor(d);
                    var column = actualOAccessor(d);
                    decoratedData.push({
                        renderKey: appliedKey,
                        data: d,
                        rIndex: rIndex,
                        rName: rName,
                        oIndex: oIndex,
                        oName: oName,
                        value: value,
                        column: column && column.toString ? column.toString() : column
                    });
                }
            });
        });
    });
    return { allData: decoratedData, multiExtents: multiExtents };
}
function adjustedPositionSize(_a) {
    var _b = _a.size, size = _b === void 0 ? [500, 500] : _b, _c = _a.position, position = _c === void 0 ? [0, 0] : _c, margin = _a.margin, projection = _a.projection;
    var heightAdjust = margin.top + margin.bottom;
    var widthAdjust = margin.left + margin.right;
    var adjustedPosition = [position[0], position[1]];
    var adjustedSize = [size[0] - widthAdjust, size[1] - heightAdjust];
    if (projection === "radial") {
        var minSize = Math.min(adjustedSize[0], adjustedSize[1]);
        adjustedSize = [minSize, minSize];
    }
    return { adjustedPosition: adjustedPosition, adjustedSize: adjustedSize };
}
function generateFrameTitle(_a) {
    var _b = _a.title, rawTitle = _b === void 0 ? { title: "", orient: "top" } : _b, size = _a.size;
    var finalTitle = null;
    var _c = findActualTitle(rawTitle), title = _c.title, orient = _c.orient;
    var x = 0, y = 0, transform;
    switch (orient) {
        case "top":
            x = size[0] / 2;
            y = 25;
            break;
        case "bottom":
            x = size[0] / 2;
            y = size[1] - 25;
            break;
        case "left":
            x = 25;
            y = size[1] / 2;
            transform = "rotate(-90)";
            break;
        case "right":
            x = size[0] - 25;
            y = size[1] / 2;
            transform = "rotate(90)";
            break;
    }
    var gTransform = "translate(" + x + "," + y + ")";
    if (typeof title === "string" && title.length > 0) {
        finalTitle = (React.createElement("g", { transform: gTransform },
            React.createElement("text", { className: "frame-title", transform: transform, style: { textAnchor: "middle", pointerEvents: "none" } }, title)));
    }
    else if (title) {
        //assume if defined then its an svg mark of some sort
        finalTitle = React.createElement("g", { transform: gTransform }, title);
    }
    return finalTitle;
}
function orFrameConnectionRenderer(_a) {
    var e_1, _b;
    var type = _a.type, data = _a.data, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, classFn = _a.classFn, projection = _a.projection, canvasRender = _a.canvasRender, canvasDrawing = _a.canvasDrawing, baseMarkProps = _a.baseMarkProps, pieceType = _a.pieceType;
    if (!type.type) {
        return null;
    }
    var renderedConnectorMarks = [];
    var radarHash = new Map();
    if (typeof type.type === "function") {
        var connectionRule_1 = type.type;
        var keys_1 = Object.keys(data);
        keys_1.forEach(function (key, pieceArrayI) {
            var pieceArray = data[key];
            var nextColumn = data[keys_1[pieceArrayI + 1]];
            if (nextColumn) {
                var matchArray_1 = nextColumn.map(function (d, i) {
                    return connectionRule_1(__assign(__assign({}, d.piece), d.piece.data), i);
                });
                pieceArray.forEach(function (piece, pieceI) {
                    var thisConnectionPiece = connectionRule_1(__assign(__assign({}, piece.piece), piece.piece.data), pieceI);
                    var targetMatch = connectionRule_1(__assign(__assign({}, piece.piece), piece.piece.data), pieceI);
                    var matchingPieceIndex = targetMatch !== undefined &&
                        targetMatch !== false &&
                        matchArray_1.indexOf(targetMatch);
                    if (thisConnectionPiece !== undefined &&
                        thisConnectionPiece !== null &&
                        matchingPieceIndex !== false &&
                        matchingPieceIndex !== -1) {
                        var matchingPiece = nextColumn[matchingPieceIndex];
                        var markD = void 0;
                        if (projection === "radial" && pieceType.type === "point") {
                            if (!radarHash.get(piece)) {
                                radarHash.set(piece, [piece]);
                            }
                            var thisRadar = radarHash.get(piece);
                            if (thisRadar) {
                                thisRadar.push(matchingPiece);
                                radarHash.set(matchingPiece, thisRadar);
                                radarHash.delete(piece);
                            }
                        }
                        else {
                            var xy = piece.xy;
                            var mxy = matchingPiece.xy;
                            var x = xy.x, y = xy.y, _a = xy.height, height = _a === void 0 ? 1 : _a, _b = xy.width, width = _b === void 0 ? 1 : _b;
                            var mx = mxy.x, my = mxy.y, _c = mxy.height, mheight = _c === void 0 ? 1 : _c, _d = mxy.width, mwidth = _d === void 0 ? 1 : _d;
                            if (projection === "vertical") {
                                markD = drawAreaConnector({
                                    x1: x + width,
                                    x2: mx,
                                    y1: y,
                                    y2: my,
                                    sizeX1: 0,
                                    sizeX2: 0,
                                    sizeY1: height,
                                    sizeY2: mheight
                                });
                            }
                            else if (projection === "horizontal") {
                                markD = drawAreaConnector({
                                    x1: x,
                                    x2: mx,
                                    y1: y + height,
                                    y2: my,
                                    sizeX1: width,
                                    sizeX2: mwidth,
                                    sizeY1: 0,
                                    sizeY2: 0
                                });
                            }
                            else if (projection === "radial") {
                                markD = drawAreaConnector({
                                    x1: x,
                                    x2: mx,
                                    y1: y + height,
                                    y2: my,
                                    sizeX1: width,
                                    sizeX2: mwidth,
                                    sizeY1: 0,
                                    sizeY2: 0
                                });
                            }
                            var renderValue = renderMode && renderMode(piece.piece, pieceI);
                            var source = __assign(__assign({}, piece.piece.data), piece.piece.data);
                            var target = __assign(__assign({}, matchingPiece.piece), matchingPiece.piece.data);
                            var calculatedStyle = styleFn({
                                source: source,
                                target: target
                            });
                            var eventListeners = eventListenersGenerator({ source: source, target: target }, pieceI);
                            if (canvasRender && canvasRender(piece.piece) === true) {
                                var canvasConnector = {
                                    baseClass: "xyframe-line",
                                    tx: 0,
                                    ty: 0,
                                    d: {
                                        source: source,
                                        target: target
                                    },
                                    markProps: { d: markD, markType: "path" },
                                    styleFn: styleFn,
                                    renderFn: renderMode,
                                    classFn: classFn
                                };
                                canvasDrawing.push(canvasConnector);
                            }
                            else {
                                renderedConnectorMarks.push(React.createElement(Mark, __assign({}, baseMarkProps, eventListeners, { renderMode: renderValue, markType: "path", d: markD, className: classFn ? classFn(piece.piece.data, pieceI) : "", key: "connector" + piece.piece.renderKey, style: calculatedStyle })));
                            }
                        }
                    }
                });
            }
        });
        if (radarHash.size > 0) {
            try {
                for (var _c = __values(radarHash.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var ring = _d.value;
                    var ringPiece = __assign(__assign({}, ring[0].piece), ring[0].piece.data);
                    var markD = "M" + ring.map(function (d) { return d.xy.x + "," + d.xy.y; }).join("L") + "Z";
                    if (canvasRender && canvasRender(ringPiece)) {
                        var canvasRadar = {
                            baseClass: "ordinal-radar",
                            tx: 0,
                            ty: 0,
                            d: {
                                source: ringPiece
                            },
                            markProps: { d: markD, markType: "path" },
                            styleFn: styleFn,
                            renderFn: renderMode,
                            classFn: classFn
                        };
                        canvasDrawing.push(canvasRadar);
                    }
                    else {
                        renderedConnectorMarks.push(React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode && renderMode(ringPiece), markType: "path", d: markD, className: classFn ? classFn(ringPiece) : "", key: "ordinal-ring-" + ringPiece.renderKey, style: styleFn({
                                source: ringPiece
                            }) })));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    }
    else if (type.type) {
        console.error("Invalid connectorType - Must be a function that takes a data point and determines if it is connected to a data point in the next column");
    }
    return renderedConnectorMarks;
}
var summaryRenderHash = {
    contour: contourRenderFn,
    boxplot: boxplotRenderFn,
    violin: bucketizedRenderingFn,
    heatmap: bucketizedRenderingFn,
    ridgeline: bucketizedRenderingFn,
    histogram: bucketizedRenderingFn,
    horizon: bucketizedRenderingFn
};
function orFrameSummaryRenderer(_a) {
    var data = _a.data, type = _a.type, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, classFn = _a.classFn, projection = _a.projection, adjustedSize = _a.adjustedSize, chartSize = _a.chartSize, baseMarkProps = _a.baseMarkProps, margin = _a.margin;
    var summaryRenderFn;
    if (typeof type.type === "function") {
        summaryRenderFn = type.type;
    }
    else if (summaryRenderHash[type.type]) {
        summaryRenderFn = summaryRenderHash[type.type];
    }
    else {
        console.error("Invalid summary type: " + type.type + " - Must be a function or one of the following strings: " + Object.keys(summaryRenderHash).join(", "));
        return {};
    }
    return summaryRenderFn({
        data: data,
        type: type,
        renderMode: renderMode,
        eventListenersGenerator: eventListenersGenerator,
        styleFn: styleFn,
        classFn: classFn,
        projection: projection,
        adjustedSize: adjustedSize,
        chartSize: chartSize,
        baseMarkProps: baseMarkProps,
        margin: margin
    });
}
var orFrameAxisGenerator = function (_a) {
    var projection = _a.projection, axis = _a.axis, adjustedSize = _a.adjustedSize, size = _a.size, rScale = _a.rScale, rScaleType = _a.rScaleType, pieceType = _a.pieceType, rExtent = _a.rExtent, data = _a.data, _b = _a.maxColumnValues, maxColumnValues = _b === void 0 ? 1 : _b, xyData = _a.xyData, margin = _a.margin, thresholds = _a.thresholds;
    if (!axis)
        return { axis: undefined, axesTickLines: undefined };
    var generatedAxis, axesTickLines;
    if (projection !== "radial" && axis) {
        axesTickLines = [];
        var axisPosition_1 = [0, 0];
        generatedAxis = axis.map(function (d, i) {
            var axisClassname = d.className || "";
            var tickValues;
            var axisDomain = d.extentOverride ? d.extentOverride : rScale.domain();
            var leftRight = ["left", "right"];
            var axisScale = (leftRight.indexOf(d.orient) === -1 && projection !== "vertical") ||
                (leftRight.indexOf(d.orient) !== -1 && projection !== "horizontal")
                ? rScaleType.domain(axisDomain)
                : rScaleType.domain([0, maxColumnValues]);
            var orient = d.orient;
            var axisRange = (leftRight.indexOf(d.orient) === -1 && projection !== "vertical") ||
                (leftRight.indexOf(d.orient) !== -1 && projection !== "horizontal")
                ? rScale.range()
                : [0, projection === "vertical" ? adjustedSize[0] : adjustedSize[1]];
            if (orient === "right") {
                axisScale.range(axisRange.reverse());
                axisClassname += " right y";
            }
            else if (orient === "left") {
                axisClassname += " left y";
                axisScale.range(axisRange.reverse());
            }
            else if (orient === "top") {
                axisClassname += " top x";
                axisScale.range(axisRange);
            }
            else if (orient === "bottom") {
                axisClassname += " bottom x";
                axisScale.range(axisRange);
            }
            if (d.tickValues && Array.isArray(d.tickValues)) {
                tickValues = d.tickValues;
            }
            else if (d.tickValues instanceof Function) {
                //otherwise assume a function
                tickValues = d.tickValues(data, size, rScale);
            }
            else if (!d.tickValues && thresholds) {
                tickValues = thresholds.map(function (d) { return rScale.invert(d); });
            }
            var axisParts = axisPieces({
                padding: d.padding,
                tickValues: tickValues,
                scale: axisScale,
                ticks: d.ticks,
                orient: orient,
                size: adjustedSize,
                footer: d.footer,
                tickSize: d.tickSize,
                jaggedBase: d.jaggedBase
            });
            var axisTickLines = axisLines({
                className: d.className,
                axisParts: axisParts,
                orient: orient,
                baseMarkProps: {},
                tickLineGenerator: d.tickLineGenerator,
                jaggedBase: d.jaggedBase,
                scale: axisScale
            });
            axesTickLines.push(axisTickLines);
            if (d.baseline === "under") {
                axesTickLines.push(baselineGenerator(d.orient, adjustedSize, d.className));
            }
            var marginalSummaryType = typeof d.marginalSummaryType === "string"
                ? { type: d.marginalSummaryType }
                : d.marginalSummaryType;
            return (React.createElement(Axis, __assign({}, d, { key: d.key || "orframe-axis-" + i, axisParts: axisParts, orient: orient, size: adjustedSize, position: axisPosition_1, tickValues: tickValues, scale: axisScale, className: axisClassname, marginalSummaryType: marginalSummaryType, margin: margin, xyPoints: xyData.map(function (d) { return ({
                    x: projection === "vertical" ? 0 : d.value,
                    y: projection === "vertical" ? d.value : 0,
                    data: d.data
                }); }) })));
        });
    }
    else if (projection === "radial" && axis) {
        var _c = pieceType.innerRadius, innerRadius_1 = _c === void 0 ? 0 : _c;
        var ticks_1 = [];
        axis.forEach(function (axisObj) {
            var _a = axisObj.tickValues, baseTickValues = _a === void 0 ? rScale.ticks(Math.max(2, (adjustedSize[0] / 2 - innerRadius_1) / 50)) : _a, label = axisObj.label, _b = axisObj.tickFormat, tickFormat = _b === void 0 ? function (d) { return d; } : _b;
            var tickScale = rScaleType
                .domain(rExtent)
                .range([innerRadius_1, adjustedSize[0] / 2]);
            var tickValues = baseTickValues instanceof Function
                ? baseTickValues({
                    orient: axisObj.orient
                })
                : baseTickValues;
            tickValues.forEach(function (t, i) {
                var tickSize = tickScale(t);
                if (!(innerRadius_1 === 0 && t === 0)) {
                    var axisLabel = void 0;
                    var ref = "";
                    if (label && i === tickValues.length - 1) {
                        var labelSettings = typeof label === "string"
                            ? { name: label, locationDistance: 15 }
                            : label;
                        var _a = labelSettings.locationDistance, locationDistance = _a === void 0 ? 15 : _a;
                        ref = Math.random().toString() + " ";
                        axisLabel = (React.createElement("g", { className: "axis-label radial", transform: "translate(0," + locationDistance + ")" },
                            React.createElement("text", { textAnchor: "middle" },
                                React.createElement("textPath", { startOffset: tickSize * Math.PI * 0.5, xlinkHref: "#" + ref }, label.name))));
                    }
                    ticks_1.push(React.createElement("g", { key: "orframe-radial-axis-element-" + t, className: "axis axis-label axis-tick radial", transform: "translate(0,0)" },
                        React.createElement("path", { id: ref, d: circlePath(0, 0, tickSize), r: tickSize, stroke: "gray", fill: "none" }),
                        React.createElement("text", { y: -tickSize + 5, textAnchor: "middle" }, tickFormat(t)),
                        axisLabel));
                }
                return undefined;
            });
        });
        generatedAxis = [
            React.createElement("g", { key: axis[0].key || "orframe-radial-axis-container", className: "axis-labels", transform: "translate(" + adjustedSize[0] / 2 + "," + adjustedSize[1] / 2 + ")" }, ticks_1)
        ];
    }
    return { axis: generatedAxis, axesTickLines: axesTickLines };
};
var canvasEvent = function (canvasContext, overlayRegions, canvasMap, e) {
    var interactionContext = canvasContext.getContext("2d");
    var hoverPoint = interactionContext.getImageData(e.offsetX, e.offsetY, 1, 1);
    var mostCommonRGB = "rgba(" + hoverPoint.data[0] + "," + hoverPoint.data[1] + "," + hoverPoint.data[2] + ",255)";
    var overlay = overlayRegions[canvasMap.get(mostCommonRGB)];
    if (!overlay) {
        var hoverArea = interactionContext.getImageData(e.offsetX - 2, e.offsetY - 2, 5, 5);
        var x = 0;
        while (!overlay && x < 100) {
            overlay =
                overlayRegions[canvasMap.get("rgba(" + hoverArea.data[x] + "," + hoverArea.data[x + 1] + "," + hoverArea.data[x + 2] + ",255)")];
            x += 4;
        }
    }
    return overlay;
};

var InteractionCanvas = /** @class */ (function (_super) {
    __extends(InteractionCanvas, _super);
    function InteractionCanvas(props) {
        var _this = _super.call(this, props) || this;
        _this.canvasMap = new Map();
        _this.canvasRendering = function () {
            var canvasMap = _this.canvasMap;
            var interactionContext = _this.state.interactionContext;
            var _a = _this.props, voronoiHover = _a.voronoiHover, height = _a.height, width = _a.width, overlayRegions = _a.overlayRegions, margin = _a.margin;
            if (interactionContext === null || !overlayRegions)
                return;
            var boundCanvasEvent = canvasEvent.bind(null, interactionContext, overlayRegions, _this.canvasMap);
            interactionContext.onmousemove = function (e) {
                var overlay = boundCanvasEvent(e);
                if (overlay && overlay.props && overlay.props.children[0]) {
                    overlay.props.children[0].props.onMouseEnter();
                }
                else {
                    voronoiHover(null);
                }
            };
            interactionContext.onmouseout = function () {
                voronoiHover(null);
            };
            interactionContext.onclick = function (e) {
                var overlay = boundCanvasEvent(e);
                if (overlay && overlay.props) {
                    overlay.props.children[0].props.onClick(e);
                }
            };
            interactionContext.ondblclick = function (e) {
                var overlay = boundCanvasEvent(e);
                if (overlay && overlay.props) {
                    overlay.props.children[0].props.onDoubleClick(e);
                }
            };
            canvasMap.clear();
            var interactionContext2D = interactionContext.getContext("2d");
            interactionContext2D.imageSmoothingEnabled = false;
            interactionContext2D.setTransform(1, 0, 0, 1, margin.left, margin.top);
            interactionContext2D.clearRect(-margin.left, -margin.top, width, height);
            interactionContext2D.lineWidth = 1;
            overlayRegions.forEach(function (overlay, oi) {
                var overlayD = overlay.props.d || overlay.props.children[0].props.d;
                var interactionRGBA = "rgba(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ",255)";
                canvasMap.set(interactionRGBA, oi);
                interactionContext2D.fillStyle = interactionRGBA;
                interactionContext2D.strokeStyle = interactionRGBA;
                var p = new Path2D(overlayD);
                interactionContext2D.stroke(p);
                interactionContext2D.fill(p);
            });
        };
        _this.state = {
            ref: null,
            interactionContext: null
        };
        return _this;
    }
    InteractionCanvas.prototype.componentDidMount = function () {
        this.canvasRendering();
    };
    InteractionCanvas.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.width !== this.props.width ||
            prevProps.height !== this.props.height ||
            this.props.overlayRegions !== prevProps.overlayRegions ||
            (!prevState.interactionContext && this.state.interactionContext)) {
            this.canvasRendering();
        }
    };
    InteractionCanvas.prototype.render = function () {
        var _this = this;
        var _a = this.props, width = _a.width, height = _a.height;
        return (React.createElement("canvas", { className: "frame-canvas-interaction", ref: function (canvasContext) {
                if (canvasContext &&
                    _this.state.interactionContext !== canvasContext) {
                    _this.setState({ interactionContext: canvasContext });
                }
            }, style: {
                position: "absolute",
                left: "0px",
                top: "0px",
                imageRendering: "pixelated",
                pointerEvents: "all",
                opacity: 0
            }, width: width, height: height }));
    };
    return InteractionCanvas;
}(React.Component));

var generateOMappingFn = function (projectedColumns) {
    return function (d) {
        if (d) {
            var columnValues = Object.values(projectedColumns);
            var foundColumns = columnValues.filter(function (c) {
                return d[1] >= c.x && d[0] <= c.x + c.width;
            });
            return foundColumns;
        }
        return null;
    };
};
var generateOEndMappingFn = function (projectedColumns) {
    return function (d, event) {
        if (d &&
            event.sourceEvent &&
            event.sourceEvent.path &&
            event.sourceEvent.path[1] &&
            event.sourceEvent.path[1].classList.contains("xybrush") &&
            event.target.move) {
            var columnValues = Object.values(projectedColumns);
            var foundColumns = columnValues.filter(function (c) { return d[1] >= c.x && d[0] <= c.x + c.width; });
            var firstColumn = foundColumns[0] || {
                x: 0,
                width: 0
            };
            var lastColumn = foundColumns[foundColumns.length - 1] || {
                x: 0,
                width: 0
            };
            var columnPosition = [
                firstColumn.x + Math.min(5, firstColumn.width / 10),
                lastColumn.x + lastColumn.width - Math.min(5, lastColumn.width / 10)
            ];
            select(event.sourceEvent.path[1])
                .transition(750)
                .call(event.target.move, columnPosition);
            return foundColumns;
        }
        return null;
    };
};
var createBrush = function (interaction, props) {
    var semioticBrush, mappingFn, selectedExtent, endMappingFn;
    var xScale = props.xScale, yScale = props.yScale, size = props.size, renderPipeline = props.renderPipeline;
    var brushData = {};
    Object.entries(renderPipeline).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (value.data && value.data.length > 0) {
            brushData[key] = value.data;
        }
    });
    var projection = interaction.projection, projectedColumns = interaction.projectedColumns;
    var actualBrush = interaction.brush === "oBrush"
        ? projection === "horizontal"
            ? "yBrush"
            : "xBrush"
        : interaction.brush;
    var extent = interaction.extent;
    if (!extent) {
        extent =
            actualBrush === "xyBrush"
                ? [
                    [xScale.invert(0), yScale.invert(0)],
                    [xScale.invert(size[0]), yScale.invert(size[1])]
                ]
                : actualBrush === "xBrush"
                    ? [xScale.invert(0), xScale.invert(size[0])]
                    : [yScale.invert(0), yScale.invert(size[1])];
    }
    if (extent.indexOf && extent.indexOf(undefined) !== -1) {
        return React.createElement("g", null);
    }
    if (actualBrush === "xBrush") {
        var castExtent = __spread(extent);
        mappingFn = function (d) {
            return !d ? null : [xScale.invert(d[0]), xScale.invert(d[1])];
        };
        semioticBrush = brushX();
        selectedExtent = castExtent.map(function (d) { return xScale(d); });
        endMappingFn = mappingFn;
    }
    else if (actualBrush === "yBrush") {
        var castExtent = __spread(extent);
        mappingFn = function (d) {
            return !d
                ? null
                : [yScale.invert(d[0]), yScale.invert(d[1])].sort(function (a, b) { return a - b; });
        };
        semioticBrush = brushY();
        selectedExtent = castExtent.map(function (d) { return yScale(d); }).sort(function (a, b) { return a - b; });
        endMappingFn = mappingFn;
    }
    else {
        var typedExtent = extent;
        var castExtent = __spread(typedExtent.map(function (ee) { return __spread(ee); }));
        if (castExtent.indexOf(undefined) !== -1 ||
            castExtent[0].indexOf(undefined) !== -1 ||
            castExtent[1].indexOf(undefined) !== -1) {
            return React.createElement("g", null);
        }
        semioticBrush = brush();
        mappingFn = function (d) {
            if (!d)
                return null;
            var yValues = [yScale.invert(d[0][1]), yScale.invert(d[1][1])].sort(function (a, b) { return a - b; });
            return [
                [xScale.invert(d[0][0]), yValues[0]],
                [xScale.invert(d[1][0]), yValues[1]]
            ];
        };
        var yValues_1 = [yScale(extent[0][1]), yScale(extent[1][1])].sort(function (a, b) { return a - b; });
        selectedExtent = castExtent.map(function (d, i) { return [xScale(d[0]), yValues_1[i]]; });
        endMappingFn = mappingFn;
    }
    if (interaction.brush === "oBrush") {
        selectedExtent = null;
        if (interaction.extent) {
            var _a = __read(interaction.extent, 2), leftExtent = _a[0], rightExtent = _a[1];
            if ((typeof leftExtent === "string" || typeof leftExtent === "number") &&
                (typeof rightExtent === "string" || typeof rightExtent === "number")) {
                selectedExtent = [
                    projectedColumns[leftExtent].x,
                    projectedColumns[rightExtent].x + projectedColumns[rightExtent].width
                ];
            }
        }
        mappingFn = generateOMappingFn(projectedColumns);
        endMappingFn = generateOEndMappingFn(projectedColumns);
    }
    semioticBrush
        .extent([
        [0, 0],
        [size[0], size[1]]
    ])
        .on("start", function (event) {
        brushStart(mappingFn(event.selection), undefined, brushData, undefined, interaction);
    })
        .on("brush", function (event) {
        brushing(mappingFn(event.selection), undefined, brushData, undefined, interaction);
    })
        .on("end", function (event) {
        brushEnd(endMappingFn(event.selection, event), undefined, brushData, undefined, interaction);
    });
    return (React.createElement("g", { className: "brush" },
        React.createElement(Brush, { selectedExtent: selectedExtent, extent: extent, svgBrush: semioticBrush })));
};
var createColumnsBrush = function (interaction, props) {
    var projection = props.projection, rScale = props.rScale, oColumns = props.oColumns, renderPipeline = props.renderPipeline;
    if (!projection || !rScale || !oColumns)
        return;
    var brushData = {};
    Object.entries(renderPipeline).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (value.data && value.data.length > 0) {
            brushData[key] = value.data;
        }
    });
    var semioticBrush, mappingFn;
    var rScaleReverse = rScale
        .copy()
        .domain(rScale.domain())
        .range(rScale.domain().reverse());
    if (projection && projection === "horizontal") {
        mappingFn = function (d) {
            return !d ? null : [rScale.invert(d[0]), rScale.invert(d[1])];
        };
    }
    else
        mappingFn = function (d) {
            return !d
                ? null
                : [
                    rScaleReverse(rScale.invert(d[1])),
                    rScaleReverse(rScale.invert(d[0]))
                ];
        };
    var rRange = rScale.range();
    var columnHash = oColumns;
    var brushPosition, selectedExtent;
    var brushes = Object.keys(columnHash).map(function (c) {
        if (projection && projection === "horizontal") {
            selectedExtent = interaction.extent[c]
                ? interaction.extent[c].map(function (d) { return rScale(d); })
                : interaction.startEmpty
                    ? null
                    : rRange;
            brushPosition = [0, columnHash[c].x];
            semioticBrush = brushX();
            semioticBrush
                .extent([
                [rRange[0], 0],
                [rRange[1], columnHash[c].width]
            ])
                .on("start", function (event) {
                brushStart(mappingFn(event.selection), c, brushData, columnHash[c], interaction);
            })
                .on("brush", function (event) {
                brushing(mappingFn(event.selection), c, brushData, columnHash[c], interaction);
            })
                .on("end", function (event) {
                brushEnd(mappingFn(event.selection), c, brushData, columnHash[c], interaction);
            });
        }
        else {
            selectedExtent = interaction.extent[c]
                ? interaction.extent[c].map(function (d) { return rRange[1] - rScale(d); }).reverse()
                : interaction.startEmpty
                    ? null
                    : rRange;
            brushPosition = [columnHash[c].x, 0];
            semioticBrush = brushY();
            semioticBrush
                .extent([
                [0, rRange[0]],
                [columnHash[c].width, rRange[1]]
            ])
                .on("start", function (event) {
                brushStart(mappingFn(event.selection), c, brushData, columnHash[c], interaction);
            })
                .on("brush", function (event) {
                brushing(mappingFn(event.selection), c, brushData, columnHash[c], interaction);
            })
                .on("end", function (event) {
                brushEnd(mappingFn(event.selection), c, brushData, columnHash[c], interaction);
            });
        }
        return (React.createElement("g", { key: "column-brush-" + c, className: "brush" },
            React.createElement(Brush, { key: "orbrush" + c, selectedExtent: selectedExtent, svgBrush: semioticBrush, position: brushPosition })));
    });
    return brushes;
};
function InteractionLayer(props) {
    var semioticBrush = null;
    var interaction = props.interaction, _a = props.svgSize, svgSize = _a === void 0 ? [500, 500] : _a, _b = props.margin, margin = _b === void 0 ? { left: 0, right: 0, top: 0, bottom: 0 } : _b, _c = props.useSpans, useSpans = _c === void 0 ? false : _c, overlay = props.overlay, points = props.points, xScale = props.xScale, yScale = props.yScale, hoverAnnotation = props.hoverAnnotation, customClickBehavior = props.customClickBehavior, customDoubleClickBehavior = props.customDoubleClickBehavior, customHoverBehavior = props.customHoverBehavior, disableCanvasInteraction = props.disableCanvasInteraction, canvasRendering = props.canvasRendering, voronoiHover = props.voronoiHover;
    var enabled = props.enabled;
    var _d = __read(useState([]), 2), overlayRegions = _d[0], changeOverlayRegions = _d[1];
    var _e = __read(useState(null), 2), interactionCanvas = _e[0], changeInteractionCanvas = _e[1];
    var _f = __read(useState(function () { return HOCSpanOrDiv(useSpans); }), 1), SpanOrDiv = _f[0];
    useEffect(function () {
        var nextOverlay, interactionCanvas;
        if (disableCanvasInteraction || !overlayRegions) {
            nextOverlay = null;
            interactionCanvas = null;
        }
        else {
            nextOverlay = calculateOverlay(props);
            if (canvasRendering) {
                interactionCanvas = (React.createElement(InteractionCanvas, { height: svgSize[1], width: svgSize[0], overlayRegions: nextOverlay, margin: margin, voronoiHover: voronoiHover }));
            }
        }
        changeOverlayRegions(nextOverlay);
        changeInteractionCanvas(interactionCanvas);
    }, [
        overlay,
        points,
        xScale,
        yScale,
        !!hoverAnnotation,
        !!customClickBehavior,
        !!customDoubleClickBehavior,
        !!customHoverBehavior
    ]);
    if (interaction && interaction.brush) {
        enabled = true;
        semioticBrush = createBrush(interaction, props);
    }
    if (interaction && interaction.columnsBrush) {
        enabled = true;
        semioticBrush = createColumnsBrush(interaction, props);
    }
    if (!overlayRegions && !semioticBrush) {
        return null;
    }
    return (React.createElement(SpanOrDiv, { span: useSpans, className: "interaction-layer", style: {
            position: "absolute",
            background: "none",
            pointerEvents: "none"
        } }, interactionCanvas || (React.createElement("svg", { height: svgSize[1], width: svgSize[0], style: { background: "none", pointerEvents: "none" } },
        React.createElement("g", { className: "interaction-overlay", transform: "translate(" + margin.left + "," + margin.top + ")", style: { pointerEvents: enabled ? "all" : "none" } },
            React.createElement("g", { className: "interaction-regions" }, overlayRegions),
            semioticBrush)))));
}

var renderQueue = function (func) {
    var _queue = [], // data to be rendered
    _rate = 1000, // number of calls per frame
    _invalidate = function () { }, // invalidate last render queue
    _clear = function () { }; // clearing function
    // type RenderQueueType = { (): (data: any) => void, render?: Function, invalidate?: Function, data?: Function}
    var rq = function (data) {
        if (data)
            rq.data(data);
        _invalidate();
        _clear();
        rq.render();
    };
    rq.render = function () {
        var valid = true;
        _invalidate = rq.invalidate = function () {
            valid = false;
        };
        function doFrame() {
            if (!valid)
                return true;
            var chunk = _queue.splice(0, _rate);
            chunk.forEach(func);
            if (_queue.length > 0)
                timer_frame(doFrame);
        }
        doFrame();
    };
    rq.data = function (data) {
        _invalidate();
        _queue = data.slice(0); // creates a copy of the data
        return rq;
    };
    rq.add = function (data) {
        _queue = _queue.concat(data);
    };
    rq.rate = function (value) {
        if (!arguments.length)
            return _rate;
        _rate = value;
        return rq;
    };
    rq.remaining = function () {
        return _queue.length;
    };
    // clear the canvas
    rq.clear = function (func) {
        if (!arguments.length) {
            _clear();
            return rq;
        }
        _clear = func;
        return rq;
    };
    rq.invalidate = _invalidate;
    var timer_frame = window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        function (callback) {
            setTimeout(callback, 17);
        };
    return rq;
};
var updateVisualizationLayer = function (props, handleKeyDown) {
    var xScale = props.xScale, yScale = props.yScale, dataVersion = props.dataVersion, projectedCoordinateNames = props.projectedCoordinateNames, _a = props.renderPipeline, renderPipeline = _a === void 0 ? {} : _a, _b = props.baseMarkProps, baseMarkProps = _b === void 0 ? {} : _b, _c = props.renderOrder, renderOrder = _c === void 0 ? [] : _c, sketchyRenderingEngine = props.sketchyRenderingEngine;
    var canvasDrawing = [];
    var piecesGroup = {};
    var renderedElements = [];
    var renderVizKeys = Object.keys(renderPipeline);
    var renderKeys = renderOrder.concat(renderVizKeys.filter(function (d) { return renderOrder.indexOf(d) === -1; }));
    renderKeys.forEach(function (k) {
        var pipe = renderPipeline[k];
        if (pipe &&
            ((pipe.data &&
                typeof pipe.data === "object" &&
                !Array.isArray(pipe.data)) ||
                (pipe.data && pipe.data.length > 0))) {
            var additionalMarkProps = {
                sketchyGenerator: sketchyRenderingEngine && sketchyRenderingEngine.generator,
                "aria-label": (pipe.ariaLabel && pipe.ariaLabel.items) || "dataviz-element",
                role: "img",
                tabIndex: -1
            };
            var renderedPipe = pipe.behavior(__assign({ xScale: xScale,
                yScale: yScale,
                canvasDrawing: canvasDrawing,
                projectedCoordinateNames: projectedCoordinateNames, baseMarkProps: __assign(__assign({}, baseMarkProps), additionalMarkProps) }, pipe));
            if (renderedPipe && renderedPipe.length > 0) {
                renderedElements.push(React.createElement("g", { key: k, className: k, role: "group", tabIndex: 0, "aria-label": (pipe.ariaLabel &&
                        renderedPipe.length + " " + pipe.ariaLabel.items + "s in a " + pipe.ariaLabel.chart) ||
                        k, onKeyDown: function (e) { return handleKeyDown(e, k); }, onBlur: function () {
                        props.voronoiHover(undefined);
                    }, ref: function (thisNode) {
                        return thisNode && (piecesGroup[k] = thisNode.childNodes);
                    } }, renderedPipe));
            }
        }
    });
    return {
        renderedElements: renderedElements,
        dataVersion: dataVersion,
        canvasDrawing: canvasDrawing,
        piecesGroup: piecesGroup
    };
};
var VisualizationLayer = /** @class */ (function (_super) {
    __extends(VisualizationLayer, _super);
    function VisualizationLayer(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCanvas = function (context, margin, np, sketchyRenderingEngine, rc, disableProgressiveRendering) {
            return function (piece) {
                var style = piece.styleFn
                    ? piece.styleFn(__assign(__assign({}, piece.d), piece.d.data), piece.i) || {}
                    : {
                        fill: "black",
                        stroke: "black",
                        opacity: 1,
                        fillOpacity: 1,
                        strokeOpacity: 1,
                        strokeWidth: 1
                    };
                var fill = style.fill ? style.fill : "black";
                var stroke = style.stroke ? style.stroke : "black";
                context.setTransform(1, 0, 0, 1, margin.left, margin.top);
                context.translate.apply(context, __spread(np.position));
                context.translate(piece.tx, piece.ty);
                context.fillStyle = fill;
                context.strokeStyle = stroke;
                context.lineWidth = style.strokeWidth ? style.strokeWidth : 0;
                var rcSettings = {};
                var renderObject = piece.markProps.renderMode ||
                    (piece.renderFn &&
                        piece.renderFn(__assign(__assign({}, piece.d), piece.d.data), piece.i));
                var actualRenderMode = (renderObject && renderObject.renderMode) || renderObject;
                if (actualRenderMode) {
                    if (!sketchyRenderingEngine) {
                        console.error("You cannot render sketchy graphics without specifying a Rough.js-like library as the sketchyRenderingEngine prop of your frame");
                        actualRenderMode = undefined;
                    }
                    else {
                        var RoughCanvas = sketchyRenderingEngine.canvas;
                        if (!RoughCanvas) {
                            console.error("The sketchyRenderingEngine you specify does not expose a prop `RoughCanvas` and so cannot render sketchy HTML5 Canvas graphics");
                        }
                        else {
                            rc = rc || RoughCanvas(np.canvasContext);
                            var rcExtension = (typeof renderObject === "object" && renderObject) || {};
                            rcSettings = __assign({ fill: fill,
                                stroke: stroke, strokeWidth: context.lineWidth }, rcExtension);
                        }
                    }
                }
                if (piece.markProps.markType === "circle" ||
                    (piece.markProps.markType === "rect" && piece.markProps.rx > 0)) {
                    var vizX = 0, vizY = 0, r = style.r || piece.markProps.r;
                    if (piece.markProps.width) {
                        var halfWidth = piece.markProps.width / 2;
                        vizX = piece.markProps.x + halfWidth;
                        vizY = piece.markProps.y + halfWidth;
                        r = halfWidth;
                    }
                    if (actualRenderMode === "sketchy") {
                        if (context.globalAlpha !== 0)
                            rc.circle(vizX, vizY, r, rcSettings);
                    }
                    else {
                        context.beginPath();
                        context.arc(vizX, vizY, r, 0, 2 * Math.PI);
                        context.globalAlpha = style.fillOpacity || style.opacity || 1;
                        if (style.fill && style.fill !== "none" && context.globalAlpha !== 0)
                            context.fill();
                        context.globalAlpha = style.strokeOpacity || style.opacity || 1;
                        if (style.stroke &&
                            style.stroke !== "none" &&
                            context.globalAlpha !== 0)
                            context.stroke();
                    }
                }
                else if (piece.markProps.markType === "rect") {
                    if (actualRenderMode === "sketchy") {
                        context.globalAlpha = style.opacity || 1;
                        if (context.globalAlpha !== 0)
                            rc.rectangle(piece.markProps.x, piece.markProps.y, piece.markProps.width, piece.markProps.height, rcSettings);
                    }
                    else {
                        context.globalAlpha = style.fillOpacity || style.opacity || 1;
                        if (style.fill && style.fill !== "none" && context.globalAlpha !== 0)
                            context.fillRect(piece.markProps.x, piece.markProps.y, piece.markProps.width, piece.markProps.height);
                        context.globalAlpha = style.strokeOpacity || style.opacity || 1;
                        if (style.stroke &&
                            style.stroke !== "none" &&
                            context.globalAlpha !== 0)
                            context.strokeRect(piece.markProps.x, piece.markProps.y, piece.markProps.width, piece.markProps.height);
                    }
                }
                else if (piece.markProps.markType === "path") {
                    if (actualRenderMode === "sketchy") {
                        context.globalAlpha = style.opacity || 1;
                        rc.path(piece.markProps.d, rcSettings);
                    }
                    else {
                        var p = new Path2D(piece.markProps.d);
                        context.globalAlpha = style.strokeOpacity || style.opacity || 1;
                        if (style.stroke &&
                            style.stroke !== "none" &&
                            context.globalAlpha !== 0)
                            context.stroke(p);
                        context.globalAlpha = style.fillOpacity || style.opacity || 1;
                        if (style.fill && style.fill !== "none" && context.globalAlpha !== 0)
                            context.fill(p);
                    }
                }
                else {
                    console.error("CURRENTLY UNSUPPORTED MARKTYPE FOR CANVAS RENDERING");
                }
            };
        };
        _this.queuedCanvasRender = renderQueue(function () { });
        _this.handleKeyDown = function (e, vizgroup) {
            // If enter, focus on the first element
            var _a = _this.props, renderPipeline = _a.renderPipeline, voronoiHover = _a.voronoiHover;
            var pushed = e.keyCode;
            if (pushed !== 37 && pushed !== 39 && pushed !== 13)
                return;
            var newPieceIndex = 0;
            var vizGroupSetting = {};
            // If a user pressed enter, highlight the first one
            // Let a user move up and down in stacked bar by getting keys of bars?
            if (_this.state.focusedPieceIndex === null || pushed === 13) {
                vizGroupSetting.focusedVisualizationGroup = vizgroup;
            }
            else if (pushed === 37) {
                newPieceIndex = _this.state.focusedPieceIndex - 1;
            }
            else if (pushed === 39) {
                newPieceIndex = _this.state.focusedPieceIndex + 1;
            }
            newPieceIndex =
                newPieceIndex < 0
                    ? _this.state.piecesGroup[vizgroup].length + newPieceIndex
                    : newPieceIndex % _this.state.piecesGroup[vizgroup].length;
            var piece = renderPipeline[vizgroup].accessibleTransform(renderPipeline[vizgroup].data, newPieceIndex, _this.state.piecesGroup[vizgroup][newPieceIndex]);
            voronoiHover(piece);
            _this.setState(__assign({ focusedPieceIndex: newPieceIndex }, vizGroupSetting));
        };
        _this.state = __assign({ canvasDrawing: [], dataVersion: "", renderedElements: [], focusedPieceIndex: null, focusedVisualizationGroup: null, piecesGroup: {}, props: props, handleKeyDown: _this.handleKeyDown }, updateVisualizationLayer(props, _this.handleKeyDown));
        return _this;
    }
    VisualizationLayer.prototype.componentDidUpdate = function (lp) {
        var np = this.props;
        var propKeys = Object.keys(np);
        var update = false;
        propKeys.forEach(function (key) {
            if (key !== "title" && lp[key] !== np[key]) {
                update = true;
            }
        });
        if (update === false || np.disableContext || !np.canvasContext)
            return;
        var sketchyRenderingEngine = np.sketchyRenderingEngine, width = np.width, height = np.height, margin = np.margin, _a = np.disableProgressiveRendering, disableProgressiveRendering = _a === void 0 ? false : _a;
        var size = [
            width + margin.left + margin.right,
            height + margin.top + margin.bottom
        ];
        var rc;
        var devicePixelRatio = window.devicePixelRatio || 1;
        np.canvasContext.width = size[0] * devicePixelRatio;
        np.canvasContext.height = size[1] * devicePixelRatio;
        np.canvasContext.style.width = size[0];
        np.canvasContext.style.height = size[1];
        var context = np.canvasContext.getContext("2d");
        context.scale(devicePixelRatio, devicePixelRatio);
        context.setTransform(1, 0, 0, 1, margin.left, margin.top);
        context.clearRect(-margin.left, -margin.top, size[0], size[1]);
        if (disableProgressiveRendering) {
            this.renderCanvas(context, margin, np, sketchyRenderingEngine, rc);
        }
        else {
            this.queuedCanvasRender.invalidate();
            this.queuedCanvasRender.clear();
            this.queuedCanvasRender = renderQueue(this.renderCanvas(context, margin, np, sketchyRenderingEngine, rc)).clear(function () {
                context.clearRect(-margin.left, -margin.top, size[0], size[1]);
            });
            this.queuedCanvasRender(this.state.canvasDrawing);
        }
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.globalAlpha = 1;
        if (np.canvasPostProcess) {
            np.canvasPostProcess(np.canvasContext, context, size);
        }
        if (this.state.focusedVisualizationGroup !== null &&
            this.state.piecesGroup[this.state.focusedVisualizationGroup] &&
            this.state.focusedPieceIndex !== null) {
            var focusElParent = this.state.piecesGroup[this.state.focusedVisualizationGroup][this.state.focusedPieceIndex];
            var focusEl = (focusElParent &&
                __spread(focusElParent.childNodes).find(function (child) {
                    return child.getAttribute("aria-label");
                })) ||
                focusElParent;
            focusEl && focusEl.focus && focusEl.focus();
        }
    };
    VisualizationLayer.getDerivedStateFromProps = function (nextProps, prevState) {
        var props = prevState.props;
        var lp = props;
        var propKeys = Object.keys(nextProps);
        var update = false;
        propKeys.forEach(function (key) {
            if (key !== "title" && lp[key] !== nextProps[key]) {
                update = true;
            }
        });
        if (update ||
            (nextProps.dataVersion && nextProps.dataVersion !== prevState.dataVersion)) {
            return __assign(__assign({}, updateVisualizationLayer(nextProps, prevState.handleKeyDown)), { props: nextProps });
        }
        return null;
    };
    VisualizationLayer.prototype.render = function () {
        var _a;
        var _b = this.props, matte = _b.matte, matteClip = _b.matteClip, axes = _b.axes, _c = _b.frameKey, frameKey = _c === void 0 ? "" : _c, margin = _b.margin, title = _b.title, ariaTitle = _b.ariaTitle, axesTickLines = _b.axesTickLines, frameRenderOrder = _b.frameRenderOrder, additionalVizElements = _b.additionalVizElements;
        var renderedElements = this.state.renderedElements;
        var renderHash = __assign((_a = {}, _a["axes-tick-lines"] = axesTickLines && (React.createElement("g", { key: "visualization-tick-lines", className: "axis axis-tick-lines", "aria-hidden": true }, axesTickLines)), _a["axes-labels"] = axes && (React.createElement("g", { key: "visualization-axis-labels", className: "axis axis-labels" }, axes)), _a.matte = matte, _a["viz-layer"] = renderedElements && renderedElements.length > 0
            ? renderedElements
            : null, _a), additionalVizElements);
        var ariaLabel = "";
        var finalTitle = (title && ariaTitle) || title
            ? typeof title !== "string" &&
                title.props &&
                typeof title.props.children === "string"
                ? "titled " + title.props.children
                : "with a complex title"
            : "with no title";
        ariaLabel = "Visualization " + finalTitle + ". Use arrow keys to navigate elements.";
        var orderedElements = [];
        frameRenderOrder.forEach(function (r) {
            if (renderHash[r]) {
                orderedElements.push(renderHash[r]);
            }
        });
        var renderedDataVisualization = (orderedElements.length > 0 && (React.createElement("g", { className: "data-visualization", key: "visualization-clip-path", "aria-label": ariaLabel, role: "group", clipPath: matteClip && matte ? "url(#matte-clip" + frameKey + ")" : undefined, transform: "translate(" + margin.left + "," + margin.top + ")" }, orderedElements))) ||
            null;
        return renderedDataVisualization;
    };
    VisualizationLayer.defaultProps = {
        position: [0, 0],
        margin: { left: 0, top: 0, right: 0, bottom: 0 }
    };
    return VisualizationLayer;
}(React.PureComponent));

var filterDefs = function (_a) {
    var matte = _a.matte, key = _a.key, additionalDefs = _a.additionalDefs;
    return (React.createElement("defs", null,
        React.createElement("filter", { id: "paintyFilterHeavy" },
            React.createElement("feGaussianBlur", { id: "gaussblurrer", in: "SourceGraphic", stdDeviation: 4, colorInterpolationFilters: "sRGB", result: "blur" }),
            React.createElement("feColorMatrix", { in: "blur", mode: "matrix", values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 34 -7", result: "gooey" })),
        React.createElement("filter", { id: "paintyFilterLight" },
            React.createElement("feGaussianBlur", { id: "gaussblurrer", in: "SourceGraphic", stdDeviation: 2, colorInterpolationFilters: "sRGB", result: "blur" }),
            React.createElement("feColorMatrix", { in: "blur", mode: "matrix", values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 34 -7", result: "gooey" })),
        React.createElement("clipPath", { id: "matte-clip-" + key }, matte),
        additionalDefs));
};
var generateFinalDefs = function (_a) {
    var matte = _a.matte, size = _a.size, margin = _a.margin, frameKey = _a.frameKey, additionalDefs = _a.additionalDefs, name = _a.name;
    var marginGraphic;
    if (typeof matte === "function") {
        marginGraphic = matte({ size: size, margin: margin });
    }
    else if (React.isValidElement(matte)) {
        marginGraphic = matte;
    }
    else if (matte === true) {
        marginGraphic = (React.createElement("path", { fill: "white", transform: "translate(" + -margin.left + "," + -margin.top + ")", d: drawMarginPath({
                margin: margin,
                size: size,
                inset: 0
            }), className: name + "-matte" }));
    }
    var finalFilterDefs = filterDefs({
        matte: marginGraphic,
        key: matte && (frameKey || name),
        additionalDefs: additionalDefs
    });
    return { defs: finalFilterDefs, matte: marginGraphic };
};

var blankArray$1 = [];
var blankObject = {};
var defaultPosition = [0, 0];
var defaultCoordinateNames = { x: "x", y: "y" };
var defaultFrameRenderOrder = [
    "axes-tick-lines",
    "viz-layer",
    "matte",
    "axes-labels",
    "labels"
];
var defaultZeroMargin = { top: 0, bottom: 0, left: 0, right: 0 };
function Frame(props) {
    var axes = props.axes, axesTickLines = props.axesTickLines, _a = props.className, className = _a === void 0 ? "" : _a, _b = props.name, name = _b === void 0 ? "" : _b, frameKey = props.frameKey, _c = props.projectedCoordinateNames, projectedCoordinateNames = _c === void 0 ? defaultCoordinateNames : _c, renderPipeline = props.renderPipeline, size = props.size, _d = props.adjustedSize, adjustedSize = _d === void 0 ? size : _d, title = props.title, xScale = props.xScale, yScale = props.yScale, dataVersion = props.dataVersion, annotations = props.annotations, projectedYMiddle = props.projectedYMiddle, interaction = props.interaction, customClickBehavior = props.customClickBehavior, customHoverBehavior = props.customHoverBehavior, customDoubleClickBehavior = props.customDoubleClickBehavior, points = props.points, _e = props.margin, margin = _e === void 0 ? defaultZeroMargin : _e, backgroundGraphics = props.backgroundGraphics, foregroundGraphics = props.foregroundGraphics, beforeElements = props.beforeElements, afterElements = props.afterElements, defaultSVGRule = props.defaultSVGRule, defaultHTMLRule = props.defaultHTMLRule, _f = props.adjustedPosition, adjustedPosition = _f === void 0 ? defaultPosition : _f, legendSettings = props.legendSettings, _g = props.annotationSettings, annotationSettings = _g === void 0 ? blankObject : _g, overlay = props.overlay, columns = props.columns, rScale = props.rScale, projection = props.projection, interactionOverflow = props.interactionOverflow, canvasPostProcess = props.canvasPostProcess, baseMarkProps = props.baseMarkProps, useSpans = props.useSpans, canvasRendering = props.canvasRendering, _h = props.renderOrder, renderOrder = _h === void 0 ? blankArray$1 : _h, showLinePoints = props.showLinePoints, _j = props.disableCanvasInteraction, disableCanvasInteraction = _j === void 0 ? false : _j, sketchyRenderingEngine = props.sketchyRenderingEngine, disableContext = props.disableContext, _k = props.frameRenderOrder, frameRenderOrder = _k === void 0 ? defaultFrameRenderOrder : _k, _l = props.additionalVizElements, additionalVizElements = _l === void 0 ? blankObject : _l, interactionSettings = props.interactionSettings, disableProgressiveRendering = props.disableProgressiveRendering, additionalDefs = props.additionalDefs;
    var hoverAnnotation = props.hoverAnnotation;
    var canvasContext = useRef(null);
    var _m = __read(useState(undefined), 2), voronoiHover = _m[0], changeVoronoiHover = _m[1];
    var _o = __read(useState(null), 2), finalDefs = _o[0], changeFinalDefs = _o[1];
    var _p = __read(useState(null), 2), matte = _p[0], changeMatte = _p[1];
    var _q = __read(useState(function () { return HOCSpanOrDiv(props.useSpans); }), 1), SpanOrDiv = _q[0];
    var _r = __read(useState(function () { return function (d) { return changeVoronoiHover(d); }; }), 1), setVoronoi = _r[0];
    useEffect(function () {
        var generatedDefs = generateFinalDefs({
            matte: matte,
            size: size,
            margin: margin,
            frameKey: frameKey,
            additionalDefs: additionalDefs,
            name: name
        });
        changeFinalDefs(generatedDefs.defs);
        changeMatte(generatedDefs.matte);
    }, [
        size[0],
        size[1],
        margin.top,
        margin.bottom,
        margin.right,
        margin.left,
        margin.top,
        matte,
        additionalDefs
    ]);
    if (!hoverAnnotation &&
        (customClickBehavior || customHoverBehavior || customDoubleClickBehavior)) {
        hoverAnnotation = blankArray$1;
    }
    var areaAnnotations = [];
    var totalAnnotations = annotations
        ? __spread(annotations, areaAnnotations) : areaAnnotations;
    if (voronoiHover) {
        if (Array.isArray(voronoiHover)) {
            totalAnnotations.push.apply(totalAnnotations, __spread(voronoiHover));
        }
        else {
            totalAnnotations.push(voronoiHover);
        }
    }
    var annotationLayer = ((totalAnnotations && totalAnnotations.length > 0) ||
        legendSettings) && (React.createElement(AnnotationLayer, { legendSettings: legendSettings, margin: margin, axes: axes, voronoiHover: setVoronoi, annotationHandling: annotationSettings, pointSizeFunction: annotationSettings.layout && annotationSettings.layout.pointSizeFunction, labelSizeFunction: annotationSettings.layout && annotationSettings.layout.labelSizeFunction, annotations: totalAnnotations, svgAnnotationRule: function (d, i, thisALayer) {
            return defaultSVGRule(__assign({ d: d,
                i: i, annotationLayer: thisALayer }, renderPipeline));
        }, htmlAnnotationRule: function (d, i, thisALayer) {
            return defaultHTMLRule(__assign({ d: d,
                i: i, annotationLayer: thisALayer }, renderPipeline));
        }, useSpans: useSpans, size: adjustedSize, position: [
            adjustedPosition[0] + margin.left,
            adjustedPosition[1] + margin.top
        ] }));
    var generatedTitle = generateFrameTitle({
        title: title,
        size: size
    });
    var finalBackgroundGraphics = typeof backgroundGraphics === "function"
        ? backgroundGraphics({ size: size, margin: margin })
        : backgroundGraphics;
    var finalForegroundGraphics = typeof foregroundGraphics === "function"
        ? foregroundGraphics({ size: size, margin: margin })
        : foregroundGraphics;
    return (React.createElement(SpanOrDiv, { span: useSpans, className: className + " frame " + name, style: {
            background: "none"
        } },
        beforeElements && (React.createElement(SpanOrDiv, { span: useSpans, className: name + " frame-before-elements" }, beforeElements)),
        React.createElement(SpanOrDiv, { span: useSpans, className: "frame-elements", style: { height: size[1] + "px", width: size[0] + "px" } },
            React.createElement(SpanOrDiv, { span: useSpans, className: "visualization-layer", style: { position: "absolute" } },
                backgroundGraphics && (React.createElement("svg", { className: "background-graphics", style: { position: "absolute" }, width: size[0], height: size[1] }, backgroundGraphics && (React.createElement("g", { "aria-hidden": true, className: "background-graphics" }, finalBackgroundGraphics)))),
                canvasRendering && (React.createElement("canvas", { className: "frame-canvas", ref: canvasContext, style: {
                        position: "absolute",
                        left: "0px",
                        top: "0px"
                    }, width: size[0], height: size[1] })),
                React.createElement("svg", { className: "visualization-layer", style: { position: "absolute" }, width: size[0], height: size[1] },
                    finalDefs,
                    React.createElement(VisualizationLayer, { disableContext: disableContext, renderPipeline: renderPipeline, position: adjustedPosition, width: adjustedSize[0], height: adjustedSize[1], projectedCoordinateNames: projectedCoordinateNames, xScale: xScale, yScale: yScale, axes: axes, title: generatedTitle, frameKey: frameKey, canvasContext: canvasContext === null || canvasContext === void 0 ? void 0 : canvasContext.current, dataVersion: dataVersion, matte: matte, margin: margin, canvasPostProcess: canvasPostProcess, baseMarkProps: baseMarkProps, voronoiHover: setVoronoi, renderOrder: renderOrder, sketchyRenderingEngine: sketchyRenderingEngine, axesTickLines: axesTickLines, additionalVizElements: additionalVizElements, frameRenderOrder: frameRenderOrder, disableProgressiveRendering: disableProgressiveRendering }),
                    generatedTitle && React.createElement("g", { className: "frame-title" }, generatedTitle),
                    foregroundGraphics && (React.createElement("g", { "aria-hidden": true, className: "foreground-graphics" }, finalForegroundGraphics)))),
            React.createElement(InteractionLayer, { useSpans: useSpans, hoverAnnotation: hoverAnnotation, projectedX: projectedCoordinateNames.x, projectedY: projectedCoordinateNames.y, projectedYMiddle: projectedYMiddle, interaction: interaction, voronoiHover: setVoronoi, customClickBehavior: customClickBehavior, customHoverBehavior: customHoverBehavior, customDoubleClickBehavior: customDoubleClickBehavior, points: points, showLinePoints: showLinePoints, canvasRendering: canvasRendering, position: adjustedPosition, margin: margin, size: adjustedSize, svgSize: size, xScale: xScale, yScale: yScale, enabled: true, overlay: overlay, oColumns: columns, rScale: rScale, projection: projection, interactionOverflow: interactionOverflow, disableCanvasInteraction: disableCanvasInteraction, renderPipeline: renderPipeline, advancedSettings: interactionSettings }),
            annotationLayer),
        afterElements && (React.createElement(SpanOrDiv, { span: useSpans, className: name + " frame-after-elements" }, afterElements))));
}

var // simple heuristics to check if the tooltip container exceeds the viewport
// if so, capture the suggested offset
checkPosition = function (_a) {
    var tooltipRef = _a.tooltipRef; _a.tooltipContentArgs; var changeTooltipContentArgsCurrent = _a.changeTooltipContentArgsCurrent, changeTooltipContainerInitialDimensions = _a.changeTooltipContainerInitialDimensions, changeCollision = _a.changeCollision;
    var tooltipContainerInitialDimensions = tooltipRef.getBoundingClientRect();
    tooltipContainerInitialDimensions.right; var left = tooltipContainerInitialDimensions.left, top = tooltipContainerInitialDimensions.top; tooltipContainerInitialDimensions.bottom; var width = tooltipContainerInitialDimensions.width, height = tooltipContainerInitialDimensions.height;
    // flags to indicate whether the data point + tooltip dimension collides with the viewport
    // on each of the 4 directions/sides
    var collision = {
        left: false,
        right: false,
        top: false,
        bottom: false
    };
    if (left + width > window.innerWidth) {
        collision.right = true;
    }
    if (left - width < 0) {
        collision.left = true;
    }
    if (top + height > window.innerHeight) {
        collision.bottom = true;
    }
    if (top - height < 0) {
        collision.top = true;
    }
    changeTooltipContentArgsCurrent();
    changeTooltipContainerInitialDimensions(tooltipContainerInitialDimensions);
    changeCollision(collision);
};
function TooltipPositioner(props) {
    var tooltipContent = props.tooltipContent, tooltipContentArgs = props.tooltipContentArgs;
    var _a = __read(useState(null), 2), collision = _a[0], changeCollision = _a[1];
    var _b = __read(useState(null), 2), tooltipContainerInitialDimensions = _b[0], changeTooltipContainerInitialDimensions = _b[1];
    var _c = __read(useState(null), 2), tooltipContentArgsCurrent = _c[0], changeTooltipContentArgsCurrent = _c[1];
    var _d = __read(useState(null), 2), tooltipNode = _d[0], setTooltipNode = _d[1];
    var tooltipNodeRef = useCallback(function (node) {
        setTooltipNode(node);
        checkPosition({
            tooltipRef: node,
            tooltipContentArgs: tooltipContentArgs,
            changeTooltipContentArgsCurrent: changeTooltipContentArgsCurrent,
            changeTooltipContainerInitialDimensions: changeTooltipContainerInitialDimensions,
            changeCollision: changeCollision
        });
    }, []);
    useEffect(function () {
        // if new args, reset collision state
        changeCollision(null);
        changeTooltipContainerInitialDimensions(null);
    }, [JSON.stringify(tooltipContentArgs)]);
    useEffect(function () {
        if (tooltipNode && !collision) {
            checkPosition({
                tooltipRef: tooltipNode,
                tooltipContentArgs: tooltipContentArgs,
                changeTooltipContentArgsCurrent: changeTooltipContentArgsCurrent,
                changeTooltipContainerInitialDimensions: changeTooltipContainerInitialDimensions,
                changeCollision: changeCollision
            });
        }
    }, [tooltipNode, collision]);
    var containerStyle = {
        //to handle issue when the tooltip content has margins set by client,
        // which results in the tooltip container having smaller height,
        // which in turn causes the css transform to be inaccurate
        // (ref: https://www.w3.org/TR/css-box-3/#collapsing-margins)
        overflow: "hidden",
        opacity: collision && tooltipContentArgsCurrent === tooltipContentArgs ? 1 : 0
    };
    var tooltipContainerClasses = collision
        ? [
            "tooltip-container",
            "tooltip-collision-evaluated",
            collision && collision.top && "collision-top",
            collision && collision.bottom && "collision-bottom",
            collision && collision.right && "collision-right",
            collision && collision.left && "collision-left"
        ]
            .filter(function (el) { return el; })
            .join(" ")
        : "tooltip-container";
    var tooltipContainerAttributes = {
        offset: { x: 0, y: 0 },
        tooltipContainerInitialDimensions: tooltipContainerInitialDimensions
    };
    return (React.createElement("div", { ref: tooltipNodeRef, style: containerStyle, className: tooltipContainerClasses }, tooltipContent(__assign(__assign({}, tooltipContentArgs), { tooltipContainerAttributes: tooltipContainerAttributes }))));
}

var circleEnclosure = function (_a) {
    var d = _a.d, i = _a.i, circle = _a.circle;
    var _b = d.padding, padding = _b === void 0 ? 2 : _b, _c = d.radiusPadding, radiusPadding = _c === void 0 ? padding : _c, label = d.label;
    var noteData = Object.assign({
        dx: 0,
        dy: 0,
        note: { label: label },
        connector: { end: "arrow" }
    }, d, {
        coordinates: undefined,
        x: circle.x,
        y: circle.y,
        type: AnnotationCalloutCircle,
        subject: {
            radius: circle.r,
            radiusPadding: radiusPadding
        },
        i: i
    });
    if (noteData.rp) {
        switch (noteData.rp) {
            case "top":
                noteData.dx = 0;
                noteData.dy = -circle.r - noteData.rd;
                break;
            case "bottom":
                noteData.dx = 0;
                noteData.dy = circle.r + noteData.rd;
                break;
            case "left":
                noteData.dx = -circle.r - noteData.rd;
                noteData.dy = 0;
                break;
            default:
                noteData.dx = circle.r + noteData.rd;
                noteData.dy = 0;
        }
    }
    //TODO: Support .ra (setting angle)
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var rectangleEnclosure = function (_a) {
    var bboxNodes = _a.bboxNodes, d = _a.d, i = _a.i;
    var _b = d.padding, padding = _b === void 0 ? 0 : _b, _c = d.dx, dx = _c === void 0 ? -25 : _c, _d = d.dy, dy = _d === void 0 ? -25 : _d, label = d.label;
    var bbox = [
        [
            Math.min.apply(Math, __spread(bboxNodes.map(function (p) { return p.x0; }))) - padding,
            Math.min.apply(Math, __spread(bboxNodes.map(function (p) { return p.y0; }))) - padding
        ],
        [
            Math.max.apply(Math, __spread(bboxNodes.map(function (p) { return p.x1; }))) + padding,
            Math.max.apply(Math, __spread(bboxNodes.map(function (p) { return p.y1; }))) + padding
        ]
    ];
    var noteData = Object.assign({
        dx: dx,
        dy: dy,
        note: { label: label },
        connector: { end: "arrow" }
    }, d, {
        type: AnnotationCalloutRect,
        x: bbox[0][0],
        y: bbox[0][1],
        subject: {
            width: bbox[1][0] - bbox[0][0],
            height: bbox[1][1] - bbox[0][1]
        }
    });
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var hullEnclosure = function (_a) {
    var points = _a.points, d = _a.d, i = _a.i;
    var _b = d.color, color = _b === void 0 ? "black" : _b, _c = d.dx, dx = _c === void 0 ? -25 : _c, _d = d.dy, dy = _d === void 0 ? -25 : _d, label = d.label, _e = d.padding, padding = _e === void 0 ? 10 : _e, _f = d.buffer, buffer = _f === void 0 ? padding : _f, _g = d.strokeWidth, strokeWidth = _g === void 0 ? 10 : _g;
    var hullPoints = polygonHull(points);
    var offset = new Offset();
    var bufferedHull = offset
        .data(__spread(hullPoints, [hullPoints[0]]))
        .margin(buffer)[0];
    var hullD = "M" + bufferedHull.map(function (d) { return d.join(","); }).join("L") + "Z";
    var firstCoord = bufferedHull[0];
    var _h = d.nx, nx = _h === void 0 ? firstCoord[0] + dx : _h, _j = d.ny, ny = _j === void 0 ? firstCoord[1] + dy : _j;
    var closestCoordinates = bufferedHull.reduce(function (p, c) {
        if (Math.hypot(nx - p[0], ny - p[1]) > Math.hypot(nx - c[0], ny - c[1])) {
            p = c;
        }
        return p;
    }, firstCoord);
    var noteData = Object.assign({
        dx: dx,
        dy: dy,
        note: { label: label },
        connector: { end: "arrow" }
    }, d, {
        type: AnnotationCalloutCustom,
        x: closestCoordinates[0],
        y: closestCoordinates[1],
        subject: {
            custom: [
                React.createElement("path", { key: "hull-drawing", d: hullD, strokeWidth: strokeWidth, strokeMiterlimit: "10", strokeLinejoin: "miter", strokeLinecap: "butt", fill: "none", stroke: color, transform: "translate(" + -closestCoordinates[0] + "," + -closestCoordinates[1] + ")" })
            ],
            customID: "hull-annotation"
        }
    });
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var desaturationLayer = function (_a) {
    var _b = _a.style, style = _b === void 0 ? { fill: "white", fillOpacity: 0.5 } : _b, size = _a.size, i = _a.i, key = _a.key;
    return (React.createElement("rect", { key: key || "desaturation-" + i, x: -5, y: -5, width: size[0] + 10, height: size[1] + 10, style: style }));
};

var pointsAlong = function (along) { return function (_a) {
    var d = _a.d, lines = _a.lines, points = _a.points, xScale = _a.xScale, yScale = _a.yScale, pointStyle = _a.pointStyle;
    var alongScale = along === "x" ? xScale : yScale;
    along = along === "yTop" && d.yMiddle ? "yMiddle" : along;
    if (d && d[along]) {
        var _b = d.threshold, threshold = _b === void 0 ? 1 : _b, _c = d.r, r_1 = _c === void 0 ? function () { return 4; } : _c, _d = d.styleFn, styleFn_1 = _d === void 0 ? pointStyle : _d;
        var foundPoints_1 = [];
        var halfThreshold_1 = threshold / 2;
        if (lines && lines.length > 0) {
            lines.forEach(function (linedata) {
                var linePoints = linedata.data.filter(function (p) {
                    var pAlong = alongScale(p[along]);
                    var dAlong = alongScale(d[along]);
                    return (pAlong <= dAlong + halfThreshold_1 && pAlong >= dAlong - halfThreshold_1);
                });
                foundPoints_1.push.apply(foundPoints_1, __spread(linePoints));
            });
        }
        if (points && points.length > 0) {
            var pointPoints = points.filter(function (p) {
                var pAlong = alongScale(p[along]);
                var dAlong = alongScale(d[along]);
                return (pAlong <= dAlong + halfThreshold_1 && pAlong >= dAlong - halfThreshold_1);
            });
            foundPoints_1.push.apply(foundPoints_1, __spread(pointPoints));
        }
        return foundPoints_1.map(function (p, i) { return (React.createElement("circle", { key: "found-circle-" + i, r: r_1(p, i), style: styleFn_1(p, i), cx: xScale(p.xMiddle || p.x), cy: yScale(p.yMiddle || p.yTop) })); });
    }
    return null;
}; };
var svgHorizontalPointsAnnotation = pointsAlong("yTop");
var svgVerticalPointsAnnotation = pointsAlong("x");
var svgHighlight = function (_a) {
    var d = _a.d, i = _a.i, _b = _a.points, points = _b === void 0 ? { data: [] } : _b, _c = _a.lines, lines = _c === void 0 ? { data: [], type: {} } : _c, _d = _a.summaries, summaries = _d === void 0 ? { data: [] } : _d, idAccessor = _a.idAccessor, xScale = _a.xScale, yScale = _a.yScale, xyFrameRender = _a.xyFrameRender, defined = _a.defined;
    var dID;
    var baseID = idAccessor(__assign(__assign({}, d), d.data), i);
    if (baseID !== undefined) {
        dID = baseID;
    }
    else if (d.parentLine && idAccessor(d.parentLine, i) !== undefined) {
        dID = idAccessor(d.parentLine, i);
    }
    else if (d.parentSummary && idAccessor(d.parentSummary, i) !== undefined) {
        dID = idAccessor(d.parentSummary, i);
    }
    var foundPoints = points.data
        .filter(function (p, q) { return idAccessor(__assign(__assign({}, p), p.data), q) === dID; })
        .map(function (p, q) {
        var baseStyle = xyFrameRender.points.styleFn(__assign(__assign({}, p), p.data));
        var highlightStyle = typeof d.style === "function"
            ? d.style(__assign(__assign({}, p), p.data), q)
            : d.style || {};
        return (React.createElement("circle", { key: "highlight-point-" + q, cx: xScale(p.x), cy: yScale(p.y), r: 5, fill: "none", stroke: "black", strokeWidth: 2, style: __assign(__assign({}, baseStyle), highlightStyle), className: "highlight-annotation " + ((d.class &&
                typeof d.class === "function" &&
                d.class(__assign(__assign({}, p), p.data), q)) ||
                (d.class && d.class) ||
                "") }));
    });
    var lineGenerator = area()
        .x(function (p) { return xScale(p.x); })
        .y0(function (p) { return yScale(p.yBottom); })
        .y1(function (p) { return yScale(p.yTop); });
    var interpolatorSetting = lines.type.interpolator || lines.type.curve;
    var actualInterpolator = typeof interpolatorSetting === "string"
        ? curveHash[interpolatorSetting]
        : interpolatorSetting;
    if (actualInterpolator) {
        lineGenerator.curve(actualInterpolator);
    }
    if (defined) {
        lineGenerator.defined(function (p, q) { return defined(p.data, q); });
    }
    var foundLines = lines.data
        .filter(function (p, q) { return idAccessor(p, q) === dID; })
        .map(function (p, q) {
        var baseStyle = xyFrameRender.lines.styleFn(p, q);
        var highlightStyle = typeof d.style === "function" ? d.style(p, q) : d.style || {};
        return (React.createElement("path", { className: "highlight-annotation " + ((d.class &&
                typeof d.class === "function" &&
                d.class(p, q)) ||
                (d.class && d.class) ||
                ""), key: "highlight-summary-" + q, d: lineGenerator(p.data), fill: "none", stroke: "black", strokeWidth: 1, style: __assign(__assign({}, baseStyle), highlightStyle) }));
    });
    var foundSummaries = summaries.data
        .filter(function (p, q) { return idAccessor(p, q) === dID; })
        .map(function (p, q) {
        var baseStyle = xyFrameRender.summaries.styleFn(p, q);
        var highlightStyle = typeof d.style === "function" ? d.style(p, q) : d.style || {};
        return (React.createElement("path", { className: "highlight-annotation " + ((d.class &&
                typeof d.class === "function" &&
                d.class(p, q)) ||
                (d.class && d.class) ||
                ""), key: "highlight-summary-" + q, d: "M" + p.coordinates.join("L"), fill: "none", stroke: "black", strokeWidth: 1, style: __assign(__assign({}, baseStyle), highlightStyle) }));
    });
    return __spread(foundSummaries, foundLines, foundPoints);
};
var svgXYAnnotation = function (_a) {
    var screenCoordinates = _a.screenCoordinates, i = _a.i, d = _a.d;
    var inlineStyle;
    if (d.color)
        inlineStyle = { fill: d.color };
    var laLine = (React.createElement(Mark, { className: "annotation " + d.type + " " + (d.className || "") + " ", key: "annotationpoint" + i, markType: "circle", cx: screenCoordinates[0], cy: screenCoordinates[1], forceUpdate: true, style: inlineStyle, fill: "none", stroke: "black", r: 5 }));
    var laLabel;
    if (d.type === "xy") {
        laLabel = (React.createElement(Mark, { markType: "text", key: d.label + "annotationtext" + i, forceUpdate: true, x: screenCoordinates[0], y: 10 + screenCoordinates[1], className: "annotation annotation-xy-label " + (d.className || "") + " " }, d.label));
    }
    return [laLine, laLabel];
};
var basicReactAnnotation = function (_a) {
    var screenCoordinates = _a.screenCoordinates, d = _a.d, i = _a.i;
    var noteData = Object.assign({
        dx: 0,
        dy: 0,
        note: { label: d.label, orientation: d.orientation, align: d.align },
        connector: { end: "arrow" }
    }, d, {
        type: d.type,
        screenCoordinates: screenCoordinates,
        i: i
    });
    noteData.x = noteData.fixedX ? noteData.fixedX : screenCoordinates[0];
    noteData.y = noteData.fixedY ? noteData.fixedY : screenCoordinates[1];
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var svgXAnnotation = function (_a) {
    var screenCoordinates = _a.screenCoordinates, d = _a.d, i = _a.i, adjustedSize = _a.adjustedSize;
    var noteData = Object.assign({
        dx: 50,
        dy: 20,
        y: 0,
        note: { label: d.label },
        connector: { end: "arrow" }
    }, d, {
        type: AnnotationXYThreshold,
        x: screenCoordinates[0],
        subject: {
            x: screenCoordinates[0],
            y1: 0,
            y2: adjustedSize[1]
        },
        i: i
    });
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var svgYAnnotation = function (_a) {
    var screenCoordinates = _a.screenCoordinates, d = _a.d, i = _a.i, adjustedSize = _a.adjustedSize, adjustedPosition = _a.adjustedPosition;
    var xPosition = i * 25;
    var noteData = Object.assign({
        dx: 50,
        dy: -20,
        x: xPosition,
        note: { label: d.label },
        connector: { end: "arrow" }
    }, d, {
        type: AnnotationXYThreshold,
        y: screenCoordinates[1],
        subject: {
            y: screenCoordinates[1],
            x1: 0,
            x2: adjustedSize[0] + adjustedPosition[0]
        },
        i: i
    });
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var svgBoundsAnnotation = function (_a) {
    var d = _a.d, i = _a.i, adjustedSize = _a.adjustedSize, xAccessor = _a.xAccessor, yAccessor = _a.yAccessor, xScale = _a.xScale, yScale = _a.yScale;
    var startXValue = findFirstAccessorValue(xAccessor, d.bounds[0]);
    var startYValue = findFirstAccessorValue(yAccessor, d.bounds[0]);
    var endXValue = findFirstAccessorValue(xAccessor, d.bounds[1]);
    var endYValue = findFirstAccessorValue(yAccessor, d.bounds[1]);
    var x0Position = startXValue ? xScale(startXValue) : 0;
    var y0Position = startYValue ? yScale(startYValue) : adjustedSize[1];
    var x1Position = endXValue ? xScale(endXValue) : adjustedSize[0];
    var y1Position = endYValue ? yScale(endYValue) : 0;
    var noteData = Object.assign({
        dx: 250,
        dy: -20,
        note: { label: d.label },
        connector: { end: "arrow" }
    }, d, {
        type: AnnotationCalloutRect,
        x: Math.min(x0Position, x1Position),
        y: Math.min(y0Position, y1Position),
        subject: {
            width: Math.abs(x1Position - x0Position),
            height: Math.abs(y0Position - y1Position)
        },
        i: i
    });
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var svgLineAnnotation = function (_a) {
    var d = _a.d, i = _a.i, screenCoordinates = _a.screenCoordinates;
    var lineGenerator = line()
        .x(function (p) { return p[0]; })
        .y(function (p) { return p[1]; });
    var lineD = lineGenerator(screenCoordinates);
    var laLine = (React.createElement(Mark, { key: d.label + "annotationline" + i, markType: "path", d: lineD, className: "annotation annotation-line " + (d.className || "") + " " }));
    var laLabel = (React.createElement(Mark, { markType: "text", key: d.label + "annotationlinetext" + i, x: (screenCoordinates[0][0] + screenCoordinates[1][0]) / 2, y: (screenCoordinates[0][1] + screenCoordinates[1][1]) / 2, className: "annotation annotation-line-label " + (d.className || "") + " " }, d.label));
    return [laLine, laLabel];
};
var svgAreaAnnotation = function (_a) {
    var d = _a.d, i = _a.i, xScale = _a.xScale, xAccessor = _a.xAccessor, yScale = _a.yScale, yAccessor = _a.yAccessor, annotationLayer = _a.annotationLayer;
    var mappedCoordinates = "M" + d.coordinates
        .map(function (p) { return [
        xScale(findFirstAccessorValue(xAccessor, p)),
        yScale(findFirstAccessorValue(yAccessor, p))
    ]; })
        .join("L") + "Z";
    var xBounds = extent$1(d.coordinates.map(function (p) { return xScale(findFirstAccessorValue(xAccessor, p)); }));
    var yBounds = extent$1(d.coordinates.map(function (p) { return yScale(findFirstAccessorValue(yAccessor, p)); }));
    var xCenter = (xBounds[0] + xBounds[1]) / 2;
    var yCenter = (yBounds[0] + yBounds[1]) / 2;
    var laLine = (React.createElement(Mark, { key: d.label + "-annotation-area-" + i, markType: "path", d: mappedCoordinates, className: "annotation annotation-area " + (d.className || "") + " " }));
    var laLabel = (React.createElement(Mark, { markType: "text", key: d.label + "-annotationtext-" + i, forceUpdate: true, x: xCenter, y: yCenter, transform: "translate(" + annotationLayer.position + ")", className: "annotation annotation-area-label " + (d.className || "") + " ", style: { textAnchor: "middle" } }, d.label));
    return [laLine, laLabel];
};
var htmlTooltipAnnotation = function (_a) {
    //To string because React gives a DOM error if it gets a date
    var content = _a.content, screenCoordinates = _a.screenCoordinates, i = _a.i, d = _a.d, useSpans = _a.useSpans;
    return (React.createElement(SpanOrDiv, { span: useSpans, key: "xylabel-" + i, className: "annotation annotation-xy-label " + (d.className || "") + " ", style: {
            position: "absolute",
            top: screenCoordinates[1] + "px",
            left: screenCoordinates[0] + "px"
        } }, content));
};
var svgRectEncloseAnnotation = function (_a) {
    var d = _a.d, i = _a.i, screenCoordinates = _a.screenCoordinates;
    var bboxNodes = screenCoordinates.map(function (p) {
        return {
            x0: p.x0 = p[0],
            x1: p.x1 = p[0],
            y0: p.y0 = p[1],
            y1: p.y1 = p[1]
        };
    });
    return rectangleEnclosure({ bboxNodes: bboxNodes, d: d, i: i });
};
var svgEncloseAnnotation = function (_a) {
    var screenCoordinates = _a.screenCoordinates, d = _a.d, i = _a.i;
    var circle = packEnclose(screenCoordinates.map(function (p) { return ({ x: p[0], y: p[1], r: 2 }); }));
    return circleEnclosure({ d: d, circle: circle, i: i });
};
var svgHullEncloseAnnotation = function (_a) {
    var screenCoordinates = _a.screenCoordinates, d = _a.d, i = _a.i;
    return hullEnclosure({ points: screenCoordinates, d: d, i: i });
};

var extentValue = function (extent) {
    return (extent && extent.extent) || (Array.isArray(extent) && extent) || [];
};

var basicDataChangeCheck = function (prevData, newData) {
    return prevData !== newData ||
        (Array.isArray(prevData) &&
            Array.isArray(newData) &&
            !!prevData.find(function (p) { return newData.indexOf(p) === -1; }));
};

var baseDefinedFunction = function () { return true; };
var whichPointsHashY = {
    top: projectedYTop,
    bottom: projectedYBottom,
    orphan: projectedY
};
var whichPointsHashX = {
    top: projectedXTop,
    bottom: projectedXBottom,
    orphan: projectedX
};
var builtInTransformations = {
    stackedarea: stackedArea,
    "stackedarea-invert": stackedArea,
    stackedpercent: stackedArea,
    "stackedpercent-invert": stackedArea,
    linepercent: stackedArea,
    difference: differenceLine,
    bumparea: bumpChart,
    bumpline: bumpChart,
    "bumparea-invert": bumpChart,
    line: lineChart,
    area: lineChart,
    cumulative: cumulativeLine,
    "cumulative-reverse": cumulativeLine
};
function stringToFn(accessor, defaultAccessor, raw) {
    if (!accessor && defaultAccessor) {
        return defaultAccessor;
    }
    else if (typeof accessor === "object") {
        return function () { return accessor; };
    }
    else if (accessor instanceof Function) {
        return accessor;
    }
    else if (raw === true) {
        var castAccessor_1 = accessor;
        return function () { return castAccessor_1; };
    }
    else if (typeof accessor === "string") {
        return function (d) { return (d ? d[accessor] : undefined); };
    }
    return function () { return undefined; };
}
function stringToArrayFn(accessor, defaultAccessor, raw) {
    if (accessor === undefined) {
        return [stringToFn(undefined, defaultAccessor, raw)];
    }
    var arrayOfAccessors = [];
    if (Array.isArray(accessor)) {
        arrayOfAccessors = accessor;
    }
    else {
        arrayOfAccessors = [accessor];
    }
    return arrayOfAccessors.map(function (a) {
        return stringToFn(a, defaultAccessor, raw);
    });
}
var calculateDataExtent = function (_a) {
    var lineDataAccessor = _a.lineDataAccessor, xAccessor = _a.xAccessor, yAccessor = _a.yAccessor, summaries = _a.summaries, points = _a.points, lines = _a.lines, lineType = _a.lineType, showLinePoints = _a.showLinePoints, showSummaryPoints = _a.showSummaryPoints, xExtent = _a.xExtent, yExtent = _a.yExtent, invertX = _a.invertX, invertY = _a.invertY, summaryDataAccessor = _a.summaryDataAccessor, summaryType = _a.summaryType, size = _a.adjustedSize, margin = _a.margin, baseMarkProps = _a.baseMarkProps, summaryStyleFn = _a.summaryStyleFn, summaryClassFn = _a.summaryClassFn, summaryRenderModeFn = _a.summaryRenderModeFn, chartSize = _a.chartSize, filterRenderedLines = _a.filterRenderedLines, filterRenderedSummaries = _a.filterRenderedSummaries, filterRenderedPoints = _a.filterRenderedPoints, _b = _a.defined, defined = _b === void 0 ? baseDefinedFunction : _b, _c = _a.annotations, annotations = _c === void 0 ? [] : _c;
    var fullDataset = [];
    var initialProjectedLines = [];
    var projectedPoints = [], projectedLines = [], projectedSummaries = [];
    if (points) {
        xAccessor.forEach(function (actualXAccessor, xIndex) {
            yAccessor.forEach(function (actualYAccessor, yIndex) {
                points.forEach(function (d, i) {
                    var x = actualXAccessor(d, i);
                    var y = actualYAccessor(d, i);
                    var projectedPoint = { x: x, y: y, data: d, xIndex: xIndex, yIndex: yIndex };
                    if (Array.isArray(y)) {
                        projectedPoint[projectedYBottom] = Math.min.apply(Math, __spread(y));
                        projectedPoint[projectedYTop] = Math.max.apply(Math, __spread(y));
                        projectedPoint[projectedYMiddle] =
                            (projectedPoint[projectedYBottom] +
                                projectedPoint[projectedYTop]) /
                                2;
                    }
                    if (Array.isArray(x)) {
                        projectedPoint[projectedXBottom] = Math.min.apply(Math, __spread(x));
                        projectedPoint[projectedXTop] = Math.max.apply(Math, __spread(x));
                        projectedPoint[projectedXMiddle] =
                            (projectedPoint[projectedXBottom] +
                                projectedPoint[projectedXTop]) /
                                2;
                    }
                    projectedPoints.push(projectedPoint);
                });
            });
        });
        fullDataset = __spread(projectedPoints.map(function (d) {
            var _a;
            return (__assign(__assign({}, d), (_a = {}, _a[projectedX] = d[projectedXTop] || d[projectedXBottom] || d.x, _a[projectedY] = d[projectedYTop] || d[projectedYBottom] || d.y, _a)));
        }));
    }
    if (lines) {
        initialProjectedLines = projectLineData({
            data: lines,
            lineDataAccessor: lineDataAccessor,
            xProp: projectedX,
            xPropTop: projectedXTop,
            xPropBottom: projectedXBottom,
            yProp: projectedY,
            yPropTop: projectedYTop,
            yPropBottom: projectedYBottom,
            xAccessor: xAccessor,
            yAccessor: yAccessor
        });
        var optionsObject = {
            xProp: projectedX,
            yProp: projectedY,
            yPropMiddle: projectedYMiddle,
            yPropTop: projectedYTop,
            yPropBottom: projectedYBottom,
            xPropMiddle: projectedXMiddle,
            xPropTop: projectedXTop,
            xPropBottom: projectedXBottom
        };
        projectedLines = lineTransformation(lineType, optionsObject)(initialProjectedLines);
        projectedLines.forEach(function (d) {
            fullDataset = __spread(fullDataset, d.data
                .filter(function (p, q) { return defined(Object.assign({}, p.data, p), q); })
                .map(function (p) {
                var mappedP = {
                    parentLine: d,
                    y: p.y,
                    x: p.x,
                    xTop: p.xTop,
                    xMiddle: p.xMiddle,
                    xBottom: p.xBottom,
                    yTop: p.yTop,
                    yMiddle: p.yMiddle,
                    yBottom: p.yBottom,
                    data: p.data
                };
                if (p.percent) {
                    mappedP.percent = p.percent;
                }
                return mappedP;
            }));
        });
        if (showLinePoints) {
            var whichPointsX_1 = showLinePoints === true
                ? projectedXMiddle
                : whichPointsHashX[showLinePoints];
            var whichPointsY_1 = showLinePoints === true
                ? projectedYMiddle
                : whichPointsHashY[showLinePoints];
            projectedLines.forEach(function (d) {
                d.data
                    .filter(function (p, q) {
                    var isDefined = defined(Object.assign({}, p.data, p));
                    if (isDefined) {
                        if (showLinePoints === "orphan") {
                            var prePoint = d.data[q - 1];
                            var postPoint = d.data[q + 1];
                            if ((!prePoint ||
                                !defined(Object.assign({}, prePoint.data, prePoint))) &&
                                (!postPoint ||
                                    !defined(Object.assign({}, postPoint.data, postPoint)))) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                        else {
                            return true;
                        }
                    }
                    else {
                        return false;
                    }
                })
                    .forEach(function (p) {
                    var _a;
                    projectedPoints.push(__assign(__assign({}, p), (_a = { parentLine: d }, _a[projectedY] = p[whichPointsY_1] !== undefined
                        ? p[whichPointsY_1]
                        : p[projectedYMiddle] !== undefined
                            ? p[projectedYMiddle]
                            : p[projectedYBottom] !== undefined
                                ? p[projectedYBottom]
                                : p.y, _a[projectedX] = p[whichPointsX_1] !== undefined
                        ? p[whichPointsX_1]
                        : p[projectedXMiddle] !== undefined
                            ? p[projectedXMiddle]
                            : p[projectedXBottom] !== undefined
                                ? p[projectedXBottom]
                                : p.y, _a)));
                });
            });
        }
    }
    if (summaries) {
        projectedSummaries = projectSummaryData({
            data: summaries,
            summaryDataAccessor: summaryDataAccessor,
            xAccessor: xAccessor,
            yAccessor: yAccessor
        });
        projectedSummaries.forEach(function (d) {
            var baseData = d._baseData;
            if (d._xyfCoordinates.length > 0 && d._xyfCoordinates[0][0][0]) {
                d._xyfCoordinates[0].forEach(function (multi) {
                    if (Array.isArray(multi)) {
                        multi
                            .map(function (p, q) {
                            var _a;
                            return Object.assign({ parentSummary: d }, baseData[q], (_a = {},
                                _a[projectedX] = p[0],
                                _a[projectedY] = p[1],
                                _a));
                        })
                            .forEach(function (e) {
                            var _a;
                            if (showSummaryPoints) {
                                projectedPoints.push(__assign(__assign({ x: 0 }, e), (_a = {}, _a[projectedY] = e[projectedYTop] || e[projectedYBottom] || e[projectedY], _a)));
                            }
                            fullDataset.push(__assign({ x: 0, y: 0 }, e));
                        });
                    }
                });
            }
            else if (d._xyfCoordinates.length > 0) {
                if (Array.isArray(d._xyfCoordinates)) {
                    var coordArray = d._xyfCoordinates;
                    coordArray
                        .map(function (p, q) {
                        var _a;
                        return (__assign(__assign({ parentSummary: d }, baseData[q]), (_a = {}, _a[projectedX] = p[0], _a[projectedY] = p[1], _a)));
                    })
                        .forEach(function (e) {
                        var _a;
                        if (showSummaryPoints) {
                            projectedPoints.push(__assign(__assign({ x: 0 }, e), (_a = {}, _a[projectedY] = e[projectedYTop] || e[projectedYBottom] || e[projectedY], _a)));
                        }
                        fullDataset.push(__assign({ x: 0, y: 0 }, e));
                    });
                }
            }
        });
    }
    var suitableXAnnotations = [];
    var suitableYAnnotations = [];
    if (xExtent &&
        !Array.isArray(xExtent) &&
        xExtent.includeAnnotations === true) {
        xAccessor.forEach(function (actualXAccessor) {
            annotations.forEach(function (annotation, annotationIndex) {
                var _a;
                var x = actualXAccessor(annotation, annotationIndex);
                if (isFinite(x)) {
                    suitableXAnnotations.push((_a = {},
                        _a[projectedX] = x,
                        _a));
                }
            });
        });
    }
    if (yExtent &&
        !Array.isArray(yExtent) &&
        yExtent.includeAnnotations === true) {
        yAccessor.forEach(function (actualYAccessor) {
            annotations.forEach(function (annotation, annotationIndex) {
                var _a;
                var y = actualYAccessor(annotation, annotationIndex);
                if (isFinite(y)) {
                    suitableYAnnotations.push((_a = {},
                        _a[projectedY] = y,
                        _a));
                }
            });
        });
    }
    var dataForXExtent = __spread(fullDataset, suitableXAnnotations);
    var dataForYExtent = __spread(fullDataset, suitableYAnnotations);
    var calculatedXExtent = [
        min(dataForXExtent.map(function (d) {
            return d[projectedXBottom] === undefined
                ? d[projectedX]
                : Math.min(d[projectedXTop], d[projectedXBottom]);
        })),
        max(dataForXExtent.map(function (d) {
            return d[projectedXTop] === undefined
                ? d[projectedX]
                : Math.max(d[projectedXBottom], d[projectedXTop]);
        }))
    ];
    var calculatedYExtent = [
        min(dataForYExtent.map(function (d) {
            return d[projectedYBottom] === undefined
                ? d[projectedY]
                : Math.min(d[projectedYTop], d[projectedYBottom]);
        })),
        max(dataForYExtent.map(function (d) {
            return d[projectedYTop] === undefined
                ? d[projectedY]
                : Math.max(d[projectedYBottom], d[projectedYTop]);
        }))
    ];
    var actualXExtent = extentValue(xExtent);
    var actualYExtent = extentValue(yExtent);
    var xMin = actualXExtent && actualXExtent[0] !== undefined
        ? actualXExtent[0]
        : calculatedXExtent[0];
    var xMax = actualXExtent && actualXExtent[1] !== undefined
        ? actualXExtent[1]
        : calculatedXExtent[1];
    var yMin = actualYExtent && actualYExtent[0] !== undefined
        ? actualYExtent[0]
        : calculatedYExtent[0];
    var yMax = actualYExtent && actualYExtent[1] !== undefined
        ? actualYExtent[1]
        : calculatedYExtent[1];
    var finalYExtent = [yMin, yMax];
    var finalXExtent = [xMin, xMax];
    if (invertX && !(actualXExtent && actualXExtent.length === 2)) {
        finalXExtent = [finalXExtent[1], finalXExtent[0]];
    }
    if ((lineType.type === "bumpline" || invertY) &&
        !(actualYExtent && actualYExtent.length === 2)) {
        finalYExtent = [finalYExtent[1], finalYExtent[0]];
    }
    if (summaryType.type && summaryType.type === "contour") {
        projectedSummaries = contouring({
            summaryType: summaryType,
            data: projectedSummaries,
            finalXExtent: finalXExtent,
            finalYExtent: finalYExtent
        });
    }
    else if (summaryType.type && summaryType.type === "linebounds") {
        projectedSummaries = lineBounding({
            summaryType: summaryType,
            data: projectedSummaries,
            defined: defined
        });
    }
    else if (summaryType.type && summaryType.type === "hexbin") {
        projectedSummaries = hexbinning({
            summaryType: summaryType,
            data: projectedSummaries[0],
            processedData: summaries && !!summaries[0].processedData,
            preprocess: false,
            finalXExtent: finalXExtent,
            finalYExtent: finalYExtent,
            size: size,
            margin: margin,
            baseMarkProps: baseMarkProps,
            styleFn: summaryStyleFn,
            classFn: summaryClassFn,
            renderFn: summaryRenderModeFn,
            chartSize: chartSize
        });
        fullDataset = __spread(projectedSummaries.map(function (d) { return (__assign({}, d)); }), fullDataset.filter(function (d) { return !d.parentSummary; }));
    }
    else if (summaryType.type && summaryType.type === "heatmap") {
        projectedSummaries = heatmapping({
            summaryType: summaryType,
            data: projectedSummaries[0],
            processedData: summaries && !!summaries[0].processedData,
            preprocess: false,
            finalXExtent: finalXExtent,
            finalYExtent: finalYExtent,
            size: size,
            margin: margin,
            baseMarkProps: baseMarkProps,
            styleFn: summaryStyleFn,
            classFn: summaryClassFn,
            renderFn: summaryRenderModeFn,
            chartSize: chartSize
        });
        fullDataset = __spread(projectedSummaries.map(function (d) { return (__assign({}, d)); }), fullDataset.filter(function (d) { return !d.parentSummary; }));
    }
    else if (summaryType.type && summaryType.type === "trendline") {
        projectedSummaries = trendlining({
            summaryType: summaryType,
            data: projectedSummaries[0],
            preprocess: summaries && !!summaries[0].processedData,
            finalXExtent: finalXExtent
        });
        fullDataset = __spread(projectedSummaries.map(function (d) { return (__assign({}, d)); }), fullDataset.filter(function (d) { return !d.parentSummary; }));
    }
    if (filterRenderedLines) {
        projectedLines = projectedLines.filter(filterRenderedLines);
        fullDataset = fullDataset.filter(function (d, i) {
            return !d.parentLine || filterRenderedLines(d.parentLine, i, []);
        });
    }
    if (filterRenderedPoints) {
        fullDataset = fullDataset.filter(filterRenderedPoints);
    }
    if (filterRenderedSummaries) {
        projectedSummaries = projectedSummaries.filter(filterRenderedSummaries);
        fullDataset = fullDataset.filter(function (d, i) {
            return !d.parentSummary || filterRenderedSummaries(d.parentSummary, i, []);
        });
    }
    return {
        xExtent: finalXExtent,
        yExtent: finalYExtent,
        projectedLines: projectedLines,
        projectedPoints: projectedPoints,
        projectedSummaries: projectedSummaries,
        fullDataset: fullDataset,
        calculatedXExtent: calculatedXExtent,
        calculatedYExtent: calculatedYExtent
    };
};
var differenceCatch = function (olineType, data) {
    return olineType === "difference" && data.length !== 2 ? "line" : olineType;
};
function lineTransformation(lineType, options) {
    return function (data) {
        return builtInTransformations[differenceCatch(lineType.type, data)](__assign(__assign(__assign({}, lineType), options), { data: data }));
    };
}

var screenScales = function (_a) {
    var xExtent = _a.xExtent, yExtent = _a.yExtent, adjustedSize = _a.adjustedSize, xScaleType = _a.xScaleType, yScaleType = _a.yScaleType;
    var xDomain = [0, adjustedSize[0]];
    var yDomain = [adjustedSize[1], 0];
    var xScale = xScaleType;
    var yScale = yScaleType;
    if (xScaleType.domain) {
        xScaleType.domain(xExtent);
    }
    if (yScaleType.domain) {
        yScaleType.domain(yExtent);
    }
    xScaleType.range(xDomain);
    yScaleType.range(yDomain);
    return { xScale: xScale, yScale: yScale };
};
var naturalLanguageLineType = {
    line: { items: "line", chart: "line chart" },
    area: { items: "summary", chart: "summary chart" },
    summary: { items: "summary", chart: "summary chart" },
    cumulative: { items: "line", chart: "cumulative chart" },
    "cumulative-reverse": { items: "line", chart: "cumulative chart" },
    linepercent: { items: "line", chart: "line chart" },
    stackedarea: { items: "stacked area", chart: "stacked area chart" },
    "stackedarea-invert": { items: "stacked area", chart: "stacked area chart" },
    stackedpercent: { items: "stacked area", chart: "stacked area chart" },
    "stackedpercent-invert": {
        items: "stacked area",
        chart: "stacked area chart"
    },
    bumparea: { items: "ranked area", chart: "ranked area chart" },
    "bumparea-invert": { items: "ranked area", chart: "ranked area chart" },
    bumpline: { items: "ranked line", chart: "ranked line chart" },
    difference: {
        items: "line",
        chart: "difference chart"
    }
};
var emptyObjectReturnFunction = function () { return ({}); };
var emptyStringReturnFunction = function () { return ""; };
var calculateXYFrame = function (currentProps, prevState, updateData) {
    var _a, _b, _c;
    var legend = currentProps.legend, lines = currentProps.lines, lineClass = currentProps.lineClass, pointStyle = currentProps.pointStyle, pointRenderMode = currentProps.pointRenderMode, pointClass = currentProps.pointClass, summaryClass = currentProps.summaryClass, canvasLines = currentProps.canvasLines, canvasPoints = currentProps.canvasPoints, canvasSummaries = currentProps.canvasSummaries, defined = currentProps.defined, size = currentProps.size, renderKey = currentProps.renderKey, lineType = currentProps.lineType, summaryType = currentProps.summaryType, customLineMark = currentProps.customLineMark, customPointMark = currentProps.customPointMark, customSummaryMark = currentProps.customSummaryMark, summaryStyle = currentProps.summaryStyle, summaryRenderMode = currentProps.summaryRenderMode, lineStyle = currentProps.lineStyle, lineRenderMode = currentProps.lineRenderMode, baseXExtent = currentProps.xExtent, baseYExtent = currentProps.yExtent, title = currentProps.title, _d = currentProps.xScaleType, baseXScaleType = _d === void 0 ? scaleLinear() : _d, _e = currentProps.yScaleType, baseYScaleType = _e === void 0 ? scaleLinear() : _e, lineIDAccessor = currentProps.lineIDAccessor, invertX = currentProps.invertX, invertY = currentProps.invertY, showLinePoints = currentProps.showLinePoints, showSummaryPoints = currentProps.showSummaryPoints, points = currentProps.points, lineDataAccessor = currentProps.lineDataAccessor, summaryDataAccessor = currentProps.summaryDataAccessor, yAccessor = currentProps.yAccessor, xAccessor = currentProps.xAccessor, useSummariesAsInteractionLayer = currentProps.useSummariesAsInteractionLayer, baseMarkProps = currentProps.baseMarkProps, filterRenderedLines = currentProps.filterRenderedLines, filterRenderedSummaries = currentProps.filterRenderedSummaries, filterRenderedPoints = currentProps.filterRenderedPoints, annotations = currentProps.annotations;
    var projectedLines = currentProps.projectedLines, projectedPoints = currentProps.projectedPoints, projectedSummaries = currentProps.projectedSummaries, summaries = currentProps.summaries, fullDataset = currentProps.fullDataset;
    if (summaryType && points && !summaries) {
        summaries = [{ coordinates: points }];
    }
    else if (summaryType &&
        summaryType.type === "linebounds" &&
        lines &&
        !summaries) {
        summaries = lines;
    }
    var castXScaleType = baseXScaleType;
    var xScaleType = baseXScaleType.domain ? baseXScaleType : castXScaleType();
    var castYScaleType = baseYScaleType;
    var yScaleType = baseYScaleType.domain ? baseYScaleType : castYScaleType();
    var annotatedSettings = {
        xAccessor: stringToArrayFn(xAccessor, function (d) { return d[0]; }),
        yAccessor: stringToArrayFn(yAccessor, function (d) { return d[1]; }),
        summaryDataAccessor: stringToArrayFn(summaryDataAccessor, function (d) { return (Array.isArray(d) ? d : d.coordinates); }),
        lineDataAccessor: stringToArrayFn(lineDataAccessor, function (d) { return (Array.isArray(d) ? d : d.coordinates); }),
        renderKeyFn: stringToFn(renderKey, function (d, i) { return "line-" + i; }, true),
        lineType: objectifyType(lineType),
        summaryType: objectifyType(summaryType),
        lineIDAccessor: stringToFn(lineIDAccessor, function (l) { return l.semioticLineID; }),
        summaries: !summaries || (Array.isArray(summaries) && summaries.length === 0)
            ? undefined
            : !Array.isArray(summaries)
                ? [summaries]
                : !summaryDataAccessor && !summaries[0].coordinates
                    ? [{ coordinates: summaries }]
                    : summaries,
        lines: !lines || (Array.isArray(lines) && lines.length === 0)
            ? undefined
            : !Array.isArray(lines)
                ? [lines]
                : !lineDataAccessor && !lines[0].coordinates
                    ? [{ coordinates: lines }]
                    : lines,
        title: typeof title === "object" &&
            !React.isValidElement(title) &&
            title !== null
            ? title
            : { title: title, orient: "top" },
        xExtent: Array.isArray(baseXExtent)
            ? baseXExtent
            : !baseXExtent
                ? undefined
                : baseXExtent.extent,
        yExtent: Array.isArray(baseYExtent)
            ? baseYExtent
            : !baseYExtent
                ? undefined
                : baseYExtent.extent
    };
    if (annotatedSettings.lineType.type === "area") {
        annotatedSettings.lineType.y1 = function () { return 0; };
        annotatedSettings.lineType.simpleLine = false;
    }
    var summaryStyleFn = stringToFn(summaryStyle, emptyObjectReturnFunction, true);
    var summaryClassFn = stringToFn(summaryClass, emptyStringReturnFunction, true);
    var summaryRenderModeFn = stringToFn(summaryRenderMode, undefined, true);
    var generatedAxes = currentProps.axes &&
        currentProps.axes.map(function (axisFnOrObject) {
            return typeof axisFnOrObject === "function"
                ? axisFnOrObject({ size: currentProps.size })
                : axisFnOrObject;
        });
    var margin = calculateMargin({
        margin: currentProps.margin,
        axes: generatedAxes,
        title: annotatedSettings.title,
        size: currentProps.size
    });
    var _f = adjustedPositionSize({
        size: currentProps.size,
        margin: margin
    }), adjustedPosition = _f.adjustedPosition, adjustedSize = _f.adjustedSize;
    var calculatedXExtent = [], calculatedYExtent = [], yExtent, xExtent, xExtentSettings, yExtentSettings;
    if (typeof baseXExtent === "object") {
        xExtentSettings = baseXExtent;
    }
    else {
        xExtentSettings = { extent: baseXExtent };
    }
    if (typeof baseYExtent === "object") {
        yExtentSettings = baseYExtent;
    }
    else {
        yExtentSettings = { extent: baseYExtent };
    }
    var xScale, yScale;
    if (updateData ||
        (currentProps.dataVersion &&
            currentProps.dataVersion !== prevState.dataVersion)) {
        //This will always fire at this point because xExtent/yExtent are just defined up there so revisit this logic
        if (!xExtent ||
            !yExtent ||
            !fullDataset ||
            (!projectedLines && !projectedPoints && !projectedSummaries)) {
            (_a = calculateDataExtent({
                lineDataAccessor: annotatedSettings.lineDataAccessor,
                summaryDataAccessor: annotatedSettings.summaryDataAccessor,
                xAccessor: annotatedSettings.xAccessor,
                yAccessor: annotatedSettings.yAccessor,
                lineType: annotatedSettings.lineType,
                summaryType: annotatedSettings.summaryType,
                summaries: annotatedSettings.summaries,
                points: points,
                lines: annotatedSettings.lines,
                showLinePoints: showLinePoints,
                showSummaryPoints: showSummaryPoints,
                xExtent: baseXExtent,
                yExtent: baseYExtent,
                invertX: invertX,
                invertY: invertY,
                adjustedSize: adjustedSize,
                margin: margin,
                baseMarkProps: baseMarkProps,
                summaryStyleFn: summaryStyleFn,
                summaryClassFn: summaryClassFn,
                summaryRenderModeFn: summaryRenderModeFn,
                chartSize: size,
                xScaleType: xScaleType,
                yScaleType: yScaleType,
                defined: defined,
                filterRenderedLines: filterRenderedLines,
                filterRenderedSummaries: filterRenderedSummaries,
                filterRenderedPoints: filterRenderedPoints,
                annotations: annotations
            }), xExtent = _a.xExtent, yExtent = _a.yExtent, projectedLines = _a.projectedLines, projectedPoints = _a.projectedPoints, projectedSummaries = _a.projectedSummaries, fullDataset = _a.fullDataset, calculatedXExtent = _a.calculatedXExtent, calculatedYExtent = _a.calculatedYExtent);
        }
        (_b = screenScales({
            xExtent: xExtent,
            yExtent: yExtent,
            adjustedSize: adjustedSize,
            xScaleType: xScaleType.copy(),
            yScaleType: yScaleType.copy()
        }), xScale = _b.xScale, yScale = _b.yScale);
    }
    else {
        (xExtent = prevState.xExtent, yExtent = prevState.yExtent, projectedLines = prevState.projectedLines, projectedPoints = prevState.projectedPoints, projectedSummaries = prevState.projectedSummaries, fullDataset = prevState.fullDataset, calculatedXExtent = prevState.calculatedXExtent, calculatedYExtent = prevState.calculatedYExtent);
        if (adjustedSize[0] === prevState.adjustedSize[0] &&
            adjustedSize[1] === prevState.adjustedSize[1]) {
            xScale = prevState.xScale;
            yScale = prevState.yScale;
        }
        else {
            (_c = screenScales({
                xExtent: xExtent,
                yExtent: yExtent,
                adjustedSize: adjustedSize,
                xScaleType: xScaleType,
                yScaleType: yScaleType
            }), xScale = _c.xScale, yScale = _c.yScale);
        }
    }
    xExtent =
        Array.isArray(xExtentSettings.extent) && xExtentSettings.extent.length === 2
            ? xExtentSettings.extent
            : xExtent;
    yExtent =
        Array.isArray(yExtentSettings.extent) && yExtentSettings.extent.length === 2
            ? yExtentSettings.extent
            : yExtent;
    var canvasDrawing = [];
    var axes;
    var axesTickLines;
    var existingBaselines = {};
    if (generatedAxes) {
        axesTickLines = [];
        axes = generatedAxes.map(function (d, i) {
            var axisClassname = d.className || "";
            axisClassname += " axis";
            var axisScale = yScale;
            if (existingBaselines[d.orient]) {
                d.baseline = d.baseline || false;
            }
            existingBaselines[d.orient] = true;
            if (d.orient === "top" || d.orient === "bottom") {
                axisClassname += " x";
                axisScale = xScale;
            }
            else {
                axisClassname += " y";
            }
            axisClassname += " " + d.orient;
            var tickValues;
            if (d.tickValues && Array.isArray(d.tickValues)) {
                tickValues = d.tickValues;
            }
            else if (d.tickValues instanceof Function) {
                //otherwise assume a function
                tickValues = d.tickValues(fullDataset, currentProps.size, axisScale);
            }
            var axisSize = [adjustedSize[0], adjustedSize[1]];
            var axisParts = axisPieces({
                padding: d.padding,
                tickValues: tickValues,
                scale: axisScale,
                ticks: d.ticks,
                orient: d.orient,
                size: axisSize,
                footer: d.footer,
                tickSize: d.tickSize,
                jaggedBase: d.jaggedBase
            });
            var axisTickLines = (React.createElement("g", { key: "axes-tick-lines-" + i, className: "axis " + axisClassname },
                axisLines({
                    axisParts: axisParts,
                    orient: d.orient,
                    tickLineGenerator: d.tickLineGenerator,
                    baseMarkProps: baseMarkProps,
                    className: axisClassname,
                    jaggedBase: d.jaggedBase,
                    scale: axisScale,
                    showOutboundTickLines: d.showOutboundTickLines
                }),
                d.baseline === "under" &&
                    baselineGenerator(d.orient, adjustedSize, d.className)));
            axesTickLines.push(axisTickLines);
            return (React.createElement(Axis, __assign({}, d, { key: d.key || "axis-" + i, annotationFunction: d.axisAnnotationFunction, axisParts: axisParts, size: axisSize, margin: margin, tickValues: tickValues, scale: axisScale, className: axisClassname, xyPoints: fullDataset })));
        });
    }
    var legendSettings;
    if (legend) {
        legendSettings = legend === true ? {} : legend;
        if (projectedLines && !legendSettings.legendGroups) {
            var typeString = annotatedSettings.lineType.type;
            var type = typeof typeString === "string" &&
                ["stackedarea", "stackedpercent", "bumparea"].indexOf(typeString) === -1
                ? "line"
                : "fill";
            var legendGroups = [
                {
                    styleFn: currentProps.lineStyle,
                    type: type,
                    items: projectedLines.map(function (d) {
                        return Object.assign({ label: annotatedSettings.lineIDAccessor(d) }, d);
                    })
                }
            ];
            legendSettings.legendGroups = legendGroups;
        }
    }
    var areaAnnotations = [];
    if (annotatedSettings.summaryType.label && projectedSummaries) {
        projectedSummaries.forEach(function (d, i) {
            if (d.bounds) {
                var bounds = Array.isArray(d.bounds) ? d.bounds : [d.bounds];
                bounds.forEach(function (labelBounds) {
                    var label = typeof annotatedSettings.summaryType.label === "function"
                        ? annotatedSettings.summaryType.label(d)
                        : annotatedSettings.summaryType.label;
                    if (label && label !== null) {
                        var labelPosition = label.position || "center";
                        var labelCenter = [
                            xScale(labelBounds[labelPosition][0]),
                            yScale(labelBounds[labelPosition][1])
                        ] || [xScale(d._xyfCoordinates[0]), yScale(d._xyfCoordinates[1])];
                        var labelContent = label.content || (function (p) { return p.value || p.id || i; });
                        areaAnnotations.push({
                            x: labelCenter[0],
                            y: labelCenter[1],
                            dx: label.dx,
                            dy: label.dy,
                            className: label.className,
                            type: label.type || AnnotationCallout,
                            note: label.note || { title: labelContent(d) },
                            subject: label.subject || { text: labelContent(d) },
                            connector: label.connector
                        });
                    }
                });
            }
        });
    }
    else if (annotatedSettings.summaryType.showSlope &&
        projectedSummaries &&
        projectedSummaries[0]) {
        var firstSummary = projectedSummaries[0];
        var firstPoint = firstSummary._xyfCoordinates[0];
        var finalPoint = firstSummary._xyfCoordinates[firstSummary._xyfCoordinates.length - 1];
        areaAnnotations.push({
            x: firstPoint[0],
            y: firstPoint[1],
            x1: finalPoint[0],
            x2: finalPoint[1],
            type: "trendline-annotation",
            value: firstSummary.value,
            r2: firstSummary.r2
        });
    }
    var lineAriaLabel = annotatedSettings.lineType.type !== undefined &&
        typeof annotatedSettings.lineType.type === "string" &&
        naturalLanguageLineType[annotatedSettings.lineType.type];
    var xyFrameRender = {
        lines: {
            accessibleTransform: function (data, i) { return (__assign(__assign({}, data[i].data[data[i].data.length - 1]), { type: "frame-hover" })); },
            data: projectedLines,
            styleFn: stringToFn(lineStyle, emptyObjectReturnFunction, true),
            classFn: stringToFn(lineClass, emptyStringReturnFunction, true),
            renderMode: stringToFn(lineRenderMode, undefined, true),
            canvasRender: stringToFn(canvasLines, undefined, true),
            customMark: customLineMark,
            type: annotatedSettings.lineType,
            defined: defined,
            renderKeyFn: annotatedSettings.renderKeyFn,
            ariaLabel: lineAriaLabel,
            axesData: generatedAxes,
            behavior: createLines
        },
        summaries: {
            accessibleTransform: function (data, i) { return (__assign(__assign({}, data[i]), { type: "frame-hover" })); },
            data: projectedSummaries,
            styleFn: summaryStyleFn,
            classFn: summaryClassFn,
            renderMode: summaryRenderModeFn,
            canvasRender: stringToFn(canvasSummaries, undefined, true),
            customMark: customSummaryMark,
            type: annotatedSettings.summaryType,
            renderKeyFn: annotatedSettings.renderKeyFn,
            behavior: createSummaries
        },
        points: {
            accessibleTransform: function (data, i) { return (__assign({ type: "frame-hover" }, (data[i].data || data[i]))); },
            data: projectedPoints,
            styleFn: stringToFn(pointStyle, emptyObjectReturnFunction, true),
            classFn: stringToFn(pointClass, emptyStringReturnFunction, true),
            renderMode: stringToFn(pointRenderMode, undefined, true),
            canvasRender: stringToFn(canvasPoints, undefined, true),
            customMark: customPointMark,
            renderKeyFn: annotatedSettings.renderKeyFn,
            showLinePoints: showLinePoints,
            behavior: createPoints
        }
    };
    if (xExtentSettings.onChange &&
        prevState.calculatedXExtent.join(",") !== calculatedXExtent.join(",")) {
        xExtentSettings.onChange(calculatedXExtent);
    }
    if (yExtentSettings.onChange &&
        prevState.calculatedYExtent.join(",") !== calculatedYExtent.join(",")) {
        yExtentSettings.onChange(calculatedYExtent);
    }
    var overlay = undefined;
    if (useSummariesAsInteractionLayer && projectedSummaries) {
        overlay = createSummaries({
            xScale: xScale,
            yScale: yScale,
            data: projectedSummaries
        }).map(function (m, i) { return (__assign(__assign({}, m.props), { style: { fillOpacity: 0 }, overlayData: projectedSummaries && projectedSummaries[i] // luckily createSummaries is a map fn
         })); });
    }
    return {
        lineData: currentProps.lines,
        pointData: currentProps.points,
        summaryData: currentProps.summaries,
        dataVersion: currentProps.dataVersion,
        projectedLines: projectedLines,
        projectedPoints: projectedPoints,
        projectedSummaries: projectedSummaries,
        canvasDrawing: canvasDrawing,
        fullDataset: fullDataset,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: currentProps.backgroundGraphics,
        foregroundGraphics: currentProps.foregroundGraphics,
        axesData: generatedAxes,
        axes: axes,
        axesTickLines: axesTickLines,
        renderNumber: prevState.renderNumber + 1,
        xScale: xScale,
        yScale: yScale,
        xAccessor: annotatedSettings.xAccessor,
        yAccessor: annotatedSettings.yAccessor,
        xExtent: [
            xExtent[0] === undefined ? calculatedXExtent[0] : xExtent[0],
            xExtent[1] === undefined ? calculatedXExtent[1] : xExtent[1]
        ],
        yExtent: [
            yExtent[0] === undefined ? calculatedYExtent[0] : yExtent[0],
            yExtent[1] === undefined ? calculatedYExtent[1] : yExtent[1]
        ],
        calculatedXExtent: calculatedXExtent,
        calculatedYExtent: calculatedYExtent,
        margin: margin,
        legendSettings: legendSettings,
        areaAnnotations: areaAnnotations,
        xyFrameRender: xyFrameRender,
        size: size,
        annotatedSettings: annotatedSettings,
        overlay: overlay,
        props: currentProps
    };
};

//size is a special case and handled checking the actual values in the size array
var sharedChangeProps = [
    "customClickBehavior",
    "customHoverBehavior",
    "customDoubleClickBehavior",
    "hoverAnnotation",
    "name",
    "title",
    "margin",
    "className",
    "additionalDefs",
    "renderKey"
];
var xyFrameDataProps = [
    "lines",
    "points",
    "summaries",
    "xScaleType",
    "yScaleType",
    "xAccessor",
    "yAccessor",
    "lineDataAccessor",
    "areaDataAccessor",
    "summaryDataAccessor",
    "lineType",
    "showLinePoints",
    "showSummaryPoints",
    "defined",
    "summaryType"
];
var xyFrameChangeProps = __spread(sharedChangeProps, xyFrameDataProps, [
    "axes",
    "xExtent",
    "yExtent",
    "invertX",
    "invertY",
    "defined",
    "lineStyle",
    "pointStyle",
    "summaryStyle",
    "lineClass",
    "pointClass",
    "areaClass",
    "summaryClass",
    "canvasPoints",
    "customPointMark",
    "customLineMark",
    "lineIDAccessor"
]);
var orFrameChangeProps = __spread(sharedChangeProps, [
    "pieceHoverAnnotation",
    "summaryHoverAnnotation",
    "data",
    "orient",
    "oScaleType",
    "rScaleType",
    "oExtent",
    "rExtent",
    "invertO",
    "invertR",
    "oAccessor",
    "rAccessor",
    "oPadding",
    "projection",
    "type",
    "summaryType",
    "connectorType",
    "dataAccessor",
    "rBaseline",
    "oSort",
    "dynamicColumnWidth",
    "style",
    "connectorStyle",
    "summaryStyle",
    "summaryPosition",
    "oLabel",
    "axes",
    "renderFn"
]);
var networkFrameChangeProps = __spread(sharedChangeProps, [
    "graph",
    "nodes",
    "edges",
    "nodeIDAccessor",
    "sourceAccessor",
    "targetAccessor",
    "nodeSizeAccessor",
    "customNodeIcon",
    "nodeLabels",
    "edgeWidthAccessor",
    "networkType",
    "renderFn",
    "nodeStyle",
    "edgeStyle",
    "edgeType",
    "filterRenderedNodes"
]);

var xyframeKey = "";
var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
for (var i = 32; i > 0; --i)
    xyframeKey += chars[Math.floor(Math.random() * chars.length)];
var projectedCoordinateNames$1 = {
    y: projectedY,
    x: projectedX,
    yMiddle: projectedYMiddle,
    yTop: projectedYTop,
    yBottom: projectedYBottom,
    xMiddle: projectedXMiddle,
    xTop: projectedXTop,
    xBottom: projectedXBottom
};
var XYFrame = /** @class */ (function (_super) {
    __extends(XYFrame, _super);
    function XYFrame(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultXYSVGRule = function (_a) {
            var baseD = _a.d, i = _a.i, annotationLayer = _a.annotationLayer, lines = _a.lines, summaries = _a.summaries, points = _a.points;
            var _b = _this.props, showLinePoints = _b.showLinePoints, defined = _b.defined, baseMargin = _b.margin, size = _b.size, svgAnnotationRules = _b.svgAnnotationRules;
            var _c = _this.state, xyFrameRender = _c.xyFrameRender, xScale = _c.xScale, yScale = _c.yScale, xAccessor = _c.xAccessor, yAccessor = _c.yAccessor, axesData = _c.axesData, annotatedSettings = _c.annotatedSettings;
            var screenCoordinates = [];
            var idAccessor = annotatedSettings.lineIDAccessor;
            if (baseD.type === "highlight") {
                return svgHighlight({
                    d: baseD,
                    i: i,
                    idAccessor: idAccessor,
                    lines: lines,
                    summaries: summaries,
                    points: points,
                    xScale: xScale,
                    yScale: yScale,
                    xyFrameRender: xyFrameRender,
                    defined: defined
                });
            }
            var d = baseD.coordinates
                ? baseD
                : findPointByID({
                    point: baseD,
                    idAccessor: idAccessor,
                    lines: lines,
                    xScale: xScale,
                    projectedX: projectedX,
                    xAccessor: xAccessor
                });
            if (!d)
                return null;
            var margin = calculateMargin({
                margin: baseMargin,
                axes: axesData,
                title: annotatedSettings.title,
                size: size
            });
            var _d = adjustedPositionSize({
                size: size,
                margin: margin
            }), adjustedPosition = _d.adjustedPosition, adjustedSize = _d.adjustedSize;
            if (!d.coordinates && !d.bounds) {
                screenCoordinates = [
                    relativeX({
                        point: d,
                        projectedXMiddle: projectedXMiddle,
                        projectedX: projectedX,
                        xAccessor: xAccessor,
                        xScale: xScale
                    }) || 0,
                    relativeY({
                        point: d,
                        projectedYMiddle: projectedYMiddle,
                        projectedY: projectedY,
                        yAccessor: yAccessor,
                        yScale: yScale,
                        showLinePoints: showLinePoints
                    }) || 0
                ];
            }
            else if (!d.bounds) {
                screenCoordinates = d.coordinates.reduce(function (coords, p) {
                    var xCoordinate = relativeX({
                        point: p,
                        projectedXMiddle: projectedXMiddle,
                        projectedX: projectedX,
                        xAccessor: xAccessor,
                        xScale: xScale
                    });
                    var yCoordinate = relativeY({
                        point: p,
                        projectedYMiddle: projectedYMiddle,
                        projectedY: projectedY,
                        yAccessor: yAccessor,
                        yScale: yScale
                    });
                    if (Array.isArray(yCoordinate)) {
                        return __spread(coords, [
                            [xCoordinate, Math.min.apply(Math, __spread(yCoordinate))],
                            [xCoordinate, Math.max.apply(Math, __spread(yCoordinate))]
                        ]);
                    }
                    else if (Array.isArray(xCoordinate)) {
                        return __spread(coords, [
                            [Math.min.apply(Math, __spread(xCoordinate)), yCoordinate],
                            [Math.max.apply(Math, __spread(xCoordinate)), yCoordinate]
                        ]);
                    }
                    else {
                        return __spread(coords, [[xCoordinate, yCoordinate]]);
                    }
                }, []);
            }
            var voronoiHover = annotationLayer.voronoiHover;
            var customSVG = svgAnnotationRules &&
                svgAnnotationRules({
                    d: d,
                    i: i,
                    screenCoordinates: screenCoordinates,
                    xScale: xScale,
                    yScale: yScale,
                    xAccessor: xAccessor,
                    yAccessor: yAccessor,
                    xyFrameProps: _this.props,
                    xyFrameState: _this.state,
                    summaries: summaries,
                    points: points,
                    lines: lines,
                    voronoiHover: voronoiHover,
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize,
                    annotationLayer: annotationLayer
                });
            if (svgAnnotationRules !== undefined && customSVG !== null) {
                return customSVG;
            }
            else if (d.type === "desaturation-layer") {
                return desaturationLayer({
                    style: d.style instanceof Function ? d.style(d, i) : d.style,
                    size: adjustedSize,
                    i: i,
                    key: d.key
                });
            }
            else if (d.type === "xy" || d.type === "frame-hover") {
                return svgXYAnnotation({ d: d, i: i, screenCoordinates: screenCoordinates });
            }
            else if (d.type === "react-annotation" || typeof d.type === "function") {
                return basicReactAnnotation({ d: d, screenCoordinates: screenCoordinates, i: i });
            }
            else if (d.type === "enclose") {
                return svgEncloseAnnotation({ d: d, screenCoordinates: screenCoordinates, i: i });
            }
            else if (d.type === "enclose-rect") {
                return svgRectEncloseAnnotation({ d: d, screenCoordinates: screenCoordinates, i: i });
            }
            else if (d.type === "enclose-hull") {
                return svgHullEncloseAnnotation({ d: d, screenCoordinates: screenCoordinates, i: i });
            }
            else if (d.type === "x") {
                return svgXAnnotation({
                    d: d,
                    screenCoordinates: screenCoordinates,
                    i: i,
                    adjustedSize: adjustedSize
                });
            }
            else if (d.type === "y") {
                return svgYAnnotation({
                    d: d,
                    screenCoordinates: screenCoordinates,
                    i: i,
                    adjustedSize: adjustedSize,
                    adjustedPosition: adjustedPosition
                });
            }
            else if (d.type === "bounds") {
                return svgBoundsAnnotation({
                    d: d,
                    i: i,
                    adjustedSize: adjustedSize,
                    xAccessor: xAccessor,
                    yAccessor: yAccessor,
                    xScale: xScale,
                    yScale: yScale
                });
            }
            else if (d.type === "line") {
                return svgLineAnnotation({ d: d, i: i, screenCoordinates: screenCoordinates });
            }
            else if (d.type === "area") {
                return svgAreaAnnotation({
                    d: d,
                    i: i,
                    xScale: xScale,
                    xAccessor: xAccessor,
                    yScale: yScale,
                    yAccessor: yAccessor,
                    annotationLayer: annotationLayer
                });
            }
            else if (d.type === "horizontal-points") {
                return svgHorizontalPointsAnnotation({
                    d: d,
                    lines: lines.data,
                    points: points.data,
                    xScale: xScale,
                    yScale: yScale,
                    pointStyle: points.styleFn
                });
            }
            else if (d.type === "vertical-points") {
                return svgVerticalPointsAnnotation({
                    d: d,
                    lines: lines.data,
                    points: points.data,
                    xScale: xScale,
                    yScale: yScale,
                    pointStyle: points.styleFn
                });
            }
            return null;
        };
        _this.defaultXYHTMLRule = function (_a) {
            var baseD = _a.d, i = _a.i, lines = _a.lines, summaries = _a.summaries, points = _a.points, annotationLayer = _a.annotationLayer;
            var _b = _this.state, xAccessor = _b.xAccessor, yAccessor = _b.yAccessor, xScale = _b.xScale, yScale = _b.yScale, SpanOrDiv = _b.SpanOrDiv, annotatedSettings = _b.annotatedSettings, axesData = _b.axesData;
            var voronoiHover = annotationLayer.voronoiHover;
            var screenCoordinates = [];
            var _c = _this.props, useSpans = _c.useSpans, tooltipContent = _c.tooltipContent, optimizeCustomTooltipPosition = _c.optimizeCustomTooltipPosition, htmlAnnotationRules = _c.htmlAnnotationRules, size = _c.size, showLinePoints = _c.showLinePoints, baseMargin = _c.margin;
            var idAccessor = annotatedSettings.lineIDAccessor;
            var d = findPointByID({
                point: baseD,
                idAccessor: idAccessor,
                lines: lines,
                xScale: xScale,
                projectedX: projectedX,
                xAccessor: xAccessor
            });
            if (!d) {
                return null;
            }
            var xCoord = d[projectedXMiddle] ||
                d[projectedX] ||
                findFirstAccessorValue(xAccessor, d);
            var yCoord = d[projectedYMiddle] ||
                d[projectedY] ||
                findFirstAccessorValue(yAccessor, d);
            var xString = xCoord && xCoord.toString ? xCoord.toString() : xCoord;
            var yString = yCoord && yCoord.toString ? yCoord.toString() : yCoord;
            var margin = calculateMargin({
                margin: baseMargin,
                axes: axesData,
                title: annotatedSettings.title,
                size: size
            });
            var _d = adjustedPositionSize({
                size: size,
                margin: margin
            }), adjustedPosition = _d.adjustedPosition, adjustedSize = _d.adjustedSize;
            if (!d.coordinates) {
                screenCoordinates = [
                    xScale(xCoord) || 0,
                    relativeY({
                        point: d,
                        projectedYMiddle: projectedYMiddle,
                        projectedY: projectedY,
                        showLinePoints: showLinePoints,
                        yAccessor: yAccessor,
                        yScale: yScale
                    }) || 0
                ];
            }
            else {
                screenCoordinates = d.coordinates.map(function (p) {
                    var foundP = findPointByID({
                        point: __assign({ x: 0, y: 0 }, p),
                        idAccessor: idAccessor,
                        lines: lines,
                        xScale: xScale,
                        projectedX: projectedX,
                        xAccessor: xAccessor
                    });
                    return [
                        (xScale(findFirstAccessorValue(xAccessor, d)) || 0) +
                            adjustedPosition[0],
                        (relativeY({
                            point: foundP,
                            projectedYMiddle: projectedYMiddle,
                            projectedY: projectedY,
                            yAccessor: yAccessor,
                            yScale: yScale
                        }) || 0) + adjustedPosition[1]
                    ];
                });
            }
            var customAnnotation = htmlAnnotationRules &&
                htmlAnnotationRules({
                    d: d,
                    i: i,
                    screenCoordinates: screenCoordinates,
                    xScale: xScale,
                    yScale: yScale,
                    xAccessor: xAccessor,
                    yAccessor: yAccessor,
                    xyFrameProps: _this.props,
                    xyFrameState: _this.state,
                    summaries: summaries,
                    points: points,
                    lines: lines,
                    voronoiHover: voronoiHover,
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize,
                    annotationLayer: annotationLayer
                });
            if (htmlAnnotationRules && customAnnotation !== null) {
                return customAnnotation;
            }
            if (d.type === "frame-hover") {
                var content = (React.createElement(SpanOrDiv, { span: useSpans, className: "tooltip-content" },
                    React.createElement("p", { key: "html-annotation-content-1" }, xString),
                    React.createElement("p", { key: "html-annotation-content-2" }, yString),
                    d.percent ? (React.createElement("p", { key: "html-annotation-content-3" },
                        Math.floor(d.percent * 1000) / 10,
                        "%")) : null));
                if (d.type === "frame-hover" && tooltipContent) {
                    content = optimizeCustomTooltipPosition ? (React.createElement(TooltipPositioner, { tooltipContent: tooltipContent, tooltipContentArgs: d })) : (tooltipContent(d));
                }
                return htmlTooltipAnnotation({
                    content: content,
                    screenCoordinates: screenCoordinates,
                    i: i,
                    d: d,
                    useSpans: useSpans
                });
            }
            return null;
        };
        var baseState = {
            SpanOrDiv: HOCSpanOrDiv(props.useSpans),
            size: [500, 500],
            dataVersion: undefined,
            lineData: undefined,
            pointData: undefined,
            summaryData: undefined,
            projectedLines: undefined,
            projectedPoints: undefined,
            projectedSummaries: undefined,
            fullDataset: [],
            adjustedPosition: [0, 0],
            adjustedSize: [500, 500],
            backgroundGraphics: null,
            foregroundGraphics: null,
            axesData: undefined,
            axes: undefined,
            axesTickLines: undefined,
            renderNumber: 0,
            margin: { top: 0, bottom: 0, left: 0, right: 0 },
            calculatedXExtent: [0, 0],
            calculatedYExtent: [0, 0],
            xAccessor: [function (d) { return d.x; }],
            yAccessor: [function (d) { return d.y; }],
            xExtent: [0, 0],
            yExtent: [0, 0],
            areaAnnotations: [],
            xScale: scaleLinear(),
            yScale: scaleLinear(),
            title: null,
            legendSettings: undefined,
            xyFrameRender: {},
            canvasDrawing: [],
            annotatedSettings: {
                xAccessor: undefined,
                yAccessor: undefined,
                summaryDataAccessor: undefined,
                lineDataAccessor: undefined,
                renderKeyFn: undefined,
                lineType: undefined,
                summaryType: undefined,
                lineIDAccessor: undefined,
                summaries: undefined,
                lines: undefined,
                title: undefined,
                xExtent: undefined,
                yExtent: undefined
            },
            overlay: undefined,
            props: props
        };
        _this.state = __assign(__assign({}, baseState), calculateXYFrame(props, baseState, true));
        return _this;
    }
    XYFrame.prototype.componentWillUnmount = function () {
        var onUnmount = this.props.onUnmount;
        if (onUnmount) {
            onUnmount(this.props, this.state);
        }
    };
    XYFrame.getDerivedStateFromProps = function (nextProps, prevState) {
        var props = prevState.props;
        var _a = prevState.xExtent, oldXExtent = _a === void 0 ? [] : _a, _b = prevState.yExtent, oldYExtent = _b === void 0 ? [] : _b, oldSize = prevState.size, oldDataVersion = prevState.dataVersion, lineData = prevState.lineData, summaryData = prevState.summaryData, pointData = prevState.pointData;
        var baseNewXExtent = nextProps.xExtent, baseNewYExtent = nextProps.yExtent, newSize = nextProps.size, newDataVersion = nextProps.dataVersion, newLines = nextProps.lines, newSummaries = nextProps.summaries, newPoints = nextProps.points;
        var newXExtent = extentValue(baseNewXExtent);
        var newYExtent = extentValue(baseNewYExtent);
        var extentChange = (oldXExtent[0] !== newXExtent[0] && newXExtent[0] !== undefined) ||
            (oldYExtent[0] !== newYExtent[0] && newYExtent[0] !== undefined) ||
            (oldXExtent[1] !== newXExtent[1] && newXExtent[1] !== undefined) ||
            (oldYExtent[1] !== newYExtent[1] && newYExtent[1] !== undefined);
        var lineChange = basicDataChangeCheck(lineData, newLines);
        var summaryChange = basicDataChangeCheck(summaryData, newSummaries);
        var pointChange = basicDataChangeCheck(pointData, newPoints);
        if ((oldDataVersion && oldDataVersion !== newDataVersion) ||
            !prevState.fullDataset) {
            return calculateXYFrame(nextProps, prevState, true);
        }
        else if (lineChange ||
            summaryChange ||
            pointChange ||
            oldSize[0] !== newSize[0] ||
            oldSize[1] !== newSize[1] ||
            extentChange ||
            (!oldDataVersion &&
                xyFrameChangeProps.find(function (d) { return props[d] !== nextProps[d]; }))) {
            var dataChanged = lineChange ||
                summaryChange ||
                pointChange ||
                extentChange ||
                !!xyFrameChangeProps.find(function (d) { return props[d] !== nextProps[d]; });
            return calculateXYFrame(nextProps, prevState, dataChanged);
        }
        return null;
    };
    XYFrame.prototype.render = function () {
        var _a = this.props, size = _a.size, className = _a.className, annotationSettings = _a.annotationSettings, annotations = _a.annotations, additionalDefs = _a.additionalDefs, hoverAnnotation = _a.hoverAnnotation, interaction = _a.interaction, customClickBehavior = _a.customClickBehavior, customHoverBehavior = _a.customHoverBehavior, customDoubleClickBehavior = _a.customDoubleClickBehavior, canvasPostProcess = _a.canvasPostProcess, baseMarkProps = _a.baseMarkProps, useSpans = _a.useSpans, canvasSummaries = _a.canvasSummaries, canvasPoints = _a.canvasPoints, canvasLines = _a.canvasLines, afterElements = _a.afterElements, beforeElements = _a.beforeElements, renderOrder = _a.renderOrder, matte = _a.matte, frameKey = _a.frameKey, showLinePoints = _a.showLinePoints, sketchyRenderingEngine = _a.sketchyRenderingEngine, disableContext = _a.disableContext, frameRenderOrder = _a.frameRenderOrder, disableCanvasInteraction = _a.disableCanvasInteraction, interactionSettings = _a.interactionSettings, disableProgressiveRendering = _a.disableProgressiveRendering;
        var _b = this.state, backgroundGraphics = _b.backgroundGraphics, foregroundGraphics = _b.foregroundGraphics, adjustedPosition = _b.adjustedPosition, adjustedSize = _b.adjustedSize, margin = _b.margin, axes = _b.axes, axesTickLines = _b.axesTickLines, xScale = _b.xScale, yScale = _b.yScale, fullDataset = _b.fullDataset, dataVersion = _b.dataVersion, areaAnnotations = _b.areaAnnotations, legendSettings = _b.legendSettings, xyFrameRender = _b.xyFrameRender, annotatedSettings = _b.annotatedSettings, overlay = _b.overlay;
        return (React.createElement(Frame, { name: "xyframe", renderPipeline: xyFrameRender, adjustedPosition: adjustedPosition, size: size, projectedCoordinateNames: projectedCoordinateNames$1, xScale: xScale, yScale: yScale, axes: axes, axesTickLines: axesTickLines, title: annotatedSettings.title, dataVersion: dataVersion, matte: matte, className: className, adjustedSize: adjustedSize, frameKey: frameKey || xyframeKey, additionalDefs: additionalDefs, hoverAnnotation: hoverAnnotation, defaultSVGRule: this.defaultXYSVGRule, defaultHTMLRule: this.defaultXYHTMLRule, annotations: areaAnnotations.length > 0
                ? __spread(annotations, areaAnnotations) : annotations, annotationSettings: annotationSettings, legendSettings: legendSettings, projectedYMiddle: projectedYMiddle, interaction: interaction, customClickBehavior: customClickBehavior, customHoverBehavior: customHoverBehavior, customDoubleClickBehavior: customDoubleClickBehavior, points: fullDataset, showLinePoints: typeof showLinePoints === "string" ? showLinePoints : undefined, margin: margin, backgroundGraphics: backgroundGraphics, foregroundGraphics: foregroundGraphics, beforeElements: beforeElements, afterElements: afterElements, disableContext: disableContext, canvasPostProcess: canvasPostProcess, baseMarkProps: baseMarkProps, useSpans: useSpans, canvasRendering: !!(canvasSummaries || canvasPoints || canvasLines), renderOrder: renderOrder, overlay: overlay, sketchyRenderingEngine: sketchyRenderingEngine, frameRenderOrder: frameRenderOrder, disableCanvasInteraction: disableCanvasInteraction, interactionSettings: interactionSettings, disableProgressiveRendering: disableProgressiveRendering }));
    };
    XYFrame.defaultProps = {
        annotations: [],
        foregroundGraphics: undefined,
        size: [500, 500],
        className: "",
        lineType: "line",
        name: "xyframe",
        dataVersion: undefined
    };
    XYFrame.displayName = "XYFrame";
    return XYFrame;
}(React.Component));

var derivePieceValue = function (accessor, piece) {
    var pieceVal = accessor(piece);
    return (pieceVal && pieceVal.toString && pieceVal.toString()) || pieceVal;
};
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}
function pieContentGenerator(_a) {
    var column = _a.column, useSpans = _a.useSpans;
    return (React.createElement(SpanOrDiv, { span: useSpans, className: "tooltip-content" },
        React.createElement("p", { key: "or-annotation-1" }, column.name),
        React.createElement("p", { key: "or-annotation-2" }, (column.pct * 100).toFixed(0) + "%")));
}
function arcBracket(_a) {
    var x = _a.x, y = _a.y, radius = _a.radius, startAngle = _a.startAngle, endAngle = _a.endAngle, inset = _a.inset, outset = _a.outset, _b = _a.curly, curly = _b === void 0 ? true : _b;
    var start = polarToCartesian(x, y, radius + outset, endAngle);
    var end = polarToCartesian(x, y, radius + outset, startAngle);
    var innerStart = polarToCartesian(x, y, radius + outset - inset, endAngle);
    var innerEnd = polarToCartesian(x, y, radius + outset - inset, startAngle);
    var angleSize = endAngle - startAngle;
    var largeArcFlag = angleSize <= 180 ? "0" : "1";
    var d;
    if (curly) {
        var curlyOffset = Math.min(10, angleSize / 4);
        var middleLeft = polarToCartesian(x, y, radius + outset, (startAngle + endAngle) / 2 + curlyOffset);
        var middle = polarToCartesian(x, y, radius + outset + 10, (startAngle + endAngle) / 2);
        var middleRight = polarToCartesian(x, y, radius + outset, (startAngle + endAngle) / 2 - curlyOffset);
        d = [
            "M",
            innerStart.x,
            innerStart.y,
            "L",
            start.x,
            start.y,
            "A",
            radius + outset,
            radius + outset,
            0,
            0,
            0,
            middleLeft.x,
            middleLeft.y,
            "A",
            radius + outset,
            radius + outset,
            1,
            0,
            1,
            middle.x,
            middle.y,
            "A",
            radius + outset,
            radius + outset,
            1,
            0,
            1,
            middleRight.x,
            middleRight.y,
            "A",
            radius + outset,
            radius + outset,
            0,
            0,
            0,
            end.x,
            end.y,
            "L",
            innerEnd.x,
            innerEnd.y
        ].join(" ");
    }
    else {
        d = [
            "M",
            innerStart.x,
            innerStart.y,
            "L",
            start.x,
            start.y,
            "A",
            radius + outset,
            radius + outset,
            0,
            largeArcFlag,
            0,
            end.x,
            end.y,
            "L",
            innerEnd.x,
            innerEnd.y
        ].join(" ");
    }
    var midAngle = (startAngle + endAngle) / 2;
    var textOffset, largeTextArcFlag, finalTextEnd, finalTextStart, arcFlip;
    var lowerArc = midAngle > 90 && midAngle < 270;
    if (lowerArc) {
        textOffset = 12;
        largeTextArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
        arcFlip = 0;
    }
    else {
        largeTextArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
        textOffset = 5;
        arcFlip = 1;
    }
    textOffset += curly ? 10 : 0;
    var textStart = polarToCartesian(x, y, radius + outset + textOffset, endAngle);
    var textEnd = polarToCartesian(x, y, radius + outset + textOffset, startAngle);
    if (lowerArc) {
        finalTextStart = textStart;
        finalTextEnd = textEnd;
    }
    else {
        finalTextStart = textEnd;
        finalTextEnd = textStart;
    }
    var textD = [
        "M",
        finalTextStart.x,
        finalTextStart.y,
        "A",
        radius + outset + textOffset,
        radius + outset + textOffset,
        arcFlip,
        largeTextArcFlag,
        arcFlip,
        finalTextEnd.x,
        finalTextEnd.y
    ].join(" ");
    return { arcPath: d, textArcPath: textD };
}
var getColumnScreenCoordinates = function (_a) {
    var d = _a.d, projectedColumns = _a.projectedColumns, oAccessor = _a.oAccessor, summaryType = _a.summaryType, type = _a.type, projection = _a.projection, adjustedPosition = _a.adjustedPosition, adjustedSize = _a.adjustedSize;
    var column = typeof d.column === "object"
        ? d.column
        : projectedColumns[d.facetColumn] ||
            projectedColumns[findFirstAccessorValue(oAccessor, d)];
    if (!column) {
        return { coordinates: [0, 0], pieces: undefined, column: undefined };
    }
    var pieces = column.pieceData || column.pieces;
    var positionValue = (summaryType.type && summaryType.type !== "none") ||
        ["swarm", "point", "clusterbar", "timeline"].find(function (p) { return p === type.type; })
        ? max(pieces.map(function (p) { return p.scaledValue; }))
        : projection === "horizontal"
            ? max(pieces.map(function (p) {
                return p.value >= 0 ? p.scaledValue + p.bottom : p.bottom;
            }))
            : min(pieces.map(function (p) {
                return p.value >= 0 ? p.bottom - p.scaledValue : p.bottom;
            }));
    var xPosition = column.middle + adjustedPosition[0];
    var yPosition = projection === "horizontal"
        ? adjustedSize[0] - positionValue
        : (summaryType.type && summaryType.type !== "none") ||
            ["swarm", "point", "clusterbar", , "timeline"].find(function (p) { return p === type.type; })
            ? adjustedSize[1] - positionValue
            : positionValue;
    yPosition += 10;
    if (projection === "horizontal") {
        yPosition = column.middle;
        xPosition = positionValue + adjustedPosition[0];
    }
    else if (projection === "radial") {
        var pieArc = column.pieArc;
        var translate = pieArc.translate, outerPoint = pieArc.outerPoint, centroid = pieArc.centroid;
        xPosition = (centroid[0] + outerPoint[0]) / 2 + translate[0];
        yPosition = (centroid[1] + outerPoint[1]) / 2 + translate[1];
    }
    return { coordinates: [xPosition, yPosition], pieces: pieces, column: column };
};
var svgHighlightRule$1 = function (_a) {
    var d = _a.d, pieceIDAccessor = _a.pieceIDAccessor, orFrameRender = _a.orFrameRender, oAccessor = _a.oAccessor;
    var thisID = pieceIDAccessor(d);
    var thisO = findFirstAccessorValue(oAccessor, d);
    var pieces = orFrameRender.pieces;
    var styleFn = pieces.styleFn;
    var foundPieces = (pieces &&
        pieces.data
            .filter(function (p) {
            return ((thisID === undefined ||
                pieceIDAccessor(__assign(__assign({}, p.piece), p.piece.data)) === thisID) &&
                (thisO === undefined ||
                    findFirstAccessorValue(oAccessor, p.piece.data) === thisO));
        })
            .map(function (p, q) {
            var styleObject = {
                style: styleFn(__assign(__assign({}, p.piece), p.piece.data))
            };
            if (d.style && typeof d.style === "function") {
                styleObject = {
                    style: __assign(__assign({}, styleObject), d.style(__assign(__assign({}, p.piece), p.piece.data)))
                };
            }
            else if (d.style) {
                styleObject = { style: __assign(__assign({}, styleObject), d.style) };
            }
            var styledD = __assign(__assign({}, p.renderElement), styleObject);
            var className = "highlight-annotation " + ((d.class &&
                typeof d.class === "function" &&
                d.class(p.piece.data, q)) ||
                (d.class && d.class) ||
                "");
            if (React.isValidElement(p.renderElement)) {
                return React.cloneElement(p.renderElement, __assign(__assign({}, styleObject), { className: className }));
            }
            return (React.createElement(Mark, __assign({ fill: "none", stroke: "black", strokeWidth: "2px", key: "highlight-piece-" + q }, styledD, { className: className })));
        })) ||
        [];
    return __spread(foundPieces);
};
var findIDPiece = function (pieceIDAccessor, oColumn, d) {
    var foundIDValue = pieceIDAccessor(d);
    var pieceID = foundIDValue === "" && d.rName ? d.rName : foundIDValue;
    var basePieces = oColumn &&
        oColumn.pieceData.filter(function (r) { return r.rName === pieceID || pieceIDAccessor(r.data) === pieceID; });
    if (pieceID === "" ||
        basePieces === undefined ||
        basePieces === false ||
        basePieces.length !== 1)
        return d;
    var basePiece = basePieces[0];
    var reactAnnotationProps = [
        "type",
        "label",
        "note",
        "connector",
        "disabled",
        "color",
        "subject"
    ];
    if (basePiece) {
        reactAnnotationProps.forEach(function (prop) {
            if (d[prop])
                basePiece[prop] = d[prop];
        });
    }
    return basePiece;
};
var screenProject = function (_a) {
    var p = _a.p, adjustedSize = _a.adjustedSize, rScale = _a.rScale, oColumn = _a.oColumn, rAccessor = _a.rAccessor, idPiece = _a.idPiece, projection = _a.projection, rScaleType = _a.rScaleType;
    var basePValue = findFirstAccessorValue(rAccessor, p) || p.value;
    var pValue = Array.isArray(basePValue)
        ? Math.max.apply(Math, __spread(basePValue)) : basePValue;
    var o;
    if (oColumn) {
        o = oColumn.middle;
    }
    else {
        o = 0;
    }
    if (oColumn && projection === "radial") {
        return pointOnArcAtAngle$1([adjustedSize[0] / 2, adjustedSize[1] / 2], oColumn.pct_middle, idPiece && (idPiece.x === undefined ? idPiece.scaledValue : idPiece.x)
            ? idPiece.x / 2 || (idPiece.bottom + idPiece.scaledValue / 2) / 2
            : pValue / 2);
    }
    if (projection === "horizontal") {
        return [
            idPiece && idPiece.scaledEndValue
                ? idPiece.scaledEndValue
                : idPiece && idPiece.scaledValue
                    ? idPiece.value >= 0
                        ? idPiece.bottom + idPiece.scaledValue
                        : idPiece.bottom
                    : rScale(pValue),
            o
        ];
    }
    var newScale = rScaleType
        .copy()
        .domain(rScale.domain())
        .range(rScale.range().reverse());
    return [
        o,
        idPiece && (idPiece.x === undefined ? idPiece.scaledValue : idPiece.x)
            ? idPiece.y === undefined
                ? idPiece.value >= 0
                    ? idPiece.bottom - idPiece.scaledValue
                    : idPiece.bottom
                : idPiece.y
            : newScale(pValue)
    ];
};
var svgORRule = function (_a) {
    var d = _a.d, i = _a.i, screenCoordinates = _a.screenCoordinates, projection = _a.projection;
    return (React.createElement(Mark, { markType: "text", key: d.label + "annotationtext" + i, forceUpdate: true, x: screenCoordinates[0] + (projection === "horizontal" ? 10 : 0), y: screenCoordinates[1] + (projection === "vertical" ? 10 : 0), className: "annotation annotation-or-label " + (d.className || ""), textAnchor: "middle" }, d.label));
};
var basicReactAnnotationRule = function (_a) {
    var d = _a.d, i = _a.i, screenCoordinates = _a.screenCoordinates;
    var noteData = Object.assign({
        dx: 0,
        dy: 0,
        note: { label: d.label, orientation: d.orientation, align: d.align },
        connector: { end: "arrow" }
    }, d, {
        x: screenCoordinates[0],
        y: screenCoordinates[1],
        type: typeof d.type === "function" ? d.type : undefined,
        screenCoordinates: screenCoordinates
    });
    if (d.fixedX)
        noteData.x = d.fixedX;
    if (d.fixedY)
        noteData.y = d.fixedY;
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var svgEncloseRule$1 = function (_a) {
    var d = _a.d, i = _a.i, screenCoordinates = _a.screenCoordinates;
    var circle = packEnclose(screenCoordinates.map(function (p) { return ({ x: p[0], y: p[1], r: 2 }); }));
    return circleEnclosure({ d: d, i: i, circle: circle });
};
var svgRRule = function (_a) {
    var d = _a.d, i = _a.i, screenCoordinates = _a.screenCoordinates, rScale = _a.rScale, rAccessor = _a.rAccessor, adjustedSize = _a.adjustedSize, adjustedPosition = _a.adjustedPosition, projection = _a.projection;
    var x, y, xPosition, yPosition, subject, dx, dy;
    if (projection === "radial") {
        return (React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: Object.assign({
                dx: 50,
                dy: 50,
                note: { label: d.label },
                connector: { end: "arrow" }
            }, d, {
                type: AnnotationCalloutCircle,
                subject: {
                    radius: rScale(findFirstAccessorValue(rAccessor, d)) / 2,
                    radiusPadding: 0
                },
                x: adjustedSize[0] / 2,
                y: adjustedSize[1] / 2
            }) }));
    }
    else if (projection === "horizontal") {
        dx = 50;
        dy = 50;
        yPosition = d.offset || i * 25;
        x = screenCoordinates[0];
        y = yPosition;
        subject = {
            x: x,
            y1: 0,
            y2: adjustedSize[1] + adjustedPosition[1]
        };
    }
    else {
        dx = 50;
        dy = -20;
        xPosition = d.offset || i * 25;
        y = screenCoordinates[1];
        x = xPosition;
        subject = {
            y: y,
            x1: 0,
            x2: adjustedSize[0] + adjustedPosition[0]
        };
    }
    var noteData = Object.assign({
        dx: dx,
        dy: dy,
        note: { label: d.label },
        connector: { end: "arrow" }
    }, d, {
        type: AnnotationXYThreshold,
        x: x,
        y: y,
        subject: subject
    });
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var svgCategoryRule = function (_a) {
    var projection = _a.projection, d = _a.d, i = _a.i, categories = _a.categories, adjustedSize = _a.adjustedSize;
    var _b = d.bracketType, bracketType = _b === void 0 ? "curly" : _b, _c = d.position, position = _c === void 0 ? projection === "vertical" ? "top" : "left" : _c, _d = d.depth, depth = _d === void 0 ? 30 : _d, _e = d.offset, offset = _e === void 0 ? 0 : _e, _f = d.padding, padding = _f === void 0 ? 0 : _f;
    var actualCategories = Array.isArray(d.categories)
        ? d.categories
        : [d.categories];
    var cats = actualCategories.map(function (c) { return categories[c]; });
    if (projection === "radial") {
        var arcPadding_1 = padding / adjustedSize[1];
        var leftX = min(cats.map(function (p) { return p.pct_start + p.pct_padding / 2 + arcPadding_1 / 2; }));
        var rightX = max(cats.map(function (p) { return p.pct_start + p.pct - p.pct_padding / 2 - arcPadding_1 / 2; }));
        var chartSize = Math.min(adjustedSize[0], adjustedSize[1]) / 2;
        var centerX = adjustedSize[0] / 2;
        var centerY = adjustedSize[1] / 2;
        var _g = arcBracket({
            x: 0,
            y: 0,
            radius: chartSize,
            startAngle: leftX * 360,
            endAngle: rightX * 360,
            inset: depth,
            outset: offset,
            curly: bracketType === "curly"
        }), arcPath = _g.arcPath, textArcPath = _g.textArcPath;
        var textPathID = "text-path-" + i + "-" + Math.random();
        return (React.createElement("g", { className: "category-annotation annotation", transform: "translate(" + centerX + "," + centerY + ")" },
            React.createElement("path", { d: arcPath, fill: "none", stroke: "black" }),
            React.createElement("path", { id: textPathID, d: textArcPath, style: { display: "none" } }),
            React.createElement("text", { "font-size": "12.5" },
                React.createElement("textPath", { startOffset: "50%", textAnchor: "middle", xlinkHref: "#" + textPathID }, d.label))));
    }
    else {
        var leftX = min(cats.map(function (p) { return p.x; }));
        var rightX = max(cats.map(function (p) { return p.x + p.width; }));
        if (projection === "vertical") {
            var yPosition = position === "top" ? 0 : adjustedSize[1];
            yPosition += position === "top" ? -offset : offset;
            var noteData = {
                type: AnnotationBracket,
                y: yPosition,
                x: leftX - padding,
                note: {
                    title: d.title || d.label,
                    label: d.title ? d.label : undefined
                },
                subject: {
                    type: bracketType,
                    width: rightX - leftX + padding * 2,
                    depth: position === "top" ? -depth : depth
                }
            };
            return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
        }
        else if (projection === "horizontal") {
            var yPosition = position === "left" ? 0 : adjustedSize[0];
            yPosition += position === "left" ? -offset : offset;
            var noteData = {
                type: AnnotationBracket,
                x: yPosition,
                y: leftX - padding,
                note: {
                    title: d.title || d.label,
                    label: d.title ? d.label : undefined
                },
                subject: {
                    type: bracketType,
                    height: rightX - leftX + padding * 2,
                    depth: position === "left" ? -depth : depth
                }
            };
            return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
        }
    }
};
var htmlFrameHoverRule$1 = function (_a) {
    var d = _a.d, i = _a.i, rAccessor = _a.rAccessor, oAccessor = _a.oAccessor, projection = _a.projection, tooltipContent = _a.tooltipContent, optimizeCustomTooltipPosition = _a.optimizeCustomTooltipPosition, useSpans = _a.useSpans, pieceIDAccessor = _a.pieceIDAccessor, projectedColumns = _a.projectedColumns, adjustedSize = _a.adjustedSize, rScale = _a.rScale, type = _a.type, rScaleType = _a.rScaleType;
    tooltipContent =
        tooltipContent === "pie"
            ? function () {
                return pieContentGenerator({
                    column: d.column,
                    useSpans: useSpans
                });
            }
            : tooltipContent;
    //To string because React gives a DOM error if it gets a date
    var contentFill;
    var pO = findFirstAccessorValue(oAccessor, d) || d.column;
    var oColumn = projectedColumns[pO];
    var idPiece = findIDPiece(pieceIDAccessor, oColumn, d);
    if (!idPiece) {
        return null;
    }
    var screenCoordinates = ((type.type === "clusterbar" ||
        type.type === "point" ||
        type.type === "swarm") &&
        d.x !== undefined &&
        d.y !== undefined) ||
        d.isSummaryData
        ? [d.x, d.y]
        : screenProject({
            p: d,
            adjustedSize: adjustedSize,
            rScale: rScale,
            oColumn: oColumn,
            rAccessor: rAccessor,
            idPiece: idPiece,
            projection: projection,
            rScaleType: rScaleType
        });
    if (d.isSummaryData) {
        var summaryContent_1 = d.label;
        if (d.pieces && d.pieces.length !== 0) {
            if (d.pieces.length === 1) {
                summaryContent_1 = [];
                rAccessor.forEach(function (actualRAccessor) {
                    summaryContent_1.push(actualRAccessor(d.pieces[0].data));
                });
            }
            else {
                summaryContent_1 = [];
                rAccessor.forEach(function (actualRAccessor) {
                    var pieceData = extent$1(d.pieces.map(function (p) { return p.data; }).map(actualRAccessor));
                    summaryContent_1.push("From " + pieceData[0] + " to " + pieceData[1]);
                });
            }
        }
        var summaryLabel = React.createElement("p", { key: "html-annotation-content-2" }, summaryContent_1);
        contentFill = [
            React.createElement("p", { key: "html-annotation-content-1" }, d.key),
            summaryLabel,
            React.createElement("p", { key: "html-annotation-content-3" }, d.value)
        ];
    }
    else if (d.data) {
        contentFill = [];
        oAccessor.forEach(function (actualOAccessor, i) {
            if (idPiece.data) {
                var pieceOVal = derivePieceValue(actualOAccessor, idPiece.data);
                contentFill.push(React.createElement("p", { key: "html-annotation-content-o-" + i }, pieceOVal));
            }
        });
        rAccessor.forEach(function (actualRAccessor, i) {
            if (idPiece.data) {
                var pieceRVal = derivePieceValue(actualRAccessor, idPiece.data);
                contentFill.push(React.createElement("p", { key: "html-annotation-content-r-" + i }, pieceRVal));
            }
        });
    }
    else if (d.label) {
        contentFill = d.label;
    }
    var content = (React.createElement(SpanOrDiv, { span: useSpans, className: "tooltip-content" }, contentFill));
    if (d.type === "frame-hover" && tooltipContent && idPiece) {
        var tooltipContentArgs = __assign(__assign({}, idPiece), idPiece.data);
        content = optimizeCustomTooltipPosition ? (React.createElement(TooltipPositioner, { tooltipContent: tooltipContent, tooltipContentArgs: tooltipContentArgs })) : (tooltipContent(tooltipContentArgs));
    }
    return (React.createElement(SpanOrDiv, { span: useSpans, key: "xylabel-" + i, className: "annotation annotation-or-label " + projection + " " + (d.className || ""), style: {
            position: "absolute",
            top: screenCoordinates[1] + "px",
            left: screenCoordinates[0] + "px"
        } }, content));
};
var htmlColumnHoverRule = function (_a) {
    var d = _a.d, i = _a.i, summaryType = _a.summaryType, oAccessor = _a.oAccessor, type = _a.type, adjustedPosition = _a.adjustedPosition, adjustedSize = _a.adjustedSize, projection = _a.projection, tooltipContent = _a.tooltipContent, optimizeCustomTooltipPosition = _a.optimizeCustomTooltipPosition, useSpans = _a.useSpans, projectedColumns = _a.projectedColumns;
    //we need to ignore negative pieces to make sure the hover behavior populates on top of the positive bar
    var _b = getColumnScreenCoordinates({
        d: d,
        projectedColumns: projectedColumns,
        oAccessor: oAccessor,
        summaryType: summaryType,
        type: type,
        projection: projection,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize
    }), _c = __read(_b.coordinates, 2), xPosition = _c[0], yPosition = _c[1], pieces = _b.pieces, column = _b.column;
    if (column === undefined) {
        return null;
    }
    //To string because React gives a DOM error if it gets a date
    var oContent = [];
    oAccessor.forEach(function (actualOAccessor, i) {
        if (pieces[0].data) {
            var pieceOVal = derivePieceValue(actualOAccessor, pieces[0].data);
            oContent.push(React.createElement("p", { key: "or-annotation-o-" + i }, pieceOVal));
        }
    });
    var content = (React.createElement(SpanOrDiv, { span: useSpans, className: "tooltip-content" },
        oContent,
        React.createElement("p", { key: "or-annotation-2" }, sum(pieces.map(function (p) { return p.value; }).filter(function (p) { return p > 0; })))));
    if (d.type === "column-hover" && tooltipContent) {
        if (tooltipContent === "pie") {
            tooltipContent = pieContentGenerator;
        }
        var tooltipContentArgs = __assign(__assign({}, d), { pieces: pieces.map(function (p) { return p.data; }), column: column,
            oAccessor: oAccessor });
        content = optimizeCustomTooltipPosition ? (React.createElement(TooltipPositioner, { tooltipContent: tooltipContent, tooltipContentArgs: tooltipContentArgs })) : (tooltipContent(tooltipContentArgs));
    }
    else if (d.label) {
        content = (React.createElement(SpanOrDiv, { span: useSpans, className: "tooltip-content" }, d.label));
    }
    return (React.createElement(SpanOrDiv, { span: useSpans, key: "orlabel-" + i, className: "annotation annotation-or-label " + projection + " " + (d.className || ""), style: {
            position: "absolute",
            top: yPosition + "px",
            left: xPosition + "px"
        } }, content));
};
var svgRectEncloseRule$1 = function (_a) {
    var d = _a.d, i = _a.i, screenCoordinates = _a.screenCoordinates;
    var bboxNodes = screenCoordinates.map(function (p) {
        return {
            x0: (p.x0 = p[0]),
            x1: (p.x1 = p[0]),
            y0: (p.y0 = p[1]),
            y1: (p.y1 = p[1])
        };
    });
    return rectangleEnclosure({ bboxNodes: bboxNodes, d: d, i: i });
};
var svgOrdinalLine = function (_a) {
    var screenCoordinates = _a.screenCoordinates, d = _a.d, voronoiHover = _a.voronoiHover;
    var lineGenerator = line()
        .x(function (d) { return d[0]; })
        .y(function (d) { return d[1]; });
    if (d.curve) {
        var interpolator = curveHash[d.curve] || d.curve;
        lineGenerator.curve(interpolator);
    }
    var lineStyle = typeof d.lineStyle === "function" ? d.lineStyle(d) : d.lineStyle || {};
    return (React.createElement("g", { key: "ordinal-line-annotation" },
        React.createElement("path", { stroke: "black", fill: "none", style: lineStyle, d: lineGenerator(screenCoordinates) }),
        (d.points || d.interactive) &&
            screenCoordinates.map(function (p, q) {
                var pointStyle = typeof d.pointStyle === "function"
                    ? d.pointStyle(d.coordinates[q], q)
                    : d.pointStyle || {};
                return (React.createElement("g", { transform: "translate(" + p[0] + "," + p[1] + ")", key: "ordinal-line-point-" + q },
                    d.points && (React.createElement("circle", { style: pointStyle, r: d.radius || 5, fill: "black" })),
                    d.interactive && (React.createElement("circle", { style: { pointerEvents: "all" }, r: d.hoverRadius || 15, opacity: 0, onMouseEnter: function () {
                            return voronoiHover(__assign(__assign({ type: "frame-hover" }, d.coordinates[q]), { data: d.coordinates[q] }));
                        }, onMouseOut: function () { return voronoiHover(); } }))));
            })));
};

var twoPI$1 = Math.PI * 2;
var radialBarFeatureGenerator = function (_a) {
    var type = _a.type, ordset = _a.ordset, adjustedSize = _a.adjustedSize, piece = _a.piece, i = _a.i;
    var innerRadius = type.innerRadius;
    var _b = type.offsetAngle, offsetAngle = _b === void 0 ? 0 : _b, _c = type.angleRange, angleRange = _c === void 0 ? [0, 360] : _c;
    var offsetPct = offsetAngle / 360;
    var rangePct = angleRange.map(function (d) { return d / 360; });
    var rangeMod = rangePct[1] - rangePct[0];
    var adjustedPct = rangeMod < 1 ? scaleLinear().domain([0, 1]).range(rangePct) : function (d) { return d; };
    var innerSize = type.type === "clusterbar"
        ? 0
        : type.type === "timeline"
            ? piece.scaledValue / 2
            : piece.bottom / 2;
    var outerSize = type.type === "clusterbar"
        ? piece.scaledValue / 2
        : type.type === "timeline"
            ? piece.scaledEndValue / 2
            : piece.scaledValue / 2 + piece.bottom / 2;
    if (innerRadius) {
        innerRadius = parseInt(innerRadius, 10);
        var canvasRadius = adjustedSize[0] / 2;
        var donutMod = (canvasRadius - innerRadius) / canvasRadius;
        innerSize = innerSize * donutMod + innerRadius;
        outerSize = outerSize * donutMod + innerRadius;
    }
    var arcGenerator = arc().innerRadius(innerSize).outerRadius(outerSize);
    var angle = (type.type === "clusterbar"
        ? (ordset.pct - ordset.pct_padding) / ordset.pieceData.length
        : ordset.pct) * rangeMod;
    var startAngle = adjustedPct(type.type === "clusterbar"
        ? ordset.pct_start +
            (i / ordset.pieceData.length) * (ordset.pct - ordset.pct_padding)
        : ordset.pct === 1
            ? 0
            : ordset.pct_start + offsetPct);
    var endAngle = ordset.pct === 1
        ? rangePct[1]
        : Math.max(startAngle, startAngle + angle - ordset.pct_padding / 2);
    var startAngleFinal = startAngle * twoPI$1;
    var endAngleFinal = endAngle * twoPI$1;
    var markD = arcGenerator({
        startAngle: startAngleFinal,
        endAngle: endAngleFinal
    });
    var centroid = arcGenerator.centroid({
        startAngle: startAngleFinal,
        endAngle: endAngleFinal
    });
    var xOffset = adjustedSize[0] / 2;
    var yOffset = adjustedSize[1] / 2;
    var xPosition = centroid[0] + xOffset;
    var yPosition = centroid[1] + yOffset;
    var outerPoint = pointOnArcAtAngle([0, 0], (startAngle + endAngle) / 2, piece.scaledValue / 2);
    var xy = {
        arcGenerator: arcGenerator,
        startAngle: startAngleFinal,
        endAngle: endAngleFinal,
        dx: outerPoint[0],
        dy: outerPoint[1]
    };
    var translate = "translate(" + xOffset + "," + yOffset + ")";
    return {
        xPosition: xPosition,
        yPosition: yPosition,
        xy: xy,
        translate: translate,
        markProps: {
            markType: "path",
            d: markD,
            tx: xOffset,
            ty: yOffset,
            transform: translate,
            customTween: {
                fn: arcTweener,
                props: {
                    startAngle: startAngleFinal,
                    endAngle: endAngleFinal,
                    innerRadius: innerSize,
                    outerRadius: outerSize
                }
            }
        }
    };
};
var iconBarCustomMark = function (_a) {
    var type = _a.type, projection = _a.projection, finalHeight = _a.finalHeight, finalWidth = _a.finalWidth, styleFn = _a.styleFn, renderValue = _a.renderValue, classFn = _a.classFn;
    return function (piece, i, xy) {
        var iconD = typeof type.icon === "string" ? type.icon : type.icon(piece.data, i);
        var _a = type.iconPadding, iconPadding = _a === void 0 ? 1 : _a, _b = type.resize, resize = _b === void 0 ? "auto" : _b;
        var iconBounds = pathBounds(iconD);
        var iconTranslate = [
            0 - iconBounds.x1 + iconPadding,
            0 - iconBounds.y1 + iconPadding
        ];
        iconBounds.height += iconPadding * 2;
        iconBounds.width += iconPadding * 2;
        var icons = [];
        var stackedIconSize = iconBounds.height;
        var stackedIconNumber = 1;
        var iconScale = 1;
        var spaceToUse = projection === "horizontal" ? finalHeight : finalWidth;
        var sizeToFit = projection === "horizontal" ? iconBounds.height : iconBounds.width;
        var sizeToPad = projection === "horizontal" ? iconBounds.width : iconBounds.height;
        var spaceToFill = projection === "horizontal" ? xy.width : xy.height;
        var spaceToStackFill = projection === "horizontal" ? xy.height : xy.width;
        if (resize === "auto") {
            stackedIconSize = spaceToUse / sizeToFit;
            if (stackedIconSize < 1) {
                iconScale = stackedIconSize;
            }
            else {
                stackedIconNumber = Math.floor(stackedIconSize);
                iconScale =
                    1 + (stackedIconSize - stackedIconNumber) / stackedIconNumber;
            }
        }
        else if (resize === "fixed") {
            iconScale = spaceToUse / sizeToFit;
        }
        //  const finalIconWidth = iconBounds.width * iconScale;
        var finalIconHeight = iconBounds.height * iconScale;
        var spaceToStep = sizeToPad * iconScale;
        var spaceToStackStep = sizeToFit * iconScale;
        iconTranslate[0] = iconTranslate[0] * iconScale;
        iconTranslate[1] = iconTranslate[1] * iconScale;
        var randoClipID = "iso-clip-" + i + "-" + Math.random();
        var clipPath = "url(#" + randoClipID + ")";
        if (xy.width > 0) {
            icons.push(React.createElement("clipPath", { key: randoClipID, id: randoClipID },
                React.createElement("rect", { x: 0, y: 0, width: xy.width, height: xy.height })));
            var iconPieces = [];
            var stepStart = projection === "horizontal" ? 0 : xy.height - finalIconHeight;
            var stepper = projection === "horizontal" ? spaceToStep : -spaceToStep;
            var stepTest = projection === "horizontal"
                ? function (step, spaceToFillValue) { return step < spaceToFillValue; }
                : function (step, spaceToFillValue, stepperValue) { return step > 0 + stepperValue; };
            for (var step = stepStart; stepTest(step, spaceToFill, stepper); step += stepper) {
                for (var stack = 0; stack < spaceToStackFill; stack += spaceToStackStep) {
                    var stepX = projection === "horizontal" ? step : stack;
                    var stepY = projection === "horizontal" ? stack : step;
                    var paddedX = stepX + iconTranslate[0];
                    var paddedY = stepY + iconTranslate[1];
                    iconPieces.push(React.createElement(Mark, { forceUpdate: true, markType: "path", key: "icon-" + step + "-" + stack, transform: "translate(" + paddedX + "," + paddedY + ") scale(" + iconScale + ")", vectorEffect: "non-scaling-stroke", d: iconD, style: styleFn(__assign(__assign({}, piece), piece.data), i), renderMode: renderValue, className: classFn(__assign(__assign({}, piece), piece.data), i) }));
                }
            }
            icons.push(React.createElement("g", { key: "clipped-region-" + i, clipPath: clipPath }, iconPieces));
        }
        return icons;
    };
};
function pointOnArcAtAngle(center, angle, distance) {
    var radians = Math.PI * (angle + 0.75) * 2;
    var xPosition = center[0] + distance * Math.cos(radians);
    var yPosition = center[1] + distance * Math.sin(radians);
    return [xPosition, yPosition];
}
function clusterBarLayout(_a) {
    var type = _a.type, data = _a.data, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, projection = _a.projection, classFn = _a.classFn, adjustedSize = _a.adjustedSize, chartSize = _a.chartSize, margin = _a.margin, baseMarkProps = _a.baseMarkProps, rScale = _a.rScale;
    var allCalculatedPieces = [];
    var keys = Object.keys(data);
    keys.forEach(function (key, ordsetI) {
        var ordset = data[key];
        var barColumnWidth = Math.max(ordset.width, 1);
        var clusterWidth = barColumnWidth / ordset.pieceData.length;
        var currentX = 0;
        var currentY = 0;
        var calculatedPieces = ordset.pieceData.map(function (piece, i) {
            var _a;
            var renderValue = renderMode && renderMode(piece.data, i);
            var xPosition = piece.x;
            var yPosition = piece.base;
            var finalWidth = clusterWidth;
            var finalHeight = piece.scaledValue;
            var xy = { x: 0, y: 0 };
            if (!piece.negative) {
                yPosition -= piece.scaledValue;
            }
            if (projection === "horizontal") {
                //TODO: NEGATIVE FOR HORIZONTAL
                yPosition = piece.x;
                xPosition = piece.base;
                finalHeight = clusterWidth;
                finalWidth = piece.scaledValue;
                xy.x = piece.scaledValue;
                if (piece.negative) {
                    xPosition -= piece.scaledValue;
                    xy.x = xPosition;
                }
            }
            var translate, markProps = {};
            if (projection === "radial") {
                (_a = radialBarFeatureGenerator({
                    type: type,
                    ordset: ordset,
                    adjustedSize: adjustedSize,
                    piece: piece,
                    i: i
                }), xPosition = _a.xPosition, yPosition = _a.yPosition, markProps = _a.markProps, xy = _a.xy);
                xy.x = xPosition;
            }
            else {
                xPosition += currentX;
                yPosition += currentY;
                markProps = {
                    markType: "rect",
                    x: xPosition,
                    y: yPosition,
                    width: Math.max(0, finalWidth),
                    height: Math.max(0, finalHeight),
                    rx: 0,
                    ry: 0
                };
                if (projection === "vertical") {
                    xy.x = xPosition;
                }
            }
            var eventListeners = eventListenersGenerator(piece, i);
            xy.y = yPosition;
            xy.middle = clusterWidth / 2;
            xy.height = finalHeight;
            xy.width = finalWidth;
            if (type.icon && projection !== "radial") {
                type.customMark = iconBarCustomMark({
                    type: type,
                    projection: projection,
                    finalHeight: finalHeight,
                    finalWidth: finalWidth,
                    styleFn: styleFn,
                    renderValue: renderValue,
                    classFn: classFn
                });
            }
            else if (type.icon && projection === "radial") {
                console.error("Icons are currently unsupported on radial charts");
            }
            var renderElementObject = type.customMark ? (React.createElement("g", { key: "piece-" + piece.renderKey, transform: "translate(" + xPosition + "," + yPosition + ")" }, type.customMark(__assign(__assign(__assign({}, piece.data), piece), { x: xPosition, y: yPosition }), i, __assign(__assign({}, xy), { baseMarkProps: baseMarkProps,
                renderMode: renderMode,
                styleFn: styleFn,
                classFn: classFn,
                adjustedSize: adjustedSize,
                chartSize: chartSize,
                margin: margin,
                rScale: rScale })))) : (__assign(__assign({ className: classFn(__assign(__assign({}, piece), piece.data), i), renderMode: renderValue, key: "piece-" + piece.renderKey, transform: translate, style: styleFn(__assign(__assign({}, piece), piece.data), ordsetI) }, markProps), eventListeners));
            var calculatedPiece = {
                o: key,
                xy: xy,
                piece: piece,
                renderElement: renderElementObject
            };
            if (projection === "horizontal") {
                currentY += finalHeight;
            }
            else {
                currentX += finalWidth;
            }
            //        currentOffset += pieceSize
            return calculatedPiece;
        });
        allCalculatedPieces = __spread(allCalculatedPieces, calculatedPieces);
    });
    return allCalculatedPieces;
}
function barLayout(_a) {
    var type = _a.type, data = _a.data, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, projection = _a.projection, classFn = _a.classFn, adjustedSize = _a.adjustedSize, chartSize = _a.chartSize, margin = _a.margin, baseMarkProps = _a.baseMarkProps, rScale = _a.rScale;
    var keys = Object.keys(data);
    var allCalculatedPieces = [];
    keys.forEach(function (key, ordsetI) {
        var ordset = data[key];
        var barColumnWidth = Math.max(ordset.width, 1);
        var calculatedPieces = ordset.pieceData.map(function (piece, i) {
            var _a;
            var pieceSize = piece.scaledValue;
            var renderValue = renderMode && renderMode(piece.data, i);
            var xPosition = piece.x;
            var yPosition = piece.bottom;
            var finalWidth = barColumnWidth;
            var finalHeight = pieceSize;
            var xy = {};
            if (!piece.negative) {
                yPosition -= piece.scaledValue;
            }
            if (projection === "vertical") {
                xy = {
                    x: xPosition,
                    y: yPosition,
                    middle: barColumnWidth / 2,
                    height: finalHeight,
                    width: finalWidth
                };
            }
            else if (projection === "horizontal") {
                yPosition = piece.x;
                xPosition = piece.bottom;
                finalHeight = barColumnWidth;
                finalWidth = pieceSize;
                xy = {
                    x: xPosition + piece.scaledValue,
                    y: yPosition,
                    middle: barColumnWidth / 2,
                    height: finalHeight,
                    width: finalWidth
                };
                if (piece.negative) {
                    xPosition = piece.bottom - piece.scaledValue;
                }
            }
            var markProps;
            if (projection === "radial") {
                (_a = radialBarFeatureGenerator({
                    type: type,
                    ordset: ordset,
                    adjustedSize: adjustedSize,
                    piece: piece,
                    i: i
                }), markProps = _a.markProps, xPosition = _a.xPosition, yPosition = _a.yPosition);
                finalHeight = undefined;
                finalWidth = undefined;
                xy = {
                    x: xPosition,
                    y: yPosition,
                    middle: barColumnWidth / 2,
                    height: finalHeight,
                    width: finalWidth
                };
            }
            else {
                markProps = {
                    markType: "rect",
                    x: xPosition,
                    y: yPosition,
                    width: Math.max(0, finalWidth),
                    height: Math.max(0, finalHeight),
                    rx: 0,
                    ry: 0
                };
            }
            var eventListeners = eventListenersGenerator(piece, i);
            if (type.icon && projection !== "radial") {
                type.customMark = iconBarCustomMark({
                    type: type,
                    projection: projection,
                    finalHeight: finalHeight,
                    finalWidth: finalWidth,
                    styleFn: styleFn,
                    renderValue: renderValue,
                    classFn: classFn
                });
            }
            else if (type.icon && projection !== "horizontal") {
                console.error("Icons are currently unsupported in radial charts");
            }
            var renderElementObject = type.customMark ? (React.createElement("g", { key: "piece-" + piece.renderKey, transform: "translate(" + xPosition + "," + yPosition + ")", role: "img", tabIndex: -1 }, type.customMark(__assign(__assign(__assign({}, piece.data), piece), { x: xPosition, y: yPosition }), i, __assign(__assign({}, xy), { baseMarkProps: baseMarkProps,
                renderMode: renderMode,
                styleFn: styleFn,
                classFn: classFn,
                adjustedSize: adjustedSize,
                chartSize: chartSize,
                margin: margin,
                rScale: rScale })))) : (__assign(__assign({ className: classFn(__assign(__assign({}, piece), piece.data), i), renderMode: renderValue, key: "piece-" + piece.renderKey, style: styleFn(__assign(__assign({}, piece), piece.data), ordsetI) }, eventListeners), markProps));
            var calculatedPiece = {
                o: key,
                xy: xy,
                piece: piece,
                renderElement: renderElementObject
            };
            return calculatedPiece;
        });
        allCalculatedPieces = __spread(allCalculatedPieces, calculatedPieces);
    });
    return allCalculatedPieces;
}
function timelineLayout(_a) {
    var type = _a.type, data = _a.data, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, projection = _a.projection, classFn = _a.classFn, adjustedSize = _a.adjustedSize, chartSize = _a.chartSize, margin = _a.margin, baseMarkProps = _a.baseMarkProps, rScale = _a.rScale;
    var allCalculatedPieces = [];
    var keys = Object.keys(data);
    keys.forEach(function (key, ordsetI) {
        var ordset = data[key];
        var calculatedPieces = [];
        ordset.pieceData.forEach(function (piece, i) {
            var scaledValue, scaledBottom;
            var renderValue = renderMode && renderMode(piece.data, i);
            var xPosition = ordset.x;
            var height = piece.scaledEndValue - piece.scaledValue;
            var yPosition = piece.scaledVerticalValue - height;
            var width = ordset.width;
            var markProps = {
                markType: "rect",
                height: height < 0 ? -height : height,
                width: width,
                x: xPosition,
                y: height < 0 ? yPosition + height : yPosition
            };
            if (projection === "horizontal") {
                yPosition = ordset.x;
                xPosition = piece.scaledValue;
                scaledValue = piece.scaledEndValue - piece.scaledValue;
                scaledBottom = piece.scaledBottom;
                width = piece.scaledEndValue - piece.scaledValue;
                height = ordset.width;
                markProps = {
                    markType: "rect",
                    height: height,
                    width: width < 0 ? -width : width,
                    x: width < 0 ? xPosition + width : xPosition,
                    y: yPosition
                };
            }
            else if (projection === "radial") {
                (markProps = radialBarFeatureGenerator({
                    piece: piece,
                    type: type,
                    ordset: ordset,
                    adjustedSize: adjustedSize,
                    i: i
                }).markProps);
            }
            //Only return the actual piece if you're rendering points, otherwise you just needed to iterate and calculate the points for the contour summary type
            var eventListeners = eventListenersGenerator(piece, i);
            var xy = {
                x: xPosition,
                y: yPosition,
                scaledValue: scaledValue,
                scaledBottom: scaledBottom,
                height: height
            };
            var renderElementObject = type.customMark ? (React.createElement("g", { key: "piece-" + piece.renderKey, transform: "translate(" + xPosition + "," + (yPosition + height) + ")" }, type.customMark(__assign(__assign(__assign({}, piece.data), piece), { x: xPosition, y: yPosition }), i, __assign(__assign({}, xy), { baseMarkProps: baseMarkProps,
                renderMode: renderMode,
                styleFn: styleFn,
                classFn: classFn,
                adjustedSize: adjustedSize,
                chartSize: chartSize,
                margin: margin,
                rScale: rScale })))) : (__assign(__assign({ className: classFn(__assign(__assign({}, piece), piece.data), i), renderMode: renderValue, key: "piece-" + piece.renderKey, style: styleFn(__assign(__assign({}, piece), piece.data), ordsetI) }, markProps), eventListeners));
            var calculatedPiece = {
                o: key,
                xy: xy,
                piece: piece,
                renderElement: renderElementObject
            };
            calculatedPieces.push(calculatedPiece);
        });
        allCalculatedPieces = __spread(allCalculatedPieces, calculatedPieces);
    });
    return allCalculatedPieces;
}
function pointLayout(_a) {
    var type = _a.type, data = _a.data, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, projection = _a.projection, classFn = _a.classFn, adjustedSize = _a.adjustedSize, chartSize = _a.chartSize, margin = _a.margin, baseMarkProps = _a.baseMarkProps, rScale = _a.rScale;
    var circleRadius = type.r || 3;
    var allCalculatedPieces = [];
    var keys = Object.keys(data);
    keys.forEach(function (key, ordsetI) {
        var ordset = data[key];
        var calculatedPieces = [];
        ordset.pieceData.forEach(function (piece, i) {
            var renderValue = renderMode && renderMode(piece.data, i);
            var xPosition = ordset.middle;
            var yPosition = piece.scaledVerticalValue;
            if (projection === "horizontal") {
                yPosition = ordset.middle;
                xPosition = piece.scaledValue;
            }
            else if (projection === "radial") {
                var angle = ordset.pct_middle;
                var rPosition = piece.scaledValue / 2;
                var baseCentroid = pointOnArcAtAngle([adjustedSize[0] / 2, adjustedSize[1] / 2], angle, rPosition);
                xPosition = baseCentroid[0];
                yPosition = baseCentroid[1];
            }
            //Only return the actual piece if you're rendering points, otherwise you just needed to iterate and calculate the points for the contour summary type
            var actualCircleRadius = typeof circleRadius === "function"
                ? circleRadius(piece, i)
                : circleRadius;
            var eventListeners = eventListenersGenerator(piece, i);
            var renderElementObject = type.customMark ? (React.createElement("g", { key: "piece-" + piece.renderKey, transform: "translate(" + xPosition + "," + yPosition + ")" }, type.customMark(__assign(__assign(__assign({}, piece.data), piece), { x: xPosition, y: yPosition, width: ordset.width }), i, {
                r: circleRadius,
                x: xPosition,
                y: yPosition,
                baseMarkProps: baseMarkProps,
                renderMode: renderMode,
                styleFn: styleFn,
                classFn: classFn,
                adjustedSize: adjustedSize,
                chartSize: chartSize,
                margin: margin,
                rScale: rScale
            }))) : (__assign({ className: classFn(__assign(__assign({}, piece), piece.data), i), markType: "rect", renderMode: renderValue, key: "piece-" + piece.renderKey, height: actualCircleRadius * 2, width: actualCircleRadius * 2, x: xPosition - actualCircleRadius, y: yPosition - actualCircleRadius, rx: actualCircleRadius, ry: actualCircleRadius, style: styleFn(__assign(__assign({}, piece), piece.data), ordsetI) }, eventListeners));
            var calculatedPiece = {
                o: key,
                xy: {
                    x: xPosition,
                    y: yPosition
                },
                piece: piece,
                renderElement: renderElementObject
            };
            calculatedPieces.push(calculatedPiece);
        });
        allCalculatedPieces = __spread(allCalculatedPieces, calculatedPieces);
    });
    return allCalculatedPieces;
}
function swarmLayout(_a) {
    var type = _a.type, data = _a.data, renderMode = _a.renderMode, eventListenersGenerator = _a.eventListenersGenerator, styleFn = _a.styleFn, projection = _a.projection, classFn = _a.classFn, adjustedSize = _a.adjustedSize, chartSize = _a.chartSize, margin = _a.margin, baseMarkProps = _a.baseMarkProps, rScale = _a.rScale;
    var allCalculatedPieces = [];
    var iterations = type.iterations || 120;
    var columnKeys = Object.keys(data);
    columnKeys.forEach(function (key, ordsetI) {
        var oColumn = data[key];
        var anglePiece = 1 / columnKeys.length;
        var oData = oColumn.pieceData;
        var adjustedColumnWidth = oColumn.width;
        var circleRadius = type.r ||
            Math.max(2, Math.min(5, (4 * adjustedColumnWidth) / oData.length));
        var simulation = forceSimulation(oData)
            .force("y", forceY(function (d) { return d.scaledValue; }).strength(type.strength || 2))
            .force("x", forceX(oColumn.middle))
            .force("collide", forceCollide(circleRadius))
            .stop();
        if (projection === "vertical") {
            simulation.force("y", forceY(function (d) { return d.scaledVerticalValue; }).strength(type.strength || 2));
        }
        for (var i = 0; i < iterations; ++i)
            simulation.tick();
        var calculatedPieces = oData.map(function (piece, i) {
            var renderValue = renderMode && renderMode(piece.data, i);
            var xPosition = piece.x;
            var yPosition = piece.y;
            if (projection === "horizontal") {
                yPosition = piece.x;
                xPosition = piece.y;
            }
            else if (projection === "radial") {
                var angle = oColumn.pct_middle;
                xPosition =
                    ((piece.x - oColumn.middle) / adjustedColumnWidth) * anglePiece;
                var rPosition = piece.scaledValue / 2;
                var xAngle = angle + xPosition;
                var baseCentroid = pointOnArcAtAngle([adjustedSize[0] / 2, adjustedSize[1] / 2], xAngle, rPosition);
                xPosition = baseCentroid[0];
                yPosition = baseCentroid[1];
            }
            var actualCircleRadius = typeof circleRadius === "function"
                ? circleRadius(piece, i)
                : circleRadius;
            var eventListeners = eventListenersGenerator(piece, i);
            var renderElementObject = type.customMark ? (React.createElement("g", { key: "piece-" + piece.renderKey, transform: "translate(" + xPosition + "," + yPosition + ")" }, type.customMark(__assign(__assign(__assign({}, piece.data), piece), { x: xPosition, y: yPosition }), i, {
                x: xPosition,
                y: yPosition,
                r: circleRadius,
                baseMarkProps: baseMarkProps,
                renderMode: renderMode,
                styleFn: styleFn,
                classFn: classFn,
                adjustedSize: adjustedSize,
                chartSize: chartSize,
                margin: margin,
                rScale: rScale
            }))) : (__assign({ className: classFn(__assign(__assign({}, piece), piece.data), i), markType: "rect", renderMode: renderValue, key: "piece-" + piece.renderKey, height: actualCircleRadius * 2, width: actualCircleRadius * 2, x: xPosition - actualCircleRadius, y: yPosition - actualCircleRadius, rx: actualCircleRadius, ry: actualCircleRadius, style: styleFn(__assign(__assign({}, piece), piece.data), ordsetI) }, eventListeners));
            var calculatedPiece = {
                o: key,
                xy: {
                    x: xPosition,
                    y: yPosition
                },
                piece: piece,
                renderElement: renderElementObject
            };
            return calculatedPiece;
        });
        allCalculatedPieces = __spread(allCalculatedPieces, calculatedPieces);
    });
    return allCalculatedPieces;
}

var genericFunction = function (value) { return function () { return value; }; };

var layoutHash = {
    clusterbar: clusterBarLayout,
    bar: barLayout,
    point: pointLayout,
    swarm: swarmLayout,
    timeline: timelineLayout
};
var midMod = function (d) { return (d.middle ? d.middle : 0); };
var zeroFunction = genericFunction(0);
var twoPI = Math.PI * 2;
var naturalLanguageTypes = {
    bar: { items: "bar", chart: "bar chart" },
    clusterbar: { items: "bar", chart: "grouped bar chart" },
    swarm: { items: "point", chart: "swarm plot" },
    point: { items: "point", chart: "point plot" },
    timeline: { items: "bar", chart: "timeline" }
};
var calculateMappedMiddles = function (oScale, middleMax, padding) {
    var oScaleDomainValues = oScale.domain();
    var mappedMiddles = {};
    oScaleDomainValues.forEach(function (p, q) {
        var base = oScale(p) - padding;
        var next = oScaleDomainValues[q + 1]
            ? oScale(oScaleDomainValues[q + 1])
            : middleMax;
        var diff = (next - base) / 2;
        mappedMiddles[p] = base + diff;
    });
    return mappedMiddles;
};
var calculateOrdinalFrame = function (currentProps, currentState) {
    var oLabels;
    var projectedColumns = {};
    var _a = currentProps.oPadding, padding = _a === void 0 ? 0 : _a, baseSummaryType = currentProps.summaryType, baseType = currentProps.type, baseConnectorType = currentProps.connectorType, baseOAccessor = currentProps.oAccessor, baseRAccessor = currentProps.rAccessor, baseConnectorStyle = currentProps.connectorStyle, baseStyle = currentProps.style, baseRExtent = currentProps.rExtent, oSort = currentProps.oSort, basePieceClass = currentProps.pieceClass, baseSummaryStyle = currentProps.summaryStyle, baseSummaryClass = currentProps.summaryClass, dynamicColumnWidth = currentProps.dynamicColumnWidth, projection = currentProps.projection, customHoverBehavior = currentProps.customHoverBehavior, customClickBehavior = currentProps.customClickBehavior, customDoubleClickBehavior = currentProps.customDoubleClickBehavior, size = currentProps.size, pixelColumnWidth = currentProps.pixelColumnWidth, baseTitle = currentProps.title, oLabel = currentProps.oLabel, hoverAnnotation = currentProps.hoverAnnotation, pieceHoverAnnotation = currentProps.pieceHoverAnnotation, summaryHoverAnnotation = currentProps.summaryHoverAnnotation, backgroundGraphics = currentProps.backgroundGraphics, foregroundGraphics = currentProps.foregroundGraphics, oScaleType = currentProps.oScaleType, rScaleType = currentProps.rScaleType, legend = currentProps.legend, baseRenderKey = currentProps.renderKey, data = currentProps.data, baseMargin = currentProps.margin, baseOExtent = currentProps.oExtent, baseAxes = currentProps.axes, basePieceIDAccessor = currentProps.pieceIDAccessor, multiAxis = currentProps.multiAxis, _b = currentProps.baseMarkProps, baseMarkProps = _b === void 0 ? {} : _b, annotations = currentProps.annotations, sketchyRenderingEngine = currentProps.sketchyRenderingEngine;
    var summaryType = objectifyType(baseSummaryType);
    var pieceType = objectifyType(baseType);
    var connectorType = objectifyType(baseConnectorType);
    var oAccessor = stringToArrayFn(baseOAccessor, function (d) { return d.renderKey; });
    var rAccessor = stringToArrayFn(baseRAccessor, function (d) { return d.value || 1; });
    var renderKey = stringToFn(baseRenderKey, function (d, i) { return i; });
    var eventListenersGenerator = function () { return ({}); };
    var connectorStyle = stringToFn(baseConnectorStyle, function () { return ({}); }, true);
    var summaryStyle = stringToFn(baseSummaryStyle, function () { return ({}); }, true);
    var pieceStyle = stringToFn(baseStyle, function () { return ({}); }, true);
    var pieceClass = stringToFn(basePieceClass, function () { return ""; }, true);
    var summaryClass = stringToFn(baseSummaryClass, function () { return ""; }, true);
    var title = typeof baseTitle === "object" &&
        !React.isValidElement(baseTitle) &&
        baseTitle !== null
        ? baseTitle
        : { title: baseTitle, orient: "top" };
    var pieceIDAccessor = stringToFn(basePieceIDAccessor, function () { return ""; });
    var originalRAccessor = Array.isArray(baseRAccessor)
        ? baseRAccessor
        : [baseRAccessor];
    var originalOAccessor = Array.isArray(baseOAccessor)
        ? baseOAccessor
        : [baseOAccessor];
    var _c = keyAndObjectifyBarData({
        data: data,
        renderKey: renderKey,
        oAccessor: oAccessor,
        rAccessor: rAccessor,
        originalRAccessor: originalRAccessor,
        originalOAccessor: originalOAccessor,
        multiAxis: multiAxis
    }), allData = _c.allData, multiExtents = _c.multiExtents;
    var columnOverlays;
    var prevProps = currentState.props;
    var shouldRecalculateOverlay = currentProps.data !== prevProps.data ||
        currentProps.size[0] !== prevProps.size[0] ||
        currentProps.size[1] !== prevProps.size[1] ||
        currentProps.margin !== prevProps.margin ||
        !currentState.columnOverlays ||
        currentState.columnOverlays.length === 0 ||
        currentProps.customClickBehavior !== prevProps.customClickBehavior ||
        currentProps.customDoubleClickBehavior !==
            prevProps.customDoubleClickBehavior ||
        currentProps.customHoverBehavior !== prevProps.customHoverBehavior;
    var arrayWrappedAxis;
    if (Array.isArray(baseAxes)) {
        arrayWrappedAxis = baseAxes.map(function (axisFnOrObject) {
            return typeof axisFnOrObject === "function"
                ? axisFnOrObject({ size: currentProps.size })
                : axisFnOrObject;
        });
    }
    else if (baseAxes) {
        arrayWrappedAxis = [baseAxes].map(function (axisFnOrObject) {
            return typeof axisFnOrObject === "function"
                ? axisFnOrObject({ size: currentProps.size })
                : axisFnOrObject;
        });
    }
    if (multiExtents && baseAxes) {
        arrayWrappedAxis.forEach(function (d, i) {
            d.extentOverride = multiExtents[i];
        });
    }
    var margin = calculateMargin({
        margin: baseMargin,
        axes: arrayWrappedAxis,
        title: title,
        oLabel: oLabel,
        projection: projection,
        size: size
    });
    var _d = adjustedPositionSize({
        size: size,
        margin: margin,
        projection: projection
    }), adjustedPosition = _d.adjustedPosition, adjustedSize = _d.adjustedSize;
    var oExtentSettings = baseOExtent === undefined || Array.isArray(baseOExtent)
        ? { extent: baseOExtent }
        : baseOExtent;
    var calculatedOExtent = allData.reduce(function (p, c) {
        var baseOValue = c.column;
        var oValue = baseOValue !== undefined ? String(baseOValue) : baseOValue;
        if (p.indexOf(oValue) === -1) {
            p.push(oValue);
        }
        return p;
    }, []);
    var oExtent = oExtentSettings.extent || calculatedOExtent;
    if (pieceType.type === "barpercent") {
        var oExtentSums_1 = oExtent
            .map(function (d) {
            return allData
                .filter(function (p) { return String(p.column) === d; })
                .reduce(function (p, c) { return p + c.value; }, 0);
        })
            .reduce(function (p, c, i) {
            p[oExtent[i]] = c;
            return p;
        }, {});
        allData.forEach(function (d) {
            d.value = (oExtentSums_1[d.column] && d.value / oExtentSums_1[d.column]) || 0;
        });
        pieceType.type = "bar";
    }
    if (pixelColumnWidth) {
        if (projection === "radial") {
            console.error("pixelColumnWidth is not honored in radial mode");
        }
        else if (projection === "vertical") {
            adjustedSize[0] = oExtent.length * pixelColumnWidth;
        }
        else {
            adjustedSize[1] = oExtent.length * pixelColumnWidth;
        }
    }
    var oDomain = (projection === "vertical" && [0, adjustedSize[0]]) || [
        0,
        adjustedSize[1]
    ];
    var cwHash = oExtent.reduce(function (p, c) {
        p[c] = (1 / oExtent.length) * oDomain[1];
        p.total += p[c];
        return p;
    }, { total: 0 });
    var castOScaleType = oScaleType;
    var oScale = dynamicColumnWidth ? scaleOrdinal() : castOScaleType();
    oScale.domain(oExtent);
    var maxColumnValues;
    if (dynamicColumnWidth) {
        var columnValueCreator_1;
        if (typeof dynamicColumnWidth === "string") {
            columnValueCreator_1 = function (d) { return sum(d.map(function (p) { return p.data[dynamicColumnWidth]; })); };
        }
        else {
            columnValueCreator_1 = function (d) { return dynamicColumnWidth(d.map(function (p) { return p.data; })); };
        }
        var thresholdDomain_1 = [0];
        maxColumnValues = 0;
        var columnValues_1 = [];
        oExtent.forEach(function (d) {
            var oValues = allData.filter(function (p) { return p.column === d; });
            var columnValue = columnValueCreator_1(oValues);
            columnValues_1.push(columnValue);
            maxColumnValues += columnValue;
        });
        cwHash.total = 0;
        oExtent.forEach(function (d, i) {
            var oValue = columnValues_1[i];
            var stepValue = (oValue / maxColumnValues) * (oDomain[1] - oDomain[0]);
            cwHash[d] = stepValue;
            cwHash.total += stepValue;
            if (i !== oExtent.length - 1) {
                thresholdDomain_1.push(stepValue + thresholdDomain_1[i]);
            }
        });
        oScale.range(thresholdDomain_1);
    }
    else {
        oScale.range(oDomain);
    }
    var rExtentSettings = baseRExtent === undefined || Array.isArray(baseRExtent)
        ? { extent: baseRExtent, onChange: undefined, includeAnnotations: false }
        : baseRExtent;
    var rExtent = rExtentSettings.extent;
    var subZeroRExtent = [0, 0];
    if (pieceType.type === "bar" &&
        summaryType.type &&
        summaryType.type !== "none") {
        pieceType.type = "none";
    }
    var annotationsForExtent = [];
    if (rExtentSettings.includeAnnotations && annotations) {
        rAccessor.forEach(function (actualRAccessor) {
            annotations.forEach(function (annotation, annotationIndex) {
                var r = actualRAccessor(annotation, annotationIndex);
                if (isFinite(r)) {
                    annotationsForExtent.push(r);
                }
            });
        });
    }
    if (pieceType.type === "timeline") {
        var rData = allData.map(function (d) { return d.value; });
        var leftExtent = extent$1(rData.map(function (d) { return d[0]; }));
        var rightExtent = extent$1(rData.map(function (d) { return d[1]; }));
        rExtent = extent$1(__spread(leftExtent, rightExtent, annotationsForExtent));
    }
    else if (pieceType.type !== "bar") {
        rExtent = extent$1(__spread(allData.map(function (d) { return d.value; }), annotationsForExtent));
    }
    else {
        var positiveData = allData.filter(function (d) { return d.value >= 0; });
        var negativeData = allData.filter(function (d) { return d.value < 0; });
        var nestedPositiveData = nest()
            .key(function (d) { return d.column; })
            .rollup(function (leaves) { return sum(leaves.map(function (d) { return d.value; })); })
            .entries(positiveData);
        var nestedNegativeData = nest()
            .key(function (d) { return d.column; })
            .rollup(function (leaves) { return sum(leaves.map(function (d) { return d.value; })); })
            .entries(negativeData);
        var positiveAnnotations = annotationsForExtent.filter(function (d) { return d > 0; });
        rExtent = [
            0,
            nestedPositiveData.length === 0 && positiveAnnotations.length === 0
                ? 0
                : Math.max(max(__spread(nestedPositiveData.map(function (d) { return d.value; }), positiveAnnotations)), 0)
        ];
        var negativeAnnotations = annotationsForExtent.filter(function (d) { return d < 0; });
        subZeroRExtent = [
            0,
            nestedNegativeData.length === 0
                ? 0
                : Math.min(min(__spread(nestedNegativeData.map(function (d) { return d.value; }), negativeAnnotations)), 0)
        ];
        rExtent = [subZeroRExtent[1], rExtent[1]];
    }
    if ((pieceType.type === "clusterbar" || multiAxis) && rExtent[0] > 0) {
        rExtent[0] = 0;
    }
    var calculatedRExtent = rExtent;
    if (rExtentSettings.extent &&
        rExtentSettings.extent[0] !== undefined &&
        rExtentSettings.extent[1] !== undefined) {
        rExtent = rExtentSettings.extent;
    }
    else {
        if (rExtentSettings.extent &&
            rExtentSettings.extent[1] !== undefined &&
            rExtentSettings.extent[0] === undefined) {
            rExtent[1] = rExtentSettings.extent[1];
        }
        if (rExtentSettings.extent &&
            rExtentSettings.extent[0] !== undefined &&
            rExtentSettings.extent[1] === undefined) {
            rExtent[0] = rExtentSettings.extent[0];
        }
    }
    if (currentProps.invertR ||
        (rExtentSettings.extent &&
            rExtentSettings.extent[0] > rExtentSettings.extent[1])) {
        rExtent = [rExtent[1], rExtent[0]];
    }
    var nestedPieces = {};
    nest()
        .key(function (d) { return d.column; })
        .entries(allData)
        .forEach(function (d) {
        nestedPieces[d.key] = d.values;
    });
    if (oSort !== undefined) {
        oExtent = oExtent.sort(function (a, b) {
            return oSort(a, b, nestedPieces[a].map(function (d) { return d.data; }), nestedPieces[b].map(function (d) { return d.data; }));
        });
        oScale.domain(oExtent);
    }
    var rDomain = (projection === "vertical" && [0, adjustedSize[1]]) || [
        0,
        adjustedSize[0]
    ];
    var castRScaleType = rScaleType;
    var instantiatedRScaleType = rScaleType.domain
        ? rScaleType
        : castRScaleType();
    var zeroCheck = instantiatedRScaleType(0);
    if (rExtentSettings.extent &&
        rExtentSettings.extent[0] !== undefined &&
        (isNaN(zeroCheck) || zeroCheck === -Infinity || zeroCheck === Infinity)) {
        rExtent[0] = rExtentSettings.extent[0];
    }
    var rScale = instantiatedRScaleType.copy().domain(rExtent).range(rDomain);
    var rScaleReverse = scaleLinear().domain(rDomain).range(rDomain.reverse());
    var rScaleVertical = instantiatedRScaleType
        .copy()
        .domain(rExtent)
        .range(rDomain);
    var columnWidth = cwHash ? 0 : oScale.bandwidth();
    var pieceData = [];
    var mappedMiddleSize = adjustedSize[1];
    if (projection === "vertical") {
        mappedMiddleSize = adjustedSize[0];
    }
    var mappedMiddles = calculateMappedMiddles(oScale, mappedMiddleSize, padding);
    pieceData = oExtent.map(function (d) { return (nestedPieces[d] ? nestedPieces[d] : []); });
    var zeroValue = projection === "vertical" ? rScaleReverse(rScale(0)) : rScale(0);
    if ((isNaN(zeroValue) || zeroValue === -Infinity || zeroValue === Infinity) &&
        rExtentSettings.extent &&
        rExtentSettings.extent[0] !== undefined &&
        (zeroCheck === -Infinity || zeroCheck === Infinity)) {
        zeroValue =
            projection === "vertical"
                ? rScaleReverse(rScale(rExtentSettings.extent[0]))
                : rScale(rExtentSettings.extent[0]);
    }
    oExtent.forEach(function (o, i) {
        projectedColumns[o] = {
            name: o,
            padding: padding,
            pieceData: pieceData[i],
            pieces: pieceData[i]
        };
        projectedColumns[o].x = oScale(o) + padding / 2;
        projectedColumns[o].y = 0;
        projectedColumns[o].middle = mappedMiddles[o] + padding / 2;
        var negativeOffset = zeroValue;
        var positiveOffset = zeroValue;
        var negativeBaseValue = 0;
        var positiveBaseValue = 0;
        projectedColumns[o].pieceData.forEach(function (piece) {
            var valPosition;
            if (pieceType.type === "timeline") {
                piece.scaledValue = rScale(piece.value[0]);
                piece.scaledEndValue = rScale(piece.value[1]);
                piece.scaledVerticalValue = rScaleVertical(piece.value[0]);
            }
            else if (pieceType.type !== "bar" && pieceType.type !== "clusterbar") {
                piece.scaledValue = rScale(piece.value);
                piece.scaledVerticalValue = rScaleVertical(piece.value);
            }
            else if (pieceType.type === "clusterbar") {
                valPosition =
                    projection === "vertical"
                        ? rScaleReverse(rScale(piece.value))
                        : rScale(piece.value);
                piece.scaledValue = Math.abs(zeroValue - valPosition);
            }
            piece.x = projectedColumns[o].x;
            if (piece.value >= 0) {
                if (pieceType.type === "bar") {
                    piece.scaledValue =
                        projection === "vertical"
                            ? positiveOffset -
                                rScaleReverse(rScale(positiveBaseValue + piece.value))
                            : rScale(positiveBaseValue + piece.value) - positiveOffset;
                    positiveBaseValue += piece.value;
                }
                piece.base = zeroValue;
                piece.bottom = pieceType.type === "bar" ? positiveOffset : 0;
                piece.middle = piece.scaledValue / 2 + positiveOffset;
                positiveOffset =
                    projection === "vertical"
                        ? positiveOffset - piece.scaledValue
                        : positiveOffset + piece.scaledValue;
                piece.negative = false;
            }
            else {
                if (pieceType.type === "bar") {
                    piece.scaledValue =
                        projection === "vertical"
                            ? Math.abs(rScale(piece.value) - rScale(0))
                            : Math.abs(rScale(piece.value) - zeroValue);
                    negativeBaseValue += piece.value;
                }
                piece.base = zeroValue;
                piece.bottom = pieceType.type === "bar" ? negativeOffset : 0;
                piece.middle = negativeOffset - piece.scaledValue / 2;
                negativeOffset =
                    projection === "vertical"
                        ? negativeOffset + piece.scaledValue
                        : negativeOffset - piece.scaledValue;
                piece.negative = true;
            }
        });
        if (cwHash) {
            projectedColumns[o].width = cwHash[o] - padding;
            if (currentProps.ordinalAlign === "center") {
                if (i === 0) {
                    projectedColumns[o].x =
                        projectedColumns[o].x - projectedColumns[o].width / 2;
                    projectedColumns[o].middle =
                        projectedColumns[o].middle - projectedColumns[o].width / 2;
                }
                else {
                    projectedColumns[o].x =
                        projectedColumns[oExtent[i - 1]].x +
                            projectedColumns[oExtent[i - 1]].width;
                    projectedColumns[o].middle =
                        projectedColumns[o].x + projectedColumns[o].width / 2;
                }
            }
            projectedColumns[o].pct = cwHash[o] / cwHash.total;
            projectedColumns[o].pct_start =
                (projectedColumns[o].x - oDomain[0]) / cwHash.total;
            projectedColumns[o].pct_padding = padding / cwHash.total;
            projectedColumns[o].pct_middle =
                (projectedColumns[o].middle - oDomain[0]) / cwHash.total;
        }
        else {
            projectedColumns[o].width = columnWidth - padding;
            if (currentProps.ordinalAlign === "center") {
                projectedColumns[o].x =
                    projectedColumns[o].x - projectedColumns[o].width / 2;
                projectedColumns[o].middle =
                    projectedColumns[o].middle - projectedColumns[o].width / 2;
            }
            projectedColumns[o].pct = columnWidth / adjustedSize[1];
            projectedColumns[o].pct_start =
                (projectedColumns[o].x - oDomain[0]) / adjustedSize[1];
            projectedColumns[o].pct_padding = padding / adjustedSize[1];
            projectedColumns[o].pct_middle =
                (projectedColumns[o].middle - oDomain[0]) / adjustedSize[1];
        }
    });
    var labelArray = [];
    var pieArcs = [];
    var labelSettings = typeof oLabel === "object"
        ? Object.assign({ label: true, padding: 5 }, oLabel)
        : { orient: "default", label: oLabel, padding: 5 };
    if (oLabel || hoverAnnotation) {
        var offsetPct_1 = (pieceType.offsetAngle && pieceType.offsetAngle / 360) || 0;
        var rangePct = (pieceType.angleRange &&
            pieceType.angleRange.map(function (d) { return d / 360; })) || [0, 1];
        var rangeMod_1 = rangePct[1] - rangePct[0];
        var adjustedPct_1 = rangeMod_1 < 1 ? scaleLinear().domain([0, 1]).range(rangePct) : function (d) { return d; };
        oExtent.forEach(function (d) {
            var arcGenerator = arc()
                .innerRadius(0)
                .outerRadius(rScale.range()[1] / 2);
            var angle = projectedColumns[d].pct * rangeMod_1;
            var startAngle = adjustedPct_1(projectedColumns[d].pct_start + offsetPct_1);
            var endAngle = startAngle + angle;
            var midAngle = startAngle + angle / 2;
            var markD = arcGenerator({
                startAngle: startAngle * twoPI,
                endAngle: endAngle * twoPI
            });
            var translate = [adjustedSize[0] / 2, adjustedSize[1] / 2];
            var centroid = arcGenerator.centroid({
                startAngle: startAngle * twoPI,
                endAngle: endAngle * twoPI
            });
            var addedPadding = centroid[1] > 0 &&
                (!labelSettings.orient ||
                    labelSettings.orient === "default" ||
                    labelSettings.orient === "edge")
                ? 8
                : 0;
            var outerPoint = pointOnArcAtAngle$1([0, 0], midAngle, rScale.range()[1] / 2 + labelSettings.padding + addedPadding);
            var pieArc = {
                startAngle: startAngle,
                endAngle: endAngle,
                midAngle: midAngle,
                markD: markD,
                translate: translate,
                centroid: centroid,
                outerPoint: outerPoint
            };
            projectedColumns[d].pieArc = pieArc;
            pieArcs.push(pieArc);
        });
    }
    if (currentProps.oLabel) {
        var labelingFn_1;
        if (labelSettings.label === true) {
            var labelStyle_1 = {
                textAnchor: "middle"
            };
            if (projection === "horizontal" && labelSettings.orient === "right") {
                labelStyle_1.textAnchor = "start";
            }
            else if (projection === "horizontal") {
                labelStyle_1.textAnchor = "end";
            }
            labelingFn_1 = function (d, p, i) {
                var additionalStyle = {};
                var transformRotate;
                if (projection === "radial" && labelSettings.orient === "stem") {
                    transformRotate = "rotate(" + (pieArcs[i].outerPoint[0] < 0
                        ? pieArcs[i].midAngle * 360 + 90
                        : pieArcs[i].midAngle * 360 - 90) + ")";
                }
                else if (projection === "radial" &&
                    labelSettings.orient !== "center") {
                    transformRotate = "rotate(" + (pieArcs[i].outerPoint[1] < 0
                        ? pieArcs[i].midAngle * 360
                        : pieArcs[i].midAngle * 360 + 180) + ")";
                }
                if (projection === "radial" &&
                    labelSettings.orient === "stem" &&
                    ((pieArcs[i].outerPoint[0] > 0 && labelSettings.padding < 0) ||
                        (pieArcs[i].outerPoint[0] < 0 && labelSettings.padding >= 0))) {
                    additionalStyle.textAnchor = "end";
                }
                else if (projection === "radial" && labelSettings.orient === "stem") {
                    additionalStyle.textAnchor = "start";
                }
                return (React.createElement("text", __assign({}, labelStyle_1, additionalStyle, { transform: transformRotate }), d));
            };
        }
        else if (typeof labelSettings.label === "function") {
            labelingFn_1 = labelSettings.label;
        }
        oExtent.forEach(function (d, i) {
            var xPosition = projectedColumns[d].middle;
            var yPosition = 0;
            if (projection === "horizontal") {
                yPosition = projectedColumns[d].middle;
                if (labelSettings.orient === "right") {
                    xPosition = adjustedSize[0] + 3;
                }
                else {
                    xPosition = -3;
                }
            }
            else if (projection === "radial") {
                if (labelSettings.orient === "center") {
                    xPosition = pieArcs[i].centroid[0] + pieArcs[i].translate[0];
                    yPosition = pieArcs[i].centroid[1] + pieArcs[i].translate[1];
                }
                else {
                    xPosition = pieArcs[i].outerPoint[0] + pieArcs[i].translate[0];
                    yPosition = pieArcs[i].outerPoint[1] + pieArcs[i].translate[1];
                }
            }
            var label = labelingFn_1(d, projectedColumns[d].pieceData.map(function (d) { return d.data; }), i, projectedColumns[d]);
            labelArray.push(React.createElement("g", { key: "olabel-" + i, transform: "translate(" + xPosition + "," + yPosition + ")" }, label));
        });
        if (projection === "vertical") {
            var labelY = void 0;
            if (labelSettings.orient === "top") {
                labelY = -15;
            }
            else {
                labelY = 15 + rScale.range()[1];
            }
            oLabels = (React.createElement("g", { key: "ordinalframe-labels-container", className: "ordinal-labels", transform: "translate(0," + labelY + ")" }, labelArray));
        }
        else if (projection === "horizontal") {
            oLabels = (React.createElement("g", { key: "ordinalframe-labels-container", className: "ordinal-labels" }, labelArray));
        }
        else if (projection === "radial") {
            oLabels = (React.createElement("g", { key: "ordinalframe-labels-container", className: "ordinal-labels" }, labelArray));
        }
    }
    if (!currentProps.pieceHoverAnnotation &&
        !currentProps.summaryHoverAnnotation &&
        (currentProps.hoverAnnotation ||
            currentProps.customClickBehavior ||
            currentProps.customDoubleClickBehavior ||
            currentProps.customHoverBehavior)) {
        if (shouldRecalculateOverlay) {
            columnOverlays = oExtent.map(function (d, i) {
                var barColumnWidth = projectedColumns[d].width;
                var xPosition = projectedColumns[d].x;
                var yPosition = 0;
                var height = rScale.range()[1];
                var width = barColumnWidth + padding;
                if (projection === "horizontal") {
                    yPosition = projectedColumns[d].x;
                    xPosition = 0;
                    width = rScale.range()[1];
                    height = barColumnWidth;
                }
                if (projection === "radial") {
                    var _a = pieArcs[i], markD = _a.markD, centroid = _a.centroid, translate = _a.translate, midAngle = _a.midAngle;
                    var radialMousePackage_1 = {
                        type: "column-hover",
                        column: projectedColumns[d],
                        pieces: projectedColumns[d].pieceData,
                        summary: projectedColumns[d].pieceData,
                        arcAngles: {
                            centroid: centroid,
                            translate: translate,
                            midAngle: midAngle,
                            length: rScale.range()[1] / 2
                        }
                    };
                    return {
                        markType: "path",
                        key: "hover" + d,
                        d: markD,
                        transform: "translate(" + translate.join(",") + ")",
                        style: { opacity: 0 },
                        overlayData: radialMousePackage_1,
                        onDoubleClick: customDoubleClickBehavior &&
                            (function (e) {
                                customDoubleClickBehavior(radialMousePackage_1, e);
                            }),
                        onClick: customClickBehavior &&
                            (function (e) {
                                customClickBehavior(radialMousePackage_1, e);
                            }),
                        onMouseEnter: customHoverBehavior &&
                            (function (e) {
                                customHoverBehavior(radialMousePackage_1, e);
                            }),
                        onMouseLeave: customHoverBehavior &&
                            (function (e) {
                                customHoverBehavior(e);
                            })
                    };
                }
                var baseMousePackage = {
                    type: "column-hover",
                    column: projectedColumns[d],
                    pieces: projectedColumns[d].pieceData,
                    summary: projectedColumns[d].pieceData
                };
                return {
                    markType: "rect",
                    key: "hover-" + d,
                    x: xPosition,
                    y: yPosition,
                    height: height,
                    width: width,
                    style: { opacity: 0 },
                    onDoubleClick: customDoubleClickBehavior &&
                        (function (e) {
                            customDoubleClickBehavior(baseMousePackage, e);
                        }),
                    onClick: customClickBehavior &&
                        (function (e) {
                            customClickBehavior(baseMousePackage, e);
                        }),
                    onMouseEnter: customHoverBehavior &&
                        (function (e) {
                            customHoverBehavior(baseMousePackage, e);
                        }),
                    onMouseLeave: function (e) {
                        customHoverBehavior(undefined, e);
                    },
                    overlayData: baseMousePackage
                };
            });
        }
        else {
            columnOverlays = currentState.columnOverlays;
        }
    }
    var renderMode = currentProps.renderMode, canvasSummaries = currentProps.canvasSummaries, summaryRenderMode = currentProps.summaryRenderMode, connectorClass = currentProps.connectorClass, connectorRenderMode = currentProps.connectorRenderMode, canvasConnectors = currentProps.canvasConnectors, canvasPieces = currentProps.canvasPieces;
    var pieceDataXY;
    var pieceRenderMode = stringToFn(renderMode, undefined, true);
    var pieceCanvasRender = stringToFn(canvasPieces, undefined, true);
    var summaryCanvasRender = stringToFn(canvasSummaries, undefined, true);
    var connectorCanvasRender = stringToFn(canvasConnectors, undefined, true);
    var pieceTypeForXY = pieceType.type && pieceType.type !== "none" ? pieceType.type : "point";
    var pieceTypeLayout = typeof pieceTypeForXY === "function"
        ? pieceTypeForXY
        : layoutHash[pieceTypeForXY];
    var calculatedPieceData = pieceTypeLayout({
        type: pieceType,
        data: projectedColumns,
        renderMode: pieceRenderMode,
        eventListenersGenerator: eventListenersGenerator,
        styleFn: pieceStyle,
        projection: projection,
        classFn: pieceClass,
        adjustedSize: adjustedSize,
        chartSize: size,
        margin: margin,
        rScale: rScale,
        baseMarkProps: __assign(__assign({}, baseMarkProps), { sketchyGenerator: sketchyRenderingEngine && sketchyRenderingEngine.generator })
    });
    var keyedData = calculatedPieceData.reduce(function (p, c) {
        if (c.o) {
            if (!p[c.o]) {
                p[c.o] = [];
            }
            p[c.o].push(c);
        }
        return p;
    }, {});
    Object.keys(projectedColumns).forEach(function (d) {
        projectedColumns[d].xyData = keyedData[d] || [];
    });
    var calculatedSummaries = {};
    if (summaryType.type && summaryType.type !== "none") {
        calculatedSummaries = drawSummaries({
            data: projectedColumns,
            type: summaryType,
            renderMode: stringToFn(summaryRenderMode, undefined, true),
            styleFn: stringToFn(summaryStyle, function () { return ({}); }, true),
            classFn: stringToFn(summaryClass, function () { return ""; }, true),
            //        canvasRender: stringToFn<boolean>(canvasSummaries, undefined, true),
            projection: projection,
            eventListenersGenerator: eventListenersGenerator,
            adjustedSize: adjustedSize,
            baseMarkProps: __assign(__assign({}, baseMarkProps), { sketchyGenerator: sketchyRenderingEngine && sketchyRenderingEngine.generator }),
            //        chartSize: size,
            margin: margin
        });
        calculatedSummaries.originalData = projectedColumns;
    }
    var yMod = projection === "horizontal" ? midMod : zeroFunction;
    var xMod = projection === "vertical" ? midMod : zeroFunction;
    var basePieceData = calculatedPieceData
        .map(function (d) {
        if (d.piece && d.xy) {
            return __assign(__assign({}, d.piece), { type: "frame-hover", x: d.xy.x + xMod(d.xy), y: d.xy.y + yMod(d.xy) });
        }
        return null;
    })
        .filter(function (d) { return d; });
    if ((pieceHoverAnnotation &&
        ["bar", "clusterbar", "timeline"].indexOf(pieceType.type) === -1) ||
        summaryHoverAnnotation) {
        if (summaryHoverAnnotation && calculatedSummaries.xyPoints) {
            pieceDataXY = calculatedSummaries.xyPoints.map(function (d) {
                return Object.assign({}, d, {
                    type: "frame-hover",
                    isSummaryData: true,
                    x: d.x,
                    y: d.y
                });
            });
        }
        else if (pieceHoverAnnotation && calculatedPieceData) {
            pieceDataXY = basePieceData;
        }
    }
    var _e = orFrameAxisGenerator({
        axis: arrayWrappedAxis,
        data: allData,
        projection: projection,
        adjustedSize: adjustedSize,
        size: size,
        rScale: rScale,
        rScaleType: instantiatedRScaleType.copy(),
        pieceType: pieceType,
        rExtent: rExtent,
        maxColumnValues: maxColumnValues,
        xyData: basePieceData,
        margin: margin,
        thresholds: calculatedSummaries.thresholds
    }), axis = _e.axis, axesTickLines = _e.axesTickLines;
    if (pieceHoverAnnotation &&
        ["bar", "clusterbar", "timeline"].indexOf(pieceType.type) !== -1) {
        var yMod_1 = projection === "horizontal" ? midMod : zeroFunction;
        var xMod_1 = projection === "vertical" ? midMod : zeroFunction;
        if (shouldRecalculateOverlay) {
            columnOverlays = calculatedPieceData.map(function (d, i) {
                var mousePackage = __assign(__assign({}, d.piece), { x: d.xy.x + xMod_1(d.xy), y: d.xy.y + yMod_1(d.xy) });
                if (React.isValidElement(d.renderElement)) {
                    return {
                        renderElement: d.renderElement,
                        overlayData: mousePackage
                    };
                }
                return __assign(__assign({}, d.renderElement), { key: "hover-" + i, type: "frame-hover", style: { opacity: 0 }, overlayData: mousePackage, onClick: customClickBehavior &&
                        (function (e) {
                            customClickBehavior(mousePackage.data, e);
                        }), onDoubleClick: customDoubleClickBehavior &&
                        (function (e) {
                            customDoubleClickBehavior(mousePackage.data, e);
                        }), onMouseEnter: customHoverBehavior &&
                        (function (e) {
                            customHoverBehavior(mousePackage.data, e);
                        }), onMouseLeave: customHoverBehavior &&
                        (function (e) {
                            customHoverBehavior(undefined, e);
                        }) });
            });
        }
        else {
            columnOverlays = currentState.columnOverlays;
        }
    }
    var typeAriaLabel = (pieceType.type !== undefined &&
        typeof pieceType.type !== "function" &&
        naturalLanguageTypes[pieceType.type]) || {
        items: "piece",
        chart: "ordinal chart"
    };
    var orFrameRender = {
        connectors: {
            accessibleTransform: function (data, i) { return data[i]; },
            projection: projection,
            data: keyedData,
            styleFn: stringToFn(connectorStyle, function () { return ({}); }, true),
            classFn: stringToFn(connectorClass, function () { return ""; }, true),
            renderMode: stringToFn(connectorRenderMode, undefined, true),
            canvasRender: connectorCanvasRender,
            behavior: orFrameConnectionRenderer,
            type: connectorType,
            eventListenersGenerator: eventListenersGenerator,
            pieceType: pieceType
        },
        summaries: {
            accessibleTransform: function (data, i) {
                var columnName = oExtent[i];
                var summaryPackage = {
                    type: "column-hover",
                    column: projectedColumns[columnName],
                    pieces: projectedColumns[columnName].pieceData,
                    summary: projectedColumns[columnName].pieceData,
                    oAccessor: oAccessor
                };
                return summaryPackage;
            },
            data: calculatedSummaries.marks,
            behavior: renderLaidOutSummaries,
            canvasRender: summaryCanvasRender,
            styleFn: stringToFn(summaryStyle, function () { return ({}); }, true),
            classFn: stringToFn(summaryClass, function () { return ""; }, true)
        },
        pieces: {
            accessibleTransform: function (data, i) { return (__assign(__assign({}, (data[i].piece ? __assign(__assign({}, data[i].piece), data[i].xy) : data[i])), { type: "frame-hover" })); },
            shouldRender: pieceType.type && pieceType.type !== "none",
            data: calculatedPieceData,
            behavior: renderLaidOutPieces,
            canvasRender: pieceCanvasRender,
            styleFn: stringToFn(pieceStyle, function () { return ({}); }, true),
            classFn: stringToFn(pieceClass, function () { return ""; }, true),
            axis: arrayWrappedAxis,
            ariaLabel: typeAriaLabel
        }
    };
    if (rExtentSettings.onChange &&
        (currentState.calculatedRExtent || []).join(",") !==
            (calculatedRExtent || []).join(",")) {
        rExtentSettings.onChange(calculatedRExtent);
    }
    if (oExtentSettings.onChange &&
        (currentState.calculatedOExtent || []).join(",") !==
            (calculatedOExtent || []).join(",")) {
        oExtentSettings.onChange(calculatedOExtent);
    }
    var legendSettings;
    if (legend) {
        legendSettings = legend === true ? {} : legend;
    }
    return {
        pieceDataXY: pieceDataXY,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: foregroundGraphics,
        axisData: arrayWrappedAxis,
        axes: axis,
        axesTickLines: axesTickLines,
        oLabels: { labels: oLabels },
        title: title,
        columnOverlays: columnOverlays,
        renderNumber: currentState.renderNumber + 1,
        oAccessor: oAccessor,
        rAccessor: rAccessor,
        oScaleType: oScaleType,
        rScaleType: instantiatedRScaleType,
        oExtent: oExtent,
        rExtent: rExtent,
        oScale: oScale,
        rScale: rScale,
        calculatedOExtent: calculatedOExtent,
        calculatedRExtent: calculatedRExtent,
        projectedColumns: projectedColumns,
        margin: margin,
        legendSettings: legendSettings,
        orFrameRender: orFrameRender,
        summaryType: summaryType,
        type: pieceType,
        pieceIDAccessor: pieceIDAccessor,
        props: currentProps
    };
};

var xScale$1 = scaleLinear();
var yScale$1 = scaleLinear();
var projectedCoordinatesObject = { y: "y", x: "x" };
var defaultOverflow = { top: 0, bottom: 0, left: 0, right: 0 };
var OrdinalFrame = /** @class */ (function (_super) {
    __extends(OrdinalFrame, _super);
    function OrdinalFrame(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultORSVGRule = function (_a) {
            var d = _a.d, i = _a.i, annotationLayer = _a.annotationLayer;
            var _b = _this.props, projection = _b.projection, svgAnnotationRules = _b.svgAnnotationRules;
            var _c = _this.state, adjustedPosition = _c.adjustedPosition, adjustedSize = _c.adjustedSize, oAccessor = _c.oAccessor, rAccessor = _c.rAccessor, oScale = _c.oScale, rScale = _c.rScale, projectedColumns = _c.projectedColumns, orFrameRender = _c.orFrameRender, pieceIDAccessor = _c.pieceIDAccessor, rScaleType = _c.rScaleType, summaryType = _c.summaryType, type = _c.type;
            var screenCoordinates = [0, 0];
            if (d.isColumnAnnotation) {
                var _d = __read(getColumnScreenCoordinates({
                    d: d,
                    projectedColumns: projectedColumns,
                    oAccessor: oAccessor,
                    summaryType: summaryType,
                    type: type,
                    projection: projection,
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize
                }).coordinates, 2), xPosition = _d[0], yPosition = _d[1];
                screenCoordinates = [xPosition, yPosition];
            }
            else if (d.coordinates || (d.type === "enclose" && d.neighbors)) {
                screenCoordinates = (d.coordinates || d.neighbors).map(function (p) {
                    var pO = findFirstAccessorValue(oAccessor, p) || p.column;
                    var oColumn = projectedColumns[pO];
                    var idPiece = findIDPiece(pieceIDAccessor, oColumn, p);
                    return screenProject({
                        p: p,
                        adjustedSize: adjustedSize,
                        rScale: rScale,
                        rAccessor: rAccessor,
                        idPiece: idPiece,
                        projection: projection,
                        oColumn: oColumn,
                        rScaleType: rScaleType
                    });
                });
            }
            else {
                var pO = findFirstAccessorValue(oAccessor, d) || d.column;
                var oColumn = projectedColumns[pO];
                var idPiece = findIDPiece(pieceIDAccessor, oColumn, d);
                screenCoordinates = screenProject({
                    p: d,
                    adjustedSize: adjustedSize,
                    rScale: rScale,
                    rAccessor: rAccessor,
                    idPiece: idPiece,
                    projection: projection,
                    oColumn: oColumn,
                    rScaleType: rScaleType
                });
            }
            var voronoiHover = annotationLayer.voronoiHover;
            //TODO: Process your rules first
            var customAnnotation = svgAnnotationRules &&
                svgAnnotationRules({
                    d: d,
                    i: i,
                    oScale: oScale,
                    rScale: rScale,
                    oAccessor: oAccessor,
                    rAccessor: rAccessor,
                    orFrameProps: _this.props,
                    orFrameState: _this.state,
                    screenCoordinates: screenCoordinates,
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize,
                    annotationLayer: annotationLayer,
                    categories: projectedColumns,
                    voronoiHover: voronoiHover
                });
            if (svgAnnotationRules && customAnnotation !== null) {
                return customAnnotation;
            }
            else if (d.type === "desaturation-layer") {
                return desaturationLayer({
                    style: d.style instanceof Function ? d.style(d, i) : d.style,
                    size: adjustedSize,
                    i: i,
                    key: d.key
                });
            }
            else if (d.type === "ordinal-line") {
                return svgOrdinalLine({ d: d, screenCoordinates: screenCoordinates, voronoiHover: voronoiHover });
            }
            else if (d.type === "or") {
                return svgORRule({ d: d, i: i, screenCoordinates: screenCoordinates, projection: projection });
            }
            else if (d.type === "highlight") {
                return svgHighlightRule$1({
                    d: d,
                    pieceIDAccessor: pieceIDAccessor,
                    orFrameRender: orFrameRender,
                    oAccessor: oAccessor
                });
            }
            else if (d.type === "react-annotation" || typeof d.type === "function") {
                return basicReactAnnotationRule({ d: d, i: i, screenCoordinates: screenCoordinates });
            }
            else if (d.type === "enclose") {
                return svgEncloseRule$1({ d: d, i: i, screenCoordinates: screenCoordinates });
            }
            else if (d.type === "enclose-rect") {
                return svgRectEncloseRule$1({ d: d, screenCoordinates: screenCoordinates, i: i });
            }
            else if (d.type === "r") {
                return svgRRule({
                    d: d,
                    i: i,
                    screenCoordinates: screenCoordinates,
                    rScale: rScale,
                    rAccessor: rAccessor,
                    projection: projection,
                    adjustedSize: adjustedSize,
                    adjustedPosition: adjustedPosition
                });
            }
            else if (d.type === "category") {
                return svgCategoryRule({
                    projection: projection,
                    d: d,
                    i: i,
                    categories: _this.state.projectedColumns,
                    adjustedSize: adjustedSize
                });
            }
            return null;
        };
        _this.defaultORHTMLRule = function (_a) {
            var d = _a.d, i = _a.i, annotationLayer = _a.annotationLayer;
            var _b = _this.state, adjustedPosition = _b.adjustedPosition, adjustedSize = _b.adjustedSize, oAccessor = _b.oAccessor, rAccessor = _b.rAccessor, oScale = _b.oScale, rScale = _b.rScale, projectedColumns = _b.projectedColumns, summaryType = _b.summaryType, type = _b.type, pieceIDAccessor = _b.pieceIDAccessor, rScaleType = _b.rScaleType;
            var _c = _this.props, htmlAnnotationRules = _c.htmlAnnotationRules, tooltipContent = _c.tooltipContent, optimizeCustomTooltipPosition = _c.optimizeCustomTooltipPosition, projection = _c.projection; _c.size; var useSpans = _c.useSpans;
            var screenCoordinates = [0, 0];
            var voronoiHover = annotationLayer.voronoiHover;
            if (d.coordinates || (d.type === "enclose" && d.neighbors)) {
                screenCoordinates = (d.coordinates || d.neighbors).map(function (p) {
                    var pO = findFirstAccessorValue(oAccessor, p) || p.column;
                    var oColumn = projectedColumns[pO];
                    var idPiece = findIDPiece(pieceIDAccessor, oColumn, p);
                    return screenProject({
                        p: p,
                        adjustedSize: adjustedSize,
                        rScale: rScale,
                        rAccessor: rAccessor,
                        idPiece: idPiece,
                        projection: projection,
                        oColumn: oColumn,
                        rScaleType: rScaleType
                    });
                });
            }
            else if (d.type === "column-hover") {
                var _d = __read(getColumnScreenCoordinates({
                    d: d,
                    projectedColumns: projectedColumns,
                    oAccessor: oAccessor,
                    summaryType: summaryType,
                    type: type,
                    projection: projection,
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize
                }).coordinates, 2), xPosition = _d[0], yPosition = _d[1];
                screenCoordinates = [xPosition, yPosition];
            }
            else {
                var pO = findFirstAccessorValue(oAccessor, d) || d.column;
                var oColumn = projectedColumns[pO];
                var idPiece = findIDPiece(pieceIDAccessor, oColumn, d);
                screenCoordinates = screenProject({
                    p: d,
                    adjustedSize: adjustedSize,
                    rScale: rScale,
                    rAccessor: rAccessor,
                    idPiece: idPiece,
                    projection: projection,
                    oColumn: oColumn,
                    rScaleType: rScaleType
                });
            }
            var flippedRScale = projection === "vertical"
                ? rScaleType.domain(rScale.domain()).range(rScale.range().reverse())
                : rScale;
            //TODO: Process your rules first
            var customAnnotation = htmlAnnotationRules &&
                htmlAnnotationRules({
                    d: d,
                    i: i,
                    oScale: oScale,
                    rScale: flippedRScale,
                    oAccessor: oAccessor,
                    rAccessor: rAccessor,
                    orFrameProps: _this.props,
                    screenCoordinates: screenCoordinates,
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize,
                    annotationLayer: annotationLayer,
                    orFrameState: _this.state,
                    categories: _this.state.projectedColumns,
                    voronoiHover: voronoiHover
                });
            if (htmlAnnotationRules && customAnnotation !== null) {
                return customAnnotation;
            }
            if (d.type === "frame-hover") {
                return htmlFrameHoverRule$1({
                    d: d,
                    i: i,
                    rAccessor: rAccessor,
                    oAccessor: oAccessor,
                    projection: projection,
                    tooltipContent: tooltipContent,
                    optimizeCustomTooltipPosition: optimizeCustomTooltipPosition,
                    projectedColumns: projectedColumns,
                    useSpans: useSpans,
                    pieceIDAccessor: pieceIDAccessor,
                    adjustedSize: adjustedSize,
                    rScale: rScale,
                    type: type,
                    rScaleType: rScaleType
                });
            }
            else if (d.type === "column-hover") {
                return htmlColumnHoverRule({
                    d: d,
                    i: i,
                    summaryType: summaryType,
                    oAccessor: oAccessor,
                    projectedColumns: projectedColumns,
                    type: type,
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize,
                    projection: projection,
                    tooltipContent: tooltipContent,
                    optimizeCustomTooltipPosition: optimizeCustomTooltipPosition,
                    useSpans: useSpans
                });
            }
            return null;
        };
        var baseState = {
            adjustedPosition: [],
            adjustedSize: [],
            backgroundGraphics: undefined,
            foregroundGraphics: undefined,
            axisData: undefined,
            renderNumber: 0,
            oLabels: { labels: [] },
            oAccessor: stringToArrayFn("renderKey"),
            rAccessor: stringToArrayFn("value"),
            oScale: scaleBand(),
            rScale: scaleLinear(),
            axes: undefined,
            calculatedOExtent: [],
            calculatedRExtent: [0, 1],
            columnOverlays: [],
            dataVersion: undefined,
            legendSettings: undefined,
            margin: { top: 0, bottom: 0, left: 0, right: 0 },
            oExtent: [],
            oScaleType: scaleBand(),
            orFrameRender: {},
            pieceDataXY: [],
            pieceIDAccessor: stringToFn("semioticPieceID"),
            projectedColumns: {},
            rExtent: [],
            rScaleType: scaleLinear(),
            summaryType: { type: "none" },
            title: {},
            type: { type: "none" },
            props: props
        };
        _this.state = __assign(__assign({}, baseState), calculateOrdinalFrame(props, baseState));
        return _this;
    }
    OrdinalFrame.prototype.componentWillUnmount = function () {
        var onUnmount = this.props.onUnmount;
        if (onUnmount) {
            onUnmount(this.props, this.state);
        }
    };
    OrdinalFrame.getDerivedStateFromProps = function (nextProps, prevState) {
        var props = prevState.props;
        if ((prevState.dataVersion &&
            prevState.dataVersion !== nextProps.dataVersion) ||
            !prevState.projectedColumns ||
            props.size[0] !== nextProps.size[0] ||
            props.size[1] !== nextProps.size[1] ||
            (!prevState.dataVersion &&
                orFrameChangeProps.find(function (d) {
                    return props[d] !== nextProps[d];
                }))) {
            return __assign(__assign({}, calculateOrdinalFrame(nextProps, prevState)), { props: nextProps });
        }
        else {
            return { props: nextProps };
        }
    };
    OrdinalFrame.prototype.render = function () {
        var _a = this.props, className = _a.className, annotationSettings = _a.annotationSettings, annotations = _a.annotations, matte = _a.matte, renderKey = _a.renderKey, interaction = _a.interaction, customClickBehavior = _a.customClickBehavior, customHoverBehavior = _a.customHoverBehavior, customDoubleClickBehavior = _a.customDoubleClickBehavior, projection = _a.projection, backgroundGraphics = _a.backgroundGraphics, foregroundGraphics = _a.foregroundGraphics, afterElements = _a.afterElements, beforeElements = _a.beforeElements, disableContext = _a.disableContext, summaryType = _a.summaryType, summaryHoverAnnotation = _a.summaryHoverAnnotation, pieceHoverAnnotation = _a.pieceHoverAnnotation, hoverAnnotation = _a.hoverAnnotation, canvasPostProcess = _a.canvasPostProcess, baseMarkProps = _a.baseMarkProps, useSpans = _a.useSpans, canvasPieces = _a.canvasPieces, canvasSummaries = _a.canvasSummaries, canvasConnectors = _a.canvasConnectors, renderOrder = _a.renderOrder, additionalDefs = _a.additionalDefs, sketchyRenderingEngine = _a.sketchyRenderingEngine, frameRenderOrder = _a.frameRenderOrder, disableCanvasInteraction = _a.disableCanvasInteraction, disableProgressiveRendering = _a.disableProgressiveRendering;
        var _b = this.state, orFrameRender = _b.orFrameRender, projectedColumns = _b.projectedColumns, adjustedPosition = _b.adjustedPosition, adjustedSize = _b.adjustedSize, legendSettings = _b.legendSettings, columnOverlays = _b.columnOverlays, axesTickLines = _b.axesTickLines, axes = _b.axes, margin = _b.margin, pieceDataXY = _b.pieceDataXY, oLabels = _b.oLabels, title = _b.title;
        var size = [
            adjustedSize[0] + margin.left + margin.right,
            adjustedSize[1] + margin.top + margin.bottom
        ];
        var interactionOverflow;
        if (summaryType && summaryType.amplitude) {
            if (projection === "horizontal") {
                interactionOverflow = {
                    top: summaryType.amplitude,
                    bottom: 0,
                    left: 0,
                    right: 0
                };
            }
            else if (projection === "radial") {
                interactionOverflow = defaultOverflow;
            }
            else {
                interactionOverflow = {
                    top: 0,
                    bottom: 0,
                    left: summaryType.amplitude,
                    right: 0
                };
            }
        }
        var renderedForegroundGraphics = typeof foregroundGraphics === "function"
            ? foregroundGraphics({ size: size, margin: margin })
            : foregroundGraphics;
        return (React.createElement(Frame, { name: "ordinalframe", renderPipeline: orFrameRender, adjustedPosition: adjustedPosition, adjustedSize: adjustedSize, size: size, xScale: xScale$1, yScale: yScale$1, axes: axes, useSpans: useSpans, axesTickLines: axesTickLines, title: title, matte: matte, additionalDefs: additionalDefs, className: className + " " + projection, frameKey: "none", renderFn: renderKey, projectedCoordinateNames: projectedCoordinatesObject, defaultSVGRule: this.defaultORSVGRule.bind(this), defaultHTMLRule: this.defaultORHTMLRule.bind(this), hoverAnnotation: summaryHoverAnnotation || pieceHoverAnnotation || hoverAnnotation, annotations: annotations, annotationSettings: annotationSettings, legendSettings: legendSettings, interaction: interaction && __assign(__assign({}, interaction), { brush: interaction.columnsBrush !== true && "oBrush", projection: projection,
                projectedColumns: projectedColumns }), customClickBehavior: customClickBehavior, customHoverBehavior: customHoverBehavior, customDoubleClickBehavior: customDoubleClickBehavior, points: pieceDataXY, margin: margin, columns: projectedColumns, backgroundGraphics: backgroundGraphics, foregroundGraphics: renderedForegroundGraphics, beforeElements: beforeElements, afterElements: afterElements, overlay: columnOverlays, rScale: this.state.rScale, projection: projection, disableContext: disableContext, interactionOverflow: interactionOverflow, canvasPostProcess: canvasPostProcess, baseMarkProps: baseMarkProps, canvasRendering: !!(canvasPieces || canvasSummaries || canvasConnectors), renderOrder: renderOrder, disableCanvasInteraction: disableCanvasInteraction, sketchyRenderingEngine: sketchyRenderingEngine, frameRenderOrder: frameRenderOrder, additionalVizElements: oLabels, disableProgressiveRendering: disableProgressiveRendering }));
    };
    OrdinalFrame.defaultProps = {
        annotations: [],
        foregroundGraphics: [],
        annotationSettings: {},
        projection: "vertical",
        size: [500, 500],
        className: "",
        data: [],
        oScaleType: scaleBand,
        rScaleType: scaleLinear,
        type: "none",
        summaryType: "none",
        useSpans: false,
        optimizeCustomTooltipPosition: false
    };
    OrdinalFrame.displayName = "OrdinalFrame";
    return OrdinalFrame;
}(React.Component));

var MiniMap = function (props) {
    var brushStart = props.brushStart, brush = props.brush, brushEnd = props.brushEnd, xBrushable = props.xBrushable, yBrushable = props.yBrushable, yBrushExtent = props.yBrushExtent, xBrushExtent = props.xBrushExtent, rest = __rest(props, ["brushStart", "brush", "brushEnd", "xBrushable", "yBrushable", "yBrushExtent", "xBrushExtent"]);
    var interactivity = {
        start: brushStart,
        during: brush,
        end: brushEnd
    };
    if (xBrushable && yBrushable) {
        interactivity.brush = "xyBrush";
        if (xBrushExtent || yBrushExtent) {
            interactivity.extent = [[0, 0], __spread(props.size)];
        }
        if (xBrushExtent) {
            interactivity.extent[0] = xBrushExtent;
        }
        if (yBrushExtent) {
            interactivity.extent[1] = yBrushExtent;
        }
    }
    else if (xBrushable) {
        interactivity.brush = "xBrush";
        if (xBrushExtent) {
            interactivity.extent = xBrushExtent;
        }
    }
    else if (yBrushable) {
        interactivity.brush = "yBrush";
        if (yBrushExtent) {
            interactivity.extent = yBrushExtent;
        }
    }
    return React.createElement(XYFrame, __assign({}, rest, { interaction: interactivity }));
};

var generateMinimap = function (props) {
    var xAccessor = props.xAccessor, yAccessor = props.yAccessor, points = props.points, lines = props.lines, minimap = props.minimap, summaries = props.summaries, size = props.size, lineDataAccessor = props.lineDataAccessor, lineType = props.lineType, lineStyle = props.lineStyle, summaryStyle = props.summaryStyle, pointStyle = props.pointStyle, lineClass = props.lineClass, summaryClass = props.summaryClass, pointClass = props.pointClass, lineRenderMode = props.lineRenderMode, pointRenderMode = props.pointRenderMode, summaryRenderMode = props.summaryRenderMode, canvasLines = props.canvasLines, canvasPoints = props.canvasPoints, canvasSummaries = props.canvasSummaries, axes = props.axes, margin = props.margin, useSpans = props.useSpans, name = props.name, annotations = props.annotations, summaryType = props.summaryType, interactionSettings = props.interactionSettings;
    var miniDefaults = {
        position: [0, 0],
        size: [size[0], size[1] * 0.25],
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        points: points,
        lines: lines,
        summaries: summaries,
        lineDataAccessor: lineDataAccessor,
        xBrushable: true,
        yBrushable: true,
        brushStart: function () { },
        brush: function () { },
        brushEnd: function () { },
        lineType: lineType,
        lineStyle: lineStyle,
        summaryStyle: summaryStyle,
        pointStyle: pointStyle,
        lineClass: lineClass,
        summaryClass: summaryClass,
        pointClass: pointClass,
        lineRenderMode: lineRenderMode,
        pointRenderMode: pointRenderMode,
        summaryRenderMode: summaryRenderMode,
        canvasLines: canvasLines,
        canvasPoints: canvasPoints,
        canvasSummaries: canvasSummaries,
        axes: axes,
        margin: margin,
        useSpans: useSpans,
        name: name,
        annotations: annotations,
        summaryType: summaryType,
        interactionSettings: interactionSettings
    };
    var combinedOptions = __assign(__assign(__assign({}, miniDefaults), minimap), { hoverAnnotation: false });
    return React.createElement(MiniMap, __assign({}, combinedOptions));
};
function MinimapXYFrame(props) {
    var miniMap = generateMinimap(props);
    var options = {};
    props.minimap; var renderBefore = props.renderBefore, rest = __rest(props, ["minimap", "renderBefore"]);
    if (renderBefore) {
        options.beforeElements = miniMap;
    }
    else {
        options.afterElements = miniMap;
    }
    return React.createElement(XYFrame, __assign({}, rest, options));
}

var htmlFrameHoverRule = function (_a) {
    var baseD = _a.d, i = _a.i, tooltipContent = _a.tooltipContent, optimizeCustomTooltipPosition = _a.optimizeCustomTooltipPosition, useSpans = _a.useSpans, nodes = _a.nodes, edges = _a.edges, nodeIDAccessor = _a.nodeIDAccessor;
    var d = baseD.x !== undefined && baseD.y !== undefined
        ? baseD
        : baseD.edge
            ? __assign(__assign({}, (edges.find(function (p) {
                return nodeIDAccessor(p.source) === nodeIDAccessor(baseD.source) &&
                    nodeIDAccessor(p.target) === nodeIDAccessor(baseD.target);
            }) || {})), baseD) : nodes.find(function (p) { return nodeIDAccessor(p) === baseD.id; });
    if (!d)
        return null;
    var content = d.edge ? (React.createElement(SpanOrDiv, { span: useSpans, className: "tooltip-content" },
        React.createElement("p", { key: "html-annotation-content-1" },
            (d.source || d.edge.source).id,
            " to ",
            (d.target || d.edge.target).id))) : (React.createElement(SpanOrDiv, { span: useSpans, className: "tooltip-content" },
        React.createElement("p", { key: "html-annotation-content-1" }, d.id),
        React.createElement("p", { key: "html-annotation-content-2" },
            "Degree: ",
            d.degree)));
    if (d.type === "frame-hover" && tooltipContent) {
        content = optimizeCustomTooltipPosition ? (React.createElement(TooltipPositioner, { tooltipContent: tooltipContent, tooltipContentArgs: d })) : (tooltipContent(d));
    }
    return (React.createElement(SpanOrDiv, { span: useSpans, key: "network-annotation-label-" + i, className: "annotation annotation-network-label " + (d.className || ""), style: {
            position: "absolute",
            top: d.y + "px",
            left: d.x + "px"
        } }, content));
};
var svgNodeRule = function (_a) {
    var d = _a.d, i = _a.i, nodeSizeAccessor = _a.nodeSizeAccessor;
    if (!d) {
        return null;
    }
    var noteData = Object.assign({
        dx: d.dx || -25,
        dy: d.dy || -25,
        x: d.x,
        y: d.y,
        note: { label: d.label, orientation: d.orientation, align: d.align },
        connector: { end: "arrow" }
    }, d, {
        type: AnnotationCalloutCircle,
        subject: {
            radius: d.radius || d.radius || nodeSizeAccessor(d)
        }
    });
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var svgReactAnnotationRule = function (_a) {
    var d = _a.d, i = _a.i, projectedNodes = _a.projectedNodes, nodeIDAccessor = _a.nodeIDAccessor;
    var selectedNode = d.x !== undefined && d.y !== undefined
        ? d
        : projectedNodes.find(function (p) { return nodeIDAccessor(p) === d.id; });
    if (!selectedNode) {
        return null;
    }
    var noteData = Object.assign({
        dx: 0,
        dy: 0,
        x: selectedNode.x,
        y: selectedNode.y,
        note: { label: d.label },
        connector: { end: "arrow" }
    }, d, { type: typeof d.type === "function" ? d.type : undefined });
    return React.createElement(SemioticAnnotation, { key: d.key || "annotation-" + i, noteData: noteData });
};
var svgEncloseRule = function (_a) {
    var d = _a.d, i = _a.i, projectedNodes = _a.projectedNodes, nodeIDAccessor = _a.nodeIDAccessor, nodeSizeAccessor = _a.nodeSizeAccessor;
    var selectedNodes = projectedNodes.filter(function (p) { return d.ids.indexOf(nodeIDAccessor(p)) !== -1; });
    if (selectedNodes.length === 0) {
        return null;
    }
    var circle = packEnclose(selectedNodes.map(function (p) { return ({ x: p.x, y: p.y, r: nodeSizeAccessor(p) }); }));
    return circleEnclosure({ circle: circle, d: d, i: i });
};
var svgRectEncloseRule = function (_a) {
    var d = _a.d, i = _a.i, projectedNodes = _a.projectedNodes, nodeIDAccessor = _a.nodeIDAccessor, nodeSizeAccessor = _a.nodeSizeAccessor;
    var selectedNodes = projectedNodes.filter(function (p) { return d.ids.indexOf(nodeIDAccessor(p)) !== -1; });
    if (selectedNodes.length === 0) {
        return null;
    }
    var bboxNodes = selectedNodes.map(function (p) {
        if (p.shapeNode) {
            return {
                x0: p.x0,
                x1: p.x1,
                y0: p.y0,
                y1: p.y1
            };
        }
        var nodeSize = nodeSizeAccessor(p);
        return {
            x0: p.x - nodeSize,
            x1: p.x + nodeSize,
            y0: p.y - nodeSize,
            y1: p.y + nodeSize
        };
    });
    return rectangleEnclosure({ bboxNodes: bboxNodes, d: d, i: i });
};
var svgHullEncloseRule = function (_a) {
    var d = _a.d, i = _a.i, projectedNodes = _a.projectedNodes, nodeIDAccessor = _a.nodeIDAccessor, nodeSizeAccessor = _a.nodeSizeAccessor;
    var selectedNodes = projectedNodes.filter(function (p) { return d.ids.indexOf(nodeIDAccessor(p)) !== -1; });
    if (selectedNodes.length === 0) {
        return null;
    }
    var projectedPoints = [];
    selectedNodes.forEach(function (p) {
        if (p.shapeNode) {
            projectedPoints.push({ x: p.x0, y: p.y0 });
            projectedPoints.push({ x: p.x0, y: p.y1 });
            projectedPoints.push({ x: p.x1, y: p.y0 });
            projectedPoints.push({ x: p.x1, y: p.y1 });
        }
        else {
            var nodeSize = nodeSizeAccessor(p);
            projectedPoints.push({ x: p.x - nodeSize, y: p.y - nodeSize });
            projectedPoints.push({ x: p.x + nodeSize, y: p.y - nodeSize });
            projectedPoints.push({ x: p.x - nodeSize, y: p.y + nodeSize });
            projectedPoints.push({ x: p.x + nodeSize, y: p.y + nodeSize });
        }
    });
    return hullEnclosure({ points: projectedPoints.map(function (d) { return [d.x, d.y]; }), d: d, i: i });
};
var svgHighlightRule = function (_a) {
    var d = _a.d, i = _a.i, networkFrameRender = _a.networkFrameRender;
    var nodes = networkFrameRender.nodes;
    var customMark = nodes.customMark, baseStyle = nodes.styleFn;
    var styleFn = baseStyle;
    if (d.style && typeof d.style === "function") {
        styleFn = function (d) { return (__assign(__assign({}, baseStyle(d)), d.style(d))); };
    }
    else if (d.style) {
        styleFn = function (d) { return (__assign(__assign({}, baseStyle(d)), d.style)); };
    }
    var transform = "translate(" + d.x + "," + d.y + ")";
    var baseMarkProps = { forceUpdate: true };
    var HighlightMark = customMark({
        d: d,
        styleFn: styleFn,
        transform: transform,
        baseMarkProps: baseMarkProps,
        key: "highlight-" + i
    });
    return HighlightMark;
};

var horizontalDagreLineGenerator = line()
    .curve(curveMonotoneX)
    .x(function (d) { return d.x; })
    .y(function (d) { return d.y; });
var verticalDagreLineGenerator = line()
    .curve(curveMonotoneY)
    .x(function (d) { return d.x; })
    .y(function (d) { return d.y; });
function sankeyEdgeSort(a, b, direction) {
    if (a.circular && !b.circular)
        return -1;
    if (b.circular && !a.circular)
        return 1;
    var first = direction === "down" ? "y" : "x";
    var second = direction === "down" ? "x" : "y";
    return a.source[first] === b.source[first]
        ? a.sankeyWidth === b.sankeyWidth
            ? a.source[second] - b.source[second]
            : b.sankeyWidth - a.sankeyWidth
        : a.source[first] - b.source[first];
}
var sigmoidLinks = {
    horizontal: linkHorizontal()
        .x(function (d) { return d.x; })
        .y(function (d) { return d.y; }),
    vertical: linkVertical()
        .x(function (d) { return d.x; })
        .y(function (d) { return d.y; }),
    radial: d.lineArc
};
var customEdgeHashD = {
    curve: function (d, projection) {
        if (projection === void 0) { projection = "vertical"; }
        return sigmoidLinks[projection](d);
    },
    linearc: function (d$1) { return d.lineArc(d$1); },
    ribbon: function (d$1) { return d.ribbon(d$1, d$1.width); },
    arrowhead: function (d$1) {
        return d.arrowHead(d$1, d$1.target.nodeSize, d$1.width, d$1.width * 1.5);
    },
    halfarrow: function (d$1) {
        return d.halfArrow(d$1, d$1.target.nodeSize, d$1.width, d$1.width * 1.5);
    },
    nail: function (d$1) { return d.nail(d$1, d$1.source.nodeSize); },
    comet: function (d$1) { return d.comet(d$1, d$1.target.nodeSize); },
    taffy: function (d$1) {
        return d.taffy(d$1, d$1.source.nodeSize / 2, d$1.target.nodeSize / 2, (d$1.source.nodeSize + d$1.target.nodeSize) / 4);
    }
};
var circleNodeGenerator = function (_a) {
    //this is repetitious
    var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, transform = _a.transform, baseMarkProps = _a.baseMarkProps;
    return (React.createElement(Mark, __assign({}, baseMarkProps, { key: key, transform: transform, markType: "rect", width: d.nodeSize * 2, height: d.nodeSize * 2, ry: d.nodeSize * 2, rx: d.nodeSize * 2, x: -d.nodeSize, y: -d.nodeSize, style: styleFn(d, i), renderMode: renderMode ? renderMode(d, i) : undefined, className: className, "aria-label": "Node " + d.id, tabIndex: -1 })));
};
var matrixEdgeGenerator = function (size, nodes) {
    return function (_a) {
        var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, baseMarkProps = _a.baseMarkProps;
        var gridSize = Math.min.apply(Math, __spread(size)) / nodes.length;
        return (React.createElement("g", { key: key },
            React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode ? renderMode(d, i) : undefined, key: key, className: className, simpleInterpolate: true, transform: "translate(" + d.source.y + "," + d.target.y + ")", markType: "rect", x: -gridSize / 2, y: -gridSize / 2, width: gridSize, height: gridSize, style: styleFn(d, i), "aria-label": "Connection from " + d.source.id + " to " + d.target.id, tabIndex: -1 }))));
    };
};
var arcEdgeGenerator = function (size) {
    var yAdjust = size[1] / size[0];
    function arcDiagramArc(d) {
        var draw = line().curve(curveBasis);
        var midX = (d.source.x + d.target.x) / 2;
        var midY = d.source.x - d.target.x;
        return draw([
            [d.source.x, 0],
            [midX, midY * yAdjust],
            [d.target.x, 0]
        ]);
    }
    return function (_a) {
        var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, baseMarkProps = _a.baseMarkProps;
        return (React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode ? renderMode(d, i) : undefined, key: key, className: className, simpleInterpolate: true, markType: "path", transform: "translate(0," + size[1] / 2 + ")", d: arcDiagramArc(d), style: styleFn(d, i), "aria-label": "Connection from " + d.source.id + " to " + d.target.id, tabIndex: -1 })));
    };
};
var chordEdgeGenerator = function (size) {
    return function (_a) {
        var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, baseMarkProps = _a.baseMarkProps;
        return (React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode ? renderMode(d, i) : undefined, key: key, className: className, simpleInterpolate: true, transform: "translate(" + size[0] / 2 + "," + size[1] / 2 + ")", markType: "path", d: d.d, style: styleFn(d, i), "aria-label": "Connection from " + d.source.id + " to " + d.target.id, tabIndex: -1 })));
    };
};
var dagreEdgeGenerator = function (direction) {
    var dagreLineGenerator = direction === "LR" || direction === "RL"
        ? horizontalDagreLineGenerator
        : verticalDagreLineGenerator;
    return function (_a) {
        var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, baseMarkProps = _a.baseMarkProps;
        if (d.ribbon || d.parallelEdges) {
            var ribbonGenerator = linearRibbon();
            ribbonGenerator.x(function (p) { return p.x; });
            ribbonGenerator.y(function (p) { return p.y; });
            ribbonGenerator.r(function () { return d.weight || 1; });
            if (d.parallelEdges) {
                var sortedParallelEdges_1 = d.parallelEdges.sort(function (a, b) { return b.weight - a.weight; });
                return (React.createElement("g", { key: "" + key }, ribbonGenerator({
                    points: d.points,
                    multiple: d.parallelEdges
                }).map(function (ribbonD, ribbonI) { return (React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode ? renderMode(d, i) : undefined, key: key + "-" + ribbonI, className: className, simpleInterpolate: true, markType: "path", d: ribbonD, style: styleFn(sortedParallelEdges_1[ribbonI], i), "aria-label": "Connection from " + d.source.id + " to " + d.target.id, tabIndex: -1 }))); })));
            }
            return (React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode ? renderMode(d, i) : undefined, key: key, className: className, simpleInterpolate: true, markType: "path", d: ribbonGenerator(d.points), style: styleFn(d, i), "aria-label": "Connection from " + d.source.id + " to " + d.target.id, tabIndex: -1 })));
        }
        return (React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode ? renderMode(d, i) : undefined, key: key, className: className, simpleInterpolate: true, markType: "path", d: dagreLineGenerator(d.points), style: styleFn(d, i), "aria-label": "Connection from " + d.source.id + " to " + d.target.id, tabIndex: -1 })));
    };
};
var sankeyNodeGenerator = function (_a) {
    var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, transform = _a.transform, baseMarkProps = _a.baseMarkProps;
    var height = d.direction !== "down" ? d.height : d.width;
    var width = d.direction !== "down" ? d.width : d.height;
    if (!d) {
        return React.createElement("g", null);
    }
    return (React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode ? renderMode(d, i) : undefined, key: key, className: className, transform: transform, markType: "rect", height: height, width: width, x: -width / 2, y: -height / 2, rx: 0, ry: 0, style: styleFn(d), "aria-label": "Node " + d.id, tabIndex: -1 })));
};
var chordNodeGenerator = function (size) {
    return function (_a) {
        var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, baseMarkProps = _a.baseMarkProps;
        if (!d) {
            return React.createElement("g", null);
        }
        return (React.createElement(Mark, __assign({}, baseMarkProps, { renderMode: renderMode ? renderMode(d, i) : undefined, key: key, className: className, transform: "translate(" + size[0] / 2 + "," + size[1] / 2 + ")", markType: "path", d: d.d, style: styleFn(d, i), "aria-label": "Node " + d.id, tabIndex: -1 })));
    };
};
var matrixNodeGenerator = function (size, nodes) {
    var gridSize = Math.min.apply(Math, __spread(size));
    var stepSize = gridSize / (nodes.length + 1);
    return function (_a) {
        var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, baseMarkProps = _a.baseMarkProps;
        if (!d) {
            return React.createElement("g", null);
        }
        var showText = stepSize > 6;
        var showLine = stepSize > 3;
        var showRect = stepSize > 0.5;
        var textProps = {
            textAnchor: "end",
            fontSize: stepSize / 2 + "px"
        };
        var style = styleFn(d, i);
        var renderModeValue = renderMode ? renderMode(d, i) : undefined;
        return (React.createElement("g", { key: key, className: className },
            showRect && (React.createElement(Mark, { markType: "rect", x: stepSize / 2, y: d.y - stepSize / 2, width: gridSize - stepSize, height: stepSize, style: __assign(__assign({}, style), { stroke: "none" }), renderMode: renderModeValue, forceUpdate: true, baseMarkProps: baseMarkProps })),
            showRect && (React.createElement(Mark, { markType: "rect", y: stepSize / 2, x: d.y - stepSize / 2, height: gridSize - stepSize, width: stepSize, style: __assign(__assign({}, style), { stroke: "none" }), renderMode: renderModeValue, forceUpdate: true, baseMarkProps: baseMarkProps })),
            showLine && (React.createElement(Mark, { markType: "line", stroke: "black", x1: 0, x2: gridSize - stepSize / 2, y1: d.y - stepSize / 2, y2: d.y - stepSize / 2, style: style, renderMode: renderModeValue, forceUpdate: true, baseMarkProps: baseMarkProps })),
            showLine && (React.createElement(Mark, { markType: "line", stroke: "black", y1: 0, y2: gridSize - stepSize / 2, x1: d.y - stepSize / 2, x2: d.y - stepSize / 2, style: style, renderMode: renderModeValue, forceUpdate: true, baseMarkProps: baseMarkProps })),
            showLine && i === nodes.length - 1 && (React.createElement(Mark, { markType: "line", stroke: "black", x1: 0, x2: gridSize - stepSize / 2, y1: d.y + stepSize / 2, y2: d.y + stepSize / 2, style: style, renderMode: renderModeValue, forceUpdate: true, baseMarkProps: baseMarkProps })),
            showLine && i === nodes.length - 1 && (React.createElement(Mark, { markType: "line", stroke: "black", y1: 0, y2: gridSize - stepSize / 2, x1: d.y + stepSize / 2, x2: d.y + stepSize / 2, style: style, renderMode: renderModeValue, forceUpdate: true, baseMarkProps: baseMarkProps })),
            showText && (React.createElement("text", __assign({ x: 0, y: d.y + stepSize / 5 }, textProps), d.id)),
            showText && (React.createElement("text", __assign({ transform: "translate(" + d.y + ") rotate(90) translate(0," + stepSize / 5 + ")" }, textProps, { y: 0 }), d.id))));
    };
};
var radialRectNodeGenerator = function (size, center, type) {
    var radialArc = arc();
    var _a = type.angleRange, angleRange = _a === void 0 ? [0, 360] : _a;
    var rangePct = angleRange.map(function (d) { return d / 360; });
    var rangeMod = rangePct[1] - rangePct[0];
    var adjustedPct = rangeMod < 1 ? scaleLinear().domain([0, 1]).range(rangePct) : function (d) { return d; };
    return function (_a) {
        var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, baseMarkProps = _a.baseMarkProps;
        if (!d) {
            return React.createElement("g", null);
        }
        radialArc.innerRadius(d.y0 / 2).outerRadius(d.y1 / 2);
        return (React.createElement(Mark, __assign({}, baseMarkProps, { key: key, transform: "translate(" + center + ")", markType: "path", d: radialArc({
                startAngle: adjustedPct(d.x0 / size[0]) * Math.PI * 2,
                endAngle: adjustedPct(d.x1 / size[0]) * Math.PI * 2
            }), customTween: {
                fn: arcTweener,
                props: {
                    startAngle: adjustedPct(d.x0 / size[0]) * Math.PI * 2,
                    endAngle: adjustedPct(d.x1 / size[0]) * Math.PI * 2,
                    innerRadius: d.y0 / 2,
                    outerRadius: d.y1 / 2
                }
            }, style: styleFn(d, i), renderMode: renderMode ? renderMode(d, i) : undefined, className: className, "aria-label": "Node " + d.id, tabIndex: -1 })));
    };
};
var radialLabelGenerator = function (node, nodei, nodeIDAccessor, size) {
    var anglePct = (node.x1 + node.x0) / 2 / size[0];
    var nodeLabel = nodeIDAccessor(node, nodei);
    var labelRotate = anglePct > 0.5 ? anglePct * 360 + 90 : anglePct * 360 - 90;
    return (React.createElement("g", { transform: "rotate(" + labelRotate + ")" }, typeof nodeLabel === "string" ? (React.createElement("text", { textAnchor: "middle", y: 5 }, nodeLabel)) : (nodeLabel)));
};
var hierarchicalRectNodeGenerator = function (_a) {
    var d = _a.d, i = _a.i, styleFn = _a.styleFn, renderMode = _a.renderMode, key = _a.key, className = _a.className, baseMarkProps = _a.baseMarkProps;
    if (!d) {
        return React.createElement("g", null);
    }
    //this is repetitious
    return (React.createElement(Mark, __assign({}, baseMarkProps, { key: key, transform: "translate(0,0)", markType: "rect", width: d.x1 - d.x0, height: d.y1 - d.y0, x: d.x0, y: d.y0, rx: 0, ry: 0, style: styleFn(d, i), renderMode: renderMode ? renderMode(d, i) : undefined, className: className, "aria-label": "Node " + d.id, tabIndex: -1 })));
};
var genericLineGenerator = function (d) {
    return "M" + d.source.x + "," + d.source.y + "L" + d.target.x + "," + d.target.y;
};
var drawNodes = function (_a) {
    var data = _a.data, renderKeyFn = _a.renderKeyFn, customMark = _a.customMark, styleFn = _a.styleFn, classFn = _a.classFn, renderMode = _a.renderMode, canvasDrawing = _a.canvasDrawing, canvasRenderFn = _a.canvasRenderFn, baseMarkProps = _a.baseMarkProps;
    var markGenerator = customMark;
    var renderedData = [];
    if (customMark && canvasRenderFn) {
        console.error("canvas rendering currently only supports generic circle nodes based on nodeSize");
    }
    data.forEach(function (d, i) {
        if (canvasRenderFn && canvasRenderFn(d, i) === true) {
            var canvasNode = {
                baseClass: "frame-piece",
                tx: d.x,
                ty: d.y,
                d: d,
                i: i,
                markProps: { markType: "circle", r: d.nodeSize },
                styleFn: styleFn,
                renderFn: renderMode,
                classFn: classFn
            };
            canvasDrawing.push(canvasNode);
        }
        else {
            // CUSTOM MARK IMPLEMENTATION
            renderedData.push(markGenerator({
                d: d,
                i: i,
                renderKeyFn: renderKeyFn,
                styleFn: styleFn,
                classFn: classFn,
                renderMode: renderMode,
                key: renderKeyFn ? renderKeyFn(d, i) : d.id || "node-" + i,
                className: "node " + classFn(d, i),
                transform: "translate(" + d.x + "," + d.y + ")",
                baseMarkProps: baseMarkProps
            }));
        }
    });
    return renderedData;
};
var drawEdges = function (_a) {
    var baseData = _a.data, renderKeyFn = _a.renderKeyFn, customMark = _a.customMark, styleFn = _a.styleFn, classFn = _a.classFn, renderMode = _a.renderMode, canvasRenderFn = _a.canvasRenderFn, canvasDrawing = _a.canvasDrawing, type = _a.type, baseMarkProps = _a.baseMarkProps, networkSettings = _a.networkSettings, projection = _a.projection;
    var networkType = networkSettings.type, direction = networkSettings.direction, _b = networkSettings.edgeSort, edgeSort = _b === void 0 ? sankeyEdgeSort : _b;
    var data = networkType === "sankey"
        ? baseData.sort(function (a, b) { return edgeSort(a, b, direction); })
        : baseData;
    var dGenerator = genericLineGenerator;
    var renderedData = [];
    if (customMark) {
        // CUSTOM MARK IMPLEMENTATION
        data.forEach(function (d, i) {
            var renderedCustomMark = customMark({
                d: d,
                i: i,
                renderKeyFn: renderKeyFn,
                styleFn: styleFn,
                classFn: classFn,
                renderMode: renderMode,
                key: renderKeyFn ? renderKeyFn(d, i) : "edge-" + i,
                className: classFn(d, i) + " edge",
                transform: "translate(" + d.x + "," + d.y + ")",
                baseMarkProps: baseMarkProps
            });
            if (renderedCustomMark &&
                renderedCustomMark.props &&
                (renderedCustomMark.props.markType !== "path" ||
                    renderedCustomMark.props.d)) {
                renderedData.push(renderedCustomMark);
            }
        });
    }
    else {
        if (type) {
            if (typeof type === "function") {
                dGenerator = type;
            }
            else if (customEdgeHashD[type]) {
                dGenerator = function (d) { return customEdgeHashD[type](d, projection); };
            }
        }
        data.forEach(function (d, i) {
            var renderedD = dGenerator(d);
            if (renderedD && canvasRenderFn && canvasRenderFn(d, i) === true) {
                var canvasEdge = {
                    baseClass: "frame-piece",
                    tx: d.x,
                    ty: d.y,
                    d: d,
                    i: i,
                    markProps: { markType: "path", d: renderedD },
                    styleFn: styleFn,
                    renderFn: renderMode,
                    classFn: classFn
                };
                canvasDrawing.push(canvasEdge);
            }
            else if (renderedD) {
                renderedData.push(React.createElement(Mark, __assign({}, baseMarkProps, { key: renderKeyFn ? renderKeyFn(d, i) : "edge-" + i, markType: "path", renderMode: renderMode ? renderMode(d, i) : undefined, className: classFn(d) + " edge", d: renderedD, style: styleFn(d, i), tabIndex: -1, role: "img", "aria-label": "connection from " + d.source.id + " to " + d.target.id })));
            }
        });
    }
    return renderedData;
};
function topologicalSort(nodesArray, edgesArray) {
    // adapted from https://simplapi.wordpress.com/2015/08/19/detect-graph-cycle-in-javascript/
    var nodes = [];
    var nodeHash = {};
    edgesArray.forEach(function (edge) {
        if (!edge.source.id || !edge.target.id) {
            return false;
        }
        if (!nodeHash[edge.source.id]) {
            nodeHash[edge.source.id] = { _id: edge.source.id, links: [] };
            nodes.push(nodeHash[edge.source.id]);
        }
        if (!nodeHash[edge.target.id]) {
            nodeHash[edge.target.id] = { _id: edge.target.id, links: [] };
            nodes.push(nodeHash[edge.target.id]);
        }
        nodeHash[edge.source.id].links.push(edge.target.id);
    });
    // Test if a node got any icoming edge
    function hasIncomingEdge(list, node) {
        for (var i = 0, l = list.length; i < l; ++i) {
            if (list[i].links.indexOf(node._id) !== -1) {
                return true;
            }
        }
        return false;
    }
    // Kahn Algorithm
    var L = [], S = nodes.filter(function (node) { return !hasIncomingEdge(nodes, node); });
    var n = null;
    while (S.length) {
        // Remove a node n from S
        n = S.pop();
        // Add n to tail of L
        L.push(n);
        var i = n.links.length;
        while (i--) {
            // Getting the node associated to the current stored id in links
            var m = nodes[nodes.map(function (d) { return d._id; }).indexOf(n.links[i])];
            // Remove edge e from the graph
            n.links.pop();
            if (!hasIncomingEdge(nodes, m)) {
                S.push(m);
            }
        }
    }
    // If any of them still got links, there is cycle somewhere
    var nodeWithEdge = nodes.find(function (node) { return node.links.length !== 0; });
    return nodeWithEdge ? null : L;
}
var curvature = 0.5;
var ribbonLink = function (d) {
    var diff = d.direction === "down"
        ? Math.abs(d.target.y - d.source.y)
        : Math.abs(d.source.x - d.target.x);
    // const halfWidth = d.width / 2
    var testCoordinates = d.direction === "down"
        ? [
            {
                x: d.y0,
                y: d.source.y
            },
            {
                x: d.y0,
                y: d.source.y + diff / 3
            },
            {
                x: d.y1,
                y: d.target.y - diff / 3
            },
            {
                x: d.y1,
                y: d.target.y
            }
        ]
        : [
            {
                x: d.source.x0,
                y: d.y0
            },
            {
                x: d.source.x0 + diff / 3,
                y: d.y0
            },
            {
                x: d.target.x0 - diff / 3,
                y: d.y1
            },
            {
                x: d.target.x0,
                y: d.y1
            }
        ];
    var linkGenerator = linearRibbon();
    linkGenerator.x(function (d) { return d.x; });
    linkGenerator.y(function (d) { return d.y; });
    linkGenerator.r(function () { return d.sankeyWidth / 2; });
    return linkGenerator(testCoordinates);
};
var areaLink = function (d) {
    var x0, x1, x2, x3, y0, y1, xi, y2, y3;
    if (d.direction === "down") {
        x0 = d.y0 - d.sankeyWidth / 2;
        x1 = d.y1 - d.sankeyWidth / 2;
        x2 = d.y1 + d.sankeyWidth / 2;
        x3 = d.y0 + d.sankeyWidth / 2;
        y0 = d.source.y1;
        y1 = d.target.y0;
        xi = interpolateNumber(y0, y1);
        y2 = xi(curvature);
        y3 = xi(1 - curvature);
        return "M" + x0 + "," + y0 + "C" + x0 + "," + y2 + " " + x1 + "," + y3 + " " + x1 + "," + y1 + "L" + x2 + "," + y1 + "C" + x2 + "," + y3 + " " + x3 + "," + y2 + " " + x3 + "," + y0 + "Z";
    }
    (x0 = d.source.x1), // eslint-disable-line no-sequences
        (x1 = d.target.x0),
        (xi = interpolateNumber(x0, x1)),
        (x2 = xi(curvature)),
        (x3 = xi(1 - curvature)),
        (y0 = d.y0 - d.sankeyWidth / 2),
        (y1 = d.y1 - d.sankeyWidth / 2),
        (y2 = d.y1 + d.sankeyWidth / 2),
        (y3 = d.y0 + d.sankeyWidth / 2);
    return "M" + x0 + "," + y0 + "C" + x2 + "," + y0 + " " + x3 + "," + y1 + " " + x1 + "," + y1 + "L" + x1 + "," + y2 + "C" + x3 + "," + y2 + " " + x2 + "," + y3 + " " + x0 + "," + y3 + "Z";
};
function circularAreaLink(link) {
    var linkGenerator = linearRibbon();
    linkGenerator.x(function (d) { return d.x; });
    linkGenerator.y(function (d) { return d.y; });
    linkGenerator.r(function () { return link.sankeyWidth / 2; });
    var xyForLink = link.direction === "down"
        ? [
            {
                x: link.circularPathData.sourceY,
                y: link.circularPathData.sourceX
            },
            {
                x: link.circularPathData.sourceY,
                y: link.circularPathData.leftFullExtent
            },
            {
                x: link.circularPathData.verticalFullExtent,
                y: link.circularPathData.leftFullExtent
            },
            {
                x: link.circularPathData.verticalFullExtent,
                y: link.circularPathData.rightFullExtent
            },
            {
                x: link.circularPathData.targetY,
                y: link.circularPathData.rightFullExtent
            },
            {
                x: link.circularPathData.targetY,
                y: link.circularPathData.targetX
            }
        ]
        : [
            {
                x: link.circularPathData.sourceX,
                y: link.circularPathData.sourceY
            },
            {
                x: link.circularPathData.leftFullExtent,
                y: link.circularPathData.sourceY
            },
            {
                x: link.circularPathData.leftFullExtent,
                y: link.circularPathData.verticalFullExtent
            },
            {
                x: link.circularPathData.rightFullExtent,
                y: link.circularPathData.verticalFullExtent
            },
            {
                x: link.circularPathData.rightFullExtent,
                y: link.circularPathData.targetY
            },
            {
                x: link.circularPathData.targetX,
                y: link.circularPathData.targetY
            }
        ];
    return linkGenerator(xyForLink);
}
var hierarchyDecorator = function (hierarchy, hashEntries, nodeIDAccessor, nodes) {
    if (hierarchy.children) {
        hierarchy.children.forEach(function (child) {
            var theseEntries = hashEntries.filter(function (entry) { return entry[1] === child.id; });
            theseEntries.forEach(function (entry) {
                var idNode = nodes.find(function (node) { return nodeIDAccessor(node) === entry[0]; }) || {};
                child.childHash[entry[0]] = __assign(__assign({ id: entry[0] }, idNode), { children: [], childHash: {} });
                child.children.push(child.childHash[entry[0]]);
            });
            if (child.children.length > 0) {
                hierarchyDecorator(child, hashEntries, nodeIDAccessor, nodes);
            }
        });
    }
};
var softStack = function (edges, nodes, sourceAccessor, targetAccessor, nodeIDAccessor) {
    var hierarchy = { id: "root-generated", children: [], childHash: {} };
    var discoveredHierarchyHash = {};
    var targetToSourceHash = {};
    var hasLogicalRoot = true;
    var isHierarchical = true;
    for (var i = 0; i < edges.length; i++) {
        var edge = edges[i];
        var source = sourceAccessor(edge);
        var target = targetAccessor(edge);
        var sourceID = typeof source === "object" ? nodeIDAccessor(source) : source;
        var targetID = typeof target === "object" ? nodeIDAccessor(target) : target;
        targetToSourceHash[targetID] = sourceID;
        if (!discoveredHierarchyHash[sourceID]) {
            discoveredHierarchyHash[sourceID] = targetID;
        }
        else {
            isHierarchical = false;
            break;
        }
    }
    if (isHierarchical) {
        var hashEntries = Object.entries(discoveredHierarchyHash);
        hashEntries.forEach(function (entry) {
            var target = entry[1];
            if (!discoveredHierarchyHash[target]) {
                discoveredHierarchyHash[target] = "root-generated";
                var idNode = nodes.find(function (node) { return nodeIDAccessor(node) === target; }) || {};
                hierarchy.childHash[target] = __assign(__assign({ id: target }, idNode), { children: [], childHash: {} });
                hierarchy.children.push(hierarchy.childHash[target]);
            }
        });
        hierarchyDecorator(hierarchy, hashEntries, nodeIDAccessor, nodes);
        nodes.forEach(function (node) {
            var nodeID = nodeIDAccessor(node);
            if (!discoveredHierarchyHash[nodeID] && !targetToSourceHash[nodeID]) {
                hierarchy.children.push(__assign(__assign({ id: nodeID }, node), { children: [], childHash: {} }));
            }
        });
        if (hierarchy.children.length === 1) {
            hierarchy = hierarchy.children[0];
            hasLogicalRoot = false;
        }
        return { hierarchy: hierarchy, isHierarchical: true, hasLogicalRoot: hasLogicalRoot };
    }
    return { hierarchy: {}, isHierarchical: false, hasLogicalRoot: false };
};

function determineNodeIcon(baseCustomNodeIcon, networkSettings, size, nodes) {
    if (baseCustomNodeIcon)
        return baseCustomNodeIcon;
    var center = [size[0] / 2, size[1] / 2];
    switch (networkSettings.type) {
        case "sankey":
            return sankeyNodeGenerator;
        case "partition":
            return networkSettings.projection === "radial"
                ? radialRectNodeGenerator(size, center, networkSettings)
                : hierarchicalRectNodeGenerator;
        case "treemap":
            return networkSettings.projection === "radial"
                ? radialRectNodeGenerator(size, center, networkSettings)
                : hierarchicalRectNodeGenerator;
        case "circlepack":
            return circleNodeGenerator;
        case "chord":
            return chordNodeGenerator(size);
        case "dagre":
            return hierarchicalRectNodeGenerator;
        case "matrix":
            return matrixNodeGenerator(size, nodes);
    }
    return circleNodeGenerator;
}
function determineEdgeIcon(_a) {
    var baseCustomEdgeIcon = _a.baseCustomEdgeIcon, networkSettings = _a.networkSettings, size = _a.size, graph = _a.graph, nodes = _a.nodes;
    if (baseCustomEdgeIcon)
        return baseCustomEdgeIcon;
    switch (networkSettings.type) {
        case "partition":
            return function () { return null; };
        case "treemap":
            return function () { return null; };
        case "circlepack":
            return function () { return null; };
        case "chord":
            return chordEdgeGenerator(size);
        case "matrix":
            return matrixEdgeGenerator(size, nodes);
        case "arc":
            return arcEdgeGenerator(size);
        case "dagre":
            if (graph)
                return dagreEdgeGenerator(graph.graph().rankdir);
    }
    return undefined;
}
var basicMiddle = function (d) { return ({
    edge: d,
    x: (d.source.x + d.target.x) / 2,
    y: (d.source.y + d.target.y) / 2
}); };
var edgePointHash = {
    sankey: function (d) { return ({
        edge: d,
        x: (d.source.x1 + d.target.x0) / 2,
        y: d.circularPathData
            ? d.circularPathData.verticalFullExtent
            : ((d.y0 + d.y1) / 2 + (d.y0 + d.y1) / 2) / 2
    }); },
    force: basicMiddle,
    tree: basicMiddle,
    cluster: basicMiddle,
    matrix: function (d) {
        return {
            edge: d,
            x: d.source.y,
            y: d.target.y
        };
    }
};
var hierarchicalTypeHash = {
    dendrogram: tree,
    tree: tree,
    circlepack: pack,
    cluster: cluster,
    treemap: treemap,
    partition: partition
};
var hierarchicalProjectable = {
    partition: true,
    cluster: true,
    tree: true,
    dendrogram: true
};
var radialProjectable = {
    partition: true,
    cluster: true,
    tree: true,
    dendrogram: true
};
var sankeyOrientHash = {
    left: sankeyLeft,
    right: sankeyRight,
    center: sankeyCenter,
    justify: sankeyJustify
};
function breadthFirstCompontents(baseNodes, hash) {
    var componentHash = {
        "0": { componentNodes: [], componentEdges: [] }
    };
    var components = [componentHash["0"]];
    var componentID = 0;
    traverseNodesBF(baseNodes, true);
    function traverseNodesBF(nodes, top) {
        nodes.forEach(function (node) {
            var _a;
            var hashNode = hash.get(node);
            if (!hashNode) {
                componentHash["0"].componentNodes.push(node);
            }
            else if (hashNode.component === -99) {
                if (top === true) {
                    componentID++;
                    componentHash[componentID] = {
                        componentNodes: [],
                        componentEdges: []
                    };
                    components.push(componentHash[componentID]);
                }
                hashNode.component = componentID;
                componentHash[componentID].componentNodes.push(node);
                (_a = componentHash[componentID].componentEdges).push.apply(_a, __spread(hashNode.edges));
                var traversibleNodes = __spread(hashNode.connectedNodes);
                traverseNodesBF(traversibleNodes, hash);
            }
        });
    }
    return components.sort(function (a, b) { return b.componentNodes.length - a.componentNodes.length; });
}
var matrixify = function (_a) {
    var edgeHash = _a.edgeHash, nodes = _a.nodes, edgeWidthAccessor = _a.edgeWidthAccessor, nodeIDAccessor = _a.nodeIDAccessor;
    var matrix = [];
    nodes.forEach(function (nodeSource) {
        var nodeSourceID = nodeIDAccessor(nodeSource);
        var sourceRow = [];
        matrix.push(sourceRow);
        nodes.forEach(function (nodeTarget) {
            var nodeTargetID = nodeIDAccessor(nodeTarget);
            var theEdge = edgeHash.get(nodeSourceID + "|" + nodeTargetID);
            if (theEdge) {
                sourceRow.push(edgeWidthAccessor(theEdge));
            }
            else {
                sourceRow.push(0);
            }
        });
    });
    return matrix;
};
var emptyArray = [];
var baseNodeProps = {
    id: undefined,
    degree: 0,
    inDegree: 0,
    outDegree: 0,
    x: 0,
    y: 0,
    x1: 0,
    x0: 0,
    y1: 0,
    y0: 0,
    height: 0,
    width: 0,
    radius: 0,
    r: 0,
    direction: undefined,
    textHeight: 0,
    textWidth: 0,
    fontSize: 0,
    scale: 1,
    nodeSize: 0,
    component: -99,
    shapeNode: false
};
var baseNetworkSettings = {
    iterations: 500,
    hierarchicalNetwork: false
};
var baseGraphSettings = {
    nodeHash: new Map(),
    edgeHash: new Map(),
    nodes: [],
    edges: [],
    hierarchicalNetwork: false,
    type: "force"
};
function recursiveIDAccessor(idAccessor, node, accessorString) {
    if (node.parent) {
        accessorString = accessorString + "-" + recursiveIDAccessor(idAccessor, __assign(__assign({}, node.parent), node.parent.data), accessorString);
    }
    return accessorString + "-" + idAccessor(__assign(__assign({}, node), node.data));
}
var nodesEdgesFromHierarchy = function (baseRootNode, idAccessor) {
    if (idAccessor === void 0) { idAccessor = function (d) { return d.id || d.descendantIndex; }; }
    var edges = [];
    var nodes = [];
    var rootNode = baseRootNode.descendants
        ? baseRootNode
        : hierarchy(baseRootNode);
    var descendants = rootNode.descendants();
    descendants.forEach(function (d, i) {
        d.descendantIndex = i;
    });
    descendants.forEach(function (node, i) {
        var generatedID = idAccessor(__assign(__assign({}, node), node.data)) + "-" + ((node.parent &&
            recursiveIDAccessor(idAccessor, __assign(__assign({}, node.parent), node.parent.data), "")) ||
            "root");
        var dataD = Object.assign(node, node.data || {}, {
            hierarchicalID: generatedID
        });
        nodes.push(dataD);
        if (node.parent !== null) {
            var dataParent = Object.assign(node.parent, node.parent.data || {});
            edges.push({
                source: dataParent,
                target: dataD,
                depth: node.depth,
                weight: 1,
                value: 1,
                _NWFEdgeKey: generatedID
            });
        }
    });
    return { edges: edges, nodes: nodes };
};
var calculateNetworkFrame = function (currentProps, prevState) {
    var graph = currentProps.graph, _a = currentProps.nodes, nodes = _a === void 0 ? Array.isArray(graph) || typeof graph === "function"
        ? emptyArray
        : (graph && graph.nodes) || emptyArray : _a, _b = currentProps.edges, edges = _b === void 0 ? typeof graph === "function"
        ? emptyArray
        : Array.isArray(graph)
            ? graph
            : (graph && graph.edges) || emptyArray : _b, networkType = currentProps.networkType, size = currentProps.size, nodeStyle = currentProps.nodeStyle, nodeClass = currentProps.nodeClass, canvasNodes = currentProps.canvasNodes, edgeStyle = currentProps.edgeStyle, edgeClass = currentProps.edgeClass, canvasEdges = currentProps.canvasEdges, nodeRenderMode = currentProps.nodeRenderMode, edgeRenderMode = currentProps.edgeRenderMode, nodeLabels = currentProps.nodeLabels, baseTitle = currentProps.title, baseMargin = currentProps.margin, hoverAnnotation = currentProps.hoverAnnotation, baseCustomNodeIcon = currentProps.customNodeIcon, baseCustomEdgeIcon = currentProps.customEdgeIcon, filterRenderedNodes = currentProps.filterRenderedNodes;
    var edgeType = currentProps.edgeType;
    var networkSettings;
    var nodeHierarchicalIDFill = {};
    var networkSettingsKeys = ["type"];
    if (typeof networkType === "string") {
        networkSettings = __assign(__assign({ type: networkType }, baseNetworkSettings), { graphSettings: baseGraphSettings });
    }
    else {
        if (networkType)
            networkSettingsKeys = Object.keys(networkType);
        networkSettings = __assign(__assign(__assign({ type: "force" }, baseNetworkSettings), networkType), { graphSettings: baseGraphSettings });
    }
    if (networkSettings.projection === "vertical" &&
        networkSettings.type === "sankey") {
        networkSettings.direction = "down";
    }
    networkSettingsKeys.push("height", "width");
    var title = typeof baseTitle === "object" &&
        !React.isValidElement(baseTitle) &&
        baseTitle !== null
        ? baseTitle
        : { title: baseTitle, orient: "top" };
    var margin = calculateMargin({
        margin: baseMargin,
        title: title,
        size: size
    });
    var _c = adjustedPositionSize({
        size: size,
        margin: margin
    }), adjustedPosition = _c.adjustedPosition, adjustedSize = _c.adjustedSize;
    networkSettings.graphSettings.nodes = nodes;
    networkSettings.graphSettings.edges = edges;
    networkSettings.graphSettings.filterRenderedNodes = filterRenderedNodes;
    var _d = networkSettings.graphSettings, edgeHash = _d.edgeHash, nodeHash = _d.nodeHash;
    var createPointLayer = networkSettings.type === "treemap" ||
        networkSettings.type === "partition" ||
        networkSettings.type === "sankey";
    var nodeIDAccessor = stringToFn(currentProps.nodeIDAccessor, function (d) {
        return d ? d.id : undefined;
    });
    var sourceAccessor = stringToFn(currentProps.sourceAccessor, function (d) { return d.source; });
    var targetAccessor = stringToFn(currentProps.targetAccessor, function (d) { return d.target; });
    var nodeSizeAccessor = typeof currentProps.nodeSizeAccessor === "number"
        ? genericFunction(currentProps.nodeSizeAccessor)
        : stringToFn(currentProps.nodeSizeAccessor, function (d) { return d.r || 5; });
    var edgeWidthAccessor = stringToFn(currentProps.edgeWidthAccessor, function (d) { return d.weight || 1; });
    var nodeStyleFn = stringToFn(nodeStyle, function () { return ({}); }, true);
    var nodeClassFn = stringToFn(nodeClass, function () { return ""; }, true);
    var nodeRenderModeFn = stringToFn(nodeRenderMode, undefined, true);
    var nodeCanvasRenderFn = canvasNodes && stringToFn(canvasNodes, undefined, true);
    var projectedNodes = prevState.projectedNodes, projectedEdges = prevState.projectedEdges;
    var isHierarchical = typeof networkSettings.type === "string" &&
        hierarchicalTypeHash[networkSettings.type];
    var changedData = !prevState.projectedNodes ||
        !prevState.projectedEdges ||
        prevState.graphSettings.nodes !== nodes ||
        prevState.graphSettings.edges !== edges ||
        isHierarchical ||
        prevState.graphSettings.filterRenderedNodes !== filterRenderedNodes;
    if (networkSettings.type === "dagre") {
        var dagreGraph_1 = graph;
        var dagreNodeHash_1 = {};
        projectedNodes = dagreGraph_1.nodes().map(function (n) {
            var baseNode = dagreGraph_1.node(n);
            dagreNodeHash_1[n] = __assign(__assign({}, baseNode), { x0: baseNode.x - baseNode.width / 2, x1: baseNode.x + baseNode.width / 2, y0: baseNode.y - baseNode.height / 2, y1: baseNode.y + baseNode.height / 2, id: n, shapeNode: true, sourceLinks: [], targetLinks: [] });
            return dagreNodeHash_1[n];
        });
        projectedEdges = dagreGraph_1.edges().map(function (e) {
            var dagreEdge = dagreGraph_1.edge(e);
            var baseEdge = __assign(__assign({}, dagreEdge), { points: dagreEdge.points.map(function (d) { return (__assign({}, d)); }) });
            baseEdge.source = projectedNodes.find(function (p) { return p.id === e.v; });
            baseEdge.target = projectedNodes.find(function (p) { return p.id === e.w; });
            baseEdge.points.unshift({ x: baseEdge.source.x, y: baseEdge.source.y });
            baseEdge.points.push({ x: baseEdge.target.x, y: baseEdge.target.y });
            dagreNodeHash_1[e.v].targetLinks.push(baseEdge);
            dagreNodeHash_1[e.w].sourceLinks.push(baseEdge);
            return baseEdge;
        });
    }
    else if (changedData) {
        var previousNodes_1 = projectedNodes;
        edgeHash = new Map();
        nodeHash = new Map();
        networkSettings.graphSettings.edgeHash = edgeHash;
        networkSettings.graphSettings.nodeHash = nodeHash;
        projectedNodes = [];
        projectedEdges = [];
        var fixFunction_1 = typeof networkSettings.fixExistingNodes === "function"
            ? networkSettings.fixExistingNodes
            : networkSettings.fixExistingNodes
                ? function () { return true; }
                : false;
        nodes.forEach(function (node) {
            var projectedNode = __assign({}, node);
            var id = nodeIDAccessor(projectedNode);
            var existingNode = previousNodes_1.find(function (prevNode) { return prevNode.id === id; });
            var equivalentOldNode = existingNode || { x: undefined, y: undefined };
            nodeHash.set(id, projectedNode);
            nodeHash.set(node, projectedNode);
            projectedNodes.push(projectedNode);
            projectedNode.id = id;
            projectedNode.inDegree = 0;
            projectedNode.outDegree = 0;
            projectedNode.degree = 0;
            projectedNode.x = equivalentOldNode.x;
            projectedNode.y = equivalentOldNode.y;
            if (existingNode && fixFunction_1 && fixFunction_1(existingNode)) {
                projectedNode.fx = existingNode.x;
                projectedNode.fy = existingNode.y;
            }
        });
        var operationalEdges = edges;
        var baseEdges = edges;
        if (isHierarchical && Array.isArray(edges)) {
            var createdHierarchicalData = softStack(edges, nodes, sourceAccessor, targetAccessor, nodeIDAccessor);
            if (createdHierarchicalData.isHierarchical) {
                baseEdges = createdHierarchicalData.hierarchy;
                projectedNodes = [];
            }
            else {
                console.error("You've sent an edge list that is not strictly hierarchical (there are nodes with multiple parents) defaulting to force-directed network layout");
                networkSettings.type = "force";
            }
        }
        if (!Array.isArray(baseEdges)) {
            networkSettings.hierarchicalNetwork = true;
            var rootNode = hierarchy(baseEdges, networkSettings.hierarchyChildren);
            rootNode.sum(networkSettings.hierarchySum || (function (d) { return d.value; }));
            if (isHierarchical) {
                var layout = networkSettings.layout || isHierarchical;
                var hierarchicalLayout_1 = layout();
                var networkSettingKeys = Object.keys(networkSettings);
                if ((networkSettings.type === "dendrogram" ||
                    networkSettings.type === "tree" ||
                    networkSettings.type === "cluster") &&
                    hierarchicalLayout_1.separation) {
                    hierarchicalLayout_1.separation(function (a, b) {
                        return (nodeSizeAccessor(__assign(__assign({}, a), a.data)) || 1) +
                            (networkSettings.nodePadding || 0) +
                            (nodeSizeAccessor(__assign(__assign({}, b), b.data)) || 1);
                    });
                }
                networkSettingKeys.forEach(function (key) {
                    if (hierarchicalLayout_1[key]) {
                        hierarchicalLayout_1[key](networkSettings[key]);
                    }
                });
                var layoutSize = networkSettings.projection === "horizontal" && isHierarchical
                    ? [adjustedSize[1], adjustedSize[0]]
                    : adjustedSize;
                if (!networkSettings.nodeSize && hierarchicalLayout_1.size) {
                    hierarchicalLayout_1.size(layoutSize);
                }
                hierarchicalLayout_1(rootNode);
            }
            operationalEdges = nodesEdgesFromHierarchy(rootNode, nodeIDAccessor).edges;
        }
        baseNodeProps.shapeNode = createPointLayer;
        if (Array.isArray(operationalEdges)) {
            operationalEdges.forEach(function (edge) {
                var source = sourceAccessor(edge);
                var target = targetAccessor(edge);
                var sourceTarget = [source, target];
                sourceTarget.forEach(function (nodeDirection) {
                    if (!nodeHash.get(nodeDirection)) {
                        var nodeObject = typeof nodeDirection === "object"
                            ? __assign(__assign({}, baseNodeProps), nodeDirection) : __assign(__assign({}, baseNodeProps), { id: nodeDirection, createdByFrame: true });
                        var nodeIDValue = nodeObject.id || nodeIDAccessor(nodeObject);
                        nodeHierarchicalIDFill[nodeIDValue]
                            ? (nodeHierarchicalIDFill[nodeIDValue] += 1)
                            : (nodeHierarchicalIDFill[nodeIDValue] = 1);
                        if (!nodeObject.id) {
                            var nodeSuffix = nodeHierarchicalIDFill[nodeIDValue] === 1
                                ? ""
                                : "-" + nodeHierarchicalIDFill[nodeIDValue];
                            nodeObject.id = "" + nodeIDValue + nodeSuffix;
                        }
                        nodeHash.set(nodeDirection, nodeObject);
                        projectedNodes.push(nodeObject);
                    }
                });
                var edgeWeight = edge.weight || 1;
                var sourceNode = nodeHash.get(source);
                var targetNode = nodeHash.get(target);
                targetNode.inDegree += edgeWeight;
                sourceNode.outDegree += edgeWeight;
                targetNode.degree += edgeWeight;
                sourceNode.degree += edgeWeight;
                var edgeKey = (nodeIDAccessor(sourceNode) || source) + "|" + (nodeIDAccessor(targetNode) || target);
                var newEdge = Object.assign({}, edge, {
                    source: nodeHash.get(source),
                    target: nodeHash.get(target)
                });
                edgeHash.set(edgeKey, newEdge);
                projectedEdges.push(newEdge);
                if (networkSettings.type === "matrix") {
                    projectedEdges.push(__assign(__assign({}, newEdge), { source: newEdge.target, target: newEdge.source }));
                }
            });
        }
    }
    else {
        edgeHash = new Map();
        networkSettings.graphSettings.edgeHash = edgeHash;
        projectedEdges.forEach(function (edge) {
            var edgeSource = typeof edge.source === "string"
                ? edge.source
                : nodeIDAccessor(edge.source);
            var edgeTarget = typeof edge.target === "string"
                ? edge.target
                : nodeIDAccessor(edge.target);
            var edgeKey = edgeSource + "|" + edgeTarget;
            edgeHash.set(edgeKey, edge);
        });
    }
    var customNodeIcon = determineNodeIcon(baseCustomNodeIcon, networkSettings, adjustedSize, projectedNodes);
    var customEdgeIcon = determineEdgeIcon({
        baseCustomEdgeIcon: baseCustomEdgeIcon,
        networkSettings: networkSettings,
        size: adjustedSize,
        nodes: projectedNodes,
        graph: graph
    });
    if ((networkSettings.type === "sankey" ||
        networkSettings.type === "flowchart") &&
        topologicalSort(projectedNodes, projectedEdges) === null) {
        networkSettings.customSankey = sankeyCircular;
    }
    networkSettings.width = size[0];
    networkSettings.height = size[1];
    var networkSettingsChanged = false;
    networkSettingsKeys.forEach(function (key) {
        if (key !== "edgeType" &&
            key !== "graphSettings" &&
            networkSettings[key] !== prevState.graphSettings[key]) {
            networkSettingsChanged = true;
        }
    });
    //Support bubble chart with circle pack and with force
    if (networkSettings.type === "sankey") {
        edgeType = function (d) {
            return d.circular
                ? circularAreaLink(d)
                : edgeType === "angled"
                    ? ribbonLink(d)
                    : areaLink(d);
        };
    }
    else if (isHierarchical) {
        projectedNodes.forEach(function (node) {
            if (createPointLayer) {
                node.x = (node.x0 + node.x1) / 2;
                node.y = (node.y0 + node.y1) / 2;
            }
            if (typeof networkSettings.type === "string" &&
                hierarchicalProjectable[networkSettings.type] &&
                networkSettings.projection === "horizontal") {
                var ox = node.x;
                node.x = node.y;
                node.y = ox;
                if (createPointLayer) {
                    var ox0 = node.x0;
                    var ox1 = node.x1;
                    node.x0 = node.y0;
                    node.x1 = node.y1;
                    node.y0 = ox0;
                    node.y1 = ox1;
                }
            }
            else if (typeof networkSettings.type === "string" &&
                radialProjectable[networkSettings.type] &&
                networkSettings.projection === "radial") {
                var radialPoint = node.depth === 0
                    ? [adjustedSize[0] / 2, adjustedSize[1] / 2]
                    : pointOnArcAtAngle$1([adjustedSize[0] / 2, adjustedSize[1] / 2], node.x / adjustedSize[0], node.y / 2);
                node.x = radialPoint[0];
                node.y = radialPoint[1];
            }
            else {
                node.x = node.x;
                node.y = node.y;
                if (createPointLayer) {
                    node.x0 = node.x0;
                    node.x1 = node.x1;
                    node.y0 = node.y0;
                    node.y1 = node.y1;
                }
            }
        });
    }
    if (networkSettings.type !== "static" &&
        (changedData || networkSettingsChanged)) {
        var components = [
            {
                componentNodes: projectedNodes,
                componentEdges: projectedEdges
            }
        ];
        if (networkSettings.type === "chord") {
            var radius = adjustedSize[1] / 2;
            var _e = networkSettings.groupWidth, groupWidth = _e === void 0 ? 20 : _e, _f = networkSettings.padAngle, padAngle = _f === void 0 ? 0.01 : _f, sortGroups = networkSettings.sortGroups;
            var arcGenerator_1 = arc()
                .innerRadius(radius - groupWidth)
                .outerRadius(radius);
            var ribbonGenerator_1 = ribbon().radius(radius - groupWidth);
            var matrixifiedNetwork = matrixify({
                edgeHash: edgeHash,
                nodes: projectedNodes,
                edgeWidthAccessor: edgeWidthAccessor,
                nodeIDAccessor: nodeIDAccessor
            });
            var chordLayout = chord().padAngle(padAngle);
            if (sortGroups) {
                chordLayout.sortGroups(sortGroups);
            }
            var chords = chordLayout(matrixifiedNetwork);
            var groups = chords.groups;
            groups.forEach(function (group) {
                var groupCentroid = arcGenerator_1.centroid(group);
                var groupD = arcGenerator_1(group);
                var groupNode = projectedNodes[group.index];
                groupNode.d = groupD;
                groupNode.index = group.index;
                groupNode.x = groupCentroid[0] + adjustedSize[0] / 2;
                groupNode.y = groupCentroid[1] + adjustedSize[1] / 2;
            });
            chords.forEach(function (generatedChord) {
                var chordD = ribbonGenerator_1(generatedChord);
                //this is incorrect should use edgeHash
                var nodeSourceID = nodeIDAccessor(projectedNodes[generatedChord.source.index]);
                var nodeTargetID = nodeIDAccessor(projectedNodes[generatedChord.target.index]);
                var chordEdge = edgeHash.get(nodeSourceID + "|" + nodeTargetID);
                chordEdge.d = chordD;
                var chordBounds = pathBounds(chordD);
                chordEdge.x =
                    adjustedSize[0] / 2 + (chordBounds.x1 + chordBounds.x2) / 2;
                chordEdge.y =
                    adjustedSize[1] / 2 + (chordBounds.y1 + chordBounds.y2) / 2;
            });
        }
        else if (networkSettings.type === "sankey" ||
            networkSettings.type === "flowchart") {
            var _g = networkSettings.orient, orient = _g === void 0 ? "center" : _g, _h = networkSettings.iterations, iterations = _h === void 0 ? 100 : _h, nodePadding = networkSettings.nodePadding, _j = networkSettings.nodePaddingRatio, nodePaddingRatio = _j === void 0 ? nodePadding ? undefined : 0.5 : _j, _k = networkSettings.nodeWidth, nodeWidth = _k === void 0 ? networkSettings.type === "flowchart" ? 2 : 24 : _k, customSankey = networkSettings.customSankey, _l = networkSettings.direction, direction_1 = _l === void 0 ? "right" : _l;
            var sankeyOrient = sankeyOrientHash[orient];
            var actualSankey = customSankey || sankeyCircular;
            var frameExtent = [[0, 0], adjustedSize];
            if (networkSettings.direction === "up" ||
                networkSettings.direction === "down") {
                frameExtent = [
                    [0, 0],
                    [adjustedSize[1], adjustedSize[0]]
                ];
            }
            var frameSankey = actualSankey()
                .extent(frameExtent)
                .links(projectedEdges)
                .nodes(projectedNodes)
                .nodeAlign(sankeyOrient)
                .nodeId(nodeIDAccessor)
                .nodeWidth(nodeWidth)
                .iterations(iterations);
            if (frameSankey.nodePaddingRatio && nodePaddingRatio) {
                frameSankey.nodePaddingRatio(nodePaddingRatio);
            }
            else if (nodePadding) {
                frameSankey.nodePadding(nodePadding);
            }
            frameSankey();
            projectedNodes.forEach(function (d) {
                d.height = d.y1 - d.y0;
                d.width = d.x1 - d.x0;
                d.x = d.x0 + d.width / 2;
                d.y = d.y0 + d.height / 2;
                d.radius = d.height / 2;
                d.direction = direction_1;
            });
            projectedEdges.forEach(function (d) {
                d.sankeyWidth = d.width;
                d.direction = direction_1;
                d.width = undefined;
            });
        }
        else if (networkSettings.type === "force") {
            var _m = networkSettings.iterations, iterations = _m === void 0 ? 500 : _m, _o = networkSettings.edgeStrength, edgeStrength_1 = _o === void 0 ? 0.1 : _o, _p = networkSettings.distanceMax, distanceMax = _p === void 0 ? Infinity : _p, edgeDistance = networkSettings.edgeDistance, _q = networkSettings.forceManyBody, nsForceMB = _q === void 0 ? function (d) { return -25 * nodeSizeAccessor(d); } : _q;
            var linkForce = forceLink().strength(function (d) {
                return Math.min(2.5, d.weight ? d.weight * edgeStrength_1 : edgeStrength_1);
            });
            if (edgeDistance) {
                linkForce.distance(edgeDistance);
            }
            var simulation = networkSettings.simulation ||
                forceSimulation().force("charge", forceManyBody().distanceMax(distanceMax).strength(nsForceMB));
            //        simulation.force("link", linkForce).nodes(projectedNodes)
            simulation.nodes(projectedNodes);
            var forceMod = adjustedSize[1] / adjustedSize[0];
            if (!simulation.force("x")) {
                simulation.force("x", forceX(adjustedSize[0] / 2).strength(forceMod * 0.1));
            }
            if (!simulation.force("y")) {
                simulation.force("y", forceY(adjustedSize[1] / 2).strength(0.1));
            }
            if (projectedEdges.length !== 0 && !simulation.force("link")) {
                simulation.force("link", linkForce);
                simulation.force("link").links(projectedEdges);
            }
            //reset alpha if it's too cold
            if (simulation.alpha() < 0.1) {
                simulation.alpha(1);
            }
            simulation.stop();
            for (var i = 0; i < iterations; ++i) {
                simulation.tick();
            }
        }
        else if (networkSettings.type === "motifs") {
            var componentHash_1 = new Map();
            projectedEdges.forEach(function (edge) {
                [edge.source, edge.target].forEach(function (node) {
                    if (!componentHash_1.get(node)) {
                        componentHash_1.set(node, {
                            node: node,
                            component: -99,
                            connectedNodes: [],
                            edges: []
                        });
                    }
                });
                componentHash_1.get(edge.source).connectedNodes.push(edge.target);
                componentHash_1.get(edge.target).connectedNodes.push(edge.source);
                componentHash_1.get(edge.source).edges.push(edge);
            });
            components = breadthFirstCompontents(projectedNodes, componentHash_1);
            var largestComponent_1 = Math.max(projectedNodes.length / 3, components[0].componentNodes.length);
            var layoutSize_1 = size[0] > size[1] ? size[1] : size[0];
            var layoutDirection_1 = size[0] > size[1] ? "horizontal" : "vertical";
            var _r = networkSettings.iterations, iterations_1 = _r === void 0 ? 500 : _r, _s = networkSettings.edgeStrength, edgeStrength_2 = _s === void 0 ? 0.1 : _s, edgeDistance_1 = networkSettings.edgeDistance, _t = networkSettings.padding, padding_1 = _t === void 0 ? 0 : _t;
            var currentX_1 = padding_1;
            var currentY_1 = padding_1;
            components.forEach(function (_a) {
                var componentNodes = _a.componentNodes, componentEdges = _a.componentEdges;
                var linkForce = forceLink().strength(function (d) {
                    return Math.min(2.5, d.weight ? d.weight * edgeStrength_2 : edgeStrength_2);
                });
                if (edgeDistance_1) {
                    linkForce.distance(edgeDistance_1);
                }
                var componentLayoutSize = Math.max(componentNodes.length / largestComponent_1, 0.2) * layoutSize_1;
                var xBound = componentLayoutSize + currentX_1;
                var yBound = componentLayoutSize + currentY_1;
                if (layoutDirection_1 === "horizontal") {
                    if (yBound > size[1]) {
                        currentX_1 = componentLayoutSize + currentX_1 + padding_1;
                        currentY_1 = componentLayoutSize + padding_1;
                    }
                    else {
                        currentY_1 = componentLayoutSize + currentY_1 + padding_1;
                    }
                }
                else {
                    if (xBound > size[0]) {
                        currentY_1 = componentLayoutSize + currentY_1 + padding_1;
                        currentX_1 = componentLayoutSize + padding_1;
                    }
                    else {
                        currentX_1 = componentLayoutSize + currentX_1 + padding_1;
                    }
                }
                var xCenter = currentX_1 - componentLayoutSize / 2;
                var yCenter = currentY_1 - componentLayoutSize / 2;
                var simulation = forceSimulation()
                    .force("charge", forceManyBody().strength(networkSettings.forceManyBody ||
                    (function (d) { return -25 * nodeSizeAccessor(d); })))
                    .force("link", linkForce);
                simulation
                    .force("x", forceX(xCenter))
                    .force("y", forceY(yCenter))
                    .nodes(componentNodes);
                simulation.force("link").links(componentEdges);
                simulation.stop();
                for (var i = 0; i < iterations_1; ++i)
                    simulation.tick();
                var maxX = max(componentNodes.map(function (d) { return d.x; }));
                var maxY = max(componentNodes.map(function (d) { return d.y; }));
                var minX = min(componentNodes.map(function (d) { return d.x; }));
                var minY = min(componentNodes.map(function (d) { return d.y; }));
                var resetX = scaleLinear()
                    .domain([minX, maxX])
                    .range([currentX_1 - componentLayoutSize, currentX_1 - 20]);
                var resetY = scaleLinear()
                    .domain([minY, maxY])
                    .range([currentY_1 - componentLayoutSize, currentY_1 - 20]);
                componentNodes.forEach(function (node) {
                    node.x = resetX(node.x);
                    node.y = resetY(node.y);
                });
            });
        }
        else if (networkSettings.type === "matrix") {
            if (networkSettings.sort) {
                projectedNodes = projectedNodes.sort(networkSettings.sort);
            }
            var gridSize = Math.min.apply(Math, __spread(adjustedSize));
            var stepSize_1 = gridSize / (projectedNodes.length + 1);
            projectedNodes.forEach(function (node, index) {
                node.x = 0;
                node.y = (index + 1) * stepSize_1;
            });
        }
        else if (networkSettings.type === "arc") {
            if (networkSettings.sort) {
                projectedNodes = projectedNodes.sort(networkSettings.sort);
            }
            var stepSize_2 = adjustedSize[0] / (projectedNodes.length + 2);
            projectedNodes.forEach(function (node, index) {
                node.x = (index + 1) * stepSize_2;
                node.y = adjustedSize[1] / 2;
            });
        }
        else if (typeof networkSettings.type === "function") {
            networkSettings.type({
                nodes: projectedNodes,
                edges: projectedEdges
            });
        }
        else {
            projectedNodes.forEach(function (node) {
                node.x = node.x === undefined ? (node.x0 + node.x1) / 2 : node.x;
                node.y = node.y === undefined ? node.y0 : node.y;
            });
        }
        prevState.graphSettings.nodes = currentProps.nodes;
        prevState.graphSettings.edges = currentProps.edges;
    }
    //filter out user-defined nodes
    projectedNodes = projectedNodes.filter(filterRenderedNodes);
    projectedEdges = projectedEdges.filter(function (d) {
        return projectedNodes.indexOf(d.target) !== -1 &&
            projectedNodes.indexOf(d.source) !== -1;
    });
    if (networkSettings.direction === "flip") {
        projectedNodes.forEach(function (node) {
            // const ox = node.x
            // const oy = node.y
            node.x = adjustedSize[0] - node.x;
            node.y = adjustedSize[1] - node.y;
        });
    }
    else if (networkSettings.direction === "up" ||
        networkSettings.direction === "down") {
        var mod_1 = networkSettings.direction === "up"
            ? function (value) { return adjustedSize[1] - value; }
            : function (value) { return value; };
        projectedNodes.forEach(function (node) {
            var ox = node.x;
            var ox0 = node.x0;
            var ox1 = node.x1;
            node.x = mod_1(node.y);
            node.x0 = mod_1(node.y0);
            node.x1 = mod_1(node.y1);
            node.y = ox;
            node.y0 = ox0;
            node.y1 = ox1;
        });
    }
    else if (networkSettings.direction === "left") {
        projectedNodes.forEach(function (node) {
            node.x = adjustedSize[0] - node.x;
            node.x0 = adjustedSize[0] - node.x0;
            node.x1 = adjustedSize[0] - node.x1;
        });
    }
    if (typeof networkSettings.zoom === "function") {
        networkSettings.zoom(projectedNodes, adjustedSize);
    }
    else if (networkSettings.zoom !== false &&
        networkSettings.type !== "matrix" &&
        networkSettings.type !== "chord" &&
        networkSettings.type !== "sankey" &&
        networkSettings.type !== "partition" &&
        networkSettings.type !== "treemap" &&
        networkSettings.type !== "circlepack" &&
        networkSettings.type !== "dagre") {
        // ZOOM SHOULD MAINTAIN ASPECT RATIO, ADD "stretch" to fill whole area
        var xMin = min(projectedNodes.map(function (p) { return p.x - nodeSizeAccessor(p); }));
        var xMax = max(projectedNodes.map(function (p) { return p.x + nodeSizeAccessor(p); }));
        var yMin = min(projectedNodes.map(function (p) { return p.y - nodeSizeAccessor(p); }));
        var yMax = max(projectedNodes.map(function (p) { return p.y + nodeSizeAccessor(p); }));
        var xSize = Math.abs(xMax - xMin);
        var ySize = Math.abs(yMax - yMin);
        var networkAspectRatio = xSize / ySize;
        var baseAspectRatio = adjustedSize[0] / adjustedSize[1];
        var yMod = void 0, xMod = void 0;
        if (networkSettings.zoom === "stretch") {
            yMod = 0;
            xMod = 0;
        }
        else if (xSize > ySize) {
            if (networkAspectRatio > baseAspectRatio) {
                xMod = 0;
                yMod = (adjustedSize[1] - (adjustedSize[0] / xSize) * ySize) / 2;
            }
            else {
                yMod = 0;
                xMod = (adjustedSize[0] - (adjustedSize[1] / ySize) * xSize) / 2;
            }
        }
        else {
            if (networkAspectRatio > baseAspectRatio) {
                xMod = 0;
                yMod = (adjustedSize[1] - (adjustedSize[0] / xSize) * ySize) / 2;
            }
            else {
                yMod = 0;
                xMod = (adjustedSize[0] - (adjustedSize[1] / ySize) * xSize) / 2;
            }
        }
        var projectionScaleX_1 = scaleLinear()
            .domain([xMin, xMax])
            .range([xMod, adjustedSize[0] - xMod]);
        var projectionScaleY_1 = scaleLinear()
            .domain([yMin, yMax])
            .range([yMod, adjustedSize[1] - yMod]);
        projectedNodes.forEach(function (node) {
            node.x = projectionScaleX_1(node.x);
            node.y = projectionScaleY_1(node.y);
        });
    }
    else if (networkSettings.zoom !== false &&
        networkSettings.projection !== "radial" &&
        (networkSettings.type === "partition" ||
            networkSettings.type === "treemap" ||
            networkSettings.type === "dagre")) {
        var xMin = min(projectedNodes.map(function (p) { return p.x0; }));
        var xMax = max(projectedNodes.map(function (p) { return p.x1; }));
        var yMin = min(projectedNodes.map(function (p) { return p.y0; }));
        var yMax = max(projectedNodes.map(function (p) { return p.y1; }));
        var projectionScaleX_2 = scaleLinear()
            .domain([xMin, xMax])
            .range([margin.left, adjustedSize[0] - margin.right]);
        var projectionScaleY_2 = scaleLinear()
            .domain([yMin, yMax])
            .range([margin.top, adjustedSize[1] - margin.bottom]);
        projectedNodes.forEach(function (node) {
            node.x = projectionScaleX_2(node.x);
            node.y = projectionScaleY_2(node.y);
            node.x0 = projectionScaleX_2(node.x0);
            node.y0 = projectionScaleY_2(node.y0);
            node.x1 = projectionScaleX_2(node.x1);
            node.y1 = projectionScaleY_2(node.y1);
            node.zoomedHeight = node.y1 - node.y0;
            node.zoomedWidth = node.x1 - node.x0;
        });
        projectedEdges.forEach(function (edge) {
            if (edge.points) {
                edge.points.forEach(function (p) {
                    p.x = projectionScaleX_2(p.x);
                    p.y = projectionScaleY_2(p.y);
                });
            }
        });
    }
    projectedNodes.forEach(function (node) {
        node.nodeSize = nodeSizeAccessor(node);
    });
    projectedEdges.forEach(function (edge) {
        edge.width = edgeWidthAccessor(edge);
    });
    var legendSettings;
    if (currentProps.legend) {
        legendSettings = currentProps.legend;
        if (!legendSettings.legendGroups) {
            ///Something auto for networks
            var legendGroups = [
                {
                    styleFn: currentProps.nodeStyle,
                    type: "fill",
                    items: []
                }
            ];
            legendSettings.legendGroups = legendGroups;
        }
    }
    var networkFrameRender = {
        edges: {
            accessibleTransform: function (data, i) {
                var edgeX = (data[i].source.x + data[i].target.x) / 2;
                var edgeY = (data[i].source.y + data[i].target.y) / 2;
                return __assign(__assign({ type: "frame-hover" }, data[i]), { x: edgeX, y: edgeY });
            },
            data: projectedEdges,
            styleFn: stringToFn(edgeStyle, function () { return ({}); }, true),
            classFn: stringToFn(edgeClass, function () { return ""; }, true),
            renderMode: stringToFn(edgeRenderMode, undefined, true),
            canvasRenderFn: canvasEdges && stringToFn(canvasEdges, undefined, true),
            renderKeyFn: currentProps.edgeRenderKey
                ? currentProps.edgeRenderKey
                : function (d) { return d._NWFEdgeKey || d.key || d.source.id + "-" + d.target.id; },
            behavior: drawEdges,
            projection: networkSettings.projection,
            type: edgeType,
            customMark: customEdgeIcon,
            networkSettings: networkSettings
        },
        nodes: {
            accessibleTransform: function (data, i) { return (__assign(__assign({ type: "frame-hover" }, data[i]), (data[i].data || {}))); },
            data: projectedNodes,
            styleFn: nodeStyleFn,
            classFn: nodeClassFn,
            renderMode: nodeRenderModeFn,
            canvasRenderFn: nodeCanvasRenderFn,
            customMark: customNodeIcon,
            behavior: drawNodes,
            renderKeyFn: currentProps.nodeRenderKey
        }
    };
    var nodeLabelAnnotations = [];
    if (currentProps.nodeLabels && projectedNodes) {
        projectedNodes.forEach(function (node, nodei) {
            var feasibleLabel = nodeLabels && nodeLabels !== true && nodeLabels(node);
            if (nodeLabels === true || feasibleLabel) {
                var actualLabel = networkSettings.projection === "radial" && node.depth !== 0
                    ? radialLabelGenerator(node, nodei, nodeLabels === true ? nodeIDAccessor : nodeLabels, adjustedSize)
                    : nodeLabels === true
                        ? nodeIDAccessor(node, nodei)
                        : feasibleLabel;
                var nodeLabel = void 0;
                if (React.isValidElement(actualLabel)) {
                    nodeLabel = {
                        key: "node-label-" + nodei,
                        type: "basic-node-label",
                        x: node.x,
                        y: node.y,
                        element: actualLabel
                    };
                }
                else {
                    nodeLabel = {
                        key: "node-label-" + nodei,
                        className: "node-label",
                        dx: 0,
                        dy: 0,
                        x: node.x,
                        y: node.y,
                        note: { label: actualLabel },
                        connector: { end: "none" },
                        type: AnnotationLabel,
                        subject: { radius: nodeSizeAccessor(node) + 2 }
                    };
                }
                nodeLabelAnnotations.push(nodeLabel);
            }
        });
    }
    var projectedXYPoints;
    var overlay = [];
    var areaBasedTypes = [
        "circlepack",
        "treemap",
        "partition",
        "chord"
        //    "matrix"
    ];
    if ((hoverAnnotation &&
        areaBasedTypes.find(function (d) { return d === networkSettings.type; })) ||
        hoverAnnotation === "area") {
        if (hoverAnnotation !== "edge") {
            var renderedNodeOverlays = projectedNodes.map(function (d, i) { return (__assign({ overlayData: d }, customNodeIcon({
                d: d,
                i: i,
                transform: "translate(" + d.x + "," + d.y + ")",
                styleFn: function () { return ({ opacity: 0 }); }
            }).props)); });
            overlay.push.apply(overlay, __spread(renderedNodeOverlays));
        }
        if (hoverAnnotation !== "node") {
            projectedEdges.forEach(function (d, i) {
                var generatedIcon = customEdgeIcon({
                    d: d,
                    i: i,
                    transform: "translate(" + d.x + "," + d.y + ")",
                    styleFn: function () { return ({ opacity: 0 }); }
                });
                if (generatedIcon) {
                    overlay.push(__assign({ overlayData: __assign(__assign({}, d), { x: d.x === undefined ? (d.source.x + d.target.x) / 2 : d.x, y: d.y === undefined ? (d.source.y + d.target.y) / 2 : d.y, edge: true }) }, generatedIcon.props));
                }
            });
        }
    }
    else if (hoverAnnotation === "edge" &&
        typeof networkSettings.type === "string" &&
        edgePointHash[networkSettings.type]) {
        projectedXYPoints = projectedEdges.map(edgePointHash[networkSettings.type]);
    }
    else if (Array.isArray(hoverAnnotation) ||
        hoverAnnotation === true ||
        hoverAnnotation === "node") {
        projectedXYPoints = projectedNodes;
        if (changedData || networkSettingsChanged)
            projectedXYPoints = __spread(projectedNodes);
    }
    else if (hoverAnnotation === "all" &&
        typeof networkSettings.type === "string") {
        projectedXYPoints = __spread(projectedEdges.map(edgePointHash[networkSettings.type]), projectedNodes);
    }
    return {
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: currentProps.backgroundGraphics,
        foregroundGraphics: currentProps.foregroundGraphics,
        title: title,
        renderNumber: prevState.renderNumber + 1,
        projectedNodes: projectedNodes,
        projectedEdges: projectedEdges,
        projectedXYPoints: projectedXYPoints,
        overlay: overlay,
        nodeIDAccessor: nodeIDAccessor,
        sourceAccessor: sourceAccessor,
        targetAccessor: targetAccessor,
        nodeSizeAccessor: nodeSizeAccessor,
        edgeWidthAccessor: edgeWidthAccessor,
        margin: margin,
        legendSettings: legendSettings,
        networkFrameRender: networkFrameRender,
        nodeLabelAnnotations: nodeLabelAnnotations,
        graphSettings: __assign(__assign({}, networkSettings.graphSettings), networkSettings),
        props: currentProps
    };
};

var blankArray = [];
var matrixRenderOrder = ["nodes", "edges"];
var generalRenderOrder = ["edges", "nodes"];
var projectedCoordinateNames = { y: "y", x: "x" };
var xScale = scaleLinear();
var yScale = scaleLinear();
var NetworkFrame = /** @class */ (function (_super) {
    __extends(NetworkFrame, _super);
    function NetworkFrame(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultNetworkSVGRule = function (_a) {
            var baseD = _a.d, i = _a.i, annotationLayer = _a.annotationLayer;
            var _b = _this.state, projectedNodes = _b.projectedNodes, projectedEdges = _b.projectedEdges, nodeIDAccessor = _b.nodeIDAccessor, nodeSizeAccessor = _b.nodeSizeAccessor, networkFrameRender = _b.networkFrameRender, adjustedSize = _b.adjustedSize, adjustedPosition = _b.adjustedPosition;
            //TODO PASS FRAME STYLE FNs TO HIGHLIGHT
            var svgAnnotationRules = _this.props.svgAnnotationRules;
            var d = baseD.ids
                ? baseD
                : baseD.edge
                    ? __assign(__assign({}, (projectedEdges.find(function (p) {
                        return (nodeIDAccessor(p.source) === nodeIDAccessor(baseD.edge.source) &&
                            nodeIDAccessor(p.target) === nodeIDAccessor(baseD.edge.target));
                    }) || {})), baseD) : __assign(__assign({}, (projectedNodes.find(function (p) { return nodeIDAccessor(p) === baseD.id; }) || {})), baseD);
            var voronoiHover = annotationLayer.voronoiHover;
            if (svgAnnotationRules) {
                var customAnnotation = svgAnnotationRules({
                    d: d,
                    i: i,
                    networkFrameProps: _this.props,
                    networkFrameState: _this.state,
                    nodes: projectedNodes,
                    edges: projectedEdges,
                    voronoiHover: voronoiHover,
                    screenCoordinates: [d.x, d.y],
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize,
                    annotationLayer: annotationLayer
                });
                if (customAnnotation !== null) {
                    return customAnnotation;
                }
            }
            if (d.type === "node") {
                return svgNodeRule({
                    d: d,
                    i: i,
                    nodeSizeAccessor: nodeSizeAccessor
                });
            }
            else if (d.type === "desaturation-layer") {
                return desaturationLayer({
                    style: d.style instanceof Function ? d.style(d, i) : d.style,
                    size: adjustedSize,
                    i: i,
                    key: d.key
                });
            }
            else if (d.type === "basic-node-label") {
                return (React.createElement("g", { key: d.key || "basic-" + i, transform: "translate(" + d.x + "," + d.y + ")" }, baseD.element || baseD.label));
            }
            else if (d.type === "react-annotation" || typeof d.type === "function") {
                return svgReactAnnotationRule({
                    d: d,
                    i: i,
                    projectedNodes: projectedNodes,
                    nodeIDAccessor: nodeIDAccessor
                });
            }
            else if (d.type === "enclose") {
                return svgEncloseRule({
                    d: d,
                    i: i,
                    projectedNodes: projectedNodes,
                    nodeIDAccessor: nodeIDAccessor,
                    nodeSizeAccessor: nodeSizeAccessor
                });
            }
            else if (d.type === "enclose-rect") {
                return svgRectEncloseRule({
                    d: d,
                    i: i,
                    projectedNodes: projectedNodes,
                    nodeIDAccessor: nodeIDAccessor,
                    nodeSizeAccessor: nodeSizeAccessor
                });
            }
            else if (d.type === "enclose-hull") {
                return svgHullEncloseRule({
                    d: d,
                    i: i,
                    projectedNodes: projectedNodes,
                    nodeIDAccessor: nodeIDAccessor,
                    nodeSizeAccessor: nodeSizeAccessor
                });
            }
            else if (d.type === "highlight") {
                return svgHighlightRule({
                    d: d,
                    i: i,
                    networkFrameRender: networkFrameRender
                });
            }
            return null;
        };
        _this.defaultNetworkHTMLRule = function (_a) {
            var baseD = _a.d, i = _a.i, annotationLayer = _a.annotationLayer;
            var _b = _this.props, tooltipContent = _b.tooltipContent, optimizeCustomTooltipPosition = _b.optimizeCustomTooltipPosition, htmlAnnotationRules = _b.htmlAnnotationRules, useSpans = _b.useSpans;
            var _c = _this.state, projectedNodes = _c.projectedNodes, projectedEdges = _c.projectedEdges, nodeIDAccessor = _c.nodeIDAccessor, adjustedSize = _c.adjustedSize, adjustedPosition = _c.adjustedPosition;
            var voronoiHover = annotationLayer.voronoiHover;
            var d = baseD.ids
                ? baseD
                : baseD.edge
                    ? __assign(__assign({}, (projectedEdges.find(function (p) {
                        return nodeIDAccessor(p.source) === nodeIDAccessor(baseD.source) &&
                            nodeIDAccessor(p.target) === nodeIDAccessor(baseD.target);
                    }) || {})), baseD) : __assign(__assign({}, (projectedNodes.find(function (p) { return nodeIDAccessor(p) === baseD.id; }) || {})), baseD);
            if (htmlAnnotationRules) {
                var customAnnotation = htmlAnnotationRules({
                    d: d,
                    i: i,
                    networkFrameProps: _this.props,
                    networkFrameState: _this.state,
                    nodes: projectedNodes,
                    edges: projectedEdges,
                    voronoiHover: voronoiHover,
                    screenCoordinates: [d.x, d.y],
                    adjustedPosition: adjustedPosition,
                    adjustedSize: adjustedSize,
                    annotationLayer: annotationLayer
                });
                if (customAnnotation !== null) {
                    return customAnnotation;
                }
            }
            if (d.type === "frame-hover") {
                return htmlFrameHoverRule({
                    d: d,
                    i: i,
                    tooltipContent: tooltipContent,
                    optimizeCustomTooltipPosition: optimizeCustomTooltipPosition,
                    useSpans: useSpans,
                    nodes: projectedNodes,
                    edges: projectedEdges,
                    nodeIDAccessor: nodeIDAccessor
                });
            }
            return null;
        };
        var baseState = {
            dataVersion: undefined,
            nodeData: [],
            edgeData: [],
            adjustedPosition: [],
            adjustedSize: [],
            backgroundGraphics: null,
            foregroundGraphics: null,
            projectedNodes: [],
            projectedEdges: [],
            renderNumber: 0,
            nodeLabelAnnotations: [],
            graphSettings: {
                type: "empty-start",
                nodes: [],
                edges: [],
                nodeHash: new Map(),
                edgeHash: new Map(),
                hierarchicalNetwork: false
            },
            edgeWidthAccessor: stringToFn("weight"),
            legendSettings: undefined,
            margin: { top: 0, left: 0, right: 0, bottom: 0 },
            networkFrameRender: {},
            nodeIDAccessor: stringToFn("id"),
            nodeSizeAccessor: genericFunction(5),
            overlay: [],
            projectedXYPoints: [],
            sourceAccessor: stringToFn("source"),
            targetAccessor: stringToFn("target"),
            title: { title: undefined },
            props: props
        };
        _this.state = __assign(__assign({}, baseState), calculateNetworkFrame(props, baseState));
        return _this;
    }
    NetworkFrame.prototype.componentWillUnmount = function () {
        var onUnmount = this.props.onUnmount;
        if (onUnmount) {
            onUnmount(this.props, this.state);
        }
    };
    NetworkFrame.getDerivedStateFromProps = function (nextProps, prevState) {
        var props = prevState.props;
        if ((prevState.dataVersion &&
            prevState.dataVersion !== nextProps.dataVersion) ||
            (!prevState.projectedNodes && !prevState.projectedEdges) ||
            props.size[0] !== nextProps.size[0] ||
            props.size[1] !== nextProps.size[1] ||
            (!prevState.dataVersion &&
                networkFrameChangeProps.find(function (d) {
                    return props[d] !== nextProps[d];
                }))) {
            return __assign(__assign({}, calculateNetworkFrame(nextProps, prevState)), { props: nextProps });
        }
        return { props: nextProps };
    };
    NetworkFrame.prototype.onNodeClick = function (d, i) {
        var onNodeClick = this.props.onNodeClick;
        if (onNodeClick) {
            onNodeClick(d, i);
        }
    };
    NetworkFrame.prototype.onNodeEnter = function (d, i) {
        var onNodeEnter = this.props.onNodeEnter;
        if (onNodeEnter) {
            onNodeEnter(d, i);
        }
    };
    NetworkFrame.prototype.onNodeOut = function (d, i) {
        var onNodeOut = this.props.onNodeOut;
        if (onNodeOut) {
            onNodeOut(d, i);
        }
    };
    NetworkFrame.prototype.render = function () {
        var _a = this.props, annotations = _a.annotations, annotationSettings = _a.annotationSettings, className = _a.className, customClickBehavior = _a.customClickBehavior, customDoubleClickBehavior = _a.customDoubleClickBehavior, customHoverBehavior = _a.customHoverBehavior, size = _a.size, matte = _a.matte, hoverAnnotation = _a.hoverAnnotation, beforeElements = _a.beforeElements, afterElements = _a.afterElements, interaction = _a.interaction, disableContext = _a.disableContext, canvasPostProcess = _a.canvasPostProcess, baseMarkProps = _a.baseMarkProps, useSpans = _a.useSpans, canvasNodes = _a.canvasNodes, canvasEdges = _a.canvasEdges, additionalDefs = _a.additionalDefs, _b = _a.renderOrder, renderOrder = _b === void 0 ? this.state.graphSettings &&
            this.state.graphSettings.type === "matrix"
            ? matrixRenderOrder
            : generalRenderOrder : _b, sketchyRenderingEngine = _a.sketchyRenderingEngine, frameRenderOrder = _a.frameRenderOrder, disableCanvasInteraction = _a.disableCanvasInteraction, interactionSettings = _a.interactionSettings, disableProgressiveRendering = _a.disableProgressiveRendering;
        var _c = this.state, backgroundGraphics = _c.backgroundGraphics, foregroundGraphics = _c.foregroundGraphics, projectedXYPoints = _c.projectedXYPoints, margin = _c.margin, legendSettings = _c.legendSettings, adjustedPosition = _c.adjustedPosition, adjustedSize = _c.adjustedSize, networkFrameRender = _c.networkFrameRender, nodeLabelAnnotations = _c.nodeLabelAnnotations, overlay = _c.overlay, title = _c.title;
        var formattedOverlay;
        if (overlay && overlay.length > 0) {
            formattedOverlay = overlay;
        }
        var activeHoverAnnotation;
        if (Array.isArray(hoverAnnotation)) {
            activeHoverAnnotation = hoverAnnotation;
        }
        else if (customClickBehavior ||
            customDoubleClickBehavior ||
            customHoverBehavior) {
            activeHoverAnnotation = blankArray;
        }
        else {
            activeHoverAnnotation = !!hoverAnnotation;
        }
        return (React.createElement(Frame, { name: "networkframe", renderPipeline: networkFrameRender, adjustedPosition: adjustedPosition, adjustedSize: adjustedSize, size: size, xScale: xScale, yScale: yScale, title: title, matte: matte, className: className, additionalDefs: additionalDefs, frameKey: "none", projectedCoordinateNames: projectedCoordinateNames, defaultSVGRule: this.defaultNetworkSVGRule, defaultHTMLRule: this.defaultNetworkHTMLRule, hoverAnnotation: activeHoverAnnotation, annotations: __spread(annotations, nodeLabelAnnotations), annotationSettings: annotationSettings, legendSettings: legendSettings, interaction: interaction, customClickBehavior: customClickBehavior, customHoverBehavior: customHoverBehavior, customDoubleClickBehavior: customDoubleClickBehavior, points: projectedXYPoints, margin: margin, overlay: formattedOverlay, backgroundGraphics: backgroundGraphics, foregroundGraphics: foregroundGraphics, beforeElements: beforeElements, afterElements: afterElements, disableContext: disableContext, canvasPostProcess: canvasPostProcess, baseMarkProps: baseMarkProps, useSpans: !!useSpans, canvasRendering: !!(canvasNodes || canvasEdges), renderOrder: renderOrder, disableCanvasInteraction: disableCanvasInteraction, sketchyRenderingEngine: sketchyRenderingEngine, frameRenderOrder: frameRenderOrder, interactionSettings: interactionSettings, disableProgressiveRendering: disableProgressiveRendering }));
    };
    NetworkFrame.defaultProps = {
        annotations: [],
        foregroundGraphics: [],
        annotationSettings: {},
        size: [500, 500],
        className: "",
        name: "networkframe",
        networkType: { type: "force", iterations: 500 },
        filterRenderedNodes: function (d) { return d.id !== "root-generated"; }
    };
    NetworkFrame.displayName = "NetworkFrame";
    return NetworkFrame;
}(React.Component));

var framePropHash = {
    NetworkFrame: true,
    XYFrame: true,
    OrdinalFrame: true,
    ResponsiveNetworkFrame: true,
    ResponsiveXYFrame: true,
    ResponsiveOrdinalFrame: true,
    SparkNetworkFrame: true,
    SparkXYFrame: true,
    SparkOrdinalFrame: true
};
var invertKeys = {
    rExtent: "invertR",
    xExtent: "invertX",
    yExtent: "invertY"
};
var buildNewState = function (prevState, extentValue, extentType, extentPosition, invertedExtent) {
    var _a, _b;
    var oldExtents = prevState.rawExtents[extentType] || {};
    oldExtents[extentPosition] = extentValue;
    var extentMinMaxValues = Object.values(oldExtents)
        .flat()
        .filter(function (d) { return d !== undefined && d !== null && !isNaN(d); });
    var baseExtent = [
        Math.min.apply(Math, __spread(extentMinMaxValues)),
        Math.max.apply(Math, __spread(extentMinMaxValues))
    ];
    if (invertedExtent) {
        baseExtent = baseExtent.reverse();
    }
    return {
        extents: __assign(__assign({}, prevState.extents), (_a = {}, _a[extentType] = extentMinMaxValues.length === 0 ? undefined : baseExtent, _a)),
        rawExtents: __assign(__assign({}, prevState.rawExtents), (_b = {}, _b[extentType] = oldExtents, _b))
    };
};
function validFrameProps(originalProps) {
    var newProps = __assign({}, originalProps);
    return newProps;
}
var processFacetController = memoize(function (props, state) {
    return React.Children.map(props.children, function (child, index) {
        if (!child)
            return null;
        return mapChildrenWithAppropriateProps({
            child: child,
            index: index,
            originalAnnotations: child.props.annotations || [],
            props: props,
            state: state
        });
    });
});
/**
 * Helper for creating extent if we have a  min/max value
 * use that else use the onChange version so we can in return
 * normalize all of the facets to have the same extents
 */
var createExtent = function (extentType, props, state, index) {
    return state.extents && state.extents[extentType]
        ? {
            onChange: extentHandler(extentType, props, state, index),
            extent: state.extents[extentType]
        }
        : { onChange: extentHandler(extentType, props, state, index) };
};
/**
 * Whenever the extent changes, create the min/max values for each extentType
 * so this could be rExtent for OrdinalFrame or x/yExtent for the XYFrame
 */
var extentHandler = function (extentType, props, state, extentPosition) {
    var invertedExtent = props[invertKeys[extentType]] || false;
    return function (extentValue) {
        var newState = buildNewState(state, extentValue, extentType, extentPosition, invertedExtent);
        state.changeRawExtents(newState.rawExtents);
        state.changeExtents(newState.extents);
        return extentValue;
    };
};
/**
 * Map hover annotations and extent to child. Initially the extent is an object with
 * an onChange handler however once each of those resolve we then create an
 * extent that matches between all of them. This logic can be found in createExtent and also
 * extentHandler
 */
var mapChildrenWithAppropriateProps = function (_a) {
    var child = _a.child, index = _a.index, originalAnnotations = _a.originalAnnotations, props = _a.props, state = _a.state;
    var childType = child.type;
    var frameType = childType.displayName;
    var annotations = generateChildAnnotations({
        state: state,
        props: props,
        originalAnnotations: originalAnnotations
    });
    var customProps = __assign(__assign({}, props), { annotations: annotations });
    if (!framePropHash[frameType]) {
        return React.cloneElement(child, { facetprops: customProps });
    }
    // pieceHoverAnnotation could be an object, so we need to be explicit in checking for true
    if (props.hoverAnnotation || props.pieceHoverAnnotation) {
        customProps.customHoverBehavior = function (d) {
            state.changeFacetHover(d);
            state.changeFacetHoverAnnotations(props.hoverAnnotation || props.pieceHoverAnnotation);
        };
    }
    if ((frameType === "OrdinalFrame" ||
        frameType === "ResponsiveOrdinalFrame" ||
        frameType === "SparkOrdinalFrame") &&
        props.sharedRExtent === true) {
        var invertedExtent_1 = customProps[invertKeys["rExtent"]] || false;
        customProps.rExtent = createExtent("rExtent", props, state, index);
        customProps.onUnmount = function () {
            var newState = buildNewState(state, [], "rExtent", index, invertedExtent_1);
            state.changeRawExtents(newState.rawExtents);
            state.changeExtents(newState.extents);
        };
    }
    if ((frameType === "XYFrame" ||
        frameType === "ResponsiveXYFrame" ||
        frameType === "SparkXYFrame") &&
        props.sharedXExtent === true) {
        var invertedExtent_2 = customProps[invertKeys["xExtent"]] || false;
        customProps.xExtent = createExtent("xExtent", props, state, index);
        customProps.onUnmount = function () {
            var newState = buildNewState(state, [], "xExtent", index, invertedExtent_2);
            state.changeRawExtents(newState.rawExtents);
            state.changeExtents(newState.extents);
        };
    }
    if ((frameType === "XYFrame" ||
        frameType === "ResponsiveXYFrame" ||
        frameType === "SparkXYFrame") &&
        props.sharedYExtent === true) {
        var invertedExtent_3 = customProps[invertKeys["yExtent"]] || false;
        customProps.yExtent = createExtent("yExtent", props, state, index);
        customProps.onUnmount = function () {
            var newState = buildNewState(state, [], "yExtent", index, invertedExtent_3);
            state.changeRawExtents(newState.rawExtents);
            state.changeExtents(newState.extents);
        };
    }
    if (customProps.pieceHoverAnnotation) {
        customProps.pieceHoverAnnotation = [];
    }
    else if (customProps.hoverAnnotation) {
        customProps.hoverAnnotation = [];
    }
    return React.cloneElement(child, validFrameProps(customProps));
};
/**
 * Remove and add required annotation props for specific annotation types.
 */
var generateChildAnnotations = function (_a) {
    var originalAnnotations = _a.originalAnnotations, state = _a.state, props = _a.props;
    var annotationBase = state.facetHoverAnnotations;
    var hoverAnnotation = props.hoverAnnotation, pieceHoverAnnotation = props.pieceHoverAnnotation;
    var annotationSettings = hoverAnnotation || pieceHoverAnnotation;
    if (!annotationSettings || !annotationBase) {
        return originalAnnotations;
    }
    if (state.facetHover) {
        var annotations = __spread(originalAnnotations);
        if (annotationSettings === true) {
            annotationBase = [__assign({}, state.facetHover)];
        }
        else {
            var annotationMap = annotationSettings;
            annotationBase = annotationMap.map(function (annotation) {
                var decoratedAnnotation = typeof annotation === "function"
                    ? annotation(state.facetHover)
                    : __assign(__assign({}, state.facetHover), annotation);
                return decoratedAnnotation;
            });
        }
        if (Array.isArray(annotationBase)) {
            annotationBase.forEach(function (annotation) {
                if (typeof annotation !== "function") {
                    if (annotation.type === "column-hover") {
                        annotation.facetColumn = annotation.column.name;
                        annotation.column = undefined;
                    }
                    else {
                        if (!annotation.type) {
                            annotation.type = "frame-hover";
                        }
                        annotation.y = undefined;
                        annotation.yBottom = undefined;
                        annotation.yMiddle = undefined;
                        annotation.yTop = undefined;
                    }
                }
            });
            annotations.push.apply(annotations, __spread(annotationBase));
        }
        return annotations;
    }
    return originalAnnotations;
};
function FacetController(props) {
    var _a = __read(useState({}), 2), extents = _a[0], changeExtents = _a[1];
    var _b = __read(useState({}), 2), rawExtents = _b[0], changeRawExtents = _b[1];
    var _c = __read(useState(undefined), 2), facetHover = _c[0], changeFacetHover = _c[1];
    var _d = __read(useState(undefined), 2), facetHoverAnnotations = _d[0], changeFacetHoverAnnotations = _d[1];
    return (React.createElement(React.Fragment, null, processFacetController(props, {
        extents: extents,
        rawExtents: rawExtents,
        facetHover: facetHover,
        facetHoverAnnotations: facetHoverAnnotations,
        changeFacetHoverAnnotations: changeFacetHoverAnnotations,
        changeExtents: changeExtents,
        changeRawExtents: changeRawExtents,
        changeFacetHover: changeFacetHover
    })));
}

/** ISC License (c) 2021 Alexey Raspopov */
function useElementSize(ref) {
    var _a = __read(useState([null, null]), 2), size = _a[0], setSize = _a[1];
    useLayoutEffect(function () {
        var element = ref.current;
        if (element != null) {
            var rect = element.getBoundingClientRect();
            setSize([rect.width, rect.height]);
            // @ts-ignore
            var observer_1 = new ResizeObserver(function (entries) {
                if (entries.length > 0) {
                    var rect_1 = entries[0].contentRect;
                    setSize([rect_1.width, rect_1.height]);
                }
            });
            observer_1.observe(element);
            return function () { return observer_1.disconnect(); };
        }
    }, []);
    return size;
}
var createResponsiveFrame = function (ParticularFrame) {
    function ResponsiveFrame(props) {
        var responsiveWidth = props.responsiveWidth, responsiveHeight = props.responsiveHeight, _a = props.size, size = _a === void 0 ? [500, 500] : _a, dataVersion = props.dataVersion, _b = props.debounce, debounce = _b === void 0 ? 200 : _b, gridDisplay = props.gridDisplay, rest = __rest(props, ["responsiveWidth", "responsiveHeight", "size", "dataVersion", "debounce", "gridDisplay"]);
        var actualSize = __spread(size);
        var returnEmpty = false;
        var sceneRef = useRef();
        var _c = __read(useElementSize(sceneRef), 2), containerWidth = _c[0], containerHeight = _c[1];
        if (responsiveWidth) {
            if (!containerWidth)
                returnEmpty = true;
            actualSize[0] = containerWidth;
        }
        if (responsiveHeight) {
            if (!containerHeight)
                returnEmpty = true;
            actualSize[1] = containerHeight;
        }
        var dataVersionWithSize = dataVersion + actualSize.toString() + debounce;
        return (React.createElement("div", { className: "responsive-container", style: gridDisplay
                ? { minWidth: "0px", minHeight: "0px" }
                : { height: "100%", width: "100%" }, ref: sceneRef }, !returnEmpty && (React.createElement(ParticularFrame, __assign({}, rest, { size: actualSize, dataVersion: dataVersion ? dataVersionWithSize : undefined })))));
    }
    ResponsiveFrame.isResizing = setTimeout(function () { });
    ResponsiveFrame.displayName = "Responsive" + ParticularFrame.displayName;
    return ResponsiveFrame;
};

var ResponsiveNetworkFrame = createResponsiveFrame(NetworkFrame);

var ResponsiveMinimapXYFrame = createResponsiveFrame(MinimapXYFrame);

var ResponsiveXYFrame = createResponsiveFrame(XYFrame);

var ResponsiveOrdinalFrame = createResponsiveFrame(OrdinalFrame);

var allFrameDefaults = {
    margin: 0
};
function sparkNetworkSettings(originalSettings) {
    if (originalSettings === void 0) { originalSettings = "force"; }
    var finalSettings = {};
    if (originalSettings) {
        finalSettings = originalSettings;
        if (originalSettings === "force")
            finalSettings = { type: "force" };
        return __assign({ edgeStrength: 2, edgeDistance: 5, nodePadding: 1, nodeWidth: 5, groupWidth: 4 }, finalSettings);
    }
    return originalSettings;
}
var axisDefaults = {
    tickFormat: function () { return ""; },
    baseline: false
};
var xyFrameDefaults = function (props) { return (__assign(__assign(__assign({}, allFrameDefaults), props), { hoverAnnotation: props.hoverAnnotation, axes: props.axes
        ? props.axes.map(function (a) { return (__assign(__assign({}, axisDefaults), a)); })
        : props.axes })); };
var ordinalFrameDefaults = function (props) { return (__assign(__assign(__assign({}, allFrameDefaults), props), { hoverAnnotation: props.hoverAnnotation, axes: props.axes
        ? props.axes.map(function (a) { return (__assign(__assign({}, axisDefaults), a)); })
        : props.axes })); };
var networkFrameDefaults = function (props) { return (__assign(__assign(__assign(__assign({}, allFrameDefaults), { nodeSizeAccessor: 2 }), props), { networkType: sparkNetworkSettings(props.networkType) })); };
function createSparkFrame(Frame, defaults, frameName) {
    return function (props) {
        var size = props.size, _a = props.sparkStyle, sparkStyle = _a === void 0 ? {} : _a;
        var _b = __read(useState(30), 2), containerHeight = _b[0], changeContainerHeight = _b[1];
        var actualSize = [];
        actualSize[0] =
            typeof size === "number" ? size : size[0] ? size[0] : containerHeight;
        actualSize[1] = containerHeight;
        var sparkNodeRef = useCallback(function (node) {
            var lineHeight = +window.getComputedStyle(node).lineHeight.split("px")[0] - 5;
            changeContainerHeight(isNaN(lineHeight) ? node.offsetHeight : lineHeight);
        }, []);
        return (React.createElement("span", { style: Object.assign({
                width: actualSize[0] + "px",
                height: actualSize[1] + "px",
                display: "inline-block",
                marginLeft: "5px",
                marginRight: "5px"
            }, sparkStyle), ref: sparkNodeRef },
            React.createElement(Frame, __assign({}, defaults(props), { size: actualSize, useSpans: true }))));
    };
}

var SparkXYFrame = createSparkFrame(XYFrame, xyFrameDefaults);

var SparkOrdinalFrame = createSparkFrame(OrdinalFrame, ordinalFrameDefaults);

var SparkNetworkFrame = createSparkFrame(NetworkFrame, networkFrameDefaults);

export { SemioticAnnotation as Annotation, AnnotationLayer, Axis, Brush, DividedLine, FacetController, InteractionLayer, Legend, MiniMap, MinimapXYFrame, NetworkFrame, OrdinalFrame, ResponsiveMinimapXYFrame, ResponsiveNetworkFrame, ResponsiveOrdinalFrame, ResponsiveXYFrame, SparkNetworkFrame, SparkOrdinalFrame, SparkXYFrame, VisualizationLayer, XYFrame, calculateDataExtent, funnelize, heatmapping, hexbinning, nodesEdgesFromHierarchy };
